import React, { useState, useEffect, useCallback } from 'react';
import './../App.css';
import './Users.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import loadingSpinner from './../assets/loading.gif';
import {token, domain} from './Security';
import {useTable, useSortBy} from 'react-table';
// icons
import HowToRegIcon from '@mui/icons-material/HowToReg';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import LockResetIcon from '@mui/icons-material/LockReset';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

function Users({user, isHideSideMenu}) {
    var header = [
        "Username",
        "Display Name",
        "Access",
        ""
    ]
    var accessor = [
        "username",
        "employeePersonalInformationFullName",
        "accessTemplateDescription",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const [loadingRequest, setLoadingRequest] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationEmployeeId, setEmployeePersonalInformationEmployeeId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [accessTemplateId, setAccessTemplateId] = useState("");
    //old
    const [oldEmployeePersonalInformationId, setOldEmployeePersonalInformationId] = useState("");
    const [oldAccessTemplateId, setOldAccessTemplateId] = useState("");

    const [filterData, setFilterData] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [accessTemplates, setAccessTemplates] = useState([]);

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");

    const [loading, setLoading] = useState(false);
    const [showRegisterForm, setShowRegisterForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
    const [showUserTemplate, setShowUserTemplate] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [showConfirmationForm, setShowConfirmationForm] = useState(false);
    const [isAddState, setIsAddState] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/Authentication";

    const fetchDataAccess = useCallback(async () => {
        const apiUrl =  domain + "/api/AccessTemplate";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
                }
            });
            
            return response.data; // Return the response data
        } catch (error) {
            console.error('Error fetching data:', error);
            return []; // Return an empty array in case of error
        }
    }, []);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setUsers(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state

            const accessTemp = await fetchDataAccess();
            setAccessTemplates(accessTemp);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, fetchDataAccess]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if(showEditForm){
            setUsername(selectedUser.username);
            setEmployeePersonalInformationId(selectedUser.employeePersonalInformationId);
            setEmployeePersonalInformationFullName(selectedUser.employeePersonalInformationFullName);
            setEmployeePersonalInformationEmployeeId(selectedUser.employeePersonalInformationEmployeeId);
            setAccessTemplateId(selectedUser.accessTemplateId);

            setOldEmployeePersonalInformationId(selectedUser.employeePersonalInformationId);
            setOldAccessTemplateId(selectedUser.accessTemplateId);
        }
    }, [showEditForm, selectedUser]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterData.filter((f) =>
            f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue) 
            || f.username.toLowerCase().includes(lowercaseValue) 
        );

        setUsers(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            username: username,
            password: password,
            employeePersonalInformationId: employeePersonalInformationId,
            accessTemplateId: accessTemplateId
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl + `/register`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowRegisterForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Users", 
                actionTaken: "insert", 
                field: "Register User", 
                newValue: `${employeePersonalInformationFullName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setRequestMessage("Request Success");
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setUsername("");
            setPassword("");
            setConfirmPassword("");
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationEmployeeId("");
            setEmployeePersonalInformationFullName("");
            setAccessTemplateId("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowRegisterForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            id: selectedUser.id,
            username: username,
            employeePersonalInformationId: employeePersonalInformationId,
            accessTemplateId: accessTemplateId
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/update`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            let auditInfo = [];

            if(data.employeePersonalInformationId !== oldEmployeePersonalInformationId){
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee",
                    newValue: `${data.employeePersonalInformationId}`,
                    oldValue: `${oldEmployeePersonalInformationId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.accessTemplateId !== oldAccessTemplateId){
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Access Template",
                    newValue: `${data.accessTemplateId}`,
                    oldValue: `${oldAccessTemplateId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setShowRequestMessage(true);
            setRequestMessage("Request Success");
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setUsername("");
            setPassword("");
            setConfirmPassword("");
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationEmployeeId("");
            setEmployeePersonalInformationFullName("");
            setAccessTemplateId("");
            setSelectedUser([]);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleChangePassword = async (event) => {
        event.preventDefault();

        const data = {
            oldPassword: oldPassword,
            newPassword: newPassword,
            username: selectedUser.username
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/change-password`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowChangePasswordForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Users", 
                actionTaken: "update", 
                field: "Password", 
                newValue: `********`, 
                oldValue: "********", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setShowRequestMessage(true);
            setRequestMessage("Request Success");
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setOldPassword("");
            setNewPassword("");
            setSelectedUser([]);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleResetConfirm = async (event) => {
        event.preventDefault();

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl + `/username/${selectedUser.username}`, [], {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowConfirmationForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Users", 
                actionTaken: "reset", 
                field: "Reset Password", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setShowRequestMessage(true);
            setRequestMessage("Request Success: Your password successfully reset into 'password' ");
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setSelectedUser([]);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowConfirmationForm(false);
    };
    const editHandleClick = (data) =>{
        setSelectedUser(data);
        setShowEditForm(true);
    }
    const resetHandleClick = (data) =>{
        setSelectedUser(data);
        setShowConfirmationForm(true);
    }
    const openRegisterForm = () =>{
        setShowRegisterForm(true);
    }
    const closeRegisterForm = () =>{
        setShowRegisterForm(false);
    }
    const closeEditForm = () =>{
        setShowEditForm(false);
    }
    const openChangePasswordForm = (data) =>{
        setSelectedUser(data);
        setShowChangePasswordForm(true);
    }
    const closeChangePasswordForm = () =>{
        setShowChangePasswordForm(false);
    }
    const closeEmployeeForm = () =>{
        setShowEmployeeForm(false);
    }
    const closeConfirmationFormHandleClick = () =>{
        setShowConfirmationForm(false);
    }
    const openUserTemplateForm = () =>{
        setShowUserTemplate(true);
    }
    const closeUserTemplateForm = () =>{
        setShowUserTemplate(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="UsersInfo shadow-xl">
                        <div className="users-header">
                            <h3>Users</h3>
                            <div className="search_sect" style={{marginTop:"20px"}}>
                                {CreateSearchBarWithPlaceHolder("", 
                                            "employees-list-search row", 
                                            "search-icon", 
                                            "search-input", 
                                            (e) => handleFilter(e.target.value), 
                                            "Search by display name", 
                                            SearchIcon
                                )}
                            </div>
                            <div className="manage row">
                                {CreateButton("registerUser", "registerUser row", openRegisterForm, "Register User", HowToRegIcon)} 
                                {CreateButton("manageUser", "manageUser row", openUserTemplateForm, "Manage User", AppRegistrationIcon)} 
                            </div>
                            
                        </div>
                        <div className="users-body">
                            <div className="users-table container">
                                <CreateTable
                                    dataList={users}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    deleteHandleClick={resetHandleClick}
                                    changePassword={openChangePasswordForm}
                                    accessTemplates={accessTemplates}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                        <div className="users-footer"></div>
                    </div>
                </div>
            </div>
            <RegisterForm  isOpen={showRegisterForm} 
                    onClose={closeRegisterForm}
                    username={username}
                    setUsername={setUsername}
                    password={password}
                    setPassword={setPassword}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationEmployeeId={employeePersonalInformationEmployeeId}
                    setEmployeePersonalInformationEmployeeId={setEmployeePersonalInformationEmployeeId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    accessTemplateId={accessTemplateId}
                    setAccessTemplateId={setAccessTemplateId}
                    setShowEmployeeForm={setShowEmployeeForm}
                    handleSubmit={handleSubmit}
            >
            </RegisterForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditForm}
                    username={username} setUsername={setUsername}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationEmployeeId={employeePersonalInformationEmployeeId}
                    setEmployeePersonalInformationEmployeeId={setEmployeePersonalInformationEmployeeId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    accessTemplateId={accessTemplateId}
                    setAccessTemplateId={setAccessTemplateId}
                    setShowEmployeeForm={setShowEmployeeForm}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <ChangePasswordForm  isOpen={showChangePasswordForm} 
                    onClose={closeChangePasswordForm}
                    username={selectedUser.username}
                    oldPassword={oldPassword}
                    setOldPassword={setOldPassword}
                    newPassword={newPassword}
                    setNewPassword={setNewPassword}
                    handleUpdate={handleChangePassword}
            >
            </ChangePasswordForm>
            <UserTemplate isOpen={showUserTemplate} 
                    onClose={closeUserTemplateForm}
                    isAddState={isAddState}
                    setIsAddState={setIsAddState}
                    user={user}
            >
            </UserTemplate>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    setEmployeeEmployeeId={setEmployeePersonalInformationEmployeeId}
            >
            </EmployeeSelectForm>
            <ConfirmationForm  isOpen={showConfirmationForm} 
                    onClose={closeConfirmationFormHandleClick}
                    handleResetConfirm={handleResetConfirm}
            >
            </ConfirmationForm>
            <GenerateMessage form={showRequestMessage}
                    message={requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function RegisterForm({
    isOpen, 
    onClose,
    username,
    setUsername,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationEmployeeId,
    setEmployeePersonalInformationEmployeeId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    accessTemplateId,
    setAccessTemplateId,
    setShowEmployeeForm,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);
    const [isPasswordNotMatch, setIsPasswordNotMatch] = useState(false);

    const submit = (e) =>{
        if(!username 
            || !password
            || !confirmPassword
            || !employeePersonalInformationId
            || !accessTemplateId
        ){
            setErrorState(true);
            return;
        }

        if(password !== confirmPassword){
            setIsPasswordNotMatch(true);
            return;
        }

        handleSubmit(e);
        setErrorState(false);
        setIsPasswordNotMatch(false);
    };

    const handleClose = () => {
        onClose();
        setUsername("");
        setPassword("");
        setConfirmPassword("");
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setAccessTemplateId("");
        setErrorState(false);
        setIsPasswordNotMatch(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Register User</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Username</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !username && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: (!password && errorState) ||  (isPasswordNotMatch) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>
                                        {
                                            (isPasswordNotMatch) ? "Doesn't match" 
                                            :
                                            "Please fill up this field"
                                        }
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Confirm Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: (!confirmPassword && errorState) ||  (isPasswordNotMatch)? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>
                                        {
                                            (isPasswordNotMatch) ? "Doesn't match" 
                                            :
                                            "Please fill up this field"
                                        }
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee Id</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationEmployeeId + " - " + employeePersonalInformationFullName) : employeePersonalInformationEmployeeId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Access Template</div>
                            <div className="info-item-input">
                                <AccessTemplateIdSelect accessTemplateId={accessTemplateId} setAccessTemplateId={setAccessTemplateId} />
                            </div>
                            <span style={{
                                        visibility: !accessTemplateId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({
    isOpen, 
    onClose,
    username,
    setUsername,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationEmployeeId,
    setEmployeePersonalInformationEmployeeId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    accessTemplateId,
    setAccessTemplateId,
    setShowEmployeeForm,
    handleUpdate}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!username 
            || !employeePersonalInformationId
            || !accessTemplateId
        ){
            setErrorState(true);
            return;
        }

        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setAccessTemplateId("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update User</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Username</div>
                            <div className="info-item-input">
                                <input
                                // readOnly
                                placeholder="Username"
                                value={username}
                                // style={{cursor:"not-allowed"}}
                                onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !username && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee Id</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationEmployeeId + " - " + employeePersonalInformationFullName) : employeePersonalInformationEmployeeId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Access Template</div>
                            <div className="info-item-input">
                                <AccessTemplateIdSelect accessTemplateId={accessTemplateId} setAccessTemplateId={setAccessTemplateId} />
                            </div>
                            <span style={{
                                        visibility: !accessTemplateId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ChangePasswordForm({
    isOpen, 
    onClose,
    username,
    oldPassword,
    setOldPassword,
    newPassword,
    setNewPassword,
    handleUpdate}) 
{
    const [errorState, setErrorState] = useState(false);
    const [isPasswordNotMatch, setIsPasswordNotMatch] = useState(false);
    const [isOldPasswordNotMatch, setIsOldPasswordNotMatch] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) =>{
        if(!oldPassword 
            || !newPassword
            || !confirmPassword
        ){
            setErrorState(true);
            return;
        }

        const isNotMatch = await logInToGetPassword(e);

        if(isNotMatch){
            setIsOldPasswordNotMatch(true);
            return;
        } else {
            setIsOldPasswordNotMatch(false);
        }

        if(newPassword !== confirmPassword){
            setIsPasswordNotMatch(true);
            return;
        }

        handleUpdate(e);
        setErrorState(false);
        setIsPasswordNotMatch(false);
        setIsOldPasswordNotMatch(false)
    };

    const logInToGetPassword = async (event) => {
        event.preventDefault();

        const data = {
            userName: username,
            password: oldPassword
        };

        const apiUrlFetch = domain + "/api/Authentication/login";

        try {
            setLoading(true);
            await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            return false;
        } catch (error) {
            setLoading(false);
            return true;
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        onClose();
        setNewPassword("")
        setOldPassword("")
        setConfirmPassword("")
        setErrorState(false);
        setIsPasswordNotMatch(false);
        setIsOldPasswordNotMatch(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Change Password</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Username</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                placeholder="Password"
                                value={username}
                                style={{cursor:"not-allowed"}}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>
                                        {
                                            "Please fill up this field"
                                        }
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Old Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Password"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: (!oldPassword && errorState) ||  (isOldPasswordNotMatch) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>
                                        {
                                            (isOldPasswordNotMatch) ? "Doesn't match" 
                                            :
                                            "Please fill up this field"
                                        }
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">New Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: (!newPassword && errorState) ||  (isPasswordNotMatch) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>
                                        {
                                            (isPasswordNotMatch) ? "Doesn't match" 
                                            :
                                            "Please fill up this field"
                                        }
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Confirm Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: (!confirmPassword && errorState) ||  (isPasswordNotMatch)? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>
                                        {
                                            (isPasswordNotMatch) ? "Doesn't match" 
                                            :
                                            "Please fill up this field"
                                        }
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                CHANGE
                        </button>
                    </div>
                </div>
            )}
            </div>
            {loading ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function UserTemplate({
    isOpen, 
    onClose,
    isAddState,
    setIsAddState,
    user
    }) 
{
    const handleClose = () => {
        onClose();
        setIsAddState(false);
        setIsEditState(false);
    };

    var header = [
        "Id",
        "Template Name",
        "Home",
        "Add Employee",
        "Employee List",
        "Employment Status",
        "Employee Schedule",
        "Employee Reliever",
        "Time Entries",
        "Tampered Approval",
        "Shift Schedule",
        "Process Payroll",
        "13th Month",
        "Final Pay",
        "Subcon",
        "Agency",
        "Payroll Period",
        "Client",
        "Pay Type",
        "Holiday",
        "Holiday Type",
        "Leave Type",
        "Department",
        "Section",
        "Classification",
        "Company",
        "Position",
        "Employee Status",
        "Job Title",
        "Location",
        "DTR Rules Configuration",
        "Time Keeper",
        "Plantilya",
        "Cost Center",
        "Payroll Journal Account",
        "Employee Monthly Salary",
        "Employee Daily Salary",
        "Quota-Based Salary",
        "Position-Designation Salary",
        "Position-Designation Salary (La Union)",
        "Employee Bank Account",
        "BIR / Tax",
        "Pagibig",
        "SSS",
        "Philhealth",
        "DTR (Admin's View)",
        "DTR (Employee's View)",
        "DTR With OT Viewing",
        "Mobile DTR Approval",
        "Approver Hierarchy",
        "Approver Hierarchy Per Location",
        "Request Approval",
        "Request Approval Time Keeper",
        "Mass Approval",
        "DTR Correction Workers",
        "Overtime",
        "DTR Correction",
        "Leave",
        "Change of Schedule",
        "SSS Loan",
        "SSS Calamity Loan",
        "Pagibig Loan",
        "Pagibig Calamity Loan",
        "Cash Advance",
        "Loans",
        "Deductions",
        "Benefits",
        "Settings",
        "Calendar",
        "User",
        "Notifications",
        "Mobile Biometrics",
        "Reports",
        "User Time Out (minutes)",
        "",
    ]
    var accessor = [
        "id",
        "description",
        "hasHome",
        "hasAddEmployee",
        "hasEmployeeList",
        "hasEmploymentStatus",
        "hasEmployeeSchedule",
        "hasEmployeereliever",
        "hasTimeEntries",
        "hasTamperedApproval",
        "hasShiftSchedule",
        "hasProcessPayroll",
        "has13thMonth",
        "hasFinalPay",
        "hasSubcon",
        "hasAgency",
        "hasPayrollPeriod",
        "hasClient",
        "hasPayType",
        "hasHoliday",
        "hasHolidayType",
        "hasLeaveType",
        "hasDepartment",
        "hasSection",
        "hasClassification",
        "hasCompany",
        "hasPosition",
        "hasEmployeeStatus",
        "hasJobTitle",
        "hasLocation",
        "hasDTRRulesConfiguration",
        "hasTimeKeeper",
        "hasPlantilya",
        "hasCostCenter",
        "hasPayrollJournalAccount",
        "hasEmployeeMonthlySalary",
        "hasEmployeeDailySalary",
        "hasPositionDesignationSalary",
        "hasQuotaBasedSalary",
        "hasPositionDesignationSalaryLaUnion",
        "hasEmployeeBankAccount",
        "hasBIRTax",
        "hasPagibig",
        "hasSSS",
        "hasPhilhealth",
        "hasDTR",
        "hasDTRBiometrics",
        "hasDTRWithOTViewing",
        "hasMobileDTRApproval",
        "hasApproverHierarchy",
        "hasApproverheirarchyperlocation",
        "hasRequestApproval",
        "hasRequestApprovalTimeKeeper",
        "hasMassapproval",
        "hasDTRCorrectionWorkers",
        "hasOvertime",
        "hasDTRCorrection",
        "hasLeave",
        "hasChangeOfSchedule",
        "hasSSSLoan",
        "hasSSSCalamityLoan",
        "hasPagibigLoan",
        "hasPagibigCalamityLoan",
        "hasCashAdvance",
        "hasLoans",
        "hasDeductions",
        "hasBenefits",
        "hasSettings",
        "hasCalendar",
        "hasUser",
        "hasNotification",
        "hasMobileBiometrics",
        "hasReports",
        "userTimeOut",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [userTemplate, setUserTempalte] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const [description, setDescription] = useState("");
    const [hasHome, setHasHome] = useState(false);
    const [hasAddEmployee, setHasAddEmployee] = useState(false);
    const [hasEmployeeList, setHasEmployeeList] = useState(false);
    const [hasEmployeeStatus, setHasEmployeeStatus] = useState(false);
    const [hasEmployeeSchedule, setHasEmployeeSchedule] = useState(false);
    const [hasTimeEntries, setHasTimeEntries] = useState(false);
    const [hasShiftSchedule, setHasShiftSchedule] = useState(false);
    const [hasProcessPayroll, setHasProcessPayroll] = useState(false);
    const [has13thMonth, setHas13thMonth] = useState(false);
    const [hasPayrollPeriod, setHasPayrollPeriod] = useState(false);
    const [hasClient, setHasClient] = useState(false);
    const [hasPayType, setHasPayType] = useState(false);
    const [hasHoliday, setHasHoliday] = useState(false);
    const [hasHolidayType, setHasHolidayType] = useState(false);
    const [hasLeaveType, setHasLeaveType] = useState(false);
    const [hasDepartment, setHasDepartment] = useState(false);
    const [hasSection, setHasSection] = useState(false);
    const [hasClassification, setHasClassification] = useState(false);
    const [hasCompany, setHasCompany] = useState(false);
    const [hasPosition, setHasPosition] = useState(false);
    const [hasJobTitle, setHasJobTitle] = useState(false);
    const [hasLocation, setHasLocation] = useState(false);
    const [hasDTRRulesConfiguration, setHasDTRRulesConfiguration] = useState(false);
    const [hasEmployeeMonthlySalary, setHasEmployeeMonthlySalary] = useState(false);
    const [hasEmployeeDailySalary, setHasEmployeeDailySalary] = useState(false);
    const [hasPositionDesignationSalary, setHasPositionDesignationSalary] = useState(false);
    const [hasQuotaBasedSalary, setHasQuotaBasedSalary] = useState(false);
    const [hasPositionDesignationSalaryLaUnion, setHasPositionDesignationSalaryLaUnion] = useState(false);
    const [hasEmployeeBankAccount, setHasEmployeeBankAccount] = useState(false);
    const [hasBIRTax, setHasBIRTax] = useState(false);
    const [hasPagibig, setHasPagibig] = useState(false);
    const [hasSSS, setHasSSS] = useState(false);
    const [hasPhilhealth, setHasPhilhealth] = useState(false);
    const [hasDTR, setHasDTR] = useState(false);
    const [hasDTRBiometrics, setHasDTRBiometrics] = useState(false);
    const [hasApproverHierarchy, setHasApproverHierarchy] = useState(false);
    const [hasRequestApproval, setHasRequestApproval] = useState(false);
    const [hasOvertime, setHasOvertime] = useState(false);
    const [hasDTRCorrection, setHasDTRCorrection] = useState(false);
    const [hasLeave, setHasLeave] = useState(false);
    const [hasChangeOfSchedule, setHasChangeOfSchedule] = useState(false);
    const [hasSSSLoan, setHasSSSLoan] = useState(false);
    const [hasSSSCalamityLoan, setHasSSSCalamityLoan] = useState(false);
    const [hasPagibigLoan, setHasPagibigLoan] = useState(false);
    const [hasPagibigCalamityLoan, setHasPagibigCalamityLoan] = useState(false);
    const [hasCashAdvance, setHasCashAdvance] = useState(false);
    const [hasDeductions, setHasDeductions] = useState(false);
    const [hasBenefits, setHasBenefits] = useState(false);
    const [hasReports, setHasReports] = useState(false);
    const [hasSettings, setHasSettings] = useState(false);
    const [hasCalendar, setHasCalendar] = useState(false);
    const [hasUser, setHasUser] = useState(false);
    const [userTimeOut, setUserTimeOut] = useState("");

    const [hasTamperedApproval, setHasTamperedApproval] = useState(false);
    const [hasMobileDTRApproval, setHasMobileDTRApproval] = useState(false);
    const [hasDTRWithOTViewing, setHasDTRWithOTViewing] = useState(false);
    const [hasDTRCorrectionWorkers, setHasDTRCorrectionWorkers] = useState(false);
    const [hasPlantilya, setHasPlantilya] = useState(false);
    const [hasCostCenter, setHasCostCenter] = useState(false);
    const [hasPayrollJournalAccount, setHasPayrollJournalAccount] = useState(false);

    // additional
    const [hasEmployeereliever, setHasEmployeereliever] = useState(false);
    const [hasMassapproval, setHasMassapproval] = useState(false);
    const [hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation] = useState(false);
    const [hasFinalPay, setHasFinalPay] = useState(false);
    const [hasSubcon, setHasSubcon] = useState(false);
    const [hasAgency, setHasAgency] = useState(false);
    const [hasEmploymentStatus, setHasEmploymentStatus] = useState(false);
    const [hasLoans, setHasLoans] = useState(false);
    const [hasTimeKeeper, setHasTimeKeeper] = useState(false);
    const [hasPerDayTracker, setHasPerDayTracker] = useState(false);
    const [hasOvertimeSummaryReport, setHasOvertimeSummaryReport] = useState(false);
    const [hasTrackerReport, setHasTrackerReport] = useState(false);
    const [hasPayslip, setHasPayslip] = useState(false);
    const [hasPayrollRegister, setHasPayrollRegister] = useState(false);
    const [hasResigned, setHasResigned] = useState(false);
    const [hasActiveEmployees, setHasActiveEmployees] = useState(false);
    const [hasYearofService, setHasYearofService] = useState(false);
    const [hasSSSSummary, setHasSSSSummary] = useState(false);
    const [hasPagibigSummary, setHasPagibigSummary] = useState(false);
    const [hasPhilhealthSummary, setHasPhilhealthSummary] = useState(false);
    const [hasSSSLoanReport, setHasSSSLoanReport] = useState(false);
    const [hasPagibigLoanReport, setHasPagibigLoanReport] = useState(false);
    const [has201Report, setHas201Report] = useState(false);
    const [hasAttendanceReport, setHasAttendanceReport] = useState(false);
    const [hasBankTransmittalBDO, setHasBankTransmittalBDO] = useState(false);
    const [hasBankTransmittalBPI, setHasBankTransmittalBPI] = useState(false);
    const [hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings] = useState(false);
    const [hasBankTransmittalHSBC, setHasBankTransmittalHSBC] = useState(false);
    const [hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank] = useState(false);
    const [hasSummaryOfTardiness, setHasSummaryOfTardiness] = useState(false);
    const [hasAbsencesMemo, setHasAbsencesMemo] = useState(false);
    const [hasAbsencesReport, setHasAbsencesReport] = useState(false);
    const [hasActionHistoryReport, setHasActionHistoryReport] = useState(false);
    const [hasAllowanceSummary, setHasAllowanceSummary] = useState(false);
    const [hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup] = useState(false);
    const [hasBundyClockUsage, setHasBundyClockUsage] = useState(false);
    const [hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport] = useState(false);
    const [hasCertificateOfEmployment, setHasCertificateOfEmployment] = useState(false);
    const [hasCertificateOfPagibig, setHasCertificateOfPagibig] = useState(false);
    const [hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth] = useState(false);
    const [hasCertificateOfSSS, setHasCertificateOfSSS] = useState(false);
    const [hasCommissionsSummary, setHasCommissionsSummary] = useState(false);
    const [hasCostCenterReport, setHasCostCenterReport] = useState(false);
    const [hasDeductionsPerMonth, setHasDeductionsPerMonth] = useState(false);
    const [hasDTRReport, setHasDTRReport] = useState(false);
    const [hasEarningsPerMonth, setHasEarningsPerMonth] = useState(false);
    const [hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup] = useState(false);
    const [hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup] = useState(false);
    const [hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup] = useState(false);
    const [hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory] = useState(false);
    const [hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate] = useState(false);
    const [hasEmployeeRegister, setHasEmployeeRegister] = useState(false);
    const [hasExpenseReport, setHasExpenseReport] = useState(false);
    const [hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory] = useState(false);
    const [hasHeadcountReport, setHasHeadcountReport] = useState(false);
    const [hasHolidayPremiumSummary, setHasHolidayPremiumSummary] = useState(false);
    const [hasLeaveLedgerReport, setHasLeaveLedgerReport] = useState(false);
    const [hasLeaveSummaryReport, setHasLeaveSummaryReport] = useState(false);
    const [hasLoanHistory, setHasLoanHistory] = useState(false);
    const [hasLoanPaymentsSummary, setHasLoanPaymentsSummary] = useState(false);
    const [hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary] = useState(false);
    const [hasLoansPenaltyHistory, setHasLoansPenaltyHistory] = useState(false);
    const [hasNightDifferentialSummary, setHasNightDifferentialSummary] = useState(false);
    const [hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport] = useState(false);
    const [hasOtherEarningsReport, setHasOtherEarningsReport] = useState(false);
    const [hasOtherDeductionsSummary, setHasOtherDeductionsSummary] = useState(false);
    const [hasOutstandingLoans, setHasOutstandingLoans] = useState(false);
    const [hasPayrollCashRegister, setHasPayrollCashRegister] = useState(false);
    const [hasPayrollCheckRegister, setHasPayrollCheckRegister] = useState(false);
    const [hasPayrollDebitMemo, setHasPayrollDebitMemo] = useState(false);
    const [hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter] = useState(false);
    const [hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment] = useState(false);
    const [hasPayrollJournalBySummary, setHasPayrollJournalBySummary] = useState(false);
    const [hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod] = useState(false);
    const [hasSelectLogs, setHasSelectLogs] = useState(false);
    const [hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment] = useState(false);
    const [hasTardinessMemo, setHasTardinessMemo] = useState(false);
    const [hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport] = useState(false);
    const [hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport] = useState(false);
    const [hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary] = useState(false);
    const [hasTimesheetStatusReport, setHasTimesheetStatusReport] = useState(false);
    const [hasYTDDeductionSummary, setHasYTDDeductionSummary] = useState(false);
    const [hasYTDEarningsSummary, setHasYTDEarningsSummary] = useState(false);
    const [hasYTDPayrollRegister, setHasYTDPayrollRegister] = useState(false);
    const [hasNotification, setHasNotification] = useState(false);
    const [hasMobileBiometrics, setHasMobileBiometrics] = useState(false);
    const [hasRequestApprovalTimeKeeper, setHasRequestApprovalTimeKeeper] = useState(false);
    const [hasManHour, setHasManHour] = useState(false);
    const [hasYearlyReport, setHasYearlyReport] = useState(false);
    const [hasBIR2316, setHasBIR2316] = useState(false);
    const [hasBIR1601C, setHasBIR1601C] = useState(false);
    const [hasAlphaList, setHasAlphaList] = useState(false);
    const [hasLoanReport, setHasLoanReport] = useState(false);
    const [hasBankTransmittalReport, setHasBankTransmittalReport] = useState(false);

    const [hasOffsetCredits, setHasOffsetCredits] = useState(false);
    const [hasOffsetRequest, setHasOffsetRequest] = useState(false);
    const [hasEmployeeGroup1, setHasEmployeeGroup1] = useState(false);
    const [hasEmployeeGroup2, setHasEmployeeGroup2] = useState(false);
    const [hasOnBoarding, setHasOnBoarding] = useState(false);
    const [hasOnBoardingPersonnel, setHasOnBoardingPersonnel] = useState(false);
    const [hasOutBoarding, setHasOutBoarding] = useState(false);
    const [hasOnBoardingRequirements, setHasOnBoardingRequirements] = useState(false);
    const [hasOutBoardingRequirements, setHasOutBoardingRequirements] = useState(false);
    
    //Old 
    const [oldDescription, setOldDescription] = useState("");
    const [oldHasHome, setOldHasHome] = useState(false);
    const [oldHasAddEmployee, setOldHasAddEmployee] = useState(false);
    const [oldHasEmployeeList, setOldHasEmployeeList] = useState(false);
    const [oldHasEmployeeStatus, setOldHasEmployeeStatus] = useState(false);
    const [oldHasEmployeeSchedule, setOldHasEmployeeSchedule] = useState(false);
    const [oldHasTimeEntries, setOldHasTimeEntries] = useState(false);
    const [oldHasShiftSchedule, setOldHasShiftSchedule] = useState(false);
    const [oldHasProcessPayroll, setOldHasProcessPayroll] = useState(false);
    const [oldHasPayrollPeriod, setOldHasPayrollPeriod] = useState(false);
    const [oldHasPayType, setOldHasPayType] = useState(false);
    const [oldHasHoliday, setOldHasHoliday] = useState(false);
    const [oldHasHolidayType, setOldHasHolidayType] = useState(false);
    const [oldHasLeaveType, setOldHasLeaveType] = useState(false);
    const [oldHasDepartment, setOldHasDepartment] = useState(false);
    const [oldHasSection, setOldHasSection] = useState(false);
    const [oldHasClassification, setOldHasClassification] = useState(false);
    const [oldHasCompany, setOldHasCompany] = useState(false);
    const [oldHasPosition, setOldHasPosition] = useState(false);
    const [oldHasJobTitle, setOldHasJobTitle] = useState(false);
    const [oldHasLocation, setOldHasLocation] = useState(false);
    const [oldHasEmployeeMonthlySalary, setOldHasEmployeeMonthlySalary] = useState(false);
    const [oldHasEmployeeDailySalary, setOldHasEmployeeDailySalary] = useState(false);
    const [oldHasPositionDesignationSalary, setOldHasPositionDesignationSalary] = useState(false);
    const [oldHasEmployeeBankAccount, setOldHasEmployeeBankAccount] = useState(false);
    const [oldHasBIRTax, setOldHasBIRTax] = useState(false);
    const [oldHasPagibig, setOldHasPagibig] = useState(false);
    const [oldHasSSS, setOldHasSSS] = useState(false);
    const [oldHasPhilhealth, setOldHasPhilhealth] = useState(false);
    const [oldHasDTR, setOldHasDTR] = useState(false);
    const [oldHasDTRBiometrics, setOldHasDTRBiometrics] = useState(false);
    const [oldHasApproverHierarchy, setOldHasApproverHierarchy] = useState(false);
    const [oldHasRequestApproval, setOldHasRequestApproval] = useState(false);
    const [oldHasOvertime, setOldHasOvertime] = useState(false);
    const [oldHasDTRCorrection, setOldHasDTRCorrection] = useState(false);
    const [oldHasLeave, setOldHasLeave] = useState(false);
    const [oldHasChangeOfSchedule, setOldHasChangeOfSchedule] = useState(false);
    const [oldHasSSSLoan, setOldHasSSSLoan] = useState(false);
    const [oldHasSSSCalamityLoan, setOldHasSSSCalamityLoan] = useState(false);
    const [oldHasPagibigLoan, setOldHasPagibigLoan] = useState(false);
    const [oldHasPagibigCalamityLoan, setOldHasPagibigCalamityLoan] = useState(false);
    const [oldHasCashAdvance, setOldHasCashAdvance] = useState(false);
    const [oldHasDeductions, setOldHasDeductions] = useState(false);
    const [oldHasBenefits, setOldHasBenefits] = useState(false);
    const [oldHasReports, setOldHasReports] = useState(false);
    const [oldHasSettings, setOldHasSettings] = useState(false);
    const [oldHasCalendar, setOldHasCalendar] = useState(false);
    const [oldHasUser, setOldHasUser] = useState(false);
    const [oldUserTimeOut, setOldUserTimeOut] = useState("");

    // additional
    const [oldHasEmployeeReliever, setOldHasEmployeeReliever] = useState(false);
    const [oldHasMassApproval, setOldHasMassApproval] = useState(false);
    const [oldHasApproverHierarchyPerLocation, setOldHasApproverHierarchyPerLocation] = useState(false);
    const [oldHasFinalPay, setOldHasFinalPay] = useState(false);
    const [oldHasSubcon, setOldHasSubcon] = useState(false);
    const [oldHasAgency, setOldHasAgency] = useState(false);
    const [oldHasEmploymentStatus, setOldHasEmploymentStatus] = useState(false);
    const [oldHasLoans, setOldHasLoans] = useState(false);
    const [oldHasTimeKeeper, setOldHasTimeKeeper] = useState(false);
    const [oldHasPerDayTracker, setOldHasPerDayTracker] = useState(false);
    const [oldHasOvertimeSummaryReport, setOldHasOvertimeSummaryReport] = useState(false);
    const [oldHasTrackerReport, setOldHasTrackerReport] = useState(false);
    const [oldHasPayslip, setOldHasPayslip] = useState(false);
    const [oldHasPayrollRegister, setOldHasPayrollRegister] = useState(false);
    const [oldHasResigned, setOldHasResigned] = useState(false);
    const [oldHasActiveEmployees, setOldHasActiveEmployees] = useState(false);
    const [oldHasYearOfService, setOldHasYearOfService] = useState(false);
    const [oldHasSSSSummary, setOldHasSSSSummary] = useState(false);
    const [oldHasPagibigSummary, setOldHasPagibigSummary] = useState(false);
    const [oldHasPhilhealthSummary, setOldHasPhilhealthSummary] = useState(false);
    const [oldHasSSSLoanReport, setOldHasSSSLoanReport] = useState(false);
    const [oldHasPagibigLoanReport, setOldHasPagibigLoanReport] = useState(false);
    const [oldHas201Report, setOldHas201Report] = useState(false);
    const [oldHasAttendanceReport, setOldHasAttendanceReport] = useState(false);
    const [oldHasBankTransmittalBDO, setOldHasBankTransmittalBDO] = useState(false);
    const [oldHasBankTransmittalBPI, setOldHasBankTransmittalBPI] = useState(false);
    const [oldHasBankTransmittalChinaBankSavings, setOldHasBankTransmittalChinaBankSavings] = useState(false);
    const [oldHasBankTransmittalHSBC, setOldHasBankTransmittalHSBC] = useState(false);
    const [oldHasBankTransmittalSecurityBank, setOldHasBankTransmittalSecurityBank] = useState(false);
    const [oldHasSummaryOfTardiness, setOldHasSummaryOfTardiness] = useState(false);
    const [oldHasAbsencesMemo, setOldHasAbsencesMemo] = useState(false);
    const [oldHasAbsencesReport, setOldHasAbsencesReport] = useState(false);
    const [oldHasActionHistoryReport, setOldHasActionHistoryReport] = useState(false);
    const [oldHasAllowanceSummary, setOldHasAllowanceSummary] = useState(false);
    const [oldHasAuditTrailReportEmployeeSetup, setOldHasAuditTrailReportEmployeeSetup] = useState(false);
    const [oldHasBundyClockUsage, setOldHasBundyClockUsage] = useState(false);
    const [oldHasBasicPayAdjustmentReport, setOldHasBasicPayAdjustmentReport] = useState(false);
    const [oldHasCertificateOfEmployment, setOldHasCertificateOfEmployment] = useState(false);
    const [oldHasCertificateOfPagibig, setOldHasCertificateOfPagibig] = useState(false);
    const [oldHasCertificateOfPhilhealth, setOldHasCertificateOfPhilhealth] = useState(false);
    const [oldHasCertificateOfSSS, setOldHasCertificateOfSSS] = useState(false);
    const [oldHasCommissionsSummary, setOldHasCommissionsSummary] = useState(false);
    const [oldHasCostCenterReport, setOldHasCostCenterReport] = useState(false);
    const [oldHasDeductionsPerMonth, setOldHasDeductionsPerMonth] = useState(false);
    const [oldHasDTRReport, setOldHasDTRReport] = useState(false);
    const [oldHasEarningsPerMonth, setOldHasEarningsPerMonth] = useState(false);
    const [oldHasEmployeeLeaveGroup, setOldHasEmployeeLeaveGroup] = useState(false);
    const [oldHasEmployeeOvertimeGroup, setOldHasEmployeeOvertimeGroup] = useState(false);
    const [oldHasEmployeeExpenseGroup, setOldHasEmployeeExpenseGroup] = useState(false);
    const [oldHasEmployeeLeaveHistory, setOldHasEmployeeLeaveHistory] = useState(false);
    const [oldHasEmployeeListingByHiringDate, setOldHasEmployeeListingByHiringDate] = useState(false);
    const [oldHasEmployeeRegister, setOldHasEmployeeRegister] = useState(false);
    const [oldHasExpenseReport, setOldHasExpenseReport] = useState(false);
    const [oldHasGovernmentEmployeeInventory, setOldHasGovernmentEmployeeInventory] = useState(false);
    const [oldHasHeadcountReport, setOldHasHeadcountReport] = useState(false);
    const [oldHasHolidayPremiumSummary, setOldHasHolidayPremiumSummary] = useState(false);
    const [oldHasLeaveLedgerReport, setOldHasLeaveLedgerReport] = useState(false);
    const [oldHasLeaveSummaryReport, setOldHasLeaveSummaryReport] = useState(false);
    const [oldHasLoanHistory, setOldHasLoanHistory] = useState(false);
    const [oldHasLoanPaymentsSummary, setOldHasLoanPaymentsSummary] = useState(false);
    const [oldHasLoansMonthlyAmortizationSummary, setOldHasLoansMonthlyAmortizationSummary] = useState(false);
    const [oldHasLoansPenaltyHistory, setOldHasLoansPenaltyHistory] = useState(false);
    const [oldHasNightDifferentialSummary, setOldHasNightDifferentialSummary] = useState(false);
    const [oldHasNonTaxableAllowancesReport, setOldHasNonTaxableAllowancesReport] = useState(false);
    const [oldHasOtherEarningsReport, setOldHasOtherEarningsReport] = useState(false);
    const [oldHasOtherDeductionsSummary, setOldHasOtherDeductionsSummary] = useState(false);
    const [oldHasOutstandingLoans, setOldHasOutstandingLoans] = useState(false);
    const [oldHasPayrollCashRegister, setOldHasPayrollCashRegister] = useState(false);
    const [oldHasPayrollCheckRegister, setOldHasPayrollCheckRegister] = useState(false);
    const [oldHasPayrollDebitMemo, setOldHasPayrollDebitMemo] = useState(false);
    const [oldHasPayrollJournalByCostCenter, setOldHasPayrollJournalByCostCenter] = useState(false);
    const [oldHasPayrollJournalByDepartment, setOldHasPayrollJournalByDepartment] = useState(false);
    const [oldHasPayrollJournalBySummary, setOldHasPayrollJournalBySummary] = useState(false);
    const [oldHasPayrollPerPaymentMethod, setOldHasPayrollPerPaymentMethod] = useState(false);
    const [oldHasSelectLogs, setOldHasSelectLogs] = useState(false);
    const [oldHasSummaryReportByMonthAndDepartment, setOldHasSummaryReportByMonthAndDepartment] = useState(false);
    const [oldHasTardinessMemo, setOldHasTardinessMemo] = useState(false);
    const [oldHasTimeKeepingHistoryDetailedReport, setOldHasTimeKeepingHistoryDetailedReport] = useState(false);
    const [oldHasTimeKeepingHoursWorkedReport, setOldHasTimeKeepingHoursWorkedReport] = useState(false);
    const [oldHasTimeKeepingHoursWorkedSummary, setOldHasTimeKeepingHoursWorkedSummary] = useState(false);
    const [oldHasTimesheetStatusReport, setOldHasTimesheetStatusReport] = useState(false);
    const [oldHasYTDeductionSummary, setOldHasYTDeductionSummary] = useState(false);
    const [oldHasYTDEarningsSummary, setOldHasYTDearningsSummary] = useState(false);
    const [oldHasYTDPayrollRegister, setOldHasYTDPayrollRegister] = useState(false);
    const [oldHasNotification, setOldHasNotification] = useState(false);
    const [oldHasMobileBiometrics, setOldHasMobileBiometrics] = useState(false);
    const [oldHasRequestApprovalTimeKeeper, setOldHasRequestApprovalTimeKeeper] = useState(false);

    //retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("template name");
    //update
    const [isEditState, setIsEditState] = useState(false);
    const [dataToEdit, setDataToEdit] = useState([]);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [dataToDelete, setDataToDelete] = useState([]);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/AccessTemplate";

    const fetchData =  useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setUserTempalte(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);
    

    useEffect(() => {
        fetchData();

        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("template name")
                break;
            case 1:
                setSearchPlaceholder("template id")
                break;
            default:
                setSearchPlaceholder("description")
                break;
        }
    }, [fetchData, filterDataIndex]);

    useEffect(() => {
        if(isEditState){
            setDescription(dataToEdit.description);
            setHasHome(dataToEdit.hasHome);
            setHasAddEmployee(dataToEdit.hasAddEmployee);
            setHasEmployeeList(dataToEdit.hasEmployeeList);
            setHasEmployeeStatus(dataToEdit.hasEmployeeStatus);
            setHasEmployeeSchedule(dataToEdit.hasEmployeeSchedule);
            setHasTimeEntries(dataToEdit.hasTimeEntries);
            setHasShiftSchedule(dataToEdit.hasShiftSchedule);
            setHasProcessPayroll(dataToEdit.hasProcessPayroll);
            setHas13thMonth(dataToEdit.has13thMonth);
            setHasPayrollPeriod(dataToEdit.hasPayrollPeriod);
            setHasPayType(dataToEdit.hasPayType);
            setHasClient(dataToEdit.hasClient);
            setHasHoliday(dataToEdit.hasHoliday);
            setHasHolidayType(dataToEdit.hasHolidayType);
            setHasLeaveType(dataToEdit.hasLeaveType);
            setHasDepartment(dataToEdit.hasDepartment);
            setHasSection(dataToEdit.hasSection);
            setHasClassification(dataToEdit.hasClassification);
            setHasCompany(dataToEdit.hasCompany);
            setHasPosition(dataToEdit.hasPosition);
            setHasJobTitle(dataToEdit.hasJobTitle);
            setHasLocation(dataToEdit.hasLocation);
            setHasDTRRulesConfiguration(dataToEdit.hasDTRRulesConfiguration);
            setHasEmployeeMonthlySalary(dataToEdit.hasEmployeeMonthlySalary);
            setHasEmployeeDailySalary(dataToEdit.hasEmployeeDailySalary);
            setHasPositionDesignationSalary(dataToEdit.hasPositionDesignationSalary);
            setHasQuotaBasedSalary(dataToEdit.hasQuotaBasedSalary);
            setHasPositionDesignationSalaryLaUnion(dataToEdit.hasPositionDesignationSalaryLaUnion);
            setHasEmployeeBankAccount(dataToEdit.hasEmployeeBankAccount);
            setHasBIRTax(dataToEdit.hasBIRTax);
            setHasPagibig(dataToEdit.hasPagibig);
            setHasSSS(dataToEdit.hasSSS);
            setHasPhilhealth(dataToEdit.hasPhilhealth);
            setHasDTR(dataToEdit.hasDTR);
            setHasDTRBiometrics(dataToEdit.hasDTRBiometrics);
            setHasApproverHierarchy(dataToEdit.hasApproverHierarchy);
            setHasRequestApproval(dataToEdit.hasRequestApproval);
            setHasOvertime(dataToEdit.hasOvertime);
            setHasDTRCorrection(dataToEdit.hasDTRCorrection);
            setHasLeave(dataToEdit.hasLeave);
            setHasChangeOfSchedule(dataToEdit.hasChangeOfSchedule);
            setHasSSSLoan(dataToEdit.hasSSSLoan);
            setHasSSSCalamityLoan(dataToEdit.hasSSSCalamityLoan);
            setHasPagibigLoan(dataToEdit.hasPagibigLoan);
            setHasPagibigCalamityLoan(dataToEdit.hasPagibigCalamityLoan);
            setHasCashAdvance(dataToEdit.hasCashAdvance);
            setHasDeductions(dataToEdit.hasDeductions);
            setHasBenefits(dataToEdit.hasBenefits);
            setHasReports(dataToEdit.hasReports);
            setHasSettings(dataToEdit.hasSettings);
            setHasCalendar(dataToEdit.hasCalendar);
            setHasUser(dataToEdit.hasUser);
            setUserTimeOut(dataToEdit.userTimeOut);

            // additional
            setHasEmployeereliever(dataToEdit.hasEmployeereliever);
            setHasMassapproval(dataToEdit.hasMassapproval);
            setHasApproverheirarchyperlocation(dataToEdit.hasApproverheirarchyperlocation);
            setHasFinalPay(dataToEdit.hasFinalPay);
            setHasSubcon(dataToEdit.hasSubcon);
            setHasAgency(dataToEdit.hasAgency);
            setHasEmploymentStatus(dataToEdit.hasEmploymentStatus);
            setHasLoans(dataToEdit.hasLoans);
            setHasTimeKeeper(dataToEdit.hasTimeKeeper);
            setHasPerDayTracker(dataToEdit.hasPerDayTracker);
            setHasOvertimeSummaryReport(dataToEdit.hasOvertimeSummaryReport);
            setHasTrackerReport(dataToEdit.hasTrackerReport);
            setHasPayslip(dataToEdit.hasPayslip);
            setHasPayrollRegister(dataToEdit.hasPayrollRegister);
            setHasResigned(dataToEdit.hasResigned);
            setHasActiveEmployees(dataToEdit.hasActiveEmployees);
            setHasYearofService(dataToEdit.hasYearofService);
            setHasSSSSummary(dataToEdit.hasSSSSummary);
            setHasPagibigSummary(dataToEdit.hasPagibigSummary);
            setHasPhilhealthSummary(dataToEdit.hasPhilhealthSummary);
            setHasSSSLoanReport(dataToEdit.hasSSSLoanReport);
            setHasPagibigLoanReport(dataToEdit.hasPagibigLoanReport);
            setHas201Report(dataToEdit.has201Report);
            setHasAttendanceReport(dataToEdit.hasAttendanceReport);
            setHasBankTransmittalBDO(dataToEdit.hasBankTransmittalBDO);
            setHasBankTransmittalBPI(dataToEdit.hasBankTransmittalBPI);
            setHasBankTransmittalChinaBankSavings(dataToEdit.hasBankTransmittalChinaBankSavings);
            setHasBankTransmittalHSBC(dataToEdit.hasBankTransmittalHSBC);
            setHasBankTransmittalSecurityBank(dataToEdit.hasBankTransmittalSecurityBank);
            setHasSummaryOfTardiness(dataToEdit.hasSummaryOfTardiness);
            setHasAbsencesMemo(dataToEdit.hasAbsencesMemo);
            setHasAbsencesReport(dataToEdit.hasAbsencesReport);
            setHasActionHistoryReport(dataToEdit.hasActionHistoryReport);
            setHasAllowanceSummary(dataToEdit.hasAllowanceSummary);
            setHasAuditTrailReportEmployeeSetup(dataToEdit.hasAuditTrailReportEmployeeSetup);
            setHasBundyClockUsage(dataToEdit.hasBundyClockUsage);
            setHasBasicPayAdjustmentReport(dataToEdit.hasBasicPayAdjustmentReport);
            setHasCertificateOfEmployment(dataToEdit.hasCertificateOfEmployment);
            setHasCertificateOfPagibig(dataToEdit.hasCertificateOfPagibig);
            setHasCertificateOfPhilhealth(dataToEdit.hasCertificateOfPhilhealth);
            setHasCertificateOfSSS(dataToEdit.hasCertificateOfSSS);
            setHasCommissionsSummary(dataToEdit.hasCommissionsSummary);
            setHasCostCenterReport(dataToEdit.hasCostCenterReport);
            setHasDeductionsPerMonth(dataToEdit.hasDeductionsPerMonth);
            setHasDTRReport(dataToEdit.hasDTRReport);
            setHasEarningsPerMonth(dataToEdit.hasEarningsPerMonth);
            setHasEmployeeLeaveGroup(dataToEdit.hasEmployeeLeaveGroup);
            setHasEmployeeOvertimeGroup(dataToEdit.hasEmployeeOvertimeGroup);
            setHasEmployeeExpenseGroup(dataToEdit.hasEmployeeExpenseGroup);
            setHasEmployeeLeaveHistory(dataToEdit.hasEmployeeLeaveHistory);
            setHasEmployeeListingByHiringDate(dataToEdit.hasEmployeeListingByHiringDate);
            setHasEmployeeRegister(dataToEdit.hasEmployeeRegister);
            setHasExpenseReport(dataToEdit.hasExpenseReport);
            setHasGovernmentEmployeeInventory(dataToEdit.hasGovernmentEmployeeInventory);
            setHasHeadcountReport(dataToEdit.hasHeadcountReport);
            setHasHolidayPremiumSummary(dataToEdit.hasHolidayPremiumSummary);
            setHasLeaveLedgerReport(dataToEdit.hasLeaveLedgerReport);
            setHasLeaveSummaryReport(dataToEdit.hasLeaveSummaryReport);
            setHasLoanHistory(dataToEdit.hasLoanHistory);
            setHasLoanPaymentsSummary(dataToEdit.hasLoanPaymentsSummary);
            setHasLoansMonthlyAmortizationSummary(dataToEdit.hasLoansMonthlyAmortizationSummary);
            setHasLoansPenaltyHistory(dataToEdit.hasLoansPenaltyHistory);
            setHasNightDifferentialSummary(dataToEdit.hasNightDifferentialSummary);
            setHasNonTaxableAllowancesReport(dataToEdit.hasNonTaxableAllowancesReport);
            setHasOtherEarningsReport(dataToEdit.hasOtherEarningsReport);
            setHasOtherDeductionsSummary(dataToEdit.hasOtherDeductionsSummary);
            setHasOutstandingLoans(dataToEdit.hasOutstandingLoans);
            setHasPayrollCashRegister(dataToEdit.hasPayrollCashRegister);
            setHasPayrollCheckRegister(dataToEdit.hasPayrollCheckRegister);
            setHasPayrollDebitMemo(dataToEdit.hasPayrollDebitMemo);
            setHasPayrollJournalByCostCenter(dataToEdit.hasPayrollJournalByCostCenter);
            setHasPayrollJournalByDepartment(dataToEdit.hasPayrollJournalByDepartment);
            setHasPayrollJournalBySummary(dataToEdit.hasPayrollJournalBySummary);
            setHasPayrollPerPaymentMethod(dataToEdit.hasPayrollPerPaymentMethod);
            setHasSelectLogs(dataToEdit.hasSelectLogs);
            setHasSummaryReportByMonthAndDepartment(dataToEdit.hasSummaryReportByMonthAndDepartment);
            setHasTardinessMemo(dataToEdit.hasTardinessMemo);
            setHasTimeKeepingHistoryDetailedReport(dataToEdit.hasTimeKeepingHistoryDetailedReport);
            setHasTimeKeepingHoursWorkedReport(dataToEdit.hasTimeKeepingHoursWorkedReport);
            setHasTimeKeepingHoursWorkedSummary(dataToEdit.hasTimeKeepingHoursWorkedSummary);
            setHasTimesheetStatusReport(dataToEdit.hasTimesheetStatusReport);
            setHasYTDDeductionSummary(dataToEdit.hasYTDDeductionSummary);
            setHasYTDEarningsSummary(dataToEdit.hasYTDEarningsSummary);
            setHasYTDPayrollRegister(dataToEdit.hasYTDPayrollRegister);
            setHasNotification(dataToEdit.hasNotification);
            setHasMobileBiometrics(dataToEdit.hasMobileBiometrics);
            setHasRequestApprovalTimeKeeper(dataToEdit.hasRequestApprovalTimeKeeper);
            setHasTamperedApproval(dataToEdit.hasTamperedApproval);
            setHasMobileDTRApproval(dataToEdit.hasMobileDTRApproval);
            setHasDTRWithOTViewing(dataToEdit.hasDTRWithOTViewing);
            setHasDTRCorrectionWorkers(dataToEdit.hasDTRCorrectionWorkers);
            setHasPlantilya(dataToEdit.hasPlantilya);
            setHasCostCenter(dataToEdit.hasCostCenter);
            setHasPayrollJournalAccount(dataToEdit.hasPayrollJournalAccount);
            setHasManHour(dataToEdit.hasManHour);
            setHasYearlyReport(dataToEdit.hasYearlyReport);
            setHasBIR2316(dataToEdit.hasBIR2316);
            setHasBIR1601C(dataToEdit.hasBIR1601C);
            setHasAlphaList(dataToEdit.hasAlphaList);
            setHasLoanReport(dataToEdit.hasLoanReport);
            setHasBankTransmittalReport(dataToEdit.hasBankTransmittalReport);
            setHasOffsetCredits(dataToEdit.hasOffsetCredits);
            setHasOffsetRequest(dataToEdit.hasOffsetRequest);
            setHasEmployeeGroup1(dataToEdit.hasEmployeeGroup1);
            setHasEmployeeGroup2(dataToEdit.hasEmployeeGroup2);
            setHasOnBoarding(dataToEdit.hasOnBoarding);
            setHasOnBoardingPersonnel(dataToEdit.hasOnBoardingPersonnel);
            setHasOutBoarding(dataToEdit.hasOutBoarding);
            setHasOnBoardingRequirements(dataToEdit.hasOnBoardingRequirements);
            setHasOutBoardingRequirements(dataToEdit.hasOutBoardingRequirements);

            setOldDescription(dataToEdit.description);
            setOldHasHome(dataToEdit.hasHome);
            setOldHasAddEmployee(dataToEdit.hasAddEmployee);
            setOldHasEmployeeList(dataToEdit.hasEmployeeList);
            setOldHasEmployeeStatus(dataToEdit.hasEmployeeStatus);
            setOldHasEmployeeSchedule(dataToEdit.hasEmployeeSchedule);
            setOldHasTimeEntries(dataToEdit.hasTimeEntries);
            setOldHasShiftSchedule(dataToEdit.hasShiftSchedule);
            setOldHasProcessPayroll(dataToEdit.hasProcessPayroll);
            setOldHasPayrollPeriod(dataToEdit.hasPayrollPeriod);
            setOldHasPayType(dataToEdit.hasPayType);
            setOldHasHoliday(dataToEdit.hasHoliday);
            setOldHasHolidayType(dataToEdit.hasHolidayType);
            setOldHasLeaveType(dataToEdit.hasLeaveType);
            setOldHasDepartment(dataToEdit.hasDepartment);
            setOldHasSection(dataToEdit.hasSection);
            setOldHasClassification(dataToEdit.hasClassification);
            setOldHasCompany(dataToEdit.hasCompany);
            setOldHasPosition(dataToEdit.hasPosition);
            setOldHasJobTitle(dataToEdit.hasJobTitle);
            setOldHasLocation(dataToEdit.hasLocation);
            setOldHasEmployeeMonthlySalary(dataToEdit.hasEmployeeMonthlySalary);
            setOldHasEmployeeDailySalary(dataToEdit.hasEmployeeDailySalary);
            setOldHasPositionDesignationSalary(dataToEdit.hasPositionDesignationSalary);
            setOldHasEmployeeBankAccount(dataToEdit.hasEmployeeBankAccount);
            setOldHasBIRTax(dataToEdit.hasBIRTax);
            setOldHasPagibig(dataToEdit.hasPagibig);
            setOldHasSSS(dataToEdit.hasSSS);
            setOldHasPhilhealth(dataToEdit.hasPhilhealth);
            setOldHasDTR(dataToEdit.hasDTR);
            setOldHasDTRBiometrics(dataToEdit.hasDTRBiometrics);
            setOldHasApproverHierarchy(dataToEdit.hasApproverHierarchy);
            setOldHasRequestApproval(dataToEdit.hasRequestApproval);
            setOldHasOvertime(dataToEdit.hasOvertime);
            setOldHasDTRCorrection(dataToEdit.hasDTRCorrection);
            setOldHasLeave(dataToEdit.hasLeave);
            setOldHasChangeOfSchedule(dataToEdit.hasChangeOfSchedule);
            setOldHasSSSLoan(dataToEdit.hasSSSLoan);
            setOldHasSSSCalamityLoan(dataToEdit.hasSSSCalamityLoan);
            setOldHasPagibigLoan(dataToEdit.hasPagibigLoan);
            setOldHasPagibigCalamityLoan(dataToEdit.hasPagibigCalamityLoan);
            setOldHasCashAdvance(dataToEdit.hasCashAdvance);
            setOldHasDeductions(dataToEdit.hasDeductions);
            setOldHasBenefits(dataToEdit.hasBenefits);
            setOldHasReports(dataToEdit.hasReports);
            setOldHasSettings(dataToEdit.hasSettings);
            setOldHasCalendar(dataToEdit.hasCalendar);
            setOldHasUser(dataToEdit.hasUser);
            setOldUserTimeOut(dataToEdit.userTimeOut);

            // additional
            setOldHasEmployeeReliever(dataToEdit.hasEmployeereliever);
            setOldHasMassApproval(dataToEdit.hasMassapproval);
            setOldHasApproverHierarchyPerLocation(dataToEdit.hasApproverheirarchyperlocation);
            setOldHasFinalPay(dataToEdit.hasFinalPay);
            setOldHasSubcon(dataToEdit.hasSubcon);
            setOldHasAgency(dataToEdit.hasAgency);
            setOldHasEmploymentStatus(dataToEdit.hasEmploymentStatus);
            setOldHasLoans(dataToEdit.hasLoans);
            setOldHasTimeKeeper(dataToEdit.hasTimeKeeper);
            setOldHasPerDayTracker(dataToEdit.hasPerDayTracker);
            setOldHasOvertimeSummaryReport(dataToEdit.hasOvertimeSummaryReport);
            setOldHasTrackerReport(dataToEdit.hasTrackerReport);
            setOldHasPayslip(dataToEdit.hasPayslip);
            setOldHasPayrollRegister(dataToEdit.hasPayrollRegister);
            setOldHasResigned(dataToEdit.hasResigned);
            setOldHasActiveEmployees(dataToEdit.hasActiveEmployees);
            setOldHasYearOfService(dataToEdit.hasYearofService);
            setOldHasSSSSummary(dataToEdit.hasSSSSummary);
            setOldHasPagibigSummary(dataToEdit.hasPagibigSummary);
            setOldHasPhilhealthSummary(dataToEdit.hasPhilhealthSummary);
            setOldHasSSSLoanReport(dataToEdit.hasSSSLoanReport);
            setOldHasPagibigLoanReport(dataToEdit.hasPagibigLoanReport);
            setOldHas201Report(dataToEdit.has201Report);
            setOldHasAttendanceReport(dataToEdit.hasAttendanceReport);
            setOldHasBankTransmittalBDO(dataToEdit.hasBankTransmittalBDO);
            setOldHasBankTransmittalBPI(dataToEdit.hasBankTransmittalBPI);
            setOldHasBankTransmittalChinaBankSavings(dataToEdit.hasBankTransmittalChinaBankSavings);
            setOldHasBankTransmittalHSBC(dataToEdit.hasBankTransmittalHSBC);
            setOldHasBankTransmittalSecurityBank(dataToEdit.hasBankTransmittalSecurityBank);
            setOldHasSummaryOfTardiness(dataToEdit.hasSummaryOfTardiness);
            setOldHasAbsencesMemo(dataToEdit.hasAbsencesMemo);
            setOldHasAbsencesReport(dataToEdit.hasAbsencesReport);
            setOldHasActionHistoryReport(dataToEdit.hasActionHistoryReport);
            setOldHasAllowanceSummary(dataToEdit.hasAllowanceSummary);
            setOldHasAuditTrailReportEmployeeSetup(dataToEdit.hasAuditTrailReportEmployeeSetup);
            setOldHasBundyClockUsage(dataToEdit.hasBundyClockUsage);
            setOldHasBasicPayAdjustmentReport(dataToEdit.hasBasicPayAdjustmentReport);
            setOldHasCertificateOfEmployment(dataToEdit.hasCertificateOfEmployment);
            setOldHasCertificateOfPagibig(dataToEdit.hasCertificateOfPagibig);
            setOldHasCertificateOfPhilhealth(dataToEdit.hasCertificateOfPhilhealth);
            setOldHasCertificateOfSSS(dataToEdit.hasCertificateOfSSS);
            setOldHasCommissionsSummary(dataToEdit.hasCommissionsSummary);
            setOldHasCostCenterReport(dataToEdit.hasCostCenterReport);
            setOldHasDeductionsPerMonth(dataToEdit.hasDeductionsPerMonth);
            setOldHasDTRReport(dataToEdit.hasDTRReport);
            setOldHasEarningsPerMonth(dataToEdit.hasEarningsPerMonth);
            setOldHasEmployeeLeaveGroup(dataToEdit.hasEmployeeLeaveGroup);
            setOldHasEmployeeOvertimeGroup(dataToEdit.hasEmployeeOvertimeGroup);
            setOldHasEmployeeExpenseGroup(dataToEdit.hasEmployeeExpenseGroup);
            setOldHasEmployeeLeaveHistory(dataToEdit.hasEmployeeLeaveHistory);
            setOldHasEmployeeListingByHiringDate(dataToEdit.hasEmployeeListingByHiringDate);
            setOldHasEmployeeRegister(dataToEdit.hasEmployeeRegister);
            setOldHasExpenseReport(dataToEdit.hasExpenseReport);
            setOldHasGovernmentEmployeeInventory(dataToEdit.hasGovernmentEmployeeInventory);
            setOldHasHeadcountReport(dataToEdit.hasHeadcountReport);
            setOldHasHolidayPremiumSummary(dataToEdit.hasHolidayPremiumSummary);
            setOldHasLeaveLedgerReport(dataToEdit.hasLeaveLedgerReport);
            setOldHasLeaveSummaryReport(dataToEdit.hasLeaveSummaryReport);
            setOldHasLoanHistory(dataToEdit.hasLoanHistory);
            setOldHasLoanPaymentsSummary(dataToEdit.hasLoanPaymentsSummary);
            setOldHasLoansMonthlyAmortizationSummary(dataToEdit.hasLoansMonthlyAmortizationSummary);
            setOldHasLoansPenaltyHistory(dataToEdit.hasLoansPenaltyHistory);
            setOldHasNightDifferentialSummary(dataToEdit.hasNightDifferentialSummary);
            setOldHasNonTaxableAllowancesReport(dataToEdit.hasNonTaxableAllowancesReport);
            setOldHasOtherEarningsReport(dataToEdit.hasOtherEarningsReport);
            setOldHasOtherDeductionsSummary(dataToEdit.hasOtherDeductionsSummary);
            setOldHasOutstandingLoans(dataToEdit.hasOutstandingLoans);
            setOldHasPayrollCashRegister(dataToEdit.hasPayrollCashRegister);
            setOldHasPayrollCheckRegister(dataToEdit.hasPayrollCheckRegister);
            setOldHasPayrollDebitMemo(dataToEdit.hasPayrollDebitMemo);
            setOldHasPayrollJournalByCostCenter(dataToEdit.hasPayrollJournalByCostCenter);
            setOldHasPayrollJournalByDepartment(dataToEdit.hasPayrollJournalByDepartment);
            setOldHasPayrollJournalBySummary(dataToEdit.hasPayrollJournalBySummary);
            setOldHasPayrollPerPaymentMethod(dataToEdit.hasPayrollPerPaymentMethod);
            setOldHasSelectLogs(dataToEdit.hasSelectLogs);
            setOldHasSummaryReportByMonthAndDepartment(dataToEdit.hasSummaryReportByMonthAndDepartment);
            setOldHasTardinessMemo(dataToEdit.hasTardinessMemo);
            setOldHasTimeKeepingHistoryDetailedReport(dataToEdit.hasTimeKeepingHistoryDetailedReport);
            setOldHasTimeKeepingHoursWorkedReport(dataToEdit.hasTimeKeepingHoursWorkedReport);
            setOldHasTimeKeepingHoursWorkedSummary(dataToEdit.hasTimeKeepingHoursWorkedSummary);
            setOldHasTimesheetStatusReport(dataToEdit.hasTimesheetStatusReport);
            setOldHasYTDeductionSummary(dataToEdit.hasYTDDeductionSummary);
            setOldHasYTDearningsSummary(dataToEdit.hasYTDEarningsSummary);
            setOldHasYTDPayrollRegister(dataToEdit.hasYTDPayrollRegister);
            setOldHasNotification(dataToEdit.hasNotification);
            setOldHasMobileBiometrics(dataToEdit.hasMobileBiometrics);
            setOldHasRequestApprovalTimeKeeper(dataToEdit.hasRequestApprovalTimeKeeper);
        }
    }, [isEditState, dataToEdit])

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setUserTempalte(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            description: description,
            hasHome: hasHome,
            hasAddEmployee: hasAddEmployee,
            hasEmployeeList: hasEmployeeList,
            hasEmployeeStatus: hasEmployeeStatus,
            hasEmployeeSchedule: hasEmployeeSchedule,
            hasTimeEntries: hasTimeEntries,
            hasShiftSchedule: hasShiftSchedule,
            hasProcessPayroll: hasProcessPayroll,
            has13thMonth: has13thMonth,
            hasPayrollPeriod: hasPayrollPeriod,
            hasClient: hasClient,
            hasPayType: hasPayType,
            hasHoliday: hasHoliday,
            hasHolidayType: hasHolidayType,
            hasLeaveType: hasLeaveType,
            hasDepartment: hasDepartment,
            hasSection: hasSection,
            hasClassification: hasClassification,
            hasCompany: hasCompany,
            hasPosition: hasPosition,
            hasJobTitle: hasJobTitle,
            hasLocation: hasLocation,
            hasOffsetCredits: hasOffsetCredits,
            hasOffsetRequest: hasOffsetRequest,
            hasEmployeeGroup1: hasEmployeeGroup1,
            hasEmployeeGroup2: hasEmployeeGroup2,
            hasOnBoarding: hasOnBoarding,
            hasOnBoardingPersonnel: hasOnBoardingPersonnel,
            hasOutBoarding: hasOutBoarding,
            hasOnBoardingRequirements: hasOnBoardingRequirements,
            hasOutBoardingRequirements: hasOutBoardingRequirements,
            hasDTRRulesConfiguration: hasDTRRulesConfiguration,
            hasEmployeeMonthlySalary: hasEmployeeMonthlySalary,
            hasEmployeeDailySalary: hasEmployeeDailySalary,
            hasPositionDesignationSalary: hasPositionDesignationSalary,
            hasQuotaBasedSalary: hasQuotaBasedSalary,
            hasPositionDesignationSalaryLaUnion: hasPositionDesignationSalaryLaUnion,
            hasEmployeeBankAccount: hasEmployeeBankAccount,
            hasBIRTax: hasBIRTax,
            hasPagibig: hasPagibig,
            hasSSS: hasSSS,
            hasPhilhealth: hasPhilhealth,
            hasDTR: hasDTR,
            hasDTRBiometrics: hasDTRBiometrics,
            hasApproverHierarchy: hasApproverHierarchy,
            hasRequestApproval: hasRequestApproval,
            hasOvertime: hasOvertime,
            hasDTRCorrection: hasDTRCorrection,
            hasLeave: hasLeave,
            hasChangeOfSchedule: hasChangeOfSchedule,
            hasSSSLoan: hasSSSLoan,
            hasSSSCalamityLoan: hasSSSCalamityLoan,
            hasPagibigLoan: hasPagibigLoan,
            hasPagibigCalamityLoan: hasPagibigCalamityLoan,
            hasCashAdvance: hasCashAdvance,
            hasDeductions: hasDeductions,
            hasBenefits: hasBenefits,
            hasReports: hasReports,
            hasSettings: hasSettings,
            hasCalendar: hasCalendar,
            hasUser: hasUser,
            hasEmployeereliever: hasEmployeereliever,
            hasMassapproval: hasMassapproval,
            hasApproverheirarchyperlocation: hasApproverheirarchyperlocation,
            hasFinalPay: hasFinalPay,
            hasSubcon: hasSubcon,
            hasAgency: hasAgency,
            hasEmploymentStatus: hasEmploymentStatus,
            hasLoans: hasLoans,
            hasTimeKeeper: hasTimeKeeper,
            hasPerDayTracker: hasPerDayTracker,
            hasOvertimeSummaryReport: hasOvertimeSummaryReport,
            hasTrackerReport: hasTrackerReport,
            hasPayslip: hasPayslip,
            hasPayrollRegister: hasPayrollRegister,
            hasResigned: hasResigned,
            hasActiveEmployees: hasActiveEmployees,
            hasYearofService: hasYearofService,
            hasSSSSummary: hasSSSSummary,
            hasPagibigSummary: hasPagibigSummary,
            hasPhilhealthSummary: hasPhilhealthSummary,
            hasSSSLoanReport: hasSSSLoanReport,
            hasPagibigLoanReport: hasPagibigLoanReport,
            has201Report: has201Report,
            hasAttendanceReport: hasAttendanceReport,
            hasBankTransmittalBDO: hasBankTransmittalBDO,
            hasBankTransmittalBPI: hasBankTransmittalBPI,
            hasBankTransmittalChinaBankSavings: hasBankTransmittalChinaBankSavings,
            hasBankTransmittalHSBC: hasBankTransmittalHSBC,
            hasBankTransmittalSecurityBank: hasBankTransmittalSecurityBank,
            hasSummaryOfTardiness: hasSummaryOfTardiness,
            hasAbsencesMemo: hasAbsencesMemo,
            hasAbsencesReport: hasAbsencesReport,
            hasActionHistoryReport: hasActionHistoryReport,
            hasAllowanceSummary: hasAllowanceSummary,
            hasAuditTrailReportEmployeeSetup: hasAuditTrailReportEmployeeSetup,
            hasBundyClockUsage: hasBundyClockUsage,
            hasBasicPayAdjustmentReport: hasBasicPayAdjustmentReport,
            hasCertificateOfEmployment: hasCertificateOfEmployment,
            hasCertificateOfPagibig: hasCertificateOfPagibig,
            hasCertificateOfPhilhealth: hasCertificateOfPhilhealth,
            hasCertificateOfSSS: hasCertificateOfSSS,
            hasCommissionsSummary: hasCommissionsSummary,
            hasCostCenterReport: hasCostCenterReport,
            hasDeductionsPerMonth: hasDeductionsPerMonth,
            hasDTRReport: hasDTRReport,
            hasEarningsPerMonth: hasEarningsPerMonth,
            hasEmployeeLeaveGroup: hasEmployeeLeaveGroup,
            hasEmployeeOvertimeGroup: hasEmployeeOvertimeGroup,
            hasEmployeeExpenseGroup: hasEmployeeExpenseGroup,
            hasEmployeeLeaveHistory: hasEmployeeLeaveHistory,
            hasEmployeeListingByHiringDate: hasEmployeeListingByHiringDate,
            hasEmployeeRegister: hasEmployeeRegister,
            hasExpenseReport: hasExpenseReport,
            hasGovernmentEmployeeInventory: hasGovernmentEmployeeInventory,
            hasHeadcountReport: hasHeadcountReport,
            hasHolidayPremiumSummary: hasHolidayPremiumSummary,
            hasLeaveLedgerReport: hasLeaveLedgerReport,
            hasLeaveSummaryReport: hasLeaveSummaryReport,
            hasLoanHistory: hasLoanHistory,
            hasLoanPaymentsSummary: hasLoanPaymentsSummary,
            hasLoansMonthlyAmortizationSummary: hasLoansMonthlyAmortizationSummary,
            hasLoansPenaltyHistory: hasLoansPenaltyHistory,
            hasNightDifferentialSummary: hasNightDifferentialSummary,
            hasNonTaxableAllowancesReport: hasNonTaxableAllowancesReport,
            hasOtherEarningsReport: hasOtherEarningsReport,
            hasOtherDeductionsSummary: hasOtherDeductionsSummary,
            hasOutstandingLoans: hasOutstandingLoans,
            hasPayrollCashRegister: hasPayrollCashRegister,
            hasPayrollCheckRegister: hasPayrollCheckRegister,
            hasPayrollDebitMemo: hasPayrollDebitMemo,
            hasPayrollJournalByCostCenter: hasPayrollJournalByCostCenter,
            hasPayrollJournalByDepartment: hasPayrollJournalByDepartment,
            hasPayrollJournalBySummary: hasPayrollJournalBySummary,
            hasPayrollPerPaymentMethod: hasPayrollPerPaymentMethod,
            hasSelectLogs: hasSelectLogs,
            hasSummaryReportByMonthAndDepartment: hasSummaryReportByMonthAndDepartment,
            hasTardinessMemo: hasTardinessMemo,
            hasTimeKeepingHistoryDetailedReport: hasTimeKeepingHistoryDetailedReport,
            hasTimeKeepingHoursWorkedReport: hasTimeKeepingHoursWorkedReport,
            hasTimeKeepingHoursWorkedSummary: hasTimeKeepingHoursWorkedSummary,
            hasTimesheetStatusReport: hasTimesheetStatusReport,
            hasYTDDeductionSummary: hasYTDDeductionSummary,
            hasYTDEarningsSummary: hasYTDEarningsSummary,
            hasYTDPayrollRegister: hasYTDPayrollRegister,
            hasNotification: hasNotification,
            hasMobileBiometrics: hasMobileBiometrics,
            hasRequestApprovalTimeKeeper: hasRequestApprovalTimeKeeper,
            hasTamperedApproval: hasTamperedApproval,
            hasMobileDTRApproval: hasMobileDTRApproval,
            hasDTRWithOTViewing: hasDTRWithOTViewing,
            hasDTRCorrectionWorkers: hasDTRCorrectionWorkers,
            hasPlantilya: hasPlantilya,
            hasCostCenter: hasCostCenter,
            hasPayrollJournalAccount: hasPayrollJournalAccount,
            hasManHour: hasManHour,
            hasYearlyReport: hasYearlyReport,
            hasBIR2316: hasBIR2316,
            hasBIR1601C: hasBIR1601C,
            hasAlphaList: hasAlphaList,
            hasLoanReport: hasLoanReport,
            hasBankTransmittalReport: hasBankTransmittalReport,
            userTimeOut: userTimeOut ? userTimeOut : 2
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Users", 
                actionTaken: "insert", 
                field: "Add Manage User", 
                newValue: `${data.description}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setHasHome(false);
            setHasAddEmployee(false);
            setHasEmployeeList(false);
            setHasEmployeeStatus(false);
            setHasEmployeeSchedule(false);
            setHasTimeEntries(false);
            setHasShiftSchedule(false);
            setHasProcessPayroll(false);
            setHas13thMonth(false);
            setHasPayrollPeriod(false);
            setHasPayType(false);
            setHasClient(false);
            setHasHoliday(false);
            setHasHolidayType(false);
            setHasLeaveType(false);
            setHasDepartment(false);
            setHasSection(false);
            setHasClassification(false);
            setHasCompany(false);
            setHasPosition(false);
            setHasJobTitle(false);
            setHasLocation(false);
            setHasDTRRulesConfiguration(false);
            setHasEmployeeMonthlySalary(false);
            setHasEmployeeDailySalary(false);
            setHasPositionDesignationSalary(false);
            setHasQuotaBasedSalary(false);
            setHasPositionDesignationSalaryLaUnion(false);
            setHasEmployeeBankAccount(false);
            setHasBIRTax(false);
            setHasPagibig(false);
            setHasSSS(false);
            setHasPhilhealth(false);
            setHasDTR(false);
            setHasDTRBiometrics(false);
            setHasApproverHierarchy(false);
            setHasRequestApproval(false);
            setHasOvertime(false);
            setHasDTRCorrection(false);
            setHasLeave(false);
            setHasChangeOfSchedule(false);
            setHasSSSLoan(false);
            setHasSSSCalamityLoan(false);
            setHasPagibigLoan(false);
            setHasPagibigCalamityLoan(false);
            setHasCashAdvance(false);
            setHasDeductions(false);
            setHasBenefits(false);
            setHasReports(false);
            setHasSettings(false);
            setHasCalendar(false);
            setHasUser(false);
            setUserTimeOut("");

            // Additional
            setHasEmployeereliever(false);
            setHasMassapproval(false);
            setHasApproverheirarchyperlocation(false);
            setHasFinalPay(false);
            setHasSubcon(false);
            setHasAgency(false);
            setHasEmploymentStatus(false);
            setHasLoans(false);
            setHasTimeKeeper(false);
            setHasPerDayTracker(false);
            setHasOvertimeSummaryReport(false);
            setHasTrackerReport(false);
            setHasPayslip(false);
            setHasPayrollRegister(false);
            setHasResigned(false);
            setHasActiveEmployees(false);
            setHasYearofService(false);
            setHasSSSSummary(false);
            setHasPagibigSummary(false);
            setHasPhilhealthSummary(false);
            setHasSSSLoanReport(false);
            setHasPagibigLoanReport(false);
            setHas201Report(false);
            setHasAttendanceReport(false);
            setHasBankTransmittalBDO(false);
            setHasBankTransmittalBPI(false);
            setHasBankTransmittalChinaBankSavings(false);
            setHasBankTransmittalHSBC(false);
            setHasBankTransmittalSecurityBank(false);
            setHasSummaryOfTardiness(false);
            setHasAbsencesMemo(false);
            setHasAbsencesReport(false);
            setHasActionHistoryReport(false);
            setHasAllowanceSummary(false);
            setHasAuditTrailReportEmployeeSetup(false);
            setHasBundyClockUsage(false);
            setHasBasicPayAdjustmentReport(false);
            setHasCertificateOfEmployment(false);
            setHasCertificateOfPagibig(false);
            setHasCertificateOfPhilhealth(false);
            setHasCertificateOfSSS(false);
            setHasCommissionsSummary(false);
            setHasCostCenterReport(false);
            setHasDeductionsPerMonth(false);
            setHasDTRReport(false);
            setHasEarningsPerMonth(false);
            setHasEmployeeLeaveGroup(false);
            setHasEmployeeOvertimeGroup(false);
            setHasEmployeeExpenseGroup(false);
            setHasEmployeeLeaveHistory(false);
            setHasEmployeeListingByHiringDate(false);
            setHasEmployeeRegister(false);
            setHasExpenseReport(false);
            setHasGovernmentEmployeeInventory(false);
            setHasHeadcountReport(false);
            setHasHolidayPremiumSummary(false);
            setHasLeaveLedgerReport(false);
            setHasLeaveSummaryReport(false);
            setHasLoanHistory(false);
            setHasLoanPaymentsSummary(false);
            setHasLoansMonthlyAmortizationSummary(false);
            setHasLoansPenaltyHistory(false);
            setHasNightDifferentialSummary(false);
            setHasNonTaxableAllowancesReport(false);
            setHasOtherEarningsReport(false);
            setHasOtherDeductionsSummary(false);
            setHasOutstandingLoans(false);
            setHasPayrollCashRegister(false);
            setHasPayrollCheckRegister(false);
            setHasPayrollDebitMemo(false);
            setHasPayrollJournalByCostCenter(false);
            setHasPayrollJournalByDepartment(false);
            setHasPayrollJournalBySummary(false);
            setHasPayrollPerPaymentMethod(false);
            setHasSelectLogs(false);
            setHasSummaryReportByMonthAndDepartment(false);
            setHasTardinessMemo(false);
            setHasTimeKeepingHistoryDetailedReport(false);
            setHasTimeKeepingHoursWorkedReport(false);
            setHasTimeKeepingHoursWorkedSummary(false);
            setHasTimesheetStatusReport(false);
            setHasYTDDeductionSummary(false);
            setHasYTDEarningsSummary(false);
            setHasYTDPayrollRegister(false);
            setHasNotification(false);
            setHasMobileBiometrics(false);
            setHasRequestApprovalTimeKeeper(false);
            setHasTamperedApproval(false);
            setHasMobileDTRApproval(false);
            setHasDTRWithOTViewing(false);
            setHasDTRCorrectionWorkers(false);
            setHasPlantilya(false);
            setHasCostCenter(false);
            setHasPayrollJournalAccount(false);
            setHasManHour(false);
            setHasYearlyReport(false);
            setHasBIR2316(false);
            setHasBIR1601C(false);
            setHasAlphaList(false);
            setHasBankTransmittalReport(false);
            setHasLoanReport(false);
            setHasOffsetCredits(false);
            setHasOffsetRequest(false);
            setHasEmployeeGroup1(false);
            setHasEmployeeGroup2(false);
            setHasOnBoarding(false);
            setHasOnBoardingPersonnel(false);
            setHasOutBoarding(false);
            setHasOnBoardingRequirements(false);
            setHasOutBoardingRequirements(false);

            setIsAddState(false);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            description: description,
            hasHome: hasHome,
            hasAddEmployee: hasAddEmployee,
            hasEmployeeList: hasEmployeeList,
            hasEmployeeStatus: hasEmployeeStatus,
            hasEmployeeSchedule: hasEmployeeSchedule,
            hasTimeEntries: hasTimeEntries,
            hasShiftSchedule: hasShiftSchedule,
            hasProcessPayroll: hasProcessPayroll,
            has13thMonth: has13thMonth,
            hasPayrollPeriod: hasPayrollPeriod,
            hasClient: hasClient,
            hasPayType: hasPayType,
            hasHoliday: hasHoliday,
            hasHolidayType: hasHolidayType,
            hasLeaveType: hasLeaveType,
            hasDepartment: hasDepartment,
            hasSection: hasSection,
            hasClassification: hasClassification,
            hasCompany: hasCompany,
            hasPosition: hasPosition,
            hasJobTitle: hasJobTitle,
            hasLocation: hasLocation,
            hasOffsetCredits: hasOffsetCredits,
            hasOffsetRequest: hasOffsetRequest,
            hasEmployeeGroup1: hasEmployeeGroup1,
            hasEmployeeGroup2: hasEmployeeGroup2,
            hasOnBoarding: hasOnBoarding,
            hasOnBoardingPersonnel: hasOnBoardingPersonnel,
            hasOutBoarding: hasOutBoarding,
            hasOnBoardingRequirements: hasOnBoardingRequirements,
            hasOutBoardingRequirements: hasOutBoardingRequirements,
            hasDTRRulesConfiguration: hasDTRRulesConfiguration,
            hasEmployeeMonthlySalary: hasEmployeeMonthlySalary,
            hasEmployeeDailySalary: hasEmployeeDailySalary,
            hasPositionDesignationSalary: hasPositionDesignationSalary,
            hasQuotaBasedSalary: hasQuotaBasedSalary,
            hasPositionDesignationSalaryLaUnion: hasPositionDesignationSalaryLaUnion,
            hasEmployeeBankAccount: hasEmployeeBankAccount,
            hasBIRTax: hasBIRTax,
            hasPagibig: hasPagibig,
            hasSSS: hasSSS,
            hasPhilhealth: hasPhilhealth,
            hasDTR: hasDTR,
            hasDTRBiometrics: hasDTRBiometrics,
            hasApproverHierarchy: hasApproverHierarchy,
            hasRequestApproval: hasRequestApproval,
            hasOvertime: hasOvertime,
            hasDTRCorrection: hasDTRCorrection,
            hasLeave: hasLeave,
            hasChangeOfSchedule: hasChangeOfSchedule,
            hasSSSLoan: hasSSSLoan,
            hasSSSCalamityLoan: hasSSSCalamityLoan,
            hasPagibigLoan: hasPagibigLoan,
            hasPagibigCalamityLoan: hasPagibigCalamityLoan,
            hasCashAdvance: hasCashAdvance,
            hasDeductions: hasDeductions,
            hasBenefits: hasBenefits,
            hasReports: hasReports,
            hasSettings: hasSettings,
            hasCalendar: hasCalendar,
            hasUser: hasUser,
            
            hasEmployeereliever: hasEmployeereliever,
            hasMassapproval: hasMassapproval,
            hasApproverheirarchyperlocation: hasApproverheirarchyperlocation,
            hasFinalPay: hasFinalPay,
            hasSubcon: hasSubcon,
            hasAgency: hasAgency,
            hasEmploymentStatus: hasEmploymentStatus,
            hasLoans: hasLoans,
            hasTimeKeeper: hasTimeKeeper,
            hasPerDayTracker: hasPerDayTracker,
            hasOvertimeSummaryReport: hasOvertimeSummaryReport,
            hasTrackerReport: hasTrackerReport,
            hasPayslip: hasPayslip,
            hasPayrollRegister: hasPayrollRegister,
            hasResigned: hasResigned,
            hasActiveEmployees: hasActiveEmployees,
            hasYearofService: hasYearofService,
            hasSSSSummary: hasSSSSummary,
            hasPagibigSummary: hasPagibigSummary,
            hasPhilhealthSummary: hasPhilhealthSummary,
            hasSSSLoanReport: hasSSSLoanReport,
            hasPagibigLoanReport: hasPagibigLoanReport,
            has201Report: has201Report,
            hasAttendanceReport: hasAttendanceReport,
            hasBankTransmittalBDO: hasBankTransmittalBDO,
            hasBankTransmittalBPI: hasBankTransmittalBPI,
            hasBankTransmittalChinaBankSavings: hasBankTransmittalChinaBankSavings,
            hasBankTransmittalHSBC: hasBankTransmittalHSBC,
            hasBankTransmittalSecurityBank: hasBankTransmittalSecurityBank,
            hasSummaryOfTardiness: hasSummaryOfTardiness,
            hasAbsencesMemo: hasAbsencesMemo,
            hasAbsencesReport: hasAbsencesReport,
            hasActionHistoryReport: hasActionHistoryReport,
            hasAllowanceSummary: hasAllowanceSummary,
            hasAuditTrailReportEmployeeSetup: hasAuditTrailReportEmployeeSetup,
            hasBundyClockUsage: hasBundyClockUsage,
            hasBasicPayAdjustmentReport: hasBasicPayAdjustmentReport,
            hasCertificateOfEmployment: hasCertificateOfEmployment,
            hasCertificateOfPagibig: hasCertificateOfPagibig,
            hasCertificateOfPhilhealth: hasCertificateOfPhilhealth,
            hasCertificateOfSSS: hasCertificateOfSSS,
            hasCommissionsSummary: hasCommissionsSummary,
            hasCostCenterReport: hasCostCenterReport,
            hasDeductionsPerMonth: hasDeductionsPerMonth,
            hasDTRReport: hasDTRReport,
            hasEarningsPerMonth: hasEarningsPerMonth,
            hasEmployeeLeaveGroup: hasEmployeeLeaveGroup,
            hasEmployeeOvertimeGroup: hasEmployeeOvertimeGroup,
            hasEmployeeExpenseGroup: hasEmployeeExpenseGroup,
            hasEmployeeLeaveHistory: hasEmployeeLeaveHistory,
            hasEmployeeListingByHiringDate: hasEmployeeListingByHiringDate,
            hasEmployeeRegister: hasEmployeeRegister,
            hasExpenseReport: hasExpenseReport,
            hasGovernmentEmployeeInventory: hasGovernmentEmployeeInventory,
            hasHeadcountReport: hasHeadcountReport,
            hasHolidayPremiumSummary: hasHolidayPremiumSummary,
            hasLeaveLedgerReport: hasLeaveLedgerReport,
            hasLeaveSummaryReport: hasLeaveSummaryReport,
            hasLoanHistory: hasLoanHistory,
            hasLoanPaymentsSummary: hasLoanPaymentsSummary,
            hasLoansMonthlyAmortizationSummary: hasLoansMonthlyAmortizationSummary,
            hasLoansPenaltyHistory: hasLoansPenaltyHistory,
            hasNightDifferentialSummary: hasNightDifferentialSummary,
            hasNonTaxableAllowancesReport: hasNonTaxableAllowancesReport,
            hasOtherEarningsReport: hasOtherEarningsReport,
            hasOtherDeductionsSummary: hasOtherDeductionsSummary,
            hasOutstandingLoans: hasOutstandingLoans,
            hasPayrollCashRegister: hasPayrollCashRegister,
            hasPayrollCheckRegister: hasPayrollCheckRegister,
            hasPayrollDebitMemo: hasPayrollDebitMemo,
            hasPayrollJournalByCostCenter: hasPayrollJournalByCostCenter,
            hasPayrollJournalByDepartment: hasPayrollJournalByDepartment,
            hasPayrollJournalBySummary: hasPayrollJournalBySummary,
            hasPayrollPerPaymentMethod: hasPayrollPerPaymentMethod,
            hasSelectLogs: hasSelectLogs,
            hasSummaryReportByMonthAndDepartment: hasSummaryReportByMonthAndDepartment,
            hasTardinessMemo: hasTardinessMemo,
            hasTimeKeepingHistoryDetailedReport: hasTimeKeepingHistoryDetailedReport,
            hasTimeKeepingHoursWorkedReport: hasTimeKeepingHoursWorkedReport,
            hasTimeKeepingHoursWorkedSummary: hasTimeKeepingHoursWorkedSummary,
            hasTimesheetStatusReport: hasTimesheetStatusReport,
            hasYTDDeductionSummary: hasYTDDeductionSummary,
            hasYTDEarningsSummary: hasYTDEarningsSummary,
            hasYTDPayrollRegister: hasYTDPayrollRegister,
            hasNotification: hasNotification,
            hasMobileBiometrics: hasMobileBiometrics,
            hasRequestApprovalTimeKeeper: hasRequestApprovalTimeKeeper,
            hasTamperedApproval: hasTamperedApproval,
            hasMobileDTRApproval: hasMobileDTRApproval,
            hasDTRWithOTViewing: hasDTRWithOTViewing,
            hasDTRCorrectionWorkers: hasDTRCorrectionWorkers,
            hasPlantilya: hasPlantilya,
            hasCostCenter: hasCostCenter,
            hasPayrollJournalAccount: hasPayrollJournalAccount,
            hasManHour: hasManHour,
            hasYearlyReport: hasYearlyReport,
            hasBIR2316: hasBIR2316,
            hasBIR1601C: hasBIR1601C,
            hasAlphaList: hasAlphaList,
            hasBankTransmittalReport: hasBankTransmittalReport,
            hasLoanReport: hasLoanReport,
            userTimeOut: userTimeOut
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${dataToEdit.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if (description !== oldDescription) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Description",
                    newValue: description,

                    
                    oldValue: oldDescription,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasHome !== oldHasHome) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Home",
                    newValue: hasHome ? "Enabled" : "Disabled",
                    oldValue: oldHasHome ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasAddEmployee !== oldHasAddEmployee) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Add Employee",
                    newValue: hasAddEmployee ? "Enabled" : "Disabled",
                    oldValue: oldHasAddEmployee ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeList !== oldHasEmployeeList) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee List",
                    newValue: hasEmployeeList ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeList ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeStatus !== oldHasEmployeeStatus) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Status",
                    newValue: hasEmployeeStatus ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeStatus ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeSchedule !== oldHasEmployeeSchedule) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Schedule",
                    newValue: hasEmployeeSchedule ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeSchedule ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasTimeEntries !== oldHasTimeEntries) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Time Entries",
                    newValue: hasTimeEntries ? "Enabled" : "Disabled",
                    oldValue: oldHasTimeEntries ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasShiftSchedule !== oldHasShiftSchedule) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Shift Schedule",
                    newValue: hasShiftSchedule ? "Enabled" : "Disabled",
                    oldValue: oldHasShiftSchedule ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasProcessPayroll !== oldHasProcessPayroll) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Process Payroll",
                    newValue: hasProcessPayroll ? "Enabled" : "Disabled",
                    oldValue: oldHasProcessPayroll ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollPeriod !== oldHasPayrollPeriod) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payroll Period",
                    newValue: hasPayrollPeriod ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollPeriod ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayType !== oldHasPayType) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Pay Type",
                    newValue: hasPayType ? "Enabled" : "Disabled",
                    oldValue: oldHasPayType ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasHoliday !== oldHasHoliday) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Holiday",
                    newValue: hasHoliday ? "Enabled" : "Disabled",
                    oldValue: oldHasHoliday ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasHolidayType !== oldHasHolidayType) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Holiday Type",
                    newValue: hasHolidayType ? "Enabled" : "Disabled",
                    oldValue: oldHasHolidayType ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLeaveType !== oldHasLeaveType) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Leave Type",
                    newValue: hasLeaveType ? "Enabled" : "Disabled",
                    oldValue: oldHasLeaveType ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDepartment !== oldHasDepartment) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Department",
                    newValue: hasDepartment ? "Enabled" : "Disabled",
                    oldValue: oldHasDepartment ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSection !== oldHasSection) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Section",
                    newValue: hasSection ? "Enabled" : "Disabled",
                    oldValue: oldHasSection ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasClassification !== oldHasClassification) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Classification",
                    newValue: hasClassification ? "Enabled" : "Disabled",
                    oldValue: oldHasClassification ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCompany !== oldHasCompany) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Company",
                    newValue: hasCompany ? "Enabled" : "Disabled",
                    oldValue: oldHasCompany ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPosition !== oldHasPosition) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Position",
                    newValue: hasPosition ? "Enabled" : "Disabled",
                    oldValue: oldHasPosition ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasJobTitle !== oldHasJobTitle) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Job Title",
                    newValue: hasJobTitle ? "Enabled" : "Disabled",
                    oldValue: oldHasJobTitle ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLocation !== oldHasLocation) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Location",
                    newValue: hasLocation ? "Enabled" : "Disabled",
                    oldValue: oldHasLocation ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeMonthlySalary !== oldHasEmployeeMonthlySalary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Monthly Salary",
                    newValue: hasEmployeeMonthlySalary ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeMonthlySalary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeDailySalary !== oldHasEmployeeDailySalary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Daily Salary",
                    newValue: hasEmployeeDailySalary ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeDailySalary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPositionDesignationSalary !== oldHasPositionDesignationSalary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Position Designation Salary",
                    newValue: hasPositionDesignationSalary ? "Enabled" : "Disabled",
                    oldValue: oldHasPositionDesignationSalary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if (hasEmployeeBankAccount !== oldHasEmployeeBankAccount) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Bank Account",
                    newValue: hasEmployeeBankAccount ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeBankAccount ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBIRTax !== oldHasBIRTax) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "BIR Tax",
                    newValue: hasBIRTax ? "Enabled" : "Disabled",
                    oldValue: oldHasBIRTax ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPagibig !== oldHasPagibig) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Pagibig",
                    newValue: hasPagibig ? "Enabled" : "Disabled",
                    oldValue: oldHasPagibig ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSSS !== oldHasSSS) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "SSS",
                    newValue: hasSSS ? "Enabled" : "Disabled",
                    oldValue: oldHasSSS ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPhilhealth !== oldHasPhilhealth) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Philhealth",
                    newValue: hasPhilhealth ? "Enabled" : "Disabled",
                    oldValue: oldHasPhilhealth ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDTR !== oldHasDTR) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "DTR",
                    newValue: hasDTR ? "Enabled" : "Disabled",
                    oldValue: oldHasDTR ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDTRBiometrics !== oldHasDTRBiometrics) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "DTR Biometrics",
                    newValue: hasDTRBiometrics ? "Enabled" : "Disabled",
                    oldValue: oldHasDTRBiometrics ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasApproverHierarchy !== oldHasApproverHierarchy) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Approver Hierarchy",
                    newValue: hasApproverHierarchy ? "Enabled" : "Disabled",
                    oldValue: oldHasApproverHierarchy ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasRequestApproval !== oldHasRequestApproval) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Request Approval",
                    newValue: hasRequestApproval ? "Enabled" : "Disabled",
                    oldValue: oldHasRequestApproval ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasOvertime !== oldHasOvertime) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Overtime",
                    newValue: hasOvertime ? "Enabled" : "Disabled",
                    oldValue: oldHasOvertime ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDTRCorrection !== oldHasDTRCorrection) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "DTR Correction",
                    newValue: hasDTRCorrection ? "Enabled" : "Disabled",
                    oldValue: oldHasDTRCorrection ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLeave !== oldHasLeave) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Leave",
                    newValue: hasLeave ? "Enabled" : "Disabled",
                    oldValue: oldHasLeave ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasChangeOfSchedule !== oldHasChangeOfSchedule) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Change Of Schedule",
                    newValue: hasChangeOfSchedule ? "Enabled" : "Disabled",
                    oldValue: oldHasChangeOfSchedule ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSSSLoan !== oldHasSSSLoan) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "SSS Loan",
                    newValue: hasSSSLoan ? "Enabled" : "Disabled",
                    oldValue: oldHasSSSLoan ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSSSCalamityLoan !== oldHasSSSCalamityLoan) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "SSS Calamity Loan",
                    newValue: hasSSSCalamityLoan ? "Enabled" : "Disabled",
                    oldValue: oldHasSSSCalamityLoan ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPagibigLoan !== oldHasPagibigLoan) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Pagibig Loan",
                    newValue: hasPagibigLoan ? "Enabled" : "Disabled",
                    oldValue: oldHasPagibigLoan ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPagibigCalamityLoan !== oldHasPagibigCalamityLoan) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Pagibig Calamity Loan",
                    newValue: hasPagibigCalamityLoan ? "Enabled" : "Disabled",
                    oldValue: oldHasPagibigCalamityLoan ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCashAdvance !== oldHasCashAdvance) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Cash Advance",
                    newValue: hasCashAdvance ? "Enabled" : "Disabled",
                    oldValue: oldHasCashAdvance ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDeductions !== oldHasDeductions) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Deductions",
                    newValue: hasDeductions ? "Enabled" : "Disabled",
                    oldValue: oldHasDeductions ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBenefits !== oldHasBenefits) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Benefits",
                    newValue: hasBenefits ? "Enabled" : "Disabled",
                    oldValue: oldHasBenefits ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasReports !== oldHasReports) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Reports",
                    newValue: hasReports ? "Enabled" : "Disabled",
                    oldValue: oldHasReports ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSettings !== oldHasSettings) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Settings",
                    newValue: hasSettings ? "Enabled" : "Disabled",
                    oldValue: oldHasSettings ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCalendar !== oldHasCalendar) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Calendar",
                    newValue: hasCalendar ? "Enabled" : "Disabled",
                    oldValue: oldHasCalendar ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasUser !== oldHasUser) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "User",
                    newValue: hasUser ? "Enabled" : "Disabled",
                    oldValue: oldHasUser ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if (userTimeOut !== oldUserTimeOut) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "User Time Out",
                    newValue: userTimeOut,
                    oldValue: oldUserTimeOut,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // additional
            // Employee Reliever
            if (hasEmployeereliever !== oldHasEmployeeReliever) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Reliever",
                    newValue: hasEmployeereliever ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeReliever ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Mass Approval
            if (hasMassapproval !== oldHasMassApproval) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Mass Approval",
                    newValue: hasMassapproval ? "Enabled" : "Disabled",
                    oldValue: oldHasMassApproval ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Approver Hierarchy Per Location
            if (hasApproverheirarchyperlocation !== oldHasApproverHierarchyPerLocation) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Approver Hierarchy Per Location",
                    newValue: hasApproverheirarchyperlocation ? "Enabled" : "Disabled",
                    oldValue: oldHasApproverHierarchyPerLocation ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Final Pay
            if (hasFinalPay !== oldHasFinalPay) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Final Pay",
                    newValue: hasFinalPay ? "Enabled" : "Disabled",
                    oldValue: oldHasFinalPay ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Subcon
            if (hasSubcon !== oldHasSubcon) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Subcon",
                    newValue: hasSubcon ? "Enabled" : "Disabled",
                    oldValue: oldHasSubcon ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Agency
            if (hasAgency !== oldHasAgency) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Agency",
                    newValue: hasAgency ? "Enabled" : "Disabled",
                    oldValue: oldHasAgency ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Employment Status
            if (hasEmploymentStatus !== oldHasEmploymentStatus) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employment Status",
                    newValue: hasEmploymentStatus ? "Enabled" : "Disabled",
                    oldValue: oldHasEmploymentStatus ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Loans
            if (hasLoans !== oldHasLoans) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Loans",
                    newValue: hasLoans ? "Enabled" : "Disabled",
                    oldValue: oldHasLoans ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Time Keeper
            if (hasTimeKeeper !== oldHasTimeKeeper) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Time Keeper",
                    newValue: hasTimeKeeper ? "Enabled" : "Disabled",
                    oldValue: oldHasTimeKeeper ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Per Day Tracker
            if (hasPerDayTracker !== oldHasPerDayTracker) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Per Day Tracker",
                    newValue: hasPerDayTracker ? "Enabled" : "Disabled",
                    oldValue: oldHasPerDayTracker ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Overtime Summary Report
            if (hasOvertimeSummaryReport !== oldHasOvertimeSummaryReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Overtime Summary Report",
                    newValue: hasOvertimeSummaryReport ? "Enabled" : "Disabled",
                    oldValue: oldHasOvertimeSummaryReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Tracker Report
            if (hasTrackerReport !== oldHasTrackerReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Tracker Report",
                    newValue: hasTrackerReport ? "Enabled" : "Disabled",
                    oldValue: oldHasTrackerReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Payslip
            if (hasPayslip !== oldHasPayslip) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payslip",
                    newValue: hasPayslip ? "Enabled" : "Disabled",
                    oldValue: oldHasPayslip ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Payroll Register
            if (hasPayrollRegister !== oldHasPayrollRegister) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payroll Register",
                    newValue: hasPayrollRegister ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollRegister ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Resigned
            if (hasResigned !== oldHasResigned) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Resigned",
                    newValue: hasResigned ? "Enabled" : "Disabled",
                    oldValue: oldHasResigned ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Active Employees
            if (hasActiveEmployees !== oldHasActiveEmployees) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Active Employees",
                    newValue: hasActiveEmployees ? "Enabled" : "Disabled",
                    oldValue: oldHasActiveEmployees ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Year of Service
            if (hasYearofService !== oldHasYearOfService) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Year of Service",
                    newValue: hasYearofService ? "Enabled" : "Disabled",
                    oldValue: oldHasYearOfService ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // SSS Summary
            if (hasSSSSummary !== oldHasSSSSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "SSS Summary",
                    newValue: hasSSSSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasSSSSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Pag-IBIG Summary
            if (hasPagibigSummary !== oldHasPagibigSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Pag-IBIG Summary",
                    newValue: hasPagibigSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasPagibigSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // PhilHealth Summary
            if (hasPhilhealthSummary !== oldHasPhilhealthSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "PhilHealth Summary",
                    newValue: hasPhilhealthSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasPhilhealthSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // SSS Loan Report
            if (hasSSSLoanReport !== oldHasSSSLoanReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "SSS Loan Report",
                    newValue: hasSSSLoanReport ? "Enabled" : "Disabled",
                    oldValue: oldHasSSSLoanReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            // Pag-IBIG Loan Report
            if (hasPagibigLoanReport !== oldHasPagibigLoanReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Pag-IBIG Loan Report",
                    newValue: hasPagibigLoanReport ? "Enabled" : "Disabled",
                    oldValue: oldHasPagibigLoanReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if (has201Report !== oldHas201Report) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "201 Report",
                    newValue: has201Report ? "Enabled" : "Disabled",
                    oldValue: oldHas201Report ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasAttendanceReport !== oldHasAttendanceReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Attendance Report",
                    newValue: hasAttendanceReport ? "Enabled" : "Disabled",
                    oldValue: oldHasAttendanceReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBankTransmittalBDO !== oldHasBankTransmittalBDO) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Bank Transmittal (BDO)",
                    newValue: hasBankTransmittalBDO ? "Enabled" : "Disabled",
                    oldValue: oldHasBankTransmittalBDO ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            // Repeat this structure for each of the other reports
            if (hasBankTransmittalBPI !== oldHasBankTransmittalBPI) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Bank Transmittal (BPI)",
                    newValue: hasBankTransmittalBPI ? "Enabled" : "Disabled",
                    oldValue: oldHasBankTransmittalBPI ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBankTransmittalChinaBankSavings !== oldHasBankTransmittalChinaBankSavings) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Bank Transmittal (China Bank Savings)",
                    newValue: hasBankTransmittalChinaBankSavings ? "Enabled" : "Disabled",
                    oldValue: oldHasBankTransmittalChinaBankSavings ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            // Continue for the other report states
            if (hasBankTransmittalHSBC !== oldHasBankTransmittalHSBC) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Bank Transmittal (HSBC)",
                    newValue: hasBankTransmittalHSBC ? "Enabled" : "Disabled",
                    oldValue: oldHasBankTransmittalHSBC ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBankTransmittalSecurityBank !== oldHasBankTransmittalSecurityBank) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Bank Transmittal (Security Bank)",
                    newValue: hasBankTransmittalSecurityBank ? "Enabled" : "Disabled",
                    oldValue: oldHasBankTransmittalSecurityBank ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSummaryOfTardiness !== oldHasSummaryOfTardiness) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Summary of Tardiness",
                    newValue: hasSummaryOfTardiness ? "Enabled" : "Disabled",
                    oldValue: oldHasSummaryOfTardiness ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasAbsencesMemo !== oldHasAbsencesMemo) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Absences Memo",
                    newValue: hasAbsencesMemo ? "Enabled" : "Disabled",
                    oldValue: oldHasAbsencesMemo ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasAbsencesReport !== oldHasAbsencesReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Absences Report",
                    newValue: hasAbsencesReport ? "Enabled" : "Disabled",
                    oldValue: oldHasAbsencesReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasActionHistoryReport !== oldHasActionHistoryReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Action History Report",
                    newValue: hasActionHistoryReport ? "Enabled" : "Disabled",
                    oldValue: oldHasActionHistoryReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasAllowanceSummary !== oldHasAllowanceSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Allowance Summary",
                    newValue: hasAllowanceSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasAllowanceSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasAuditTrailReportEmployeeSetup !== oldHasAuditTrailReportEmployeeSetup) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Audit Trail Report (Employee Setup)",
                    newValue: hasAuditTrailReportEmployeeSetup ? "Enabled" : "Disabled",
                    oldValue: oldHasAuditTrailReportEmployeeSetup ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBundyClockUsage !== oldHasBundyClockUsage) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Bundy Clock Usage",
                    newValue: hasBundyClockUsage ? "Enabled" : "Disabled",
                    oldValue: oldHasBundyClockUsage ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasBasicPayAdjustmentReport !== oldHasBasicPayAdjustmentReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Basic Pay Adjustment Report",
                    newValue: hasBasicPayAdjustmentReport ? "Enabled" : "Disabled",
                    oldValue: oldHasBasicPayAdjustmentReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCertificateOfEmployment !== oldHasCertificateOfEmployment) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Certificate of Employment",
                    newValue: hasCertificateOfEmployment ? "Enabled" : "Disabled",
                    oldValue: oldHasCertificateOfEmployment ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCertificateOfPagibig !== oldHasCertificateOfPagibig) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Certificate of Pag-IBIG",
                    newValue: hasCertificateOfPagibig ? "Enabled" : "Disabled",
                    oldValue: oldHasCertificateOfPagibig ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCertificateOfPhilhealth !== oldHasCertificateOfPhilhealth) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Certificate of Philhealth",
                    newValue: hasCertificateOfPhilhealth ? "Enabled" : "Disabled",
                    oldValue: oldHasCertificateOfPhilhealth ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCertificateOfSSS !== oldHasCertificateOfSSS) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Certificate of SSS",
                    newValue: hasCertificateOfSSS ? "Enabled" : "Disabled",
                    oldValue: oldHasCertificateOfSSS ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasCommissionsSummary !== oldHasCommissionsSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Commissions Summary",
                    newValue: hasCommissionsSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasCommissionsSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if (hasCostCenterReport !== oldHasCostCenterReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Cost Center Report",
                    newValue: hasCostCenterReport ? "Enabled" : "Disabled",
                    oldValue: oldHasCostCenterReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDeductionsPerMonth !== oldHasDeductionsPerMonth) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Deductions Per Month",
                    newValue: hasDeductionsPerMonth ? "Enabled" : "Disabled",
                    oldValue: oldHasDeductionsPerMonth ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasDTRReport !== oldHasDTRReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "DTR Report",
                    newValue: hasDTRReport ? "Enabled" : "Disabled",
                    oldValue: oldHasDTRReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEarningsPerMonth !== oldHasEarningsPerMonth) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Earnings Per Month",
                    newValue: hasEarningsPerMonth ? "Enabled" : "Disabled",
                    oldValue: oldHasEarningsPerMonth ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeLeaveGroup !== oldHasEmployeeLeaveGroup) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Leave Group",
                    newValue: hasEmployeeLeaveGroup ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeLeaveGroup ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeOvertimeGroup !== oldHasEmployeeOvertimeGroup) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Overtime Group",
                    newValue: hasEmployeeOvertimeGroup ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeOvertimeGroup ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeExpenseGroup !== oldHasEmployeeExpenseGroup) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Expense Group",
                    newValue: hasEmployeeExpenseGroup ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeExpenseGroup ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeLeaveHistory !== oldHasEmployeeLeaveHistory) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Leave History",
                    newValue: hasEmployeeLeaveHistory ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeLeaveHistory ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeListingByHiringDate !== oldHasEmployeeListingByHiringDate) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Listing By Hiring Date",
                    newValue: hasEmployeeListingByHiringDate ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeListingByHiringDate ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasEmployeeRegister !== oldHasEmployeeRegister) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Employee Register",
                    newValue: hasEmployeeRegister ? "Enabled" : "Disabled",
                    oldValue: oldHasEmployeeRegister ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasExpenseReport !== oldHasExpenseReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Expense Report",
                    newValue: hasExpenseReport ? "Enabled" : "Disabled",
                    oldValue: oldHasExpenseReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasGovernmentEmployeeInventory !== oldHasGovernmentEmployeeInventory) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Government Employee Inventory",
                    newValue: hasGovernmentEmployeeInventory ? "Enabled" : "Disabled",
                    oldValue: oldHasGovernmentEmployeeInventory ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if (hasHeadcountReport !== oldHasHeadcountReport) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Headcount Report",
                    newValue: hasHeadcountReport ? "Enabled" : "Disabled",
                    oldValue: oldHasHeadcountReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasHolidayPremiumSummary !== oldHasHolidayPremiumSummary) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Holiday Premium Summary",
                    newValue: hasHolidayPremiumSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasHolidayPremiumSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLeaveLedgerReport !== oldHasLeaveLedgerReport) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Leave Ledger Report",
                    newValue: hasLeaveLedgerReport ? "Enabled" : "Disabled",
                    oldValue: oldHasLeaveLedgerReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLeaveSummaryReport !== oldHasLeaveSummaryReport) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Leave Summary Report",
                    newValue: hasLeaveSummaryReport ? "Enabled" : "Disabled",
                    oldValue: oldHasLeaveSummaryReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLoanHistory !== oldHasLoanHistory) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Loan History",
                    newValue: hasLoanHistory ? "Enabled" : "Disabled",
                    oldValue: oldHasLoanHistory ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLoanPaymentsSummary !== oldHasLoanPaymentsSummary) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Loan Payments Summary",
                    newValue: hasLoanPaymentsSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasLoanPaymentsSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLoansMonthlyAmortizationSummary !== oldHasLoansMonthlyAmortizationSummary) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Loans Monthly Amortization Summary",
                    newValue: hasLoansMonthlyAmortizationSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasLoansMonthlyAmortizationSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasLoansPenaltyHistory !== oldHasLoansPenaltyHistory) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Loans Penalty History",
                    newValue: hasLoansPenaltyHistory ? "Enabled" : "Disabled",
                    oldValue: oldHasLoansPenaltyHistory ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasNightDifferentialSummary !== oldHasNightDifferentialSummary) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Night Differential Summary",
                    newValue: hasNightDifferentialSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasNightDifferentialSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasNonTaxableAllowancesReport !== oldHasNonTaxableAllowancesReport) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Non-Taxable Allowances Report",
                    newValue: hasNonTaxableAllowancesReport ? "Enabled" : "Disabled",
                    oldValue: oldHasNonTaxableAllowancesReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasOtherEarningsReport !== oldHasOtherEarningsReport) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Other Earnings Report",
                    newValue: hasOtherEarningsReport ? "Enabled" : "Disabled",
                    oldValue: oldHasOtherEarningsReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasOtherDeductionsSummary !== oldHasOtherDeductionsSummary) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Other Deductions Summary",
                    newValue: hasOtherDeductionsSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasOtherDeductionsSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasOutstandingLoans !== oldHasOutstandingLoans) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Outstanding Loans",
                    newValue: hasOutstandingLoans ? "Enabled" : "Disabled",
                    oldValue: oldHasOutstandingLoans ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollCashRegister !== oldHasPayrollCashRegister) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Payroll Cash Register",
                    newValue: hasPayrollCashRegister ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollCashRegister ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollCheckRegister !== oldHasPayrollCheckRegister) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Payroll Check Register",
                    newValue: hasPayrollCheckRegister ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollCheckRegister ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollDebitMemo !== oldHasPayrollDebitMemo) {
                auditInfo.push({
                    setupArea: "Reports",
                    actionTaken: "update",
                    field: "Payroll Debit Memo",
                    newValue: hasPayrollDebitMemo ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollDebitMemo ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }    
            
            if (hasPayrollJournalByCostCenter !== oldHasPayrollJournalByCostCenter) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payroll Journal by Cost Center",
                    newValue: hasPayrollJournalByCostCenter ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollJournalByCostCenter ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollJournalByDepartment !== oldHasPayrollJournalByDepartment) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payroll Journal by Department",
                    newValue: hasPayrollJournalByDepartment ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollJournalByDepartment ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollJournalBySummary !== oldHasPayrollJournalBySummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payroll Journal by Summary",
                    newValue: hasPayrollJournalBySummary ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollJournalBySummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasPayrollPerPaymentMethod !== oldHasPayrollPerPaymentMethod) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Payroll Per Payment Method",
                    newValue: hasPayrollPerPaymentMethod ? "Enabled" : "Disabled",
                    oldValue: oldHasPayrollPerPaymentMethod ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSelectLogs !== oldHasSelectLogs) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Select Logs",
                    newValue: hasSelectLogs ? "Enabled" : "Disabled",
                    oldValue: oldHasSelectLogs ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasSummaryReportByMonthAndDepartment !== oldHasSummaryReportByMonthAndDepartment) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Summary Report by Month and Department",
                    newValue: hasSummaryReportByMonthAndDepartment ? "Enabled" : "Disabled",
                    oldValue: oldHasSummaryReportByMonthAndDepartment ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasTardinessMemo !== oldHasTardinessMemo) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Tardiness Memo",
                    newValue: hasTardinessMemo ? "Enabled" : "Disabled",
                    oldValue: oldHasTardinessMemo ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasTimeKeepingHistoryDetailedReport !== oldHasTimeKeepingHistoryDetailedReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Time Keeping History Detailed Report",
                    newValue: hasTimeKeepingHistoryDetailedReport ? "Enabled" : "Disabled",
                    oldValue: oldHasTimeKeepingHistoryDetailedReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasTimeKeepingHoursWorkedReport !== oldHasTimeKeepingHoursWorkedReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Time Keeping Hours Worked Report",
                    newValue: hasTimeKeepingHoursWorkedReport ? "Enabled" : "Disabled",
                    oldValue: oldHasTimeKeepingHoursWorkedReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasTimeKeepingHoursWorkedSummary !== oldHasTimeKeepingHoursWorkedSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Time Keeping Hours Worked Summary",
                    newValue: hasTimeKeepingHoursWorkedSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasTimeKeepingHoursWorkedSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasTimesheetStatusReport !== oldHasTimesheetStatusReport) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Timesheet Status Report",
                    newValue: hasTimesheetStatusReport ? "Enabled" : "Disabled",
                    oldValue: oldHasTimesheetStatusReport ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasYTDDeductionSummary !== oldHasYTDeductionSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "YTD Deduction Summary",
                    newValue: hasYTDDeductionSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasYTDeductionSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            
            if (hasYTDEarningsSummary !== oldHasYTDEarningsSummary) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "YTD Earnings Summary",
                    newValue: hasYTDEarningsSummary ? "Enabled" : "Disabled",
                    oldValue: oldHasYTDEarningsSummary ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if (hasYTDPayrollRegister !== oldHasYTDPayrollRegister) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "YTD Payroll Register",
                    newValue: hasYTDPayrollRegister ? "Enabled" : "Disabled",
                    oldValue: oldHasYTDPayrollRegister ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if (hasNotification !== oldHasNotification) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Notification",
                    newValue: hasNotification ? "Enabled" : "Disabled",
                    oldValue: oldHasNotification ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if (hasMobileBiometrics !== oldHasMobileBiometrics) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Mobile Biometrics",
                    newValue: hasMobileBiometrics ? "Enabled" : "Disabled",
                    oldValue: oldHasMobileBiometrics ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if (hasRequestApprovalTimeKeeper !== oldHasRequestApprovalTimeKeeper) {
                auditInfo.push({
                    setupArea: "Users",
                    actionTaken: "update",
                    field: "Request Approval Time Keeper",
                    newValue: hasRequestApprovalTimeKeeper ? "Enabled" : "Disabled",
                    oldValue: oldHasRequestApprovalTimeKeeper ? "Enabled" : "Disabled",
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setDescription("");
            setHasHome(false);
            setHasAddEmployee(false);
            setHasEmployeeList(false);
            setHasEmployeeStatus(false);
            setHasEmployeeSchedule(false);
            setHasTimeEntries(false);
            setHasShiftSchedule(false);
            setHasProcessPayroll(false);
            setHas13thMonth(false);
            setHasPayrollPeriod(false);
            setHasClient(false);
            setHasPayType(false);
            setHasHoliday(false);
            setHasHolidayType(false);
            setHasLeaveType(false);
            setHasDepartment(false);
            setHasSection(false);
            setHasClassification(false);
            setHasCompany(false);
            setHasPosition(false);
            setHasJobTitle(false);
            setHasLocation(false);
            setHasDTRRulesConfiguration(false);
            setHasEmployeeMonthlySalary(false);
            setHasEmployeeDailySalary(false);
            setHasPositionDesignationSalary(false);
            setHasQuotaBasedSalary(false);
            setHasPositionDesignationSalaryLaUnion(false);
            setHasEmployeeBankAccount(false);
            setHasBIRTax(false);
            setHasPagibig(false);
            setHasSSS(false);
            setHasPhilhealth(false);
            setHasDTR(false);
            setHasDTRBiometrics(false);
            setHasApproverHierarchy(false);
            setHasRequestApproval(false);
            setHasOvertime(false);
            setHasDTRCorrection(false);
            setHasLeave(false);
            setHasChangeOfSchedule(false);
            setHasSSSLoan(false);
            setHasSSSCalamityLoan(false);
            setHasPagibigLoan(false);
            setHasPagibigCalamityLoan(false);
            setHasCashAdvance(false);
            setHasDeductions(false);
            setHasBenefits(false);
            setHasReports(false);
            setHasSettings(false);
            setHasCalendar(false);
            setHasUser(false);
            setUserTimeOut("");

            // additional 
            setHasEmployeereliever(false);
            setHasMassapproval(false);
            setHasApproverheirarchyperlocation(false);
            setHasFinalPay(false);
            setHasSubcon(false);
            setHasAgency(false);
            setHasEmploymentStatus(false);
            setHasLoans(false);
            setHasTimeKeeper(false);
            setHasPerDayTracker(false);
            setHasOvertimeSummaryReport(false);
            setHasTrackerReport(false);
            setHasPayslip(false);
            setHasPayrollRegister(false);
            setHasResigned(false);
            setHasActiveEmployees(false);
            setHasYearofService(false);
            setHasSSSSummary(false);
            setHasPagibigSummary(false);
            setHasPhilhealthSummary(false);
            setHasSSSLoanReport(false);
            setHasPagibigLoanReport(false);
            setHas201Report(false);
            setHasAttendanceReport(false);
            setHasBankTransmittalBDO(false);
            setHasBankTransmittalBPI(false);
            setHasBankTransmittalChinaBankSavings(false);
            setHasBankTransmittalHSBC(false);
            setHasBankTransmittalSecurityBank(false);
            setHasSummaryOfTardiness(false);
            setHasAbsencesMemo(false);
            setHasAbsencesReport(false);
            setHasActionHistoryReport(false);
            setHasAllowanceSummary(false);
            setHasAuditTrailReportEmployeeSetup(false);
            setHasBundyClockUsage(false);
            setHasBasicPayAdjustmentReport(false);
            setHasCertificateOfEmployment(false);
            setHasCertificateOfPagibig(false);
            setHasCertificateOfPhilhealth(false);
            setHasCertificateOfSSS(false);
            setHasCommissionsSummary(false);
            setHasCostCenterReport(false);
            setHasDeductionsPerMonth(false);
            setHasDTRReport(false);
            setHasEarningsPerMonth(false);
            setHasEmployeeLeaveGroup(false);
            setHasEmployeeOvertimeGroup(false);
            setHasEmployeeExpenseGroup(false);
            setHasEmployeeLeaveHistory(false);
            setHasEmployeeListingByHiringDate(false);
            setHasEmployeeRegister(false);
            setHasExpenseReport(false);
            setHasGovernmentEmployeeInventory(false);
            setHasHeadcountReport(false);
            setHasHolidayPremiumSummary(false);
            setHasLeaveLedgerReport(false);
            setHasLeaveSummaryReport(false);
            setHasLoanHistory(false);
            setHasLoanPaymentsSummary(false);
            setHasLoansMonthlyAmortizationSummary(false);
            setHasLoansPenaltyHistory(false);
            setHasNightDifferentialSummary(false);
            setHasNonTaxableAllowancesReport(false);
            setHasOtherEarningsReport(false);
            setHasOtherDeductionsSummary(false);
            setHasOutstandingLoans(false);
            setHasPayrollCashRegister(false);
            setHasPayrollCheckRegister(false);
            setHasPayrollDebitMemo(false);
            setHasPayrollJournalByCostCenter(false);
            setHasPayrollJournalByDepartment(false);
            setHasPayrollJournalBySummary(false);
            setHasPayrollPerPaymentMethod(false);
            setHasSelectLogs(false);
            setHasSummaryReportByMonthAndDepartment(false);
            setHasTardinessMemo(false);
            setHasTimeKeepingHistoryDetailedReport(false);
            setHasTimeKeepingHoursWorkedReport(false);
            setHasTimeKeepingHoursWorkedSummary(false);
            setHasTimesheetStatusReport(false);
            setHasYTDDeductionSummary(false);
            setHasYTDEarningsSummary(false);
            setHasYTDPayrollRegister(false);
            setHasNotification(false);
            setHasMobileBiometrics(false);
            setHasRequestApprovalTimeKeeper(false);
            setHasTamperedApproval(false);
            setHasMobileDTRApproval(false);
            setHasDTRWithOTViewing(false);
            setHasDTRCorrectionWorkers(false);
            setHasPlantilya(false);
            setHasCostCenter(false);
            setHasPayrollJournalAccount(false);
            setHasManHour(false);
            setHasYearlyReport(false);
            setHasBIR2316(false);
            setHasBIR1601C(false);
            setHasAlphaList(false);
            setHasBankTransmittalReport(false);
            setHasLoanReport(false);
            setHasOffsetCredits(false);
            setHasOffsetRequest(false);
            setHasEmployeeGroup1(false);
            setHasEmployeeGroup2(false);
            setHasOnBoarding(false);
            setHasOnBoardingPersonnel(false);
            setHasOutBoarding(false);
            setHasOnBoardingRequirements(false);
            setHasOutBoardingRequirements(false);

            setIsEditState(false);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleDelete = async (event) => {
        event.preventDefault();

        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `/${dataToDelete.id}`, [], {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Users", 
                actionTaken: "delete", 
                field: "Delete Manage User", 
                newValue: `-`, 
                oldValue: `${dataToDelete.description}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setShowDeleteForm(false);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const addHandleClick = () => {
        setIsAddState(true); 
        setIsEditState(false);

        setDescription("");
        setHasHome(false);
        setHasAddEmployee(false);
        setHasEmployeeList(false);
        setHasEmployeeStatus(false);
        setHasEmployeeSchedule(false);
        setHasTimeEntries(false);
        setHasShiftSchedule(false);
        setHasProcessPayroll(false);
        setHas13thMonth(false);
        setHasPayrollPeriod(false);
        setHasClient(false);
        setHasPayType(false);
        setHasHoliday(false);
        setHasHolidayType(false);
        setHasLeaveType(false);
        setHasDepartment(false);
        setHasSection(false);
        setHasClassification(false);
        setHasCompany(false);
        setHasPosition(false);
        setHasJobTitle(false);
        setHasLocation(false);
        setHasDTRRulesConfiguration(false);
        setHasEmployeeMonthlySalary(false);
        setHasEmployeeDailySalary(false);
        setHasPositionDesignationSalary(false);
        setHasQuotaBasedSalary(false);
        setHasPositionDesignationSalaryLaUnion(false);
        setHasEmployeeBankAccount(false);
        setHasBIRTax(false);
        setHasPagibig(false);
        setHasSSS(false);
        setHasPhilhealth(false);
        setHasDTR(false);
        setHasDTRBiometrics(false);
        setHasApproverHierarchy(false);
        setHasRequestApproval(false);
        setHasOvertime(false);
        setHasDTRCorrection(false);
        setHasLeave(false);
        setHasChangeOfSchedule(false);
        setHasSSSLoan(false);
        setHasSSSCalamityLoan(false);
        setHasPagibigLoan(false);
        setHasPagibigCalamityLoan(false);
        setHasCashAdvance(false);
        setHasDeductions(false);
        setHasBenefits(false);
        setHasReports(false);
        setHasSettings(false);
        setHasCalendar(false);
        setHasUser(false);
        setUserTimeOut("");

        // Additional
        setHasEmployeereliever(false);
        setHasMassapproval(false);
        setHasApproverheirarchyperlocation(false);
        setHasFinalPay(false);
        setHasSubcon(false);
        setHasAgency(false);
        setHasEmploymentStatus(false);
        setHasLoans(false);
        setHasTimeKeeper(false);
        setHasPerDayTracker(false);
        setHasOvertimeSummaryReport(false);
        setHasTrackerReport(false);
        setHasPayslip(false);
        setHasPayrollRegister(false);
        setHasResigned(false);
        setHasActiveEmployees(false);
        setHasYearofService(false);
        setHasSSSSummary(false);
        setHasPagibigSummary(false);
        setHasPhilhealthSummary(false);
        setHasSSSLoanReport(false);
        setHasPagibigLoanReport(false);
        setHas201Report(false);
        setHasAttendanceReport(false);
        setHasBankTransmittalBDO(false);
        setHasBankTransmittalBPI(false);
        setHasBankTransmittalChinaBankSavings(false);
        setHasBankTransmittalHSBC(false);
        setHasBankTransmittalSecurityBank(false);
        setHasSummaryOfTardiness(false);
        setHasAbsencesMemo(false);
        setHasAbsencesReport(false);
        setHasActionHistoryReport(false);
        setHasAllowanceSummary(false);
        setHasAuditTrailReportEmployeeSetup(false);
        setHasBundyClockUsage(false);
        setHasBasicPayAdjustmentReport(false);
        setHasCertificateOfEmployment(false);
        setHasCertificateOfPagibig(false);
        setHasCertificateOfPhilhealth(false);
        setHasCertificateOfSSS(false);
        setHasCommissionsSummary(false);
        setHasCostCenterReport(false);
        setHasDeductionsPerMonth(false);
        setHasDTRReport(false);
        setHasEarningsPerMonth(false);
        setHasEmployeeLeaveGroup(false);
        setHasEmployeeOvertimeGroup(false);
        setHasEmployeeExpenseGroup(false);
        setHasEmployeeLeaveHistory(false);
        setHasEmployeeListingByHiringDate(false);
        setHasEmployeeRegister(false);
        setHasExpenseReport(false);
        setHasGovernmentEmployeeInventory(false);
        setHasHeadcountReport(false);
        setHasHolidayPremiumSummary(false);
        setHasLeaveLedgerReport(false);
        setHasLeaveSummaryReport(false);
        setHasLoanHistory(false);
        setHasLoanPaymentsSummary(false);
        setHasLoansMonthlyAmortizationSummary(false);
        setHasLoansPenaltyHistory(false);
        setHasNightDifferentialSummary(false);
        setHasNonTaxableAllowancesReport(false);
        setHasOtherEarningsReport(false);
        setHasOtherDeductionsSummary(false);
        setHasOutstandingLoans(false);
        setHasPayrollCashRegister(false);
        setHasPayrollCheckRegister(false);
        setHasPayrollDebitMemo(false);
        setHasPayrollJournalByCostCenter(false);
        setHasPayrollJournalByDepartment(false);
        setHasPayrollJournalBySummary(false);
        setHasPayrollPerPaymentMethod(false);
        setHasSelectLogs(false);
        setHasSummaryReportByMonthAndDepartment(false);
        setHasTardinessMemo(false);
        setHasTimeKeepingHistoryDetailedReport(false);
        setHasTimeKeepingHoursWorkedReport(false);
        setHasTimeKeepingHoursWorkedSummary(false);
        setHasTimesheetStatusReport(false);
        setHasYTDDeductionSummary(false);
        setHasYTDEarningsSummary(false);
        setHasYTDPayrollRegister(false);
        setHasNotification(false);
        setHasMobileBiometrics(false);

        setHasRequestApprovalTimeKeeper(false);
        setHasTamperedApproval(false);
        setHasMobileDTRApproval(false);
        setHasDTRWithOTViewing(false);
        setHasDTRCorrectionWorkers(false);
        setHasPlantilya(false);
        setHasCostCenter(false);
        setHasPayrollJournalAccount(false);
        setHasManHour(false);
        setHasYearlyReport(false);
        setHasBIR2316(false);
        setHasBIR1601C(false);
        setHasAlphaList(false);
        setHasBankTransmittalReport(false);
        setHasOffsetCredits(false);
        setHasOffsetRequest(false);
        setHasEmployeeGroup1(false);
        setHasEmployeeGroup2(false);
        setHasOnBoarding(false);
        setHasOnBoardingPersonnel(false);
        setHasOutBoarding(false);
        setHasOnBoardingRequirements(false);
        setHasOutBoardingRequirements(false);
        setHasLoanReport(false);
    }
    const editHandleClick = (data) => {
        setDataToEdit(data);
        setIsEditState(true);
        setIsAddState(false);
    };
    const deleteHandleClick = (data) => {
        setDataToDelete(data);
        setShowDeleteForm(true);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };

    const [showReportsForm, setShowReportsForm] = useState(false);
    const [reportData, setReportData] = useState([]);

    const openReportsForm = (data) => {
        setReportData(data)
        setShowReportsForm(true);
    }
    const closeReportsForm = () => {
        setShowReportsForm(false);
    }

    const isNewDesign = true;

    var header_new = [
        "Id",
        "Template Name",
        "",
    ]
    var accessor_new = [
        "id",
        "description",
        "manage"
    ]

    const resetLocalVariables = () => {
        setDescription("");
        setHasHome(false);
        setHasAddEmployee(false);
        setHasEmployeeList(false);
        setHasEmployeeStatus(false);
        setHasEmployeeSchedule(false);
        setHasTimeEntries(false);
        setHasShiftSchedule(false);
        setHasProcessPayroll(false);
        setHas13thMonth(false);
        setHasPayrollPeriod(false);
        setHasClient(false);
        setHasPayType(false);
        setHasHoliday(false);
        setHasHolidayType(false);
        setHasLeaveType(false);
        setHasDepartment(false);
        setHasSection(false);
        setHasClassification(false);
        setHasCompany(false);
        setHasPosition(false);
        setHasJobTitle(false);
        setHasLocation(false);
        setHasDTRRulesConfiguration(false);
        setHasEmployeeMonthlySalary(false);
        setHasEmployeeDailySalary(false);
        setHasPositionDesignationSalary(false);
        setHasQuotaBasedSalary(false);
        setHasPositionDesignationSalaryLaUnion(false);
        setHasEmployeeBankAccount(false);
        setHasBIRTax(false);
        setHasPagibig(false);
        setHasSSS(false);
        setHasPhilhealth(false);
        setHasDTR(false);
        setHasDTRBiometrics(false);
        setHasApproverHierarchy(false);
        setHasRequestApproval(false);
        setHasOvertime(false);
        setHasDTRCorrection(false);
        setHasLeave(false);
        setHasChangeOfSchedule(false);
        setHasSSSLoan(false);
        setHasSSSCalamityLoan(false);
        setHasPagibigLoan(false);
        setHasPagibigCalamityLoan(false);
        setHasCashAdvance(false);
        setHasDeductions(false);
        setHasBenefits(false);
        setHasReports(false);
        setHasSettings(false);
        setHasCalendar(false);
        setHasUser(false);
        setUserTimeOut("");

        // Additional
        setHasEmployeereliever(false);
        setHasMassapproval(false);
        setHasApproverheirarchyperlocation(false);
        setHasFinalPay(false);
        setHasSubcon(false);
        setHasAgency(false);
        setHasEmploymentStatus(false);
        setHasLoans(false);
        setHasTimeKeeper(false);
        setHasPerDayTracker(false);
        setHasOvertimeSummaryReport(false);
        setHasTrackerReport(false);
        setHasPayslip(false);
        setHasPayrollRegister(false);
        setHasResigned(false);
        setHasActiveEmployees(false);
        setHasYearofService(false);
        setHasSSSSummary(false);
        setHasPagibigSummary(false);
        setHasPhilhealthSummary(false);
        setHasSSSLoanReport(false);
        setHasPagibigLoanReport(false);
        setHas201Report(false);
        setHasAttendanceReport(false);
        setHasBankTransmittalBDO(false);
        setHasBankTransmittalBPI(false);
        setHasBankTransmittalChinaBankSavings(false);
        setHasBankTransmittalHSBC(false);
        setHasBankTransmittalSecurityBank(false);
        setHasSummaryOfTardiness(false);
        setHasAbsencesMemo(false);
        setHasAbsencesReport(false);
        setHasActionHistoryReport(false);
        setHasAllowanceSummary(false);
        setHasAuditTrailReportEmployeeSetup(false);
        setHasBundyClockUsage(false);
        setHasBasicPayAdjustmentReport(false);
        setHasCertificateOfEmployment(false);
        setHasCertificateOfPagibig(false);
        setHasCertificateOfPhilhealth(false);
        setHasCertificateOfSSS(false);
        setHasCommissionsSummary(false);
        setHasCostCenterReport(false);
        setHasDeductionsPerMonth(false);
        setHasDTRReport(false);
        setHasEarningsPerMonth(false);
        setHasEmployeeLeaveGroup(false);
        setHasEmployeeOvertimeGroup(false);
        setHasEmployeeExpenseGroup(false);
        setHasEmployeeLeaveHistory(false);
        setHasEmployeeListingByHiringDate(false);
        setHasEmployeeRegister(false);
        setHasExpenseReport(false);
        setHasGovernmentEmployeeInventory(false);
        setHasHeadcountReport(false);
        setHasHolidayPremiumSummary(false);
        setHasLeaveLedgerReport(false);
        setHasLeaveSummaryReport(false);
        setHasLoanHistory(false);
        setHasLoanPaymentsSummary(false);
        setHasLoansMonthlyAmortizationSummary(false);
        setHasLoansPenaltyHistory(false);
        setHasNightDifferentialSummary(false);
        setHasNonTaxableAllowancesReport(false);
        setHasOtherEarningsReport(false);
        setHasOtherDeductionsSummary(false);
        setHasOutstandingLoans(false);
        setHasPayrollCashRegister(false);
        setHasPayrollCheckRegister(false);
        setHasPayrollDebitMemo(false);
        setHasPayrollJournalByCostCenter(false);
        setHasPayrollJournalByDepartment(false);
        setHasPayrollJournalBySummary(false);
        setHasPayrollPerPaymentMethod(false);
        setHasSelectLogs(false);
        setHasSummaryReportByMonthAndDepartment(false);
        setHasTardinessMemo(false);
        setHasTimeKeepingHistoryDetailedReport(false);
        setHasTimeKeepingHoursWorkedReport(false);
        setHasTimeKeepingHoursWorkedSummary(false);
        setHasTimesheetStatusReport(false);
        setHasYTDDeductionSummary(false);
        setHasYTDEarningsSummary(false);
        setHasYTDPayrollRegister(false);
        setHasNotification(false);
        setHasMobileBiometrics(false);
        setHasRequestApprovalTimeKeeper(false);
        setHasTamperedApproval(false);
        setHasMobileDTRApproval(false);
        setHasDTRWithOTViewing(false);
        setHasDTRCorrectionWorkers(false);
        setHasPlantilya(false);
        setHasCostCenter(false);
        setHasPayrollJournalAccount(false);
        setHasManHour(false);
        setHasYearlyReport(false);
        setHasBIR2316(false);
        setHasBIR1601C(false);
        setHasAlphaList(false);
        setHasBankTransmittalReport(false);
        setHasOffsetCredits(false);
        setHasOffsetRequest(false);
        setHasEmployeeGroup1(false);
        setHasEmployeeGroup2(false);
        setHasOnBoarding(false);
        setHasOnBoardingPersonnel(false);
        setHasOutBoarding(false);
        setHasOnBoardingRequirements(false);
        setHasOutBoardingRequirements(false);
        setHasLoanReport(false);
    }

    const [showAddForm_new, setShowAddForm_new] = useState(false);
    const openAddForm_new = () => {
        setShowAddForm_new(true);
    }
    const closeAddForm_new = () => {
        setShowAddForm_new(false);
        resetLocalVariables();
    }

    const [showEditForm_new, setShowEditForm_new] = useState(false);
    const openEditForm_new = () => {
        setShowEditForm_new(true);
    }
    const closeEditForm_new = () => {
        setShowEditForm_new(false);
        resetLocalVariables();
    }
    const editHandleClick_new = (data) => {
        setDataToEdit(data);
        openEditForm_new();
    };

    useEffect(() => {
        if(showEditForm_new){
            setDescription(dataToEdit.description);
            setHasHome(dataToEdit.hasHome);
            setHasAddEmployee(dataToEdit.hasAddEmployee);
            setHasEmployeeList(dataToEdit.hasEmployeeList);
            setHasEmployeeStatus(dataToEdit.hasEmployeeStatus);
            setHasEmployeeSchedule(dataToEdit.hasEmployeeSchedule);
            setHasTimeEntries(dataToEdit.hasTimeEntries);
            setHasShiftSchedule(dataToEdit.hasShiftSchedule);
            setHasProcessPayroll(dataToEdit.hasProcessPayroll);
            setHas13thMonth(dataToEdit.has13thMonth);
            setHasPayrollPeriod(dataToEdit.hasPayrollPeriod);
            setHasClient(dataToEdit.hasClient);
            setHasPayType(dataToEdit.hasPayType);
            setHasHoliday(dataToEdit.hasHoliday);
            setHasHolidayType(dataToEdit.hasHolidayType);
            setHasLeaveType(dataToEdit.hasLeaveType);
            setHasDepartment(dataToEdit.hasDepartment);
            setHasSection(dataToEdit.hasSection);
            setHasClassification(dataToEdit.hasClassification);
            setHasCompany(dataToEdit.hasCompany);
            setHasPosition(dataToEdit.hasPosition);
            setHasJobTitle(dataToEdit.hasJobTitle);
            setHasLocation(dataToEdit.hasLocation);
            setHasDTRRulesConfiguration(dataToEdit.hasDTRRulesConfiguration);
            setHasEmployeeMonthlySalary(dataToEdit.hasEmployeeMonthlySalary);
            setHasEmployeeDailySalary(dataToEdit.hasEmployeeDailySalary);
            setHasPositionDesignationSalary(dataToEdit.hasPositionDesignationSalary);
            setHasQuotaBasedSalary(dataToEdit.hasQuotaBasedSalary);
            setHasPositionDesignationSalaryLaUnion(dataToEdit.hasPositionDesignationSalaryLaUnion);
            setHasEmployeeBankAccount(dataToEdit.hasEmployeeBankAccount);
            setHasBIRTax(dataToEdit.hasBIRTax);
            setHasPagibig(dataToEdit.hasPagibig);
            setHasSSS(dataToEdit.hasSSS);
            setHasPhilhealth(dataToEdit.hasPhilhealth);
            setHasDTR(dataToEdit.hasDTR);
            setHasDTRBiometrics(dataToEdit.hasDTRBiometrics);
            setHasApproverHierarchy(dataToEdit.hasApproverHierarchy);
            setHasRequestApproval(dataToEdit.hasRequestApproval);
            setHasOvertime(dataToEdit.hasOvertime);
            setHasDTRCorrection(dataToEdit.hasDTRCorrection);
            setHasLeave(dataToEdit.hasLeave);
            setHasChangeOfSchedule(dataToEdit.hasChangeOfSchedule);
            setHasSSSLoan(dataToEdit.hasSSSLoan);
            setHasSSSCalamityLoan(dataToEdit.hasSSSCalamityLoan);
            setHasPagibigLoan(dataToEdit.hasPagibigLoan);
            setHasPagibigCalamityLoan(dataToEdit.hasPagibigCalamityLoan);
            setHasCashAdvance(dataToEdit.hasCashAdvance);
            setHasDeductions(dataToEdit.hasDeductions);
            setHasBenefits(dataToEdit.hasBenefits);
            setHasReports(dataToEdit.hasReports);
            setHasSettings(dataToEdit.hasSettings);
            setHasCalendar(dataToEdit.hasCalendar);
            setHasUser(dataToEdit.hasUser);
            setUserTimeOut(dataToEdit.userTimeOut);

            // additional
            setHasEmployeereliever(dataToEdit.hasEmployeereliever);
            setHasMassapproval(dataToEdit.hasMassapproval);
            setHasApproverheirarchyperlocation(dataToEdit.hasApproverheirarchyperlocation);
            setHasFinalPay(dataToEdit.hasFinalPay);
            setHasSubcon(dataToEdit.hasSubcon);
            setHasAgency(dataToEdit.hasAgency);
            setHasEmploymentStatus(dataToEdit.hasEmploymentStatus);
            setHasLoans(dataToEdit.hasLoans);
            setHasTimeKeeper(dataToEdit.hasTimeKeeper);
            setHasPerDayTracker(dataToEdit.hasPerDayTracker);
            setHasOvertimeSummaryReport(dataToEdit.hasOvertimeSummaryReport);
            setHasTrackerReport(dataToEdit.hasTrackerReport);
            setHasPayslip(dataToEdit.hasPayslip);
            setHasPayrollRegister(dataToEdit.hasPayrollRegister);
            setHasResigned(dataToEdit.hasResigned);
            setHasActiveEmployees(dataToEdit.hasActiveEmployees);
            setHasYearofService(dataToEdit.hasYearofService);
            setHasSSSSummary(dataToEdit.hasSSSSummary);
            setHasPagibigSummary(dataToEdit.hasPagibigSummary);
            setHasPhilhealthSummary(dataToEdit.hasPhilhealthSummary);
            setHasSSSLoanReport(dataToEdit.hasSSSLoanReport);
            setHasPagibigLoanReport(dataToEdit.hasPagibigLoanReport);
            setHas201Report(dataToEdit.has201Report);
            setHasAttendanceReport(dataToEdit.hasAttendanceReport);
            setHasBankTransmittalBDO(dataToEdit.hasBankTransmittalBDO);
            setHasBankTransmittalBPI(dataToEdit.hasBankTransmittalBPI);
            setHasBankTransmittalChinaBankSavings(dataToEdit.hasBankTransmittalChinaBankSavings);
            setHasBankTransmittalHSBC(dataToEdit.hasBankTransmittalHSBC);
            setHasBankTransmittalSecurityBank(dataToEdit.hasBankTransmittalSecurityBank);
            setHasSummaryOfTardiness(dataToEdit.hasSummaryOfTardiness);
            setHasAbsencesMemo(dataToEdit.hasAbsencesMemo);
            setHasAbsencesReport(dataToEdit.hasAbsencesReport);
            setHasActionHistoryReport(dataToEdit.hasActionHistoryReport);
            setHasAllowanceSummary(dataToEdit.hasAllowanceSummary);
            setHasAuditTrailReportEmployeeSetup(dataToEdit.hasAuditTrailReportEmployeeSetup);
            setHasBundyClockUsage(dataToEdit.hasBundyClockUsage);
            setHasBasicPayAdjustmentReport(dataToEdit.hasBasicPayAdjustmentReport);
            setHasCertificateOfEmployment(dataToEdit.hasCertificateOfEmployment);
            setHasCertificateOfPagibig(dataToEdit.hasCertificateOfPagibig);
            setHasCertificateOfPhilhealth(dataToEdit.hasCertificateOfPhilhealth);
            setHasCertificateOfSSS(dataToEdit.hasCertificateOfSSS);
            setHasCommissionsSummary(dataToEdit.hasCommissionsSummary);
            setHasCostCenterReport(dataToEdit.hasCostCenterReport);
            setHasDeductionsPerMonth(dataToEdit.hasDeductionsPerMonth);
            setHasDTRReport(dataToEdit.hasDTRReport);
            setHasEarningsPerMonth(dataToEdit.hasEarningsPerMonth);
            setHasEmployeeLeaveGroup(dataToEdit.hasEmployeeLeaveGroup);
            setHasEmployeeOvertimeGroup(dataToEdit.hasEmployeeOvertimeGroup);
            setHasEmployeeExpenseGroup(dataToEdit.hasEmployeeExpenseGroup);
            setHasEmployeeLeaveHistory(dataToEdit.hasEmployeeLeaveHistory);
            setHasEmployeeListingByHiringDate(dataToEdit.hasEmployeeListingByHiringDate);
            setHasEmployeeRegister(dataToEdit.hasEmployeeRegister);
            setHasExpenseReport(dataToEdit.hasExpenseReport);
            setHasGovernmentEmployeeInventory(dataToEdit.hasGovernmentEmployeeInventory);
            setHasHeadcountReport(dataToEdit.hasHeadcountReport);
            setHasHolidayPremiumSummary(dataToEdit.hasHolidayPremiumSummary);
            setHasLeaveLedgerReport(dataToEdit.hasLeaveLedgerReport);
            setHasLeaveSummaryReport(dataToEdit.hasLeaveSummaryReport);
            setHasLoanHistory(dataToEdit.hasLoanHistory);
            setHasLoanPaymentsSummary(dataToEdit.hasLoanPaymentsSummary);
            setHasLoansMonthlyAmortizationSummary(dataToEdit.hasLoansMonthlyAmortizationSummary);
            setHasLoansPenaltyHistory(dataToEdit.hasLoansPenaltyHistory);
            setHasNightDifferentialSummary(dataToEdit.hasNightDifferentialSummary);
            setHasNonTaxableAllowancesReport(dataToEdit.hasNonTaxableAllowancesReport);
            setHasOtherEarningsReport(dataToEdit.hasOtherEarningsReport);
            setHasOtherDeductionsSummary(dataToEdit.hasOtherDeductionsSummary);
            setHasOutstandingLoans(dataToEdit.hasOutstandingLoans);
            setHasPayrollCashRegister(dataToEdit.hasPayrollCashRegister);
            setHasPayrollCheckRegister(dataToEdit.hasPayrollCheckRegister);
            setHasPayrollDebitMemo(dataToEdit.hasPayrollDebitMemo);
            setHasPayrollJournalByCostCenter(dataToEdit.hasPayrollJournalByCostCenter);
            setHasPayrollJournalByDepartment(dataToEdit.hasPayrollJournalByDepartment);
            setHasPayrollJournalBySummary(dataToEdit.hasPayrollJournalBySummary);
            setHasPayrollPerPaymentMethod(dataToEdit.hasPayrollPerPaymentMethod);
            setHasSelectLogs(dataToEdit.hasSelectLogs);
            setHasSummaryReportByMonthAndDepartment(dataToEdit.hasSummaryReportByMonthAndDepartment);
            setHasTardinessMemo(dataToEdit.hasTardinessMemo);
            setHasTimeKeepingHistoryDetailedReport(dataToEdit.hasTimeKeepingHistoryDetailedReport);
            setHasTimeKeepingHoursWorkedReport(dataToEdit.hasTimeKeepingHoursWorkedReport);
            setHasTimeKeepingHoursWorkedSummary(dataToEdit.hasTimeKeepingHoursWorkedSummary);
            setHasTimesheetStatusReport(dataToEdit.hasTimesheetStatusReport);
            setHasYTDDeductionSummary(dataToEdit.hasYTDDeductionSummary);
            setHasYTDEarningsSummary(dataToEdit.hasYTDEarningsSummary);
            setHasYTDPayrollRegister(dataToEdit.hasYTDPayrollRegister);
            setHasNotification(dataToEdit.hasNotification);
            setHasMobileBiometrics(dataToEdit.hasMobileBiometrics);
            setHasRequestApprovalTimeKeeper(dataToEdit.hasRequestApprovalTimeKeeper);
            setHasTamperedApproval(dataToEdit.hasTamperedApproval);
            setHasMobileDTRApproval(dataToEdit.hasMobileDTRApproval);
            setHasDTRWithOTViewing(dataToEdit.hasDTRWithOTViewing);
            setHasDTRCorrectionWorkers(dataToEdit.hasDTRCorrectionWorkers);
            setHasPlantilya(dataToEdit.hasPlantilya);
            setHasCostCenter(dataToEdit.hasCostCenter);
            setHasPayrollJournalAccount(dataToEdit.hasPayrollJournalAccount);
            setHasManHour(dataToEdit.hasManHour);
            setHasYearlyReport(dataToEdit.hasYearlyReport);
            setHasBIR2316(dataToEdit.hasBIR2316);
            setHasBIR1601C(dataToEdit.hasBIR1601C);
            setHasAlphaList(dataToEdit.hasAlphaList);
            setHasLoanReport(dataToEdit.hasLoanReport);
            setHasBankTransmittalReport(dataToEdit.hasBankTransmittalReport);
            setHasOffsetCredits(dataToEdit.hasOffsetCredits);
            setHasOffsetRequest(dataToEdit.hasOffsetRequest);
            setHasEmployeeGroup1(dataToEdit.hasEmployeeGroup1);
            setHasEmployeeGroup2(dataToEdit.hasEmployeeGroup2);
            setHasOnBoarding(dataToEdit.hasOnBoarding);
            setHasOnBoardingPersonnel(dataToEdit.hasOnBoardingPersonnel);
            setHasOutBoarding(dataToEdit.hasOutBoarding);
            setHasOnBoardingRequirements(dataToEdit.hasOnBoardingRequirements);
            setHasOutBoardingRequirements(dataToEdit.hasOutBoardingRequirements);

            setOldDescription(dataToEdit.description);
            setOldHasHome(dataToEdit.hasHome);
            setOldHasAddEmployee(dataToEdit.hasAddEmployee);
            setOldHasEmployeeList(dataToEdit.hasEmployeeList);
            setOldHasEmployeeStatus(dataToEdit.hasEmployeeStatus);
            setOldHasEmployeeSchedule(dataToEdit.hasEmployeeSchedule);
            setOldHasTimeEntries(dataToEdit.hasTimeEntries);
            setOldHasShiftSchedule(dataToEdit.hasShiftSchedule);
            setOldHasProcessPayroll(dataToEdit.hasProcessPayroll);
            setOldHasPayrollPeriod(dataToEdit.hasPayrollPeriod);
            setOldHasPayType(dataToEdit.hasPayType);
            setOldHasHoliday(dataToEdit.hasHoliday);
            setOldHasHolidayType(dataToEdit.hasHolidayType);
            setOldHasLeaveType(dataToEdit.hasLeaveType);
            setOldHasDepartment(dataToEdit.hasDepartment);
            setOldHasSection(dataToEdit.hasSection);
            setOldHasClassification(dataToEdit.hasClassification);
            setOldHasCompany(dataToEdit.hasCompany);
            setOldHasPosition(dataToEdit.hasPosition);
            setOldHasJobTitle(dataToEdit.hasJobTitle);
            setOldHasLocation(dataToEdit.hasLocation);
            setOldHasEmployeeMonthlySalary(dataToEdit.hasEmployeeMonthlySalary);
            setOldHasEmployeeDailySalary(dataToEdit.hasEmployeeDailySalary);
            setOldHasPositionDesignationSalary(dataToEdit.hasPositionDesignationSalary);
            setOldHasEmployeeBankAccount(dataToEdit.hasEmployeeBankAccount);
            setOldHasBIRTax(dataToEdit.hasBIRTax);
            setOldHasPagibig(dataToEdit.hasPagibig);
            setOldHasSSS(dataToEdit.hasSSS);
            setOldHasPhilhealth(dataToEdit.hasPhilhealth);
            setOldHasDTR(dataToEdit.hasDTR);
            setOldHasDTRBiometrics(dataToEdit.hasDTRBiometrics);
            setOldHasApproverHierarchy(dataToEdit.hasApproverHierarchy);
            setOldHasRequestApproval(dataToEdit.hasRequestApproval);
            setOldHasOvertime(dataToEdit.hasOvertime);
            setOldHasDTRCorrection(dataToEdit.hasDTRCorrection);
            setOldHasLeave(dataToEdit.hasLeave);
            setOldHasChangeOfSchedule(dataToEdit.hasChangeOfSchedule);
            setOldHasSSSLoan(dataToEdit.hasSSSLoan);
            setOldHasSSSCalamityLoan(dataToEdit.hasSSSCalamityLoan);
            setOldHasPagibigLoan(dataToEdit.hasPagibigLoan);
            setOldHasPagibigCalamityLoan(dataToEdit.hasPagibigCalamityLoan);
            setOldHasCashAdvance(dataToEdit.hasCashAdvance);
            setOldHasDeductions(dataToEdit.hasDeductions);
            setOldHasBenefits(dataToEdit.hasBenefits);
            setOldHasReports(dataToEdit.hasReports);
            setOldHasSettings(dataToEdit.hasSettings);
            setOldHasCalendar(dataToEdit.hasCalendar);
            setOldHasUser(dataToEdit.hasUser);
            setOldUserTimeOut(dataToEdit.userTimeOut);

            // additional
            setOldHasEmployeeReliever(dataToEdit.hasEmployeereliever);
            setOldHasMassApproval(dataToEdit.hasMassapproval);
            setOldHasApproverHierarchyPerLocation(dataToEdit.hasApproverheirarchyperlocation);
            setOldHasFinalPay(dataToEdit.hasFinalPay);
            setOldHasSubcon(dataToEdit.hasSubcon);
            setOldHasAgency(dataToEdit.hasAgency);
            setOldHasEmploymentStatus(dataToEdit.hasEmploymentStatus);
            setOldHasLoans(dataToEdit.hasLoans);
            setOldHasTimeKeeper(dataToEdit.hasTimeKeeper);
            setOldHasPerDayTracker(dataToEdit.hasPerDayTracker);
            setOldHasOvertimeSummaryReport(dataToEdit.hasOvertimeSummaryReport);
            setOldHasTrackerReport(dataToEdit.hasTrackerReport);
            setOldHasPayslip(dataToEdit.hasPayslip);
            setOldHasPayrollRegister(dataToEdit.hasPayrollRegister);
            setOldHasResigned(dataToEdit.hasResigned);
            setOldHasActiveEmployees(dataToEdit.hasActiveEmployees);
            setOldHasYearOfService(dataToEdit.hasYearofService);
            setOldHasSSSSummary(dataToEdit.hasSSSSummary);
            setOldHasPagibigSummary(dataToEdit.hasPagibigSummary);
            setOldHasPhilhealthSummary(dataToEdit.hasPhilhealthSummary);
            setOldHasSSSLoanReport(dataToEdit.hasSSSLoanReport);
            setOldHasPagibigLoanReport(dataToEdit.hasPagibigLoanReport);
            setOldHas201Report(dataToEdit.has201Report);
            setOldHasAttendanceReport(dataToEdit.hasAttendanceReport);
            setOldHasBankTransmittalBDO(dataToEdit.hasBankTransmittalBDO);
            setOldHasBankTransmittalBPI(dataToEdit.hasBankTransmittalBPI);
            setOldHasBankTransmittalChinaBankSavings(dataToEdit.hasBankTransmittalChinaBankSavings);
            setOldHasBankTransmittalHSBC(dataToEdit.hasBankTransmittalHSBC);
            setOldHasBankTransmittalSecurityBank(dataToEdit.hasBankTransmittalSecurityBank);
            setOldHasSummaryOfTardiness(dataToEdit.hasSummaryOfTardiness);
            setOldHasAbsencesMemo(dataToEdit.hasAbsencesMemo);
            setOldHasAbsencesReport(dataToEdit.hasAbsencesReport);
            setOldHasActionHistoryReport(dataToEdit.hasActionHistoryReport);
            setOldHasAllowanceSummary(dataToEdit.hasAllowanceSummary);
            setOldHasAuditTrailReportEmployeeSetup(dataToEdit.hasAuditTrailReportEmployeeSetup);
            setOldHasBundyClockUsage(dataToEdit.hasBundyClockUsage);
            setOldHasBasicPayAdjustmentReport(dataToEdit.hasBasicPayAdjustmentReport);
            setOldHasCertificateOfEmployment(dataToEdit.hasCertificateOfEmployment);
            setOldHasCertificateOfPagibig(dataToEdit.hasCertificateOfPagibig);
            setOldHasCertificateOfPhilhealth(dataToEdit.hasCertificateOfPhilhealth);
            setOldHasCertificateOfSSS(dataToEdit.hasCertificateOfSSS);
            setOldHasCommissionsSummary(dataToEdit.hasCommissionsSummary);
            setOldHasCostCenterReport(dataToEdit.hasCostCenterReport);
            setOldHasDeductionsPerMonth(dataToEdit.hasDeductionsPerMonth);
            setOldHasDTRReport(dataToEdit.hasDTRReport);
            setOldHasEarningsPerMonth(dataToEdit.hasEarningsPerMonth);
            setOldHasEmployeeLeaveGroup(dataToEdit.hasEmployeeLeaveGroup);
            setOldHasEmployeeOvertimeGroup(dataToEdit.hasEmployeeOvertimeGroup);
            setOldHasEmployeeExpenseGroup(dataToEdit.hasEmployeeExpenseGroup);
            setOldHasEmployeeLeaveHistory(dataToEdit.hasEmployeeLeaveHistory);
            setOldHasEmployeeListingByHiringDate(dataToEdit.hasEmployeeListingByHiringDate);
            setOldHasEmployeeRegister(dataToEdit.hasEmployeeRegister);
            setOldHasExpenseReport(dataToEdit.hasExpenseReport);
            setOldHasGovernmentEmployeeInventory(dataToEdit.hasGovernmentEmployeeInventory);
            setOldHasHeadcountReport(dataToEdit.hasHeadcountReport);
            setOldHasHolidayPremiumSummary(dataToEdit.hasHolidayPremiumSummary);
            setOldHasLeaveLedgerReport(dataToEdit.hasLeaveLedgerReport);
            setOldHasLeaveSummaryReport(dataToEdit.hasLeaveSummaryReport);
            setOldHasLoanHistory(dataToEdit.hasLoanHistory);
            setOldHasLoanPaymentsSummary(dataToEdit.hasLoanPaymentsSummary);
            setOldHasLoansMonthlyAmortizationSummary(dataToEdit.hasLoansMonthlyAmortizationSummary);
            setOldHasLoansPenaltyHistory(dataToEdit.hasLoansPenaltyHistory);
            setOldHasNightDifferentialSummary(dataToEdit.hasNightDifferentialSummary);
            setOldHasNonTaxableAllowancesReport(dataToEdit.hasNonTaxableAllowancesReport);
            setOldHasOtherEarningsReport(dataToEdit.hasOtherEarningsReport);
            setOldHasOtherDeductionsSummary(dataToEdit.hasOtherDeductionsSummary);
            setOldHasOutstandingLoans(dataToEdit.hasOutstandingLoans);
            setOldHasPayrollCashRegister(dataToEdit.hasPayrollCashRegister);
            setOldHasPayrollCheckRegister(dataToEdit.hasPayrollCheckRegister);
            setOldHasPayrollDebitMemo(dataToEdit.hasPayrollDebitMemo);
            setOldHasPayrollJournalByCostCenter(dataToEdit.hasPayrollJournalByCostCenter);
            setOldHasPayrollJournalByDepartment(dataToEdit.hasPayrollJournalByDepartment);
            setOldHasPayrollJournalBySummary(dataToEdit.hasPayrollJournalBySummary);
            setOldHasPayrollPerPaymentMethod(dataToEdit.hasPayrollPerPaymentMethod);
            setOldHasSelectLogs(dataToEdit.hasSelectLogs);
            setOldHasSummaryReportByMonthAndDepartment(dataToEdit.hasSummaryReportByMonthAndDepartment);
            setOldHasTardinessMemo(dataToEdit.hasTardinessMemo);
            setOldHasTimeKeepingHistoryDetailedReport(dataToEdit.hasTimeKeepingHistoryDetailedReport);
            setOldHasTimeKeepingHoursWorkedReport(dataToEdit.hasTimeKeepingHoursWorkedReport);
            setOldHasTimeKeepingHoursWorkedSummary(dataToEdit.hasTimeKeepingHoursWorkedSummary);
            setOldHasTimesheetStatusReport(dataToEdit.hasTimesheetStatusReport);
            setOldHasYTDeductionSummary(dataToEdit.hasYTDDeductionSummary);
            setOldHasYTDearningsSummary(dataToEdit.hasYTDEarningsSummary);
            setOldHasYTDPayrollRegister(dataToEdit.hasYTDPayrollRegister);
            setOldHasNotification(dataToEdit.hasNotification);
            setOldHasMobileBiometrics(dataToEdit.hasMobileBiometrics);
            setOldHasRequestApprovalTimeKeeper(dataToEdit.hasRequestApprovalTimeKeeper);
        }
    }, [showEditForm_new, dataToEdit])

    return (
        <>
            { !isNewDesign ?
                <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                    {isOpen && (
                    <div className="modal">
                        <div className="popUp-header row">
                            <div className="popUp-title">
                                <h3 style={{ color: "#668fca" }}>User Template</h3>
                            </div>
                            <div className="popUp-close">
                                <CloseIcon onClick={()=>handleClose()} />
                            </div>
                        </div>
                        <div className="popUp-body user-template-body" style={{overflow: "unset"}}>
                            <div className='user-temp-fixed-header'>
                                <Filter setFilterDataIndex={setFilterDataIndex}/>
                                <div className="mainte-body-top row" style={{padding:"0", alignItems:"center", justifyContent:"space-between"}}>
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e) => handleFilter(e.target.value), 
                                                                    "Search by " + searchPlaceholder, 
                                                                    SearchIcon)}
                                    <div className="mainte-addBtn row" style={{alignItems:"center", justifyContent:"end", padding: "20px 0"}}>
                                        {CreateButton("", "add row", ()=>addHandleClick(), "ADD", NoteAddIcon)}
                                    </div>
                                </div>
                            </div>
                            <div className="users-table user-cont container" /* style={{overflow:"unset"}} */>
                                <CreateTableForUserTemplate
                                    dataList={userTemplate}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    deleteHandleClick={deleteHandleClick}
                                    viewReports={openReportsForm}
                                    isAddState={isAddState}
                                    setIsAddState={setIsAddState}
                                    isEditState={isEditState}
                                    setIsEditState={setIsEditState}
                                    dataToEdit={dataToEdit}
                                    description={description} 
                                    setDescription={setDescription}
                                    hasHome={hasHome}
                                    setHasHome={setHasHome}
                                    hasAddEmployee={hasAddEmployee}
                                    setHasAddEmployee={setHasAddEmployee}
                                    hasEmployeeList={hasEmployeeList}
                                    setHasEmployeeList={setHasEmployeeList}
                                    hasEmployeeStatus={hasEmployeeStatus}
                                    setHasEmployeeStatus={setHasEmployeeStatus}
                                    hasEmployeeSchedule={hasEmployeeSchedule}
                                    setHasEmployeeSchedule={setHasEmployeeSchedule}
                                    hasTimeEntries={hasTimeEntries}
                                    setHasTimeEntries={setHasTimeEntries}
                                    hasShiftSchedule={hasShiftSchedule}
                                    setHasShiftSchedule={setHasShiftSchedule}
                                    hasProcessPayroll={hasProcessPayroll}
                                    setHasProcessPayroll={setHasProcessPayroll}
                                    has13thMonth={has13thMonth}
                                    setHas13thMonth={setHas13thMonth}
                                    hasPayrollPeriod={hasPayrollPeriod}
                                    setHasPayrollPeriod={setHasPayrollPeriod}
                                    hasPayType={hasPayType}
                                    setHasPayType={setHasPayType}
                                    hasClient={hasClient}
                                    setHasClient={setHasClient}
                                    hasHoliday={hasHoliday}
                                    setHasHoliday={setHasHoliday}
                                    hasHolidayType={hasHolidayType}
                                    setHasHolidayType={setHasHolidayType}
                                    hasLeaveType={hasLeaveType}
                                    setHasLeaveType={setHasLeaveType}
                                    hasDepartment={hasDepartment}
                                    setHasDepartment={setHasDepartment}
                                    hasSection={hasSection}
                                    setHasSection={setHasSection}
                                    hasClassification={hasClassification}
                                    setHasClassification={setHasClassification}
                                    hasCompany={hasCompany}
                                    setHasCompany={setHasCompany}
                                    hasPosition={hasPosition}
                                    setHasPosition={setHasPosition}
                                    hasJobTitle={hasJobTitle}
                                    setHasJobTitle={setHasJobTitle}
                                    hasLocation={hasLocation}
                                    setHasLocation={setHasLocation}
                                    hasDTRRulesConfiguration={hasDTRRulesConfiguration}
                                    setHasDTRRulesConfiguration={setHasDTRRulesConfiguration}
                                    hasEmployeeMonthlySalary={hasEmployeeMonthlySalary}
                                    setHasEmployeeMonthlySalary={setHasEmployeeMonthlySalary}
                                    hasEmployeeDailySalary={hasEmployeeDailySalary}
                                    setHasEmployeeDailySalary={setHasEmployeeDailySalary}
                                    hasPositionDesignationSalary={hasPositionDesignationSalary}
                                    hasQuotaBasedSalary={hasQuotaBasedSalary}
                                    setHasPositionDesignationSalary={setHasPositionDesignationSalary}
                                    setHasQuotaBasedSalary={setHasQuotaBasedSalary}
                                    hasPositionDesignationSalaryLaUnion={hasPositionDesignationSalaryLaUnion}
                                    setHasPositionDesignationSalaryLaUnion={setHasPositionDesignationSalaryLaUnion}
                                    hasEmployeeBankAccount={hasEmployeeBankAccount}
                                    setHasEmployeeBankAccount={setHasEmployeeBankAccount}
                                    hasBIRTax={hasBIRTax}
                                    setHasBIRTax={setHasBIRTax}
                                    hasPagibig={hasPagibig}
                                    setHasPagibig={setHasPagibig}
                                    hasSSS={hasSSS}
                                    setHasSSS={setHasSSS}
                                    hasPhilhealth={hasPhilhealth}
                                    setHasPhilhealth={setHasPhilhealth}
                                    hasDTR={hasDTR}
                                    setHasDTR={setHasDTR}
                                    hasDTRBiometrics={hasDTRBiometrics}
                                    setHasDTRBiometrics={setHasDTRBiometrics}
                                    hasApproverHierarchy={hasApproverHierarchy}
                                    setHasApproverHierarchy={setHasApproverHierarchy}
                                    hasRequestApproval={hasRequestApproval}
                                    setHasRequestApproval={setHasRequestApproval}
                                    hasOvertime={hasOvertime}
                                    setHasOvertime={setHasOvertime}
                                    hasDTRCorrection={hasDTRCorrection}
                                    setHasDTRCorrection={setHasDTRCorrection}
                                    hasLeave={hasLeave}
                                    setHasLeave={setHasLeave}
                                    hasChangeOfSchedule={hasChangeOfSchedule}
                                    setHasChangeOfSchedule={setHasChangeOfSchedule}
                                    hasSSSLoan={hasSSSLoan}
                                    setHasSSSLoan={setHasSSSLoan}
                                    hasSSSCalamityLoan={hasSSSCalamityLoan}
                                    setHasSSSCalamityLoan={setHasSSSCalamityLoan}
                                    hasPagibigLoan={hasPagibigLoan}
                                    setHasPagibigLoan={setHasPagibigLoan}
                                    hasPagibigCalamityLoan={hasPagibigCalamityLoan}
                                    setHasPagibigCalamityLoan={setHasPagibigCalamityLoan}
                                    hasCashAdvance={hasCashAdvance}
                                    setHasCashAdvance={setHasCashAdvance}
                                    hasDeductions={hasDeductions}
                                    setHasDeductions={setHasDeductions}
                                    hasBenefits={hasBenefits}
                                    setHasBenefits={setHasBenefits}
                                    hasReports={hasReports}
                                    setHasReports={setHasReports}
                                    hasSettings={hasSettings}
                                    setHasSettings={setHasSettings}
                                    hasCalendar={hasCalendar}
                                    setHasCalendar={setHasCalendar}
                                    hasUser={hasUser}
                                    setHasUser={setHasUser}
                                    userTimeOut={userTimeOut}
                                    setUserTimeOut={setUserTimeOut}

                                    // additional
                                    hasEmployeereliever={hasEmployeereliever} setHasEmployeereliever={setHasEmployeereliever}
                                    hasMassapproval={hasMassapproval} setHasMassapproval={setHasMassapproval}
                                    hasApproverheirarchyperlocation={hasApproverheirarchyperlocation} setHasApproverheirarchyperlocation={setHasApproverheirarchyperlocation}
                                    hasFinalPay={hasFinalPay} setHasFinalPay={setHasFinalPay}
                                    hasSubcon={hasSubcon} setHasSubcon={setHasSubcon}
                                    hasAgency={hasAgency} setHasAgency={setHasAgency}
                                    hasEmploymentStatus={hasEmploymentStatus} setHasEmploymentStatus={setHasEmploymentStatus}
                                    hasLoans={hasLoans} setHasLoans={setHasLoans}
                                    hasTimeKeeper={hasTimeKeeper} setHasTimeKeeper={setHasTimeKeeper}
                                    hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                                    hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                                    hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                                    hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                                    hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                                    hasResigned={hasResigned} setHasResigned={setHasResigned}
                                    hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                                    hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                                    hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                                    hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                                    hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                                    hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                                    hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                                    has201Report={has201Report} setHas201Report={setHas201Report}
                                    hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                                    hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                                    hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                                    hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                                    hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                                    hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                                    hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                                    hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                                    hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                                    hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                                    hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                                    hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                                    hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                                    hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                                    hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                                    hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                                    hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                                    hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                                    hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                                    hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                                    hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                                    hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                                    hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                                    hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                                    hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                                    hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                                    hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                                    hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                                    hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                                    hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                                    hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                                    hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                                    hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                                    hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                                    hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                                    hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                                    hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                                    hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                                    hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                                    hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                                    hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                                    hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                                    hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                                    hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                                    hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                                    hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                                    hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                                    hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                                    hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                                    hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                                    hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                                    hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                                    hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                                    hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                                    hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                                    hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                                    hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                                    hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                                    hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                                    hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                                    hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                                    hasNotification={hasNotification} setHasNotification={setHasNotification}
                                    hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}
                                    hasRequestApprovalTimeKeeper={hasRequestApprovalTimeKeeper} setHasRequestApprovalTimeKeeper={setHasRequestApprovalTimeKeeper}
                                    hasTamperedApproval={hasTamperedApproval} setHasTamperedApproval={setHasTamperedApproval}
                                    hasMobileDTRApproval={hasMobileDTRApproval} setHasMobileDTRApproval={setHasMobileDTRApproval}
                                    hasDTRWithOTViewing={hasDTRWithOTViewing} setHasDTRWithOTViewing={setHasDTRWithOTViewing}
                                    hasDTRCorrectionWorkers={hasDTRCorrectionWorkers} setHasDTRCorrectionWorkers={setHasDTRCorrectionWorkers}
                                    hasPlantilya={hasPlantilya} setHasPlantilya={setHasPlantilya}
                                    hasCostCenter={hasCostCenter} setHasCostCenter={setHasCostCenter}
                                    hasPayrollJournalAccount={hasPayrollJournalAccount} setHasPayrollJournalAccount={setHasPayrollJournalAccount}
                                    hasManHour={hasManHour} setHasManHour={setHasManHour}
                                    hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                                    hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                                    hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                                    hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                                    hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}
                                    hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}
                                    hasOffsetCredits={hasOffsetCredits} setHasOffsetCredits={setHasOffsetCredits}
                                    hasOffsetRequest={hasOffsetRequest} setHasOffsetRequest={setHasOffsetRequest}
                                    hasEmployeeGroup1={hasEmployeeGroup1} setHasEmployeeGroup1={setHasEmployeeGroup1}
                                    hasEmployeeGroup2={hasEmployeeGroup2} setHasEmployeeGroup2={setHasEmployeeGroup2}
                                    hasOnBoarding={hasOnBoarding} setHasOnBoarding={setHasOnBoarding}
                                    hasOnBoardingPersonnel={hasOnBoardingPersonnel} setHasOnBoardingPersonnel={setHasOnBoardingPersonnel}
                                    hasOutBoarding={hasOutBoarding} setHasOutBoarding={setHasOutBoarding}
                                    hasOnBoardingRequirements={hasOnBoardingRequirements} setHasOnBoardingRequirements={setHasOnBoardingRequirements}
                                    hasOutBoardingRequirements={hasOutBoardingRequirements} setHasOutBoardingRequirements={setHasOutBoardingRequirements}

                                    handleSubmit={handleSubmit}
                                    handleUpdate={handleUpdate}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                                {userTemplate.length > 0 ? (
                                    <div></div>
                                )
                                :
                                (
                                    <div>
                                    {loading ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    ) : (
                                            isAddState ? <></>
                                            :
                                            <div> {/*<p>No records to display</p>*/}</div>
                                        )
                                    }
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                            {/* <button id="add-family" 
                                className="cancel row"
                                onClick={handleClose}>
                                    BACK
                            </button> */}
                        </div>
                    </div>
                )}
                </div>
            :
                <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                    {isOpen && (
                    <div className="modal">
                        <div className="popUp-header row">
                            <div className="popUp-title">
                                <h3 style={{ color: "#668fca" }}>User Template</h3>
                            </div>
                            <div className="popUp-close">
                                <CloseIcon onClick={()=>handleClose()} />
                            </div>
                        </div>
                        <div className="popUp-body user-template-body" style={{overflow: "unset"}}>
                            <div className='user-temp-fixed-header'>
                                <Filter setFilterDataIndex={setFilterDataIndex}/>
                                <div className="mainte-body-top row" style={{padding:"0", alignItems:"center", justifyContent:"space-between"}}>
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e) => handleFilter(e.target.value), 
                                                                    "Search by " + searchPlaceholder, 
                                                                    SearchIcon)}
                                    <div className="mainte-addBtn row" style={{alignItems:"center", justifyContent:"end", padding: "20px 0"}}>
                                        {CreateButton("", "add row", openAddForm_new, "ADD", NoteAddIcon)}
                                    </div>
                                </div>
                            </div>
                            <div className="users-table user-cont container" /* style={{overflow:"unset"}} */>
                                <CreateTableForUserTemplate
                                    dataList={userTemplate}
                                    dataHeader={header_new}
                                    dataAccessor={accessor_new}
                                    editHandleClick={editHandleClick_new}
                                    // deleteHandleClick={deleteHandleClick}
                                    viewReports={openReportsForm}
                                    isAddState={isAddState}
                                    setIsAddState={setIsAddState}
                                    isEditState={isEditState}
                                    setIsEditState={setIsEditState}
                                    dataToEdit={dataToEdit}
                                    description={description} 
                                    setDescription={setDescription}
                                    hasHome={hasHome}
                                    setHasHome={setHasHome}
                                    hasAddEmployee={hasAddEmployee}
                                    setHasAddEmployee={setHasAddEmployee}
                                    hasEmployeeList={hasEmployeeList}
                                    setHasEmployeeList={setHasEmployeeList}
                                    hasEmployeeStatus={hasEmployeeStatus}
                                    setHasEmployeeStatus={setHasEmployeeStatus}
                                    hasEmployeeSchedule={hasEmployeeSchedule}
                                    setHasEmployeeSchedule={setHasEmployeeSchedule}
                                    hasTimeEntries={hasTimeEntries}
                                    setHasTimeEntries={setHasTimeEntries}
                                    hasShiftSchedule={hasShiftSchedule}
                                    setHasShiftSchedule={setHasShiftSchedule}
                                    hasProcessPayroll={hasProcessPayroll}
                                    setHasProcessPayroll={setHasProcessPayroll}
                                    has13thMonth={has13thMonth}
                                    setHas13thMonth={setHas13thMonth}
                                    hasPayrollPeriod={hasPayrollPeriod}
                                    setHasPayrollPeriod={setHasPayrollPeriod}
                                    hasPayType={hasPayType}
                                    setHasPayType={setHasPayType}
                                    hasClient={hasClient}
                                    setHasClient={setHasClient}
                                    hasHoliday={hasHoliday}
                                    setHasHoliday={setHasHoliday}
                                    hasHolidayType={hasHolidayType}
                                    setHasHolidayType={setHasHolidayType}
                                    hasLeaveType={hasLeaveType}
                                    setHasLeaveType={setHasLeaveType}
                                    hasDepartment={hasDepartment}
                                    setHasDepartment={setHasDepartment}
                                    hasSection={hasSection}
                                    setHasSection={setHasSection}
                                    hasClassification={hasClassification}
                                    setHasClassification={setHasClassification}
                                    hasCompany={hasCompany}
                                    setHasCompany={setHasCompany}
                                    hasPosition={hasPosition}
                                    setHasPosition={setHasPosition}
                                    hasJobTitle={hasJobTitle}
                                    setHasJobTitle={setHasJobTitle}
                                    hasLocation={hasLocation}
                                    setHasLocation={setHasLocation}
                                    hasDTRRulesConfiguration={hasDTRRulesConfiguration}
                                    setHasDTRRulesConfiguration={setHasDTRRulesConfiguration}
                                    hasEmployeeMonthlySalary={hasEmployeeMonthlySalary}
                                    setHasEmployeeMonthlySalary={setHasEmployeeMonthlySalary}
                                    hasEmployeeDailySalary={hasEmployeeDailySalary}
                                    setHasEmployeeDailySalary={setHasEmployeeDailySalary}
                                    hasPositionDesignationSalary={hasPositionDesignationSalary}
                                    hasQuotaBasedSalary={hasQuotaBasedSalary}
                                    setHasPositionDesignationSalary={setHasPositionDesignationSalary}
                                    setHasQuotaBasedSalary={setHasQuotaBasedSalary}
                                    hasPositionDesignationSalaryLaUnion={hasPositionDesignationSalaryLaUnion}
                                    setHasPositionDesignationSalaryLaUnion={setHasPositionDesignationSalaryLaUnion}
                                    hasEmployeeBankAccount={hasEmployeeBankAccount}
                                    setHasEmployeeBankAccount={setHasEmployeeBankAccount}
                                    hasBIRTax={hasBIRTax}
                                    setHasBIRTax={setHasBIRTax}
                                    hasPagibig={hasPagibig}
                                    setHasPagibig={setHasPagibig}
                                    hasSSS={hasSSS}
                                    setHasSSS={setHasSSS}
                                    hasPhilhealth={hasPhilhealth}
                                    setHasPhilhealth={setHasPhilhealth}
                                    hasDTR={hasDTR}
                                    setHasDTR={setHasDTR}
                                    hasDTRBiometrics={hasDTRBiometrics}
                                    setHasDTRBiometrics={setHasDTRBiometrics}
                                    hasApproverHierarchy={hasApproverHierarchy}
                                    setHasApproverHierarchy={setHasApproverHierarchy}
                                    hasRequestApproval={hasRequestApproval}
                                    setHasRequestApproval={setHasRequestApproval}
                                    hasOvertime={hasOvertime}
                                    setHasOvertime={setHasOvertime}
                                    hasDTRCorrection={hasDTRCorrection}
                                    setHasDTRCorrection={setHasDTRCorrection}
                                    hasLeave={hasLeave}
                                    setHasLeave={setHasLeave}
                                    hasChangeOfSchedule={hasChangeOfSchedule}
                                    setHasChangeOfSchedule={setHasChangeOfSchedule}
                                    hasSSSLoan={hasSSSLoan}
                                    setHasSSSLoan={setHasSSSLoan}
                                    hasSSSCalamityLoan={hasSSSCalamityLoan}
                                    setHasSSSCalamityLoan={setHasSSSCalamityLoan}
                                    hasPagibigLoan={hasPagibigLoan}
                                    setHasPagibigLoan={setHasPagibigLoan}
                                    hasPagibigCalamityLoan={hasPagibigCalamityLoan}
                                    setHasPagibigCalamityLoan={setHasPagibigCalamityLoan}
                                    hasCashAdvance={hasCashAdvance}
                                    setHasCashAdvance={setHasCashAdvance}
                                    hasDeductions={hasDeductions}
                                    setHasDeductions={setHasDeductions}
                                    hasBenefits={hasBenefits}
                                    setHasBenefits={setHasBenefits}
                                    hasReports={hasReports}
                                    setHasReports={setHasReports}
                                    hasSettings={hasSettings}
                                    setHasSettings={setHasSettings}
                                    hasCalendar={hasCalendar}
                                    setHasCalendar={setHasCalendar}
                                    hasUser={hasUser}
                                    setHasUser={setHasUser}
                                    userTimeOut={userTimeOut}
                                    setUserTimeOut={setUserTimeOut}

                                    // additional
                                    hasEmployeereliever={hasEmployeereliever} setHasEmployeereliever={setHasEmployeereliever}
                                    hasMassapproval={hasMassapproval} setHasMassapproval={setHasMassapproval}
                                    hasApproverheirarchyperlocation={hasApproverheirarchyperlocation} setHasApproverheirarchyperlocation={setHasApproverheirarchyperlocation}
                                    hasFinalPay={hasFinalPay} setHasFinalPay={setHasFinalPay}
                                    hasSubcon={hasSubcon} setHasSubcon={setHasSubcon}
                                    hasAgency={hasAgency} setHasAgency={setHasAgency}
                                    hasEmploymentStatus={hasEmploymentStatus} setHasEmploymentStatus={setHasEmploymentStatus}
                                    hasLoans={hasLoans} setHasLoans={setHasLoans}
                                    hasTimeKeeper={hasTimeKeeper} setHasTimeKeeper={setHasTimeKeeper}
                                    hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                                    hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                                    hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                                    hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                                    hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                                    hasResigned={hasResigned} setHasResigned={setHasResigned}
                                    hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                                    hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                                    hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                                    hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                                    hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                                    hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                                    hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                                    has201Report={has201Report} setHas201Report={setHas201Report}
                                    hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                                    hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                                    hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                                    hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                                    hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                                    hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                                    hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                                    hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                                    hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                                    hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                                    hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                                    hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                                    hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                                    hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                                    hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                                    hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                                    hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                                    hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                                    hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                                    hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                                    hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                                    hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                                    hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                                    hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                                    hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                                    hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                                    hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                                    hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                                    hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                                    hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                                    hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                                    hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                                    hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                                    hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                                    hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                                    hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                                    hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                                    hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                                    hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                                    hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                                    hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                                    hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                                    hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                                    hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                                    hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                                    hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                                    hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                                    hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                                    hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                                    hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                                    hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                                    hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                                    hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                                    hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                                    hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                                    hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                                    hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                                    hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                                    hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                                    hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                                    hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                                    hasNotification={hasNotification} setHasNotification={setHasNotification}
                                    hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}
                                    hasRequestApprovalTimeKeeper={hasRequestApprovalTimeKeeper} setHasRequestApprovalTimeKeeper={setHasRequestApprovalTimeKeeper}
                                    hasTamperedApproval={hasTamperedApproval} setHasTamperedApproval={setHasTamperedApproval}
                                    hasMobileDTRApproval={hasMobileDTRApproval} setHasMobileDTRApproval={setHasMobileDTRApproval}
                                    hasDTRWithOTViewing={hasDTRWithOTViewing} setHasDTRWithOTViewing={setHasDTRWithOTViewing}
                                    hasDTRCorrectionWorkers={hasDTRCorrectionWorkers} setHasDTRCorrectionWorkers={setHasDTRCorrectionWorkers}
                                    hasPlantilya={hasPlantilya} setHasPlantilya={setHasPlantilya}
                                    hasCostCenter={hasCostCenter} setHasCostCenter={setHasCostCenter}
                                    hasPayrollJournalAccount={hasPayrollJournalAccount} setHasPayrollJournalAccount={setHasPayrollJournalAccount}
                                    hasManHour={hasManHour} setHasManHour={setHasManHour}
                                    hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                                    hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                                    hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                                    hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                                    hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}
                                    hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}
                                    hasOffsetCredits={hasOffsetCredits} setHasOffsetCredits={setHasOffsetCredits}
                                    hasOffsetRequest={hasOffsetRequest} setHasOffsetRequest={setHasOffsetRequest}
                                    hasEmployeeGroup1={hasEmployeeGroup1} setHasEmployeeGroup1={setHasEmployeeGroup1}
                                    hasEmployeeGroup2={hasEmployeeGroup2} setHasEmployeeGroup2={setHasEmployeeGroup2}
                                    hasOnBoarding={hasOnBoarding} setHasOnBoarding={setHasOnBoarding}
                                    hasOnBoardingPersonnel={hasOnBoardingPersonnel} setHasOnBoardingPersonnel={setHasOnBoardingPersonnel}
                                    hasOutBoarding={hasOutBoarding} setHasOutBoarding={setHasOutBoarding}
                                    hasOnBoardingRequirements={hasOnBoardingRequirements} setHasOnBoardingRequirements={setHasOnBoardingRequirements}
                                    hasOutBoardingRequirements={hasOutBoardingRequirements} setHasOutBoardingRequirements={setHasOutBoardingRequirements}

                                    handleSubmit={handleSubmit}
                                    handleUpdate={handleUpdate}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                                {userTemplate.length > 0 ? (
                                    <div></div>
                                )
                                :
                                (
                                    <div>
                                    {loading ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    ) : (
                                            isAddState ? <></>
                                            :
                                            <div> {/*<p>No records to display</p>*/}</div>
                                        )
                                    }
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        </div>
                    </div>
                )}
                </div>
            }

            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <Reports 
                isOpen={showReportsForm}
                onClose={closeReportsForm}
                isAddState={isAddState}
                setIsAddState={setIsAddState}
                user={user}
                reportData={reportData}
                setReportData={setReportData}
                dataToEdit={dataToEdit}
                isEditState={isEditState}
                setIsEditState={setIsEditState}
                userTemplate={userTemplate}
                setUserTempalte={setUserTempalte}

                description={description} setDescription={setDescription}
                hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                hasResigned={hasResigned} setHasResigned={setHasResigned}
                hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                has201Report={has201Report} setHas201Report={setHas201Report}
                hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                hasNotification={hasNotification} setHasNotification={setHasNotification}
                hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}
                hasManHour={hasManHour} setHasManHour={setHasManHour}
                hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}
                hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}
                hasOffsetCredits={hasOffsetCredits} setHasOffsetCredits={setHasOffsetCredits}
                hasOffsetRequest={hasOffsetRequest} setHasOffsetRequest={setHasOffsetRequest}
                hasEmployeeGroup1={hasEmployeeGroup1} setHasEmployeeGroup1={setHasEmployeeGroup1}
                hasEmployeeGroup2={hasEmployeeGroup2} setHasEmployeeGroup2={setHasEmployeeGroup2}
                hasOnBoarding={hasOnBoarding} setHasOnBoarding={setHasOnBoarding}
                hasOnBoardingPersonnel={hasOnBoardingPersonnel} setHasOnBoardingPersonnel={setHasOnBoardingPersonnel}
                hasOutBoarding={hasOutBoarding} setHasOutBoarding={setHasOutBoarding}
                hasOnBoardingRequirements={hasOnBoardingRequirements} setHasOnBoardingRequirements={setHasOnBoardingRequirements}
                hasOutBoardingRequirements={hasOutBoardingRequirements} setHasOutBoardingRequirements={setHasOutBoardingRequirements}

                oldHasPerDayTracker={oldHasPerDayTracker} setOldHasPerDayTracker={setOldHasPerDayTracker}
                oldHasOvertimeSummaryReport ={oldHasOvertimeSummaryReport} setOldHasOvertimeSummaryReport ={setOldHasOvertimeSummaryReport }
                oldHasTrackerReport={oldHasTrackerReport} setOldHasTrackerReport={setOldHasTrackerReport}
                oldHasPayslip={oldHasPayslip} setOldHasPayslip={setOldHasPayslip}
                oldHasPayrollRegister={oldHasPayrollRegister} setOldHasPayrollRegister={setOldHasPayrollRegister}
                oldHasResigned={oldHasResigned} setOldHasResigned={setOldHasResigned}
                oldHasActiveEmployees={oldHasActiveEmployees} setOldHasActiveEmployees={setOldHasActiveEmployees}
                oldHasYearOfService={oldHasYearOfService} setOldHasYearOfService={setOldHasYearOfService}
                oldHasSSSSummary={oldHasSSSSummary} setOldHasSSSSummary={setOldHasSSSSummary}
                oldHasPagibigSummary={oldHasPagibigSummary} setOldHasPagibigSummary={setOldHasPagibigSummary}
                oldHasPhilhealthSummary={oldHasPhilhealthSummary} setOldHasPhilhealthSummary={setOldHasPhilhealthSummary}
                oldHasSSSLoanReport={oldHasSSSLoanReport} setOldHasSSSLoanReport={setOldHasSSSLoanReport}
                oldHasPagibigLoanReport={oldHasPagibigLoanReport} setOldHasPagibigLoanReport={setOldHasPagibigLoanReport}
                oldHas201Report={oldHas201Report} setOldHas201Report={setOldHas201Report}
                oldHasAttendanceReport={oldHasAttendanceReport} setOldHasAttendanceReport={setOldHasAttendanceReport}
                oldHasBankTransmittalBDO={oldHasBankTransmittalBDO} setOldHasBankTransmittalBDO={setOldHasBankTransmittalBDO}
                oldHasBankTransmittalBPI={oldHasBankTransmittalBPI} setOldHasBankTransmittalBPI={setOldHasBankTransmittalBPI}
                oldHasBankTransmittalChinaBankSavings={oldHasBankTransmittalChinaBankSavings} setOldHasBankTransmittalChinaBankSavings={setOldHasBankTransmittalChinaBankSavings}
                oldHasBankTransmittalHSBC={oldHasBankTransmittalHSBC} setOldHasBankTransmittalHSBC={setOldHasBankTransmittalHSBC}
                oldHasBankTransmittalSecurityBank={oldHasBankTransmittalSecurityBank} setOldHasBankTransmittalSecurityBank={setOldHasBankTransmittalSecurityBank}
                oldHasSummaryOfTardiness={oldHasSummaryOfTardiness} setOldHasSummaryOfTardiness={setOldHasSummaryOfTardiness}
                oldHasAbsencesMemo={oldHasAbsencesMemo} setOldHasAbsencesMemo={setOldHasAbsencesMemo}
                oldHasAbsencesReport={oldHasAbsencesReport} setOldHasAbsencesReport={setOldHasAbsencesReport}
                oldHasActionHistoryReport={oldHasActionHistoryReport} setOldHasActionHistoryReport={setOldHasActionHistoryReport}
                oldHasAllowanceSummary={oldHasAllowanceSummary} setOldHasAllowanceSummary={setOldHasAllowanceSummary}
                oldHasAuditTrailReportEmployeeSetup={oldHasAuditTrailReportEmployeeSetup} setOldHasAuditTrailReportEmployeeSetup={setOldHasAuditTrailReportEmployeeSetup}
                oldHasBundyClockUsage={oldHasBundyClockUsage} setOldHasBundyClockUsage={setOldHasBundyClockUsage}
                oldHasBasicPayAdjustmentReport={oldHasBasicPayAdjustmentReport} setOldHasBasicPayAdjustmentReport={setOldHasBasicPayAdjustmentReport}
                oldHasCertificateOfEmployment={oldHasCertificateOfEmployment} setOldHasCertificateOfEmployment={setOldHasCertificateOfEmployment}
                oldHasCertificateOfPagibig={oldHasCertificateOfPagibig} setOldHasCertificateOfPagibig={setOldHasCertificateOfPagibig}
                oldHasCertificateOfPhilhealth={oldHasCertificateOfPhilhealth} setOldHasCertificateOfPhilhealth={setOldHasCertificateOfPhilhealth}
                oldHasCertificateOfSSS={oldHasCertificateOfSSS} setOldHasCertificateOfSSS={setOldHasCertificateOfSSS}
                oldHasCommissionsSummary={oldHasCommissionsSummary} setOldHasCommissionsSummary={setOldHasCommissionsSummary}
                oldHasCostCenterReport={oldHasCostCenterReport} setOldHasCostCenterReport={setOldHasCostCenterReport}
                oldHasDeductionsPerMonth={oldHasDeductionsPerMonth} setOldHasDeductionsPerMonth={setOldHasDeductionsPerMonth}
                oldHasDTRReport={oldHasDTRReport} setOldHasDTRReport={setOldHasDTRReport}
                oldHasEarningsPerMonth={oldHasEarningsPerMonth} setOldHasEarningsPerMonth={setOldHasEarningsPerMonth}
                oldHasEmployeeLeaveGroup={oldHasEmployeeLeaveGroup} setOldHasEmployeeLeaveGroup={setOldHasEmployeeLeaveGroup}
                oldHasEmployeeOvertimeGroup={oldHasEmployeeOvertimeGroup} setOldHasEmployeeOvertimeGroup={setOldHasEmployeeOvertimeGroup}
                oldHasEmployeeExpenseGroup={oldHasEmployeeExpenseGroup} setOldHasEmployeeExpenseGroup={setOldHasEmployeeExpenseGroup}
                oldHasEmployeeLeaveHistory={oldHasEmployeeLeaveHistory} setOldHasEmployeeLeaveHistory={setOldHasEmployeeLeaveHistory}
                oldHasEmployeeListingByHiringDate={oldHasEmployeeListingByHiringDate} setOldHasEmployeeListingByHiringDate={setOldHasEmployeeListingByHiringDate}
                oldHasEmployeeRegister={oldHasEmployeeRegister} setOldHasEmployeeRegister={setOldHasEmployeeRegister}
                oldHasExpenseReport={oldHasExpenseReport} setOldHasExpenseReport={setOldHasExpenseReport}
                oldHasGovernmentEmployeeInventory={oldHasGovernmentEmployeeInventory} setOldHasGovernmentEmployeeInventory={setOldHasGovernmentEmployeeInventory}
                oldHasHeadcountReport={oldHasHeadcountReport} setOldHasHeadcountReport={setOldHasHeadcountReport}
                oldHasHolidayPremiumSummary={oldHasHolidayPremiumSummary} setOldHasHolidayPremiumSummary={setOldHasHolidayPremiumSummary}
                oldHasLeaveLedgerReport={oldHasLeaveLedgerReport} setOldHasLeaveLedgerReport={setOldHasLeaveLedgerReport}
                oldHasLeaveSummaryReport={oldHasLeaveSummaryReport} setOldHasLeaveSummaryReport={setOldHasLeaveSummaryReport}
                oldHasLoanHistory={oldHasLoanHistory} setOldHasLoanHistory={setOldHasLoanHistory}
                oldHasLoanPaymentsSummary={oldHasLoanPaymentsSummary} setOldHasLoanPaymentsSummary={setOldHasLoanPaymentsSummary}
                oldHasLoansMonthlyAmortizationSummary={oldHasLoansMonthlyAmortizationSummary} setOldHasLoansMonthlyAmortizationSummary={setOldHasLoansMonthlyAmortizationSummary}
                oldHasLoansPenaltyHistory={oldHasLoansPenaltyHistory} setOldHasLoansPenaltyHistory={setOldHasLoansPenaltyHistory}
                oldHasNightDifferentialSummary={oldHasNightDifferentialSummary} setOldHasNightDifferentialSummary={setOldHasNightDifferentialSummary}
                oldHasNonTaxableAllowancesReport={oldHasNonTaxableAllowancesReport} setOldHasNonTaxableAllowancesReport={setOldHasNonTaxableAllowancesReport}
                oldHasOtherEarningsReport={oldHasOtherEarningsReport} setOldHasOtherEarningsReport={setOldHasOtherEarningsReport}
                oldHasOtherDeductionsSummary={oldHasOtherDeductionsSummary} setOldHasOtherDeductionsSummary={setOldHasOtherDeductionsSummary}
                oldHasOutstandingLoans={oldHasOutstandingLoans} setOldHasOutstandingLoans={setOldHasOutstandingLoans}
                oldHasPayrollCashRegister={oldHasPayrollCashRegister} setOldHasPayrollCashRegister={setOldHasPayrollCashRegister}
                oldHasPayrollCheckRegister={oldHasPayrollCheckRegister} setOldHasPayrollCheckRegister={setOldHasPayrollCheckRegister}
                oldHasPayrollDebitMemo={oldHasPayrollDebitMemo} setOldHasPayrollDebitMemo={setOldHasPayrollDebitMemo}
                oldHasPayrollJournalByCostCenter={oldHasPayrollJournalByCostCenter} setOldHasPayrollJournalByCostCenter={setOldHasPayrollJournalByCostCenter}
                oldHasPayrollJournalByDepartment={oldHasPayrollJournalByDepartment} setOldHasPayrollJournalByDepartment={setOldHasPayrollJournalByDepartment}
                oldHasPayrollJournalBySummary={oldHasPayrollJournalBySummary} setOldHasPayrollJournalBySummary={setOldHasPayrollJournalBySummary}
                oldHasPayrollPerPaymentMethod={oldHasPayrollPerPaymentMethod} setOldHasPayrollPerPaymentMethod={setOldHasPayrollPerPaymentMethod}
                oldHasSelectLogs={oldHasSelectLogs} setOldHasSelectLogs={setOldHasSelectLogs}
                oldHasSummaryReportByMonthAndDepartment={oldHasSummaryReportByMonthAndDepartment} setOldHasSummaryReportByMonthAndDepartment={setOldHasSummaryReportByMonthAndDepartment}
                oldHasTardinessMemo={oldHasTardinessMemo} setOldHasTardinessMemo={setOldHasTardinessMemo}
                oldHasTimeKeepingHistoryDetailedReport={oldHasTimeKeepingHistoryDetailedReport} setOldHasTimeKeepingHistoryDetailedReport={setOldHasTimeKeepingHistoryDetailedReport}
                oldHasTimeKeepingHoursWorkedReport={oldHasTimeKeepingHoursWorkedReport} setOldHasTimeKeepingHoursWorkedReport={setOldHasTimeKeepingHoursWorkedReport}
                oldHasTimeKeepingHoursWorkedSummary={oldHasTimeKeepingHoursWorkedSummary} setOldHasTimeKeepingHoursWorkedSummary={setOldHasTimeKeepingHoursWorkedSummary}
                oldHasTimesheetStatusReport={oldHasTimesheetStatusReport} setOldHasTimesheetStatusReport={setOldHasTimesheetStatusReport}
                oldHasYTDeductionSummary={oldHasYTDeductionSummary} setOldHasYTDeductionSummary={setOldHasYTDeductionSummary}
                oldHasYTDEarningsSummary={oldHasYTDEarningsSummary} setOldHasYTDearningsSummary={setOldHasYTDearningsSummary}
                oldHasYTDPayrollRegister={oldHasYTDPayrollRegister} setOldHasYTDPayrollRegister={setOldHasYTDPayrollRegister}
                oldHasNotification={oldHasNotification} setOldHasNotification={setHasNotification}
                oldHasMobileBiometrics={oldHasMobileBiometrics} setOldHasMobileBiometrics={setOldHasMobileBiometrics}
            />
            <AddTemplateFormNew 
                isOpen={showAddForm_new}
                onClose={closeAddForm_new}
                description={description} setDescription={setDescription}
                hasHome={hasHome} setHasHome={setHasHome}
                hasAddEmployee={hasAddEmployee} setHasAddEmployee={setHasAddEmployee}
                hasEmployeeList={hasEmployeeList} setHasEmployeeList={setHasEmployeeList}
                hasEmployeeStatus={hasEmployeeStatus} setHasEmployeeStatus={setHasEmployeeStatus}
                hasEmployeeSchedule={hasEmployeeSchedule} setHasEmployeeSchedule={setHasEmployeeSchedule}
                hasTimeEntries={hasTimeEntries} setHasTimeEntries={setHasTimeEntries}
                hasShiftSchedule={hasShiftSchedule} setHasShiftSchedule={setHasShiftSchedule}
                hasProcessPayroll={hasProcessPayroll} setHasProcessPayroll={setHasProcessPayroll}
                has13thMonth={has13thMonth} setHas13thMonth={setHas13thMonth}
                hasPayrollPeriod={hasPayrollPeriod} setHasPayrollPeriod={setHasPayrollPeriod}
                hasClient={hasClient} setHasClient={setHasClient}
                hasPayType={hasPayType} setHasPayType={setHasPayType}
                hasHoliday={hasHoliday} setHasHoliday={setHasHoliday}
                hasHolidayType={hasHolidayType} setHasHolidayType={setHasHolidayType}
                hasLeaveType={hasLeaveType} setHasLeaveType={setHasLeaveType}
                hasDepartment={hasDepartment} setHasDepartment={setHasDepartment}
                hasSection={hasSection} setHasSection={setHasSection}
                hasClassification={hasClassification} setHasClassification={setHasClassification}
                hasCompany={hasCompany} setHasCompany={setHasCompany}
                hasPosition={hasPosition} setHasPosition={setHasPosition}
                hasJobTitle={hasJobTitle} setHasJobTitle={setHasJobTitle}
                hasLocation={hasLocation} setHasLocation={setHasLocation}
                hasDTRRulesConfiguration={hasDTRRulesConfiguration} setHasDTRRulesConfiguration={setHasDTRRulesConfiguration}
                hasEmployeeMonthlySalary={hasEmployeeMonthlySalary} setHasEmployeeMonthlySalary={setHasEmployeeMonthlySalary}
                hasEmployeeDailySalary={hasEmployeeDailySalary} setHasEmployeeDailySalary={setHasEmployeeDailySalary}
                hasPositionDesignationSalary={hasPositionDesignationSalary} setHasPositionDesignationSalary={setHasPositionDesignationSalary}
                hasQuotaBasedSalary={hasQuotaBasedSalary} setHasQuotaBasedSalary={setHasQuotaBasedSalary}
                hasPositionDesignationSalaryLaUnion={hasPositionDesignationSalaryLaUnion} setHasPositionDesignationSalaryLaUnion={setHasPositionDesignationSalaryLaUnion}
                hasEmployeeBankAccount={hasEmployeeBankAccount} setHasEmployeeBankAccount={setHasEmployeeBankAccount}
                hasBIRTax={hasBIRTax} setHasBIRTax={setHasBIRTax}
                hasPagibig={hasPagibig} setHasPagibig={setHasPagibig}
                hasSSS={hasSSS} setHasSSS={setHasSSS}
                hasPhilhealth={hasPhilhealth} setHasPhilhealth={setHasPhilhealth}
                hasDTR={hasDTR} setHasDTR={setHasDTR}
                hasDTRBiometrics={hasDTRBiometrics} setHasDTRBiometrics={setHasDTRBiometrics}
                hasApproverHierarchy={hasApproverHierarchy} setHasApproverHierarchy={setHasApproverHierarchy}
                hasRequestApproval={hasRequestApproval} setHasRequestApproval={setHasRequestApproval}
                hasOvertime={hasOvertime} setHasOvertime={setHasOvertime}
                hasDTRCorrection={hasDTRCorrection} setHasDTRCorrection={setHasDTRCorrection}
                hasLeave={hasLeave} setHasLeave={setHasLeave}
                hasChangeOfSchedule={hasChangeOfSchedule} setHasChangeOfSchedule={setHasChangeOfSchedule}
                hasSSSLoan={hasSSSLoan} setHasSSSLoan={setHasSSSLoan}
                hasSSSCalamityLoan={hasSSSCalamityLoan} setHasSSSCalamityLoan={setHasSSSCalamityLoan}
                hasPagibigLoan={hasPagibigLoan} setHasPagibigLoan={setHasPagibigLoan}
                hasPagibigCalamityLoan={hasPagibigCalamityLoan} setHasPagibigCalamityLoan={setHasPagibigCalamityLoan}
                hasCashAdvance={hasCashAdvance} setHasCashAdvance={setHasCashAdvance}
                hasDeductions={hasDeductions} setHasDeductions={setHasDeductions}
                hasBenefits={hasBenefits} setHasBenefits={setHasBenefits}
                hasReports={hasReports} setHasReports={setHasReports}
                hasSettings={hasSettings} setHasSettings={setHasSettings}
                hasCalendar={hasCalendar} setHasCalendar={setHasCalendar}
                hasUser={hasUser} setHasUser={setHasUser}
                userTimeOut={userTimeOut} setUserTimeOut={setUserTimeOut}

                // additional
                hasEmployeereliever={hasEmployeereliever} setHasEmployeereliever={setHasEmployeereliever}
                hasMassapproval={hasMassapproval} setHasMassapproval={setHasMassapproval}
                hasApproverheirarchyperlocation={hasApproverheirarchyperlocation} setHasApproverheirarchyperlocation={setHasApproverheirarchyperlocation}
                hasFinalPay={hasFinalPay} setHasFinalPay={setHasFinalPay}
                hasSubcon={hasSubcon} setHasSubcon={setHasSubcon}
                hasAgency={hasAgency} setHasAgency={setHasAgency}
                hasEmploymentStatus={hasEmploymentStatus} setHasEmploymentStatus={setHasEmploymentStatus}
                hasLoans={hasLoans} setHasLoans={setHasLoans}
                hasTimeKeeper={hasTimeKeeper} setHasTimeKeeper={setHasTimeKeeper}
                hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                hasResigned={hasResigned} setHasResigned={setHasResigned}
                hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                has201Report={has201Report} setHas201Report={setHas201Report}
                hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                hasNotification={hasNotification} setHasNotification={setHasNotification}
                hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}
                hasRequestApprovalTimeKeeper={hasRequestApprovalTimeKeeper} setHasRequestApprovalTimeKeeper={setHasRequestApprovalTimeKeeper}
                hasTamperedApproval={hasTamperedApproval} setHasTamperedApproval={setHasTamperedApproval}
                hasMobileDTRApproval={hasMobileDTRApproval} setHasMobileDTRApproval={setHasMobileDTRApproval}
                hasDTRWithOTViewing={hasDTRWithOTViewing} setHasDTRWithOTViewing={setHasDTRWithOTViewing}
                hasDTRCorrectionWorkers={hasDTRCorrectionWorkers} setHasDTRCorrectionWorkers={setHasDTRCorrectionWorkers}
                hasPlantilya={hasPlantilya} setHasPlantilya={setHasPlantilya}
                hasCostCenter={hasCostCenter} setHasCostCenter={setHasCostCenter}
                hasPayrollJournalAccount={hasPayrollJournalAccount} setHasPayrollJournalAccount={setHasPayrollJournalAccount}
                hasManHour={hasManHour} setHasManHour={setHasManHour}
                hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}
                hasOffsetCredits={hasOffsetCredits} setHasOffsetCredits={setHasOffsetCredits}
                hasOffsetRequest={hasOffsetRequest} setHasOffsetRequest={setHasOffsetRequest}
                hasEmployeeGroup1={hasEmployeeGroup1} setHasEmployeeGroup1={setHasEmployeeGroup1}
                hasEmployeeGroup2={hasEmployeeGroup2} setHasEmployeeGroup2={setHasEmployeeGroup2}
                hasOnBoarding={hasOnBoarding} setHasOnBoarding={setHasOnBoarding}
                hasOnBoardingPersonnel={hasOnBoardingPersonnel} setHasOnBoardingPersonnel={setHasOnBoardingPersonnel}
                hasOutBoarding={hasOutBoarding} setHasOutBoarding={setHasOutBoarding}
                hasOnBoardingRequirements={hasOnBoardingRequirements} setHasOnBoardingRequirements={setHasOnBoardingRequirements}
                hasOutBoardingRequirements={hasOutBoardingRequirements} setHasOutBoardingRequirements={setHasOutBoardingRequirements}
                hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}

                handleSubmit={handleSubmit}
            />
            <EditTemplateFormNew 
                isOpen={showEditForm_new}
                onClose={closeEditForm_new}
                description={description} setDescription={setDescription}
                hasHome={hasHome} setHasHome={setHasHome}
                hasAddEmployee={hasAddEmployee} setHasAddEmployee={setHasAddEmployee}
                hasEmployeeList={hasEmployeeList} setHasEmployeeList={setHasEmployeeList}
                hasEmployeeStatus={hasEmployeeStatus} setHasEmployeeStatus={setHasEmployeeStatus}
                hasEmployeeSchedule={hasEmployeeSchedule} setHasEmployeeSchedule={setHasEmployeeSchedule}
                hasTimeEntries={hasTimeEntries} setHasTimeEntries={setHasTimeEntries}
                hasShiftSchedule={hasShiftSchedule} setHasShiftSchedule={setHasShiftSchedule}
                hasProcessPayroll={hasProcessPayroll} setHasProcessPayroll={setHasProcessPayroll}
                has13thMonth={has13thMonth} setHas13thMonth={setHas13thMonth}
                hasPayrollPeriod={hasPayrollPeriod} setHasPayrollPeriod={setHasPayrollPeriod}
                hasClient={hasClient} setHasClient={setHasClient}
                hasPayType={hasPayType} setHasPayType={setHasPayType}
                hasHoliday={hasHoliday} setHasHoliday={setHasHoliday}
                hasHolidayType={hasHolidayType} setHasHolidayType={setHasHolidayType}
                hasLeaveType={hasLeaveType} setHasLeaveType={setHasLeaveType}
                hasDepartment={hasDepartment} setHasDepartment={setHasDepartment}
                hasSection={hasSection} setHasSection={setHasSection}
                hasClassification={hasClassification} setHasClassification={setHasClassification}
                hasCompany={hasCompany} setHasCompany={setHasCompany}
                hasPosition={hasPosition} setHasPosition={setHasPosition}
                hasJobTitle={hasJobTitle} setHasJobTitle={setHasJobTitle}
                hasLocation={hasLocation} setHasLocation={setHasLocation}
                hasDTRRulesConfiguration={hasDTRRulesConfiguration} setHasDTRRulesConfiguration={setHasDTRRulesConfiguration}
                hasEmployeeMonthlySalary={hasEmployeeMonthlySalary} setHasEmployeeMonthlySalary={setHasEmployeeMonthlySalary}
                hasEmployeeDailySalary={hasEmployeeDailySalary} setHasEmployeeDailySalary={setHasEmployeeDailySalary}
                hasPositionDesignationSalary={hasPositionDesignationSalary} setHasPositionDesignationSalary={setHasPositionDesignationSalary}
                hasQuotaBasedSalary={hasQuotaBasedSalary} setHasQuotaBasedSalary={setHasQuotaBasedSalary}
                hasPositionDesignationSalaryLaUnion={hasPositionDesignationSalaryLaUnion} setHasPositionDesignationSalaryLaUnion={setHasPositionDesignationSalaryLaUnion}
                hasEmployeeBankAccount={hasEmployeeBankAccount} setHasEmployeeBankAccount={setHasEmployeeBankAccount}
                hasBIRTax={hasBIRTax} setHasBIRTax={setHasBIRTax}
                hasPagibig={hasPagibig} setHasPagibig={setHasPagibig}
                hasSSS={hasSSS} setHasSSS={setHasSSS}
                hasPhilhealth={hasPhilhealth} setHasPhilhealth={setHasPhilhealth}
                hasDTR={hasDTR} setHasDTR={setHasDTR}
                hasDTRBiometrics={hasDTRBiometrics} setHasDTRBiometrics={setHasDTRBiometrics}
                hasApproverHierarchy={hasApproverHierarchy} setHasApproverHierarchy={setHasApproverHierarchy}
                hasRequestApproval={hasRequestApproval} setHasRequestApproval={setHasRequestApproval}
                hasOvertime={hasOvertime} setHasOvertime={setHasOvertime}
                hasDTRCorrection={hasDTRCorrection} setHasDTRCorrection={setHasDTRCorrection}
                hasLeave={hasLeave} setHasLeave={setHasLeave}
                hasChangeOfSchedule={hasChangeOfSchedule} setHasChangeOfSchedule={setHasChangeOfSchedule}
                hasSSSLoan={hasSSSLoan} setHasSSSLoan={setHasSSSLoan}
                hasSSSCalamityLoan={hasSSSCalamityLoan} setHasSSSCalamityLoan={setHasSSSCalamityLoan}
                hasPagibigLoan={hasPagibigLoan} setHasPagibigLoan={setHasPagibigLoan}
                hasPagibigCalamityLoan={hasPagibigCalamityLoan} setHasPagibigCalamityLoan={setHasPagibigCalamityLoan}
                hasCashAdvance={hasCashAdvance} setHasCashAdvance={setHasCashAdvance}
                hasDeductions={hasDeductions} setHasDeductions={setHasDeductions}
                hasBenefits={hasBenefits} setHasBenefits={setHasBenefits}
                hasReports={hasReports} setHasReports={setHasReports}
                hasSettings={hasSettings} setHasSettings={setHasSettings}
                hasCalendar={hasCalendar} setHasCalendar={setHasCalendar}
                hasUser={hasUser} setHasUser={setHasUser}
                userTimeOut={userTimeOut} setUserTimeOut={setUserTimeOut}

                // additional
                hasEmployeereliever={hasEmployeereliever} setHasEmployeereliever={setHasEmployeereliever}
                hasMassapproval={hasMassapproval} setHasMassapproval={setHasMassapproval}
                hasApproverheirarchyperlocation={hasApproverheirarchyperlocation} setHasApproverheirarchyperlocation={setHasApproverheirarchyperlocation}
                hasFinalPay={hasFinalPay} setHasFinalPay={setHasFinalPay}
                hasSubcon={hasSubcon} setHasSubcon={setHasSubcon}
                hasAgency={hasAgency} setHasAgency={setHasAgency}
                hasEmploymentStatus={hasEmploymentStatus} setHasEmploymentStatus={setHasEmploymentStatus}
                hasLoans={hasLoans} setHasLoans={setHasLoans}
                hasTimeKeeper={hasTimeKeeper} setHasTimeKeeper={setHasTimeKeeper}
                hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                hasResigned={hasResigned} setHasResigned={setHasResigned}
                hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                has201Report={has201Report} setHas201Report={setHas201Report}
                hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                hasNotification={hasNotification} setHasNotification={setHasNotification}
                hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}
                hasRequestApprovalTimeKeeper={hasRequestApprovalTimeKeeper} setHasRequestApprovalTimeKeeper={setHasRequestApprovalTimeKeeper}
                hasTamperedApproval={hasTamperedApproval} setHasTamperedApproval={setHasTamperedApproval}
                hasMobileDTRApproval={hasMobileDTRApproval} setHasMobileDTRApproval={setHasMobileDTRApproval}
                hasDTRWithOTViewing={hasDTRWithOTViewing} setHasDTRWithOTViewing={setHasDTRWithOTViewing}
                hasDTRCorrectionWorkers={hasDTRCorrectionWorkers} setHasDTRCorrectionWorkers={setHasDTRCorrectionWorkers}
                hasPlantilya={hasPlantilya} setHasPlantilya={setHasPlantilya}
                hasCostCenter={hasCostCenter} setHasCostCenter={setHasCostCenter}
                hasPayrollJournalAccount={hasPayrollJournalAccount} setHasPayrollJournalAccount={setHasPayrollJournalAccount}
                hasManHour={hasManHour} setHasManHour={setHasManHour}
                hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}
                hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}
                hasOffsetCredits={hasOffsetCredits} setHasOffsetCredits={setHasOffsetCredits}
                hasOffsetRequest={hasOffsetRequest} setHasOffsetRequest={setHasOffsetRequest}
                hasEmployeeGroup1={hasEmployeeGroup1} setHasEmployeeGroup1={setHasEmployeeGroup1}
                hasEmployeeGroup2={hasEmployeeGroup2} setHasEmployeeGroup2={setHasEmployeeGroup2}
                hasOnBoarding={hasOnBoarding} setHasOnBoarding={setHasOnBoarding}
                hasOnBoardingPersonnel={hasOnBoardingPersonnel} setHasOnBoardingPersonnel={setHasOnBoardingPersonnel}
                hasOutBoarding={hasOutBoarding} setHasOutBoarding={setHasOutBoarding}
                hasOnBoardingRequirements={hasOnBoardingRequirements} setHasOnBoardingRequirements={setHasOnBoardingRequirements}
                hasOutBoardingRequirements={hasOutBoardingRequirements} setHasOutBoardingRequirements={setHasOutBoardingRequirements}

                handleSubmit={handleUpdate}
            />
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function Reports({
    isOpen, 
    onClose,
    isAddState,
    setIsAddState,
    user,
    reportData,
    setReportData,
    userTemplate,
    setUserTempalte,

    dataToEdit,
    isEditState,
    setIsEditState,

    description, setDescription,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,
    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,
    hasBIR2316, setHasBIR2316,
    hasBIR1601C, setHasBIR1601C,
    hasAlphaList, setHasAlphaList,
    hasBankTransmittalReport, setHasBankTransmittalReport,
    hasOffsetCredits, setHasOffsetCredits,
    hasOffsetRequest, setHasOffsetRequest,
    hasEmployeeGroup1, setHasEmployeeGroup1,
    hasEmployeeGroup2, setHasEmployeeGroup2,
    hasOnBoarding, setHasOnBoarding,
    hasOnBoardingPersonnel, setHasOnBoardingPersonnel,
    hasOutBoarding, setHasOutBoarding,
    hasOnBoardingRequirements, setHasOnBoardingRequirements,
    hasOutBoardingRequirements, setHasOutBoardingRequirements,
    hasLoanReport, setHasLoanReport,
    
    oldHasPerDayTracker, setOldHasPerDayTracker,
    oldHasOvertimeSummaryReport, setOldHasOvertimeSummaryReport,
    oldHasTrackerReport, setOldHasTrackerReport,
    oldHasPayslip, setOldHasPayslip,
    oldHasPayrollRegister, setOldHasPayrollRegister,
    oldHasResigned, setOldHasResigned,
    oldHasActiveEmployees, setOldHasActiveEmployees,
    oldHasYearOfService, setOldHasYearOfService,
    oldHasSSSSummary, setOldHasSSSSummary,
    oldHasPagibigSummary, setOldHasPagibigSummary,
    oldHasPhilhealthSummary, setOldHasPhilhealthSummary,
    oldHasSSSLoanReport, setOldHasSSSLoanReport,
    oldHasPagibigLoanReport, setOldHasPagibigLoanReport,
    oldHas201Report, setOldHas201Report,
    oldHasAttendanceReport, setOldHasAttendanceReport,
    oldHasBankTransmittalBDO, setOldHasBankTransmittalBDO,
    oldHasBankTransmittalBPI, setOldHasBankTransmittalBPI,
    oldHasBankTransmittalChinaBankSavings, setOldHasBankTransmittalChinaBankSavings,
    oldHasBankTransmittalHSBC, setOldHasBankTransmittalHSBC,
    oldHasBankTransmittalSecurityBank, setOldHasBankTransmittalSecurityBank,
    oldHasSummaryOfTardiness, setOldHasSummaryOfTardiness,
    oldHasAbsencesMemo, setOldHasAbsencesMemo,
    oldHasAbsencesReport, setOldHasAbsencesReport,
    oldHasActionHistoryReport, setOldHasActionHistoryReport,
    oldHasAllowanceSummary, setOldHasAllowanceSummary,
    oldHasAuditTrailReportEmployeeSetup, setOldHasAuditTrailReportEmployeeSetup,
    oldHasBundyClockUsage, setOldHasBundyClockUsage,
    oldHasBasicPayAdjustmentReport, setOldHasBasicPayAdjustmentReport,
    oldHasCertificateOfEmployment, setOldHasCertificateOfEmployment,
    oldHasCertificateOfPagibig, setOldHasCertificateOfPagibig,
    oldHasCertificateOfPhilhealth, setOldHasCertificateOfPhilhealth,
    oldHasCertificateOfSSS, setOldHasCertificateOfSSS,
    oldHasCommissionsSummary, setOldHasCommissionsSummary,
    oldHasCostCenterReport, setOldHasCostCenterReport,
    oldHasDeductionsPerMonth, setOldHasDeductionsPerMonth,
    oldHasDTRReport, setOldHasDTRReport,
    oldHasEarningsPerMonth, setOldHasEarningsPerMonth,
    oldHasEmployeeLeaveGroup, setOldHasEmployeeLeaveGroup,
    oldHasEmployeeOvertimeGroup, setOldHasEmployeeOvertimeGroup,
    oldHasEmployeeExpenseGroup, setOldHasEmployeeExpenseGroup,
    oldHasEmployeeLeaveHistory, setOldHasEmployeeLeaveHistory,
    oldHasEmployeeListingByHiringDate, setOldHasEmployeeListingByHiringDate,
    oldHasEmployeeRegister, setOldHasEmployeeRegister,
    oldHasExpenseReport, setOldHasExpenseReport,
    oldHasGovernmentEmployeeInventory, setOldHasGovernmentEmployeeInventory,
    oldHasHeadcountReport, setOldHasHeadcountReport,
    oldHasHolidayPremiumSummary, setOldHasHolidayPremiumSummary,
    oldHasLeaveLedgerReport, setOldHasLeaveLedgerReport,
    oldHasLeaveSummaryReport, setOldHasLeaveSummaryReport,
    oldHasLoanHistory, setOldHasLoanHistory,
    oldHasLoanPaymentsSummary, setOldHasLoanPaymentsSummary,
    oldHasLoansMonthlyAmortizationSummary, setOldHasLoansMonthlyAmortizationSummary,
    oldHasLoansPenaltyHistory, setOldHasLoansPenaltyHistory,
    oldHasNightDifferentialSummary, setOldHasNightDifferentialSummary,
    oldHasNonTaxableAllowancesReport, setOldHasNonTaxableAllowancesReport,
    oldHasOtherEarningsReport, setOldHasOtherEarningsReport,
    oldHasOtherDeductionsSummary, setOldHasOtherDeductionsSummary,
    oldHasOutstandingLoans, setOldHasOutstandingLoans,
    oldHasPayrollCashRegister, setOldHasPayrollCashRegister,
    oldHasPayrollCheckRegister, setOldHasPayrollCheckRegister,
    oldHasPayrollDebitMemo, setOldHasPayrollDebitMemo,
    oldHasPayrollJournalByCostCenter, setOldHasPayrollJournalByCostCenter,
    oldHasPayrollJournalByDepartment, setOldHasPayrollJournalByDepartment,
    oldHasPayrollJournalBySummary, setOldHasPayrollJournalBySummary,
    oldHasPayrollPerPaymentMethod, setOldHasPayrollPerPaymentMethod,
    oldHasSelectLogs, setOldHasSelectLogs,
    oldHasSummaryReportByMonthAndDepartment, setOldHasSummaryReportByMonthAndDepartment,
    oldHasTardinessMemo, setOldHasTardinessMemo,
    oldHasTimeKeepingHistoryDetailedReport, setOldHasTimeKeepingHistoryDetailedReport,
    oldHasTimeKeepingHoursWorkedReport, setOldHasTimeKeepingHoursWorkedReport,
    oldHasTimeKeepingHoursWorkedSummary, setOldHasTimeKeepingHoursWorkedSummary,
    oldHasTimesheetStatusReport, setOldHasTimesheetStatusReport,
    oldHasYTDeductionSummary, setOldHasYTDeductionSummary,
    oldHasYTDEarningsSummary, setOldHasYTDearningsSummary,
    oldHasYTDPayrollRegister, setOldHasYTDPayrollRegister,
    oldHasNotification, setOldHasNotification,
    oldHasMobileBiometrics, setOldHasMobileBiometrics,
    }) 
{
    const handleClose = () => {
        onClose();
        // setIsAddState(false);
        // setIsEditState(false);
    };

    const header = [
        "Man Hour",
        "Yearly Report",
        "BIR Form No. 2316",
        "Alphalist",
        "Loan Report",
        "Bank Transmittal Report",
        "Per Day Tracker",
        "Overtime Summary Report",
        "Tracker Report",
        "Payslip",
        "Payroll Register",
        "Resigned",
        "Active Employees",
        "Year Of Service",
        "SSS Summary",
        "Pagibig Summary",
        "Philhealth Summary",
        "SSS Loan Report",
        "Pagibig Loan Report",
        "201 Report",
        "Attendance Report",
        "Bank Transmittal BDO",
        "Bank Transmittal BPI",
        "Bank Transmittal ChinaBank Savings",
        "Bank Transmittal HSBC",
        "Bank Transmittal Security Bank",
        "Summary Of Tardiness",
        "Absences Memo",
        "Absences Report",
        "Action History Report",
        "Allowance Summary",
        "Audit Trail Report Employee Setup",
        "Bundy Clock Usage",
        "Basic Pay Adjustment Report",
        "Certificate Of Employment",
        "Certificate Of Pagibig",
        "Certificate Of Philhealth",
        "Certificate Of SSS",
        "Commissions Summary",
        "Cost Center Report",
        "Deductions Per Month",
        "DTR Report",
        "Earnings Per Month",
        "Employee Leave Group",
        "Employee Overtime Group",
        "Employee Expense Group",
        "Employee Leave History",
        "Employee Listing By Hiring Date",
        "Employee Register",
        "Expense Report",
        "Government Employee Inventory",
        "Headcount Report",
        "Holiday Premium Summary",
        "Leave Ledger Report",
        "Leave Summary Report",
        "Loan History",
        "Loan Payments Summary",
        "Loans Monthly Amortization Summary",
        "Loans Penalty History",
        "Night Differential Summary",
        "Non-Taxable Allowances Report",
        "Other Earnings Report",
        "Other Deductions Summary",
        "Outstanding Loans",
        "Payroll Cash Register",
        "Payroll Check Register",
        "Payroll Debit Memo",
        "Payroll Journal By Cost Center",
        "Payroll Journal By Department",
        "Payroll Journal By Summary",
        "Payroll Per Payment Method",
        "Select Logs",
        "Summary Report By Month And Department",
        "Tardiness Memo",
        "Time Keeping History Detailed Report",
        "Time Keeping Hours Worked Report",
        "Time Keeping Hours Worked Summary",
        "Timesheet Status Report",
        "YTD Deduction Summary",
        "YTD Earnings Summary",
        "YTD Payroll Register"
    ];
    var accessor = [
        "hasManHour",
        "hasYearlyReport",
        "hasBIR2316",
        "hasBIR1601C",
        "hasAlphaList",
        "hasLoanReport",
        "hasBankTransmittalReport",
        "hasPerDayTracker",
        "hasOvertimeSummaryReport",
        "hasTrackerReport",
        "hasPayslip",
        "hasPayrollRegister",
        "hasResigned",
        "hasActiveEmployees",
        "hasYearofService",
        "hasSSSSummary",
        "hasPagibigSummary",
        "hasPhilhealthSummary",
        "hasSSSLoanReport",
        "hasPagibigLoanReport",
        "has201Report",
        "hasAttendanceReport",
        "hasBankTransmittalBDO",
        "hasBankTransmittalBPI",
        "hasBankTransmittalChinaBankSavings",
        "hasBankTransmittalHSBC",
        "hasBankTransmittalSecurityBank",
        "hasSummaryOfTardiness",
        "hasAbsencesMemo",
        "hasAbsencesReport",
        "hasActionHistoryReport",
        "hasAllowanceSummary",
        "hasAuditTrailReportEmployeeSetup",
        "hasBundyClockUsage",
        "hasBasicPayAdjustmentReport",
        "hasCertificateOfEmployment",
        "hasCertificateOfPagibig",
        "hasCertificateOfPhilhealth",
        "hasCertificateOfSSS",
        "hasCommissionsSummary",
        "hasCostCenterReport",
        "hasDeductionsPerMonth",
        "hasDTRReport",
        "hasEarningsPerMonth",
        "hasEmployeeLeaveGroup",
        "hasEmployeeOvertimeGroup",
        "hasEmployeeExpenseGroup",
        "hasEmployeeLeaveHistory",
        "hasEmployeeListingByHiringDate",
        "hasEmployeeRegister",
        "hasExpenseReport",
        "hasGovernmentEmployeeInventory",
        "hasHeadcountReport",
        "hasHolidayPremiumSummary",
        "hasLeaveLedgerReport",
        "hasLeaveSummaryReport",
        "hasLoanHistory",
        "hasLoanPaymentsSummary",
        "hasLoansMonthlyAmortizationSummary",
        "hasLoansPenaltyHistory",
        "hasNightDifferentialSummary",
        "hasNonTaxableAllowancesReport",
        "hasOtherEarningsReport",
        "hasOtherDeductionsSummary",
        "hasOutstandingLoans",
        "hasPayrollCashRegister",
        "hasPayrollCheckRegister",
        "hasPayrollDebitMemo",
        "hasPayrollJournalByCostCenter",
        "hasPayrollJournalByDepartment",
        "hasPayrollJournalBySummary",
        "hasPayrollPerPaymentMethod",
        "hasSelectLogs",
        "hasSummaryReportByMonthAndDepartment",
        "hasTardinessMemo",
        "hasTimeKeepingHistoryDetailedReport",
        "hasTimeKeepingHoursWorkedReport",
        "hasTimeKeepingHoursWorkedSummary",
        "hasTimesheetStatusReport",
        "hasYTDDeductionSummary",
        "hasYTDEarningsSummary",
        "hasYTDPayrollRegister",
    ];

    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        if(isEditState){
            setHasManHour(dataToEdit.hasManHour);
            setHasYearlyReport(dataToEdit.hasYearlyReport);
            setHasBIR2316(dataToEdit.hasBIR2316);
            setHasBIR1601C(dataToEdit.hasBIR1601C);
            setHasAlphaList(dataToEdit.hasAlphaList);
            setHasLoanReport(dataToEdit.hasLoanReport);
            setHasBankTransmittalReport(dataToEdit.hasBankTransmittalReport);
            setHasPerDayTracker(dataToEdit.hasPerDayTracker);
            setHasOvertimeSummaryReport(dataToEdit.hasOvertimeSummaryReport);
            setHasTrackerReport(dataToEdit.hasTrackerReport);
            setHasPayslip(dataToEdit.hasPayslip);
            setHasPayrollRegister(dataToEdit.hasPayrollRegister);
            setHasResigned(dataToEdit.hasResigned);
            setHasActiveEmployees(dataToEdit.hasActiveEmployees);
            setHasYearofService(dataToEdit.hasYearofService);
            setHasSSSSummary(dataToEdit.hasSSSSummary);
            setHasPagibigSummary(dataToEdit.hasPagibigSummary);
            setHasPhilhealthSummary(dataToEdit.hasPhilhealthSummary);
            setHasSSSLoanReport(dataToEdit.hasSSSLoanReport);
            setHasPagibigLoanReport(dataToEdit.hasPagibigLoanReport);
            setHas201Report(dataToEdit.has201Report);
            setHasAttendanceReport(dataToEdit.hasAttendanceReport);
            setHasBankTransmittalBDO(dataToEdit.hasBankTransmittalBDO);
            setHasBankTransmittalBPI(dataToEdit.hasBankTransmittalBPI);
            setHasBankTransmittalChinaBankSavings(dataToEdit.hasBankTransmittalChinaBankSavings);
            setHasBankTransmittalHSBC(dataToEdit.hasBankTransmittalHSBC);
            setHasBankTransmittalSecurityBank(dataToEdit.hasBankTransmittalSecurityBank);
            setHasSummaryOfTardiness(dataToEdit.hasSummaryOfTardiness);
            setHasAbsencesMemo(dataToEdit.hasAbsencesMemo);
            setHasAbsencesReport(dataToEdit.hasAbsencesReport);
            setHasActionHistoryReport(dataToEdit.hasActionHistoryReport);
            setHasAllowanceSummary(dataToEdit.hasAllowanceSummary);
            setHasAuditTrailReportEmployeeSetup(dataToEdit.hasAuditTrailReportEmployeeSetup);
            setHasBundyClockUsage(dataToEdit.hasBundyClockUsage);
            setHasBasicPayAdjustmentReport(dataToEdit.hasBasicPayAdjustmentReport);
            setHasCertificateOfEmployment(dataToEdit.hasCertificateOfEmployment);
            setHasCertificateOfPagibig(dataToEdit.hasCertificateOfPagibig);
            setHasCertificateOfPhilhealth(dataToEdit.hasCertificateOfPhilhealth);
            setHasCertificateOfSSS(dataToEdit.hasCertificateOfSSS);
            setHasCommissionsSummary(dataToEdit.hasCommissionsSummary);
            setHasCostCenterReport(dataToEdit.hasCostCenterReport);
            setHasDeductionsPerMonth(dataToEdit.hasDeductionsPerMonth);
            setHasDTRReport(dataToEdit.hasDTRReport);
            setHasEarningsPerMonth(dataToEdit.hasEarningsPerMonth);
            setHasEmployeeLeaveGroup(dataToEdit.hasEmployeeLeaveGroup);
            setHasEmployeeOvertimeGroup(dataToEdit.hasEmployeeOvertimeGroup);
            setHasEmployeeExpenseGroup(dataToEdit.hasEmployeeExpenseGroup);
            setHasEmployeeLeaveHistory(dataToEdit.hasEmployeeLeaveHistory);
            setHasEmployeeListingByHiringDate(dataToEdit.hasEmployeeListingByHiringDate);
            setHasEmployeeRegister(dataToEdit.hasEmployeeRegister);
            setHasExpenseReport(dataToEdit.hasExpenseReport);
            setHasGovernmentEmployeeInventory(dataToEdit.hasGovernmentEmployeeInventory);
            setHasHeadcountReport(dataToEdit.hasHeadcountReport);
            setHasHolidayPremiumSummary(dataToEdit.hasHolidayPremiumSummary);
            setHasLeaveLedgerReport(dataToEdit.hasLeaveLedgerReport);
            setHasLeaveSummaryReport(dataToEdit.hasLeaveSummaryReport);
            setHasLoanHistory(dataToEdit.hasLoanHistory);
            setHasLoanPaymentsSummary(dataToEdit.hasLoanPaymentsSummary);
            setHasLoansMonthlyAmortizationSummary(dataToEdit.hasLoansMonthlyAmortizationSummary);
            setHasLoansPenaltyHistory(dataToEdit.hasLoansPenaltyHistory);
            setHasNightDifferentialSummary(dataToEdit.hasNightDifferentialSummary);
            setHasNonTaxableAllowancesReport(dataToEdit.hasNonTaxableAllowancesReport);
            setHasOtherEarningsReport(dataToEdit.hasOtherEarningsReport);
            setHasOtherDeductionsSummary(dataToEdit.hasOtherDeductionsSummary);
            setHasOutstandingLoans(dataToEdit.hasOutstandingLoans);
            setHasPayrollCashRegister(dataToEdit.hasPayrollCashRegister);
            setHasPayrollCheckRegister(dataToEdit.hasPayrollCheckRegister);
            setHasPayrollDebitMemo(dataToEdit.hasPayrollDebitMemo);
            setHasPayrollJournalByCostCenter(dataToEdit.hasPayrollJournalByCostCenter);
            setHasPayrollJournalByDepartment(dataToEdit.hasPayrollJournalByDepartment);
            setHasPayrollJournalBySummary(dataToEdit.hasPayrollJournalBySummary);
            setHasPayrollPerPaymentMethod(dataToEdit.hasPayrollPerPaymentMethod);
            setHasSelectLogs(dataToEdit.hasSelectLogs);
            setHasSummaryReportByMonthAndDepartment(dataToEdit.hasSummaryReportByMonthAndDepartment);
            setHasTardinessMemo(dataToEdit.hasTardinessMemo);
            setHasTimeKeepingHistoryDetailedReport(dataToEdit.hasTimeKeepingHistoryDetailedReport);
            setHasTimeKeepingHoursWorkedReport(dataToEdit.hasTimeKeepingHoursWorkedReport);
            setHasTimeKeepingHoursWorkedSummary(dataToEdit.hasTimeKeepingHoursWorkedSummary);
            setHasTimesheetStatusReport(dataToEdit.hasTimesheetStatusReport);
            setHasYTDDeductionSummary(dataToEdit.hasYTDDeductionSummary);
            setHasYTDEarningsSummary(dataToEdit.hasYTDEarningsSummary);
            setHasYTDPayrollRegister(dataToEdit.hasYTDPayrollRegister);
            setHasNotification(dataToEdit.hasNotification);
            setHasMobileBiometrics(dataToEdit.hasMobileBiometrics);
            
            setOldHasPerDayTracker(dataToEdit.hasPerDayTracker);
            setOldHasOvertimeSummaryReport(dataToEdit.hasOvertimeSummaryReport);
            setOldHasTrackerReport(dataToEdit.hasTrackerReport);
            setOldHasPayslip(dataToEdit.hasPayslip);
            setOldHasPayrollRegister(dataToEdit.hasPayrollRegister);
            setOldHasResigned(dataToEdit.hasResigned);
            setOldHasActiveEmployees(dataToEdit.hasActiveEmployees);
            setOldHasYearOfService(dataToEdit.hasYearofService);
            setOldHasSSSSummary(dataToEdit.hasSSSSummary);
            setOldHasPagibigSummary(dataToEdit.hasPagibigSummary);
            setOldHasPhilhealthSummary(dataToEdit.hasPhilhealthSummary);
            setOldHasSSSLoanReport(dataToEdit.hasSSSLoanReport);
            setOldHasPagibigLoanReport(dataToEdit.hasPagibigLoanReport);
            setOldHas201Report(dataToEdit.has201Report);
            setOldHasAttendanceReport(dataToEdit.hasAttendanceReport);
            setOldHasBankTransmittalBDO(dataToEdit.hasBankTransmittalBDO);
            setOldHasBankTransmittalBPI(dataToEdit.hasBankTransmittalBPI);
            setOldHasBankTransmittalChinaBankSavings(dataToEdit.hasBankTransmittalChinaBankSavings);
            setOldHasBankTransmittalHSBC(dataToEdit.hasBankTransmittalHSBC);
            setOldHasBankTransmittalSecurityBank(dataToEdit.hasBankTransmittalSecurityBank);
            setOldHasSummaryOfTardiness(dataToEdit.hasSummaryOfTardiness);
            setOldHasAbsencesMemo(dataToEdit.hasAbsencesMemo);
            setOldHasAbsencesReport(dataToEdit.hasAbsencesReport);
            setOldHasActionHistoryReport(dataToEdit.hasActionHistoryReport);
            setOldHasAllowanceSummary(dataToEdit.hasAllowanceSummary);
            setOldHasAuditTrailReportEmployeeSetup(dataToEdit.hasAuditTrailReportEmployeeSetup);
            setOldHasBundyClockUsage(dataToEdit.hasBundyClockUsage);
            setOldHasBasicPayAdjustmentReport(dataToEdit.hasBasicPayAdjustmentReport);
            setOldHasCertificateOfEmployment(dataToEdit.hasCertificateOfEmployment);
            setOldHasCertificateOfPagibig(dataToEdit.hasCertificateOfPagibig);
            setOldHasCertificateOfPhilhealth(dataToEdit.hasCertificateOfPhilhealth);
            setOldHasCertificateOfSSS(dataToEdit.hasCertificateOfSSS);
            setOldHasCommissionsSummary(dataToEdit.hasCommissionsSummary);
            setOldHasCostCenterReport(dataToEdit.hasCostCenterReport);
            setOldHasDeductionsPerMonth(dataToEdit.hasDeductionsPerMonth);
            setOldHasDTRReport(dataToEdit.hasDTRReport);
            setOldHasEarningsPerMonth(dataToEdit.hasEarningsPerMonth);
            setOldHasEmployeeLeaveGroup(dataToEdit.hasEmployeeLeaveGroup);
            setOldHasEmployeeOvertimeGroup(dataToEdit.hasEmployeeOvertimeGroup);
            setOldHasEmployeeExpenseGroup(dataToEdit.hasEmployeeExpenseGroup);
            setOldHasEmployeeLeaveHistory(dataToEdit.hasEmployeeLeaveHistory);
            setOldHasEmployeeListingByHiringDate(dataToEdit.hasEmployeeListingByHiringDate);
            setOldHasEmployeeRegister(dataToEdit.hasEmployeeRegister);
            setOldHasExpenseReport(dataToEdit.hasExpenseReport);
            setOldHasGovernmentEmployeeInventory(dataToEdit.hasGovernmentEmployeeInventory);
            setOldHasHeadcountReport(dataToEdit.hasHeadcountReport);
            setOldHasHolidayPremiumSummary(dataToEdit.hasHolidayPremiumSummary);
            setOldHasLeaveLedgerReport(dataToEdit.hasLeaveLedgerReport);
            setOldHasLeaveSummaryReport(dataToEdit.hasLeaveSummaryReport);
            setOldHasLoanHistory(dataToEdit.hasLoanHistory);
            setOldHasLoanPaymentsSummary(dataToEdit.hasLoanPaymentsSummary);
            setOldHasLoansMonthlyAmortizationSummary(dataToEdit.hasLoansMonthlyAmortizationSummary);
            setOldHasLoansPenaltyHistory(dataToEdit.hasLoansPenaltyHistory);
            setOldHasNightDifferentialSummary(dataToEdit.hasNightDifferentialSummary);
            setOldHasNonTaxableAllowancesReport(dataToEdit.hasNonTaxableAllowancesReport);
            setOldHasOtherEarningsReport(dataToEdit.hasOtherEarningsReport);
            setOldHasOtherDeductionsSummary(dataToEdit.hasOtherDeductionsSummary);
            setOldHasOutstandingLoans(dataToEdit.hasOutstandingLoans);
            setOldHasPayrollCashRegister(dataToEdit.hasPayrollCashRegister);
            setOldHasPayrollCheckRegister(dataToEdit.hasPayrollCheckRegister);
            setOldHasPayrollDebitMemo(dataToEdit.hasPayrollDebitMemo);
            setOldHasPayrollJournalByCostCenter(dataToEdit.hasPayrollJournalByCostCenter);
            setOldHasPayrollJournalByDepartment(dataToEdit.hasPayrollJournalByDepartment);
            setOldHasPayrollJournalBySummary(dataToEdit.hasPayrollJournalBySummary);
            setOldHasPayrollPerPaymentMethod(dataToEdit.hasPayrollPerPaymentMethod);
            setOldHasSelectLogs(dataToEdit.hasSelectLogs);
            setOldHasSummaryReportByMonthAndDepartment(dataToEdit.hasSummaryReportByMonthAndDepartment);
            setOldHasTardinessMemo(dataToEdit.hasTardinessMemo);
            setOldHasTimeKeepingHistoryDetailedReport(dataToEdit.hasTimeKeepingHistoryDetailedReport);
            setOldHasTimeKeepingHoursWorkedReport(dataToEdit.hasTimeKeepingHoursWorkedReport);
            setOldHasTimeKeepingHoursWorkedSummary(dataToEdit.hasTimeKeepingHoursWorkedSummary);
            setOldHasTimesheetStatusReport(dataToEdit.hasTimesheetStatusReport);
            setOldHasYTDeductionSummary(dataToEdit.hasYTDDeductionSummary);
            setOldHasYTDearningsSummary(dataToEdit.hasYTDEarningsSummary);
            setOldHasYTDPayrollRegister(dataToEdit.hasYTDPayrollRegister);
            setOldHasNotification(dataToEdit.hasNotification);
            setOldHasMobileBiometrics(dataToEdit.hasMobileBiometrics);
        }
    }, [isEditState, dataToEdit, 
        setOldHasYearOfService, 
        setHas201Report, 
        setHasAbsencesMemo, 
        setHasAbsencesReport, 
        setHasActionHistoryReport, 
        setHasActiveEmployees, 
        setHasAllowanceSummary, 
        setHasAttendanceReport, 
        setHasAuditTrailReportEmployeeSetup, 
        setHasBankTransmittalBDO, 
        setHasBankTransmittalBPI, 
        setHasBankTransmittalChinaBankSavings, 
        setHasBankTransmittalHSBC, 
        setHasBankTransmittalSecurityBank, 
        setHasBasicPayAdjustmentReport, 
        setHasBundyClockUsage, 
        setHasCertificateOfEmployment, 
        setHasCertificateOfPagibig, 
        setHasCertificateOfPhilhealth, 
        setHasCertificateOfSSS, 
        setHasCommissionsSummary, 
        setHasCostCenterReport, 
        setHasDTRReport, 
        setHasDeductionsPerMonth, 
        setHasEarningsPerMonth, 
        setHasEmployeeExpenseGroup, 
        setHasEmployeeLeaveGroup, 
        setHasEmployeeLeaveHistory, 
        setHasEmployeeListingByHiringDate, 
        setHasEmployeeOvertimeGroup, 
        setHasEmployeeRegister, 
        setHasExpenseReport,
        setHasGovernmentEmployeeInventory, 
        setHasHeadcountReport, 
        setHasHolidayPremiumSummary, 
        setHasLeaveLedgerReport, 
        setHasLeaveSummaryReport, 
        setHasLoanHistory, 
        setHasLoanPaymentsSummary, 
        setHasLoansMonthlyAmortizationSummary, 
        setHasLoansPenaltyHistory, 
        setHasNightDifferentialSummary, 
        setHasNonTaxableAllowancesReport, 
        setHasOtherDeductionsSummary, 
        setHasOtherEarningsReport, 
        setHasOutstandingLoans, 
        setHasOvertimeSummaryReport, 
        setHasPagibigLoanReport, 
        setHasPagibigSummary, 
        setHasPayrollCashRegister, 
        setHasPayrollCheckRegister, 
        setHasPayrollDebitMemo, 
        setHasPayrollJournalByCostCenter, 
        setHasPayrollJournalByDepartment, 
        setHasPayrollJournalBySummary, 
        setHasPayrollPerPaymentMethod, 
        setHasPayrollRegister, 
        setHasPayslip, 
        setHasPerDayTracker, 
        setHasPhilhealthSummary, 
        setHasResigned, 
        setHasSSSLoanReport, 
        setHasSSSSummary, 
        setHasSelectLogs, 
        setHasSummaryOfTardiness, 
        setHasSummaryReportByMonthAndDepartment, 
        setHasTardinessMemo, 
        setHasTimeKeepingHistoryDetailedReport, 
        setHasTimeKeepingHoursWorkedReport, 
        setHasTimeKeepingHoursWorkedSummary, 
        setHasTimesheetStatusReport, 
        setHasTrackerReport, 
        setHasYTDEarningsSummary, 
        setHasYTDPayrollRegister, 
        setHasNotification, 
        setHasMobileBiometrics, 
        setHasYTDDeductionSummary, 
        setHasYearofService, 
        setHasManHour, 
        setHasYearlyReport, 
        setHasBIR2316, 
        setHasBIR1601C, 
        setHasAlphaList, 
        setHasLoanReport, 
        setHasBankTransmittalReport, 
        setOldHas201Report, 
        setOldHasAbsencesMemo, 
        setOldHasAbsencesReport, 
        setOldHasActionHistoryReport, 
        setOldHasActiveEmployees, 
        setOldHasAllowanceSummary, 
        setOldHasAttendanceReport,
        setOldHasAuditTrailReportEmployeeSetup, 
        setOldHasBankTransmittalBDO, 
        setOldHasBankTransmittalBPI, 
        setOldHasBankTransmittalChinaBankSavings, 
        setOldHasBankTransmittalHSBC, 
        setOldHasBankTransmittalSecurityBank, 
        setOldHasBasicPayAdjustmentReport, 
        setOldHasBundyClockUsage, 
        setOldHasCertificateOfEmployment, 
        setOldHasCertificateOfPagibig, 
        setOldHasCertificateOfPhilhealth, 
        setOldHasCertificateOfSSS, 
        setOldHasCommissionsSummary, 
        setOldHasCostCenterReport, 
        setOldHasDTRReport, 
        setOldHasDeductionsPerMonth, 
        setOldHasEarningsPerMonth,
        setOldHasEmployeeExpenseGroup, 
        setOldHasEmployeeLeaveGroup, 
        setOldHasEmployeeLeaveHistory, 
        setOldHasEmployeeListingByHiringDate, 
        setOldHasEmployeeOvertimeGroup, 
        setOldHasEmployeeRegister, 
        setOldHasExpenseReport, 
        setOldHasGovernmentEmployeeInventory, 
        setOldHasHeadcountReport, 
        setOldHasHolidayPremiumSummary, 
        setOldHasLeaveLedgerReport, 
        setOldHasLeaveSummaryReport, 
        setOldHasLoanHistory, 
        setOldHasLoanPaymentsSummary, 
        setOldHasLoansMonthlyAmortizationSummary, 
        setOldHasLoansPenaltyHistory, 
        setOldHasNightDifferentialSummary, 
        setOldHasNonTaxableAllowancesReport, 
        setOldHasOtherDeductionsSummary, 
        setOldHasOtherEarningsReport, 
        setOldHasOutstandingLoans, 
        setOldHasOvertimeSummaryReport, 
        setOldHasPagibigLoanReport, 
        setOldHasPagibigSummary, 
        setOldHasPayrollCashRegister, 
        setOldHasPayrollCheckRegister, 
        setOldHasPayrollDebitMemo, 
        setOldHasPayrollJournalByCostCenter, 
        setOldHasPayrollJournalByDepartment, 
        setOldHasPayrollJournalBySummary, 
        setOldHasPayrollPerPaymentMethod, 
        setOldHasPayrollRegister, 
        setOldHasPayslip, 
        setOldHasPerDayTracker, 
        setOldHasPhilhealthSummary, 
        setOldHasResigned, 
        setOldHasSSSLoanReport, 
        setOldHasSSSSummary, 
        setOldHasSelectLogs, 
        setOldHasSummaryOfTardiness, 
        setOldHasSummaryReportByMonthAndDepartment, 
        setOldHasTardinessMemo, 
        setOldHasTimeKeepingHistoryDetailedReport, 
        setOldHasTimeKeepingHoursWorkedReport, 
        setOldHasTimeKeepingHoursWorkedSummary, 
        setOldHasTimesheetStatusReport, 
        setOldHasTrackerReport, 
        setOldHasYTDPayrollRegister, 
        setOldHasYTDearningsSummary, 
        setOldHasYTDeductionSummary,
        setOldHasNotification,
        setOldHasMobileBiometrics,
    ])

    const selectAll = () => {
        const setters = [
            setHasManHour,
            setHasYearlyReport,
            setHasPerDayTracker,
            setHasBIR2316,
            setHasBIR1601C,
            setHasAlphaList,
            setHasLoanReport,
            setHasBankTransmittalReport,
            setHasOvertimeSummaryReport,
            setHasTrackerReport,
            setHasPayslip,
            setHasPayrollRegister,
            setHasResigned,
            setHasActiveEmployees,
            setHasYearofService,
            setHasSSSSummary,
            setHasPagibigSummary,
            setHasPhilhealthSummary,
            setHasSSSLoanReport,
            setHasPagibigLoanReport,
            setHas201Report,
            setHasAttendanceReport,
            setHasBankTransmittalBDO,
            setHasBankTransmittalBPI,
            setHasBankTransmittalChinaBankSavings,
            setHasBankTransmittalHSBC,
            setHasBankTransmittalSecurityBank,
            setHasSummaryOfTardiness,
            setHasAbsencesMemo,
            setHasAbsencesReport,
            setHasActionHistoryReport,
            setHasAllowanceSummary,
            setHasAuditTrailReportEmployeeSetup,
            setHasBundyClockUsage,
            setHasBasicPayAdjustmentReport,
            setHasCertificateOfEmployment,
            setHasCertificateOfPagibig,
            setHasCertificateOfPhilhealth,
            setHasCertificateOfSSS,
            setHasCommissionsSummary,
            setHasCostCenterReport,
            setHasDeductionsPerMonth,
            setHasDTRReport,
            setHasEarningsPerMonth,
            setHasEmployeeLeaveGroup,
            setHasEmployeeOvertimeGroup,
            setHasEmployeeExpenseGroup,
            setHasEmployeeLeaveHistory,
            setHasEmployeeListingByHiringDate,
            setHasEmployeeRegister,
            setHasExpenseReport,
            setHasGovernmentEmployeeInventory,
            setHasHeadcountReport,
            setHasHolidayPremiumSummary,
            setHasLeaveLedgerReport,
            setHasLeaveSummaryReport,
            setHasLoanHistory,
            setHasLoanPaymentsSummary,
            setHasLoansMonthlyAmortizationSummary,
            setHasLoansPenaltyHistory,
            setHasNightDifferentialSummary,
            setHasNonTaxableAllowancesReport,
            setHasOtherEarningsReport,
            setHasOtherDeductionsSummary,
            setHasOutstandingLoans,
            setHasPayrollCashRegister,
            setHasPayrollCheckRegister,
            setHasPayrollDebitMemo,
            setHasPayrollJournalByCostCenter,
            setHasPayrollJournalByDepartment,
            setHasPayrollJournalBySummary,
            setHasPayrollPerPaymentMethod,
            setHasSelectLogs,
            setHasSummaryReportByMonthAndDepartment,
            setHasTardinessMemo,
            setHasTimeKeepingHistoryDetailedReport,
            setHasTimeKeepingHoursWorkedReport,
            setHasTimeKeepingHoursWorkedSummary,
            setHasTimesheetStatusReport,
            setHasYTDDeductionSummary,
            setHasYTDEarningsSummary,
            setHasYTDPayrollRegister,
        ];
        
        setters.forEach(setter => setter(true));
    }
    const unSelectAll = () => {
        const setters = [
            setHasManHour,
            setHasYearlyReport,
            setHasBIR2316,
            setHasBIR1601C,
            setHasAlphaList,
            setHasLoanReport,
            setHasBankTransmittalReport,
            setHasPerDayTracker,
            setHasOvertimeSummaryReport,
            setHasTrackerReport,
            setHasPayslip,
            setHasPayrollRegister,
            setHasResigned,
            setHasActiveEmployees,
            setHasYearofService,
            setHasSSSSummary,
            setHasPagibigSummary,
            setHasPhilhealthSummary,
            setHasSSSLoanReport,
            setHasPagibigLoanReport,
            setHas201Report,
            setHasAttendanceReport,
            setHasBankTransmittalBDO,
            setHasBankTransmittalBPI,
            setHasBankTransmittalChinaBankSavings,
            setHasBankTransmittalHSBC,
            setHasBankTransmittalSecurityBank,
            setHasSummaryOfTardiness,
            setHasAbsencesMemo,
            setHasAbsencesReport,
            setHasActionHistoryReport,
            setHasAllowanceSummary,
            setHasAuditTrailReportEmployeeSetup,
            setHasBundyClockUsage,
            setHasBasicPayAdjustmentReport,
            setHasCertificateOfEmployment,
            setHasCertificateOfPagibig,
            setHasCertificateOfPhilhealth,
            setHasCertificateOfSSS,
            setHasCommissionsSummary,
            setHasCostCenterReport,
            setHasDeductionsPerMonth,
            setHasDTRReport,
            setHasEarningsPerMonth,
            setHasEmployeeLeaveGroup,
            setHasEmployeeOvertimeGroup,
            setHasEmployeeExpenseGroup,
            setHasEmployeeLeaveHistory,
            setHasEmployeeListingByHiringDate,
            setHasEmployeeRegister,
            setHasExpenseReport,
            setHasGovernmentEmployeeInventory,
            setHasHeadcountReport,
            setHasHolidayPremiumSummary,
            setHasLeaveLedgerReport,
            setHasLeaveSummaryReport,
            setHasLoanHistory,
            setHasLoanPaymentsSummary,
            setHasLoansMonthlyAmortizationSummary,
            setHasLoansPenaltyHistory,
            setHasNightDifferentialSummary,
            setHasNonTaxableAllowancesReport,
            setHasOtherEarningsReport,
            setHasOtherDeductionsSummary,
            setHasOutstandingLoans,
            setHasPayrollCashRegister,
            setHasPayrollCheckRegister,
            setHasPayrollDebitMemo,
            setHasPayrollJournalByCostCenter,
            setHasPayrollJournalByDepartment,
            setHasPayrollJournalBySummary,
            setHasPayrollPerPaymentMethod,
            setHasSelectLogs,
            setHasSummaryReportByMonthAndDepartment,
            setHasTardinessMemo,
            setHasTimeKeepingHistoryDetailedReport,
            setHasTimeKeepingHoursWorkedReport,
            setHasTimeKeepingHoursWorkedSummary,
            setHasTimesheetStatusReport,
            setHasYTDDeductionSummary,
            setHasYTDEarningsSummary,
            setHasYTDPayrollRegister,
        ];
        
        setters.forEach(setter => setter(false));
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{`Reports ${reportData.description ? `(${reportData.description})` : ""}`}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body reports-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTableForReports
                                dataList={[reportData]}
                                dataHeader={header}
                                dataAccessor={accessor}
                                isAddState={isAddState}
                                setIsAddState={setIsAddState}
                                isEditState={isEditState}
                                setIsEditState={setIsEditState}
                                dataToEdit={dataToEdit}
                                
                                description={description} setDescription={setDescription}
                                hasManHour={hasManHour} setHasManHour={setHasManHour}
                                hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                                hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                                hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                                hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                                hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}
                                hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}
                                hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                                hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                                hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                                hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                                hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                                hasResigned={hasResigned} setHasResigned={setHasResigned}
                                hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                                hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                                hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                                hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                                hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                                hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                                hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                                has201Report={has201Report} setHas201Report={setHas201Report}
                                hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                                hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                                hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                                hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                                hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                                hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                                hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                                hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                                hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                                hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                                hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                                hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                                hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                                hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                                hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                                hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                                hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                                hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                                hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                                hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                                hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                                hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                                hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                                hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                                hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                                hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                                hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                                hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                                hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                                hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                                hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                                hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                                hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                                hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                                hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                                hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                                hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                                hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                                hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                                hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                                hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                                hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                                hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                                hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                                hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                                hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                                hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                                hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                                hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                                hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                                hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                                hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                                hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                                hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                                hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                                hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                                hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                                hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                                hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                                hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                                hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                                hasNotification={hasNotification} setHasNotification={setHasNotification}
                                hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}

                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {userTemplate.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {
                                    isAddState ? <></>
                                    :
                                    <div> {/*<p>No records to display</p>*/}</div>
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        {(isAddState && [reportData][0].id === undefined) &&
                            <>
                                <button id="add-family" 
                                    className="save row"
                                    style={{marginRight: "10px"}}
                                    onClick={selectAll}>
                                        SELECT ALL
                                </button>
                                <button id="add-family" 
                                    className="save row"
                                    style={{marginRight: "10px"}}
                                    onClick={unSelectAll}>
                                        UNSELECT ALL
                                </button>
                            </>
                        }
                        {(isEditState && [reportData][0].id === dataToEdit.id) &&
                            <>
                                <button id="add-family" 
                                    className="save row"
                                    style={{marginRight: "10px"}}
                                    onClick={selectAll}>
                                        SELECT ALL
                                </button>
                                <button id="add-family" 
                                    className="save row"
                                    style={{marginRight: "10px"}}
                                    onClick={unSelectAll}>
                                        UNSELECT ALL
                                </button>
                            </>
                        }
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                BACK
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this template?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployeeEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployeeEmployeeId(selectedEmployee.employeeId);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function AccessTemplateIdSelect({accessTemplateId, setAccessTemplateId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setAccessTemplateId(event.target.value);
    };

    const [accessTemplateIds, setAccessTemplateIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/AccessTemplate";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setAccessTemplateIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(accessTemplateId !== "" && accessTemplateId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [accessTemplateId]);

    return (
        <div>
            <select value={accessTemplateId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose access template</option>
            {accessTemplateIds.map((accessTemplateId) => ( 
                SetAccessTemplateId(accessTemplateId)
            ))}
            </select>
        </div>
    );
};
function SetAccessTemplateId(accessTemplateId){
    return(
        <option value={accessTemplateId.id}>{
            accessTemplateId.id + " - " + accessTemplateId.description}
        </option>
    )
    
}
function ConfirmationForm({isOpen, 
    onClose, 
    handleResetConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Reset Password!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to reset the password of this user?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleResetConfirm}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    changePassword,
    accessTemplates,
    currentPage, setCurrentPage
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            changePassword={changePassword}
                                            accessTemplates={accessTemplates}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
export function CreateTableForEmployeeSelect({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, setSelectedEmployee}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleRowClick = (rowData) => {
        setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            className={row.original.id === activeRowId ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px"}}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px"}}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div style={{textAlign:"center"}}>{`${currentPage}/${totalPages}`}</div>
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, _cell, editHandleClick, deleteHandleClick, changePassword, accessTemplates}) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { changePassword ?
                    <Tooltip text="Change">
                        <div style={{padding:"0 5px"}} onClick={()=>changePassword(data)}><LockResetIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                    { deleteHandleClick ? 
                    <Tooltip text="Reset">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><ChangeCircleIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header === "Access"){
        const findAccessName = accessTemplates.find(info => {
            return info.id === data.accessTemplateId
        })

        return (
            <td>
                {findAccessName ? findAccessName.description : ""}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
export function CreateTableForUserTemplate({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    viewReports,
    isAddState,
    setIsAddState,
    isEditState,
    setIsEditState,
    dataToEdit,
    description,
    setDescription,
    hasHome,
    setHasHome,
    hasAddEmployee,
    setHasAddEmployee,
    hasEmployeeList,
    setHasEmployeeList,
    hasEmployeeStatus,
    setHasEmployeeStatus,
    hasEmployeeSchedule,
    setHasEmployeeSchedule,
    hasTimeEntries,
    setHasTimeEntries,
    hasShiftSchedule,
    setHasShiftSchedule,
    hasProcessPayroll,
    setHasProcessPayroll,
    has13thMonth,
    setHas13thMonth,
    hasPayrollPeriod,
    setHasPayrollPeriod,
    hasClient,
    setHasClient,
    hasPayType,
    setHasPayType,
    hasHoliday,
    setHasHoliday,
    hasHolidayType,
    setHasHolidayType,
    hasLeaveType,
    setHasLeaveType,
    hasDepartment,
    setHasDepartment,
    hasSection,
    setHasSection,
    hasClassification,
    setHasClassification,
    hasCompany,
    setHasCompany,
    hasPosition,
    setHasPosition,
    hasJobTitle,
    setHasJobTitle,
    hasLocation,
    setHasLocation,
    hasDTRRulesConfiguration,
    setHasDTRRulesConfiguration,
    hasEmployeeMonthlySalary,
    setHasEmployeeMonthlySalary,
    hasEmployeeDailySalary,
    setHasEmployeeDailySalary,
    hasPositionDesignationSalary,
    hasQuotaBasedSalary,
    setHasPositionDesignationSalary,
    setHasQuotaBasedSalary,
    hasPositionDesignationSalaryLaUnion,
    setHasPositionDesignationSalaryLaUnion,
    hasEmployeeBankAccount,
    setHasEmployeeBankAccount,
    hasBIRTax,
    setHasBIRTax,
    hasPagibig,
    setHasPagibig,
    hasSSS,
    setHasSSS,
    hasPhilhealth,
    setHasPhilhealth,
    hasDTR,
    setHasDTR,
    hasDTRBiometrics,
    setHasDTRBiometrics,
    hasApproverHierarchy,
    setHasApproverHierarchy,
    hasRequestApproval,
    setHasRequestApproval,
    hasOvertime,
    setHasOvertime,
    hasDTRCorrection,
    setHasDTRCorrection,
    hasLeave,
    setHasLeave,
    hasChangeOfSchedule,
    setHasChangeOfSchedule,
    hasSSSLoan,
    setHasSSSLoan,
    hasSSSCalamityLoan,
    setHasSSSCalamityLoan,
    hasPagibigLoan,
    setHasPagibigLoan,
    hasPagibigCalamityLoan,
    setHasPagibigCalamityLoan,
    hasCashAdvance,
    setHasCashAdvance,
    hasDeductions,
    setHasDeductions,
    hasBenefits,
    setHasBenefits,
    hasReports,
    setHasReports,
    hasSettings,
    setHasSettings,
    hasCalendar,
    setHasCalendar,
    hasUser,
    setHasUser,
    userTimeOut,
    setUserTimeOut,

    // additional
    hasEmployeereliever, setHasEmployeereliever,
    hasMassapproval, setHasMassapproval,
    hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation,
    hasFinalPay, setHasFinalPay,
    hasSubcon, setHasSubcon,
    hasAgency, setHasAgency,
    hasEmploymentStatus, setHasEmploymentStatus,
    hasLoans, setHasLoans,
    hasTimeKeeper, setHasTimeKeeper,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,
    hasRequestApprovalTimeKeeper, setHasRequestApprovalTimeKeeper,

    hasTamperedApproval, setHasTamperedApproval,
    hasMobileDTRApproval, setHasMobileDTRApproval,
    hasDTRWithOTViewing, setHasDTRWithOTViewing,
    hasDTRCorrectionWorkers, setHasDTRCorrectionWorkers,
    hasPlantilya, setHasPlantilya,
    hasCostCenter, setHasCostCenter,
    hasPayrollJournalAccount, setHasPayrollJournalAccount,

    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,

    handleSubmit,
    handleUpdate,

    currentPage, setCurrentPage
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const checkboxes = [
        { value: hasHome, onChange: (e) => setHasHome(e.target.checked) },
        { value: hasAddEmployee, onChange: (e) => setHasAddEmployee(e.target.checked) },
        { value: hasEmployeeList, onChange: (e) => setHasEmployeeList(e.target.checked) },
        { value: hasEmployeeStatus, onChange: (e) => setHasEmployeeStatus(e.target.checked) },
        { value: hasEmployeeSchedule, onChange: (e) => setHasEmployeeSchedule(e.target.checked) },
        { value: hasEmployeereliever, onChange: (e) => setHasEmployeereliever(e.target.checked) },
        { value: hasTimeEntries, onChange: (e) => setHasTimeEntries(e.target.checked) },
        { value: hasTamperedApproval, onChange: (e) => setHasTamperedApproval(e.target.checked) },
        { value: hasShiftSchedule, onChange: (e) => setHasShiftSchedule(e.target.checked) },
        { value: hasProcessPayroll, onChange: (e) => setHasProcessPayroll(e.target.checked) },
        { value: has13thMonth, onChange: (e) => setHas13thMonth(e.target.checked) },
        { value: hasFinalPay, onChange: (e) => setHasFinalPay(e.target.checked) },
        { value: hasSubcon, onChange: (e) => setHasSubcon(e.target.checked) },
        { value: hasAgency, onChange: (e) => setHasAgency(e.target.checked) },
        { value: hasPayrollPeriod, onChange: (e) => setHasPayrollPeriod(e.target.checked) },
        { value: hasClient, onChange: (e) => setHasClient(e.target.checked) },
        { value: hasPayType, onChange: (e) => setHasPayType(e.target.checked) },
        { value: hasHoliday, onChange: (e) => setHasHoliday(e.target.checked) },
        { value: hasHolidayType, onChange: (e) => setHasHolidayType(e.target.checked) },
        { value: hasLeaveType, onChange: (e) => setHasLeaveType(e.target.checked) },
        { value: hasDepartment, onChange: (e) => setHasDepartment(e.target.checked) },
        { value: hasSection, onChange: (e) => setHasSection(e.target.checked) },
        { value: hasClassification, onChange: (e) => setHasClassification(e.target.checked) },
        { value: hasCompany, onChange: (e) => setHasCompany(e.target.checked) },
        { value: hasPosition, onChange: (e) => setHasPosition(e.target.checked) },
        { value: hasEmploymentStatus, onChange: (e) => setHasEmploymentStatus(e.target.checked) },
        { value: hasJobTitle, onChange: (e) => setHasJobTitle(e.target.checked) },
        { value: hasLocation, onChange: (e) => setHasLocation(e.target.checked) },
        { value: hasDTRRulesConfiguration, onChange: (e) => setHasDTRRulesConfiguration(e.target.checked) },
        { value: hasTimeKeeper, onChange: (e) => setHasTimeKeeper(e.target.checked) },
        { value: hasPlantilya, onChange: (e) => setHasPlantilya(e.target.checked) },
        { value: hasCostCenter, onChange: (e) => setHasCostCenter(e.target.checked) },
        { value: hasPayrollJournalAccount, onChange: (e) => setHasPayrollJournalAccount(e.target.checked) },
        { value: hasEmployeeMonthlySalary, onChange: (e) => setHasEmployeeMonthlySalary(e.target.checked) },
        { value: hasEmployeeDailySalary, onChange: (e) => setHasEmployeeDailySalary(e.target.checked) },
        { value: hasPositionDesignationSalary, onChange: (e) => setHasPositionDesignationSalary(e.target.checked) },
        { value: hasQuotaBasedSalary, onChange: (e) => setHasQuotaBasedSalary(e.target.checked) },
        { value: hasPositionDesignationSalaryLaUnion, onChange: (e) => setHasPositionDesignationSalaryLaUnion(e.target.checked) },
        { value: hasEmployeeBankAccount, onChange: (e) => setHasEmployeeBankAccount(e.target.checked) },
        { value: hasBIRTax, onChange: (e) => setHasBIRTax(e.target.checked) },
        { value: hasPagibig, onChange: (e) => setHasPagibig(e.target.checked) },
        { value: hasSSS, onChange: (e) => setHasSSS(e.target.checked) },
        { value: hasPhilhealth, onChange: (e) => setHasPhilhealth(e.target.checked) },
        { value: hasDTR, onChange: (e) => setHasDTR(e.target.checked) },
        { value: hasDTRBiometrics, onChange: (e) => setHasDTRBiometrics(e.target.checked) },
        { value: hasDTRWithOTViewing, onChange: (e) => setHasDTRWithOTViewing(e.target.checked) },
        { value: hasMobileDTRApproval, onChange: (e) => setHasMobileDTRApproval(e.target.checked) },
        { value: hasApproverHierarchy, onChange: (e) => setHasApproverHierarchy(e.target.checked) },
        { value: hasApproverheirarchyperlocation, onChange: (e) => setHasApproverheirarchyperlocation(e.target.checked) },
        { value: hasRequestApproval, onChange: (e) => setHasRequestApproval(e.target.checked) },
        { value: hasRequestApprovalTimeKeeper, onChange: (e) => setHasRequestApprovalTimeKeeper(e.target.checked) },
        { value: hasMassapproval, onChange: (e) => setHasMassapproval(e.target.checked) },
        { value: hasDTRCorrectionWorkers, onChange: (e) => setHasDTRCorrectionWorkers(e.target.checked) },
        { value: hasOvertime, onChange: (e) => setHasOvertime(e.target.checked) },
        { value: hasDTRCorrection, onChange: (e) => setHasDTRCorrection(e.target.checked) },
        { value: hasLeave, onChange: (e) => setHasLeave(e.target.checked) },
        { value: hasChangeOfSchedule, onChange: (e) => setHasChangeOfSchedule(e.target.checked) },
        { value: hasSSSLoan, onChange: (e) => setHasSSSLoan(e.target.checked) },
        { value: hasSSSCalamityLoan, onChange: (e) => setHasSSSCalamityLoan(e.target.checked) },
        { value: hasPagibigLoan, onChange: (e) => setHasPagibigLoan(e.target.checked) },
        { value: hasPagibigCalamityLoan, onChange: (e) => setHasPagibigCalamityLoan(e.target.checked) },
        { value: hasCashAdvance, onChange: (e) => setHasCashAdvance(e.target.checked) },
        { value: hasLoans, onChange: (e) => setHasLoans(e.target.checked) },
        { value: hasDeductions, onChange: (e) => setHasDeductions(e.target.checked) },
        { value: hasBenefits, onChange: (e) => setHasBenefits(e.target.checked) },
        // { value: hasReports, onChange: (e) => setHasReports(e.target.checked) },
        { value: hasSettings, onChange: (e) => setHasSettings(e.target.checked) },
        { value: hasCalendar, onChange: (e) => setHasCalendar(e.target.checked) },
        { value: hasUser, onChange: (e) => setHasUser(e.target.checked) },
        { value: hasNotification, onChange: (e) => setHasNotification(e.target.checked) },
        { value: hasMobileBiometrics, onChange: (e) => setHasMobileBiometrics(e.target.checked) }
    ];

    const submit = (e) =>{
        const allFalse = checkboxes.every(checkbox => checkbox.value === false);

        if(description === ""){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please input a template name");
            return;
        }

        if(allFalse){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select an access at least 1");
            return;
        }

        handleSubmit(e);
    }

    const close = () =>{
        setDescription("");
        setHasHome(false);
        setHasAddEmployee(false);
        setHasEmployeeList(false);
        setHasEmployeeStatus(false);
        setHasEmployeeSchedule(false);
        setHasTimeEntries(false);
        setHasShiftSchedule(false);
        setHasProcessPayroll(false);
        setHas13thMonth(false);
        setHasPayrollPeriod(false);
        setHasClient(false);
        setHasPayType(false);
        setHasHoliday(false);
        setHasHolidayType(false);
        setHasLeaveType(false);
        setHasDepartment(false);
        setHasSection(false);
        setHasClassification(false);
        setHasCompany(false);
        setHasPosition(false);
        setHasJobTitle(false);
        setHasLocation(false);
        setHasEmployeeMonthlySalary(false);
        setHasEmployeeDailySalary(false);
        setHasPositionDesignationSalary(false);
        setHasQuotaBasedSalary(false);
        setHasPositionDesignationSalaryLaUnion(false);
        setHasEmployeeBankAccount(false);
        setHasBIRTax(false);
        setHasPagibig(false);
        setHasSSS(false);
        setHasPhilhealth(false);
        setHasDTR(false);
        setHasDTRBiometrics(false);
        setHasApproverHierarchy(false);
        setHasRequestApproval(false);
        setHasOvertime(false);
        setHasDTRCorrection(false);
        setHasLeave(false);
        setHasChangeOfSchedule(false);
        setHasSSSLoan(false);
        setHasSSSCalamityLoan(false);
        setHasPagibigLoan(false);
        setHasPagibigCalamityLoan(false);
        setHasCashAdvance(false);
        setHasDeductions(false);
        setHasBenefits(false);
        setHasReports(false);
        setHasSettings(false);
        setHasCalendar(false);
        setHasUser(false);
        setUserTimeOut("");
        setIsAddState(false)

        setHasTamperedApproval(false);
        setHasDTRWithOTViewing(false);
        setHasMobileDTRApproval(false);
        setHasRequestApprovalTimeKeeper(false);
        setHasDTRCorrectionWorkers(false);
        setHasPlantilya(false);
        setHasCostCenter(false);
        setHasPayrollJournalAccount(false);
    }

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {isAddState ?
                        <tr>
                            <td>
                            </td>
                            <td>
                                <input
                                    placeholder="Template Name"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none"
                                    }}
                                />
                            </td>
                            {checkboxes.map((checkbox, index) => (
                                <td key={index}>
                                    <input 
                                        type="checkbox" 
                                        className="checkbox" 
                                        checked={checkbox.value} 
                                        onChange={checkbox.onChange} 
                                    />
                                </td>
                            ))}
                            <td>
                                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="View">
                                        <div style={{padding:"0 5px"}} onClick={()=>viewReports([])}><FormatAlignJustifyIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                            <td>
                                <input
                                    placeholder="User time out (minutes)"
                                    value={userTimeOut}
                                    type='number'
                                    onChange={(e) => setUserTimeOut(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={(e)=>submit(e)}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={()=>close()}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                        :
                        <></>
                    }
                    
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfoForUserTemplate header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            viewReports={viewReports}
                                            isEditState={isEditState}
                                            setIsEditState={setIsEditState}
                                            dataToEdit={dataToEdit}
                                            description={description} 
                                            setDescription={setDescription}
                                            hasHome={hasHome}
                                            setHasHome={setHasHome}
                                            hasAddEmployee={hasAddEmployee}
                                            setHasAddEmployee={setHasAddEmployee}
                                            hasEmployeeList={hasEmployeeList}
                                            setHasEmployeeList={setHasEmployeeList}
                                            hasEmployeeStatus={hasEmployeeStatus}
                                            setHasEmployeeStatus={setHasEmployeeStatus}
                                            hasEmployeeSchedule={hasEmployeeSchedule}
                                            setHasEmployeeSchedule={setHasEmployeeSchedule}
                                            hasTimeEntries={hasTimeEntries}
                                            setHasTimeEntries={setHasTimeEntries}
                                            hasShiftSchedule={hasShiftSchedule}
                                            setHasShiftSchedule={setHasShiftSchedule}
                                            hasProcessPayroll={hasProcessPayroll}
                                            setHasProcessPayroll={setHasProcessPayroll}
                                            has13thMonth={has13thMonth}
                                            setHas13thMonth={setHas13thMonth}
                                            hasPayrollPeriod={hasPayrollPeriod}
                                            setHasPayrollPeriod={setHasPayrollPeriod}
                                            hasClient={hasClient}
                                            setHasClient={setHasClient}
                                            hasPayType={hasPayType}
                                            setHasPayType={setHasPayType}
                                            hasHoliday={hasHoliday}
                                            setHasHoliday={setHasHoliday}
                                            hasHolidayType={hasHolidayType}
                                            setHasHolidayType={setHasHolidayType}
                                            hasLeaveType={hasLeaveType}
                                            setHasLeaveType={setHasLeaveType}
                                            hasDepartment={hasDepartment}
                                            setHasDepartment={setHasDepartment}
                                            hasSection={hasSection}
                                            setHasSection={setHasSection}
                                            hasClassification={hasClassification}
                                            setHasClassification={setHasClassification}
                                            hasCompany={hasCompany}
                                            setHasCompany={setHasCompany}
                                            hasPosition={hasPosition}
                                            setHasPosition={setHasPosition}
                                            hasJobTitle={hasJobTitle}
                                            setHasJobTitle={setHasJobTitle}
                                            hasLocation={hasLocation}
                                            setHasLocation={setHasLocation}
                                            hasDTRRulesConfiguration={hasDTRRulesConfiguration}
                                            setHasDTRRulesConfiguration={setHasDTRRulesConfiguration}
                                            hasEmployeeMonthlySalary={hasEmployeeMonthlySalary}
                                            setHasEmployeeMonthlySalary={setHasEmployeeMonthlySalary}
                                            hasEmployeeDailySalary={hasEmployeeDailySalary}
                                            setHasEmployeeDailySalary={setHasEmployeeDailySalary}
                                            hasPositionDesignationSalary={hasPositionDesignationSalary}
                                            hasQuotaBasedSalary={hasQuotaBasedSalary}
                                            setHasPositionDesignationSalary={setHasPositionDesignationSalary}
                                            setHasQuotaBasedSalary={setHasQuotaBasedSalary}
                                            hasPositionDesignationSalaryLaUnion={hasPositionDesignationSalaryLaUnion}
                                            setHasPositionDesignationSalaryLaUnion={setHasPositionDesignationSalaryLaUnion}
                                            hasEmployeeBankAccount={hasEmployeeBankAccount}
                                            setHasEmployeeBankAccount={setHasEmployeeBankAccount}
                                            hasBIRTax={hasBIRTax}
                                            setHasBIRTax={setHasBIRTax}
                                            hasPagibig={hasPagibig}
                                            setHasPagibig={setHasPagibig}
                                            hasSSS={hasSSS}
                                            setHasSSS={setHasSSS}
                                            hasPhilhealth={hasPhilhealth}
                                            setHasPhilhealth={setHasPhilhealth}
                                            hasDTR={hasDTR}
                                            setHasDTR={setHasDTR}
                                            hasDTRBiometrics={hasDTRBiometrics}
                                            setHasDTRBiometrics={setHasDTRBiometrics}
                                            hasApproverHierarchy={hasApproverHierarchy}
                                            setHasApproverHierarchy={setHasApproverHierarchy}
                                            hasRequestApproval={hasRequestApproval}
                                            setHasRequestApproval={setHasRequestApproval}
                                            hasOvertime={hasOvertime}
                                            setHasOvertime={setHasOvertime}
                                            hasDTRCorrection={hasDTRCorrection}
                                            setHasDTRCorrection={setHasDTRCorrection}
                                            hasLeave={hasLeave}
                                            setHasLeave={setHasLeave}
                                            hasChangeOfSchedule={hasChangeOfSchedule}
                                            setHasChangeOfSchedule={setHasChangeOfSchedule}
                                            hasSSSLoan={hasSSSLoan}
                                            setHasSSSLoan={setHasSSSLoan}
                                            hasSSSCalamityLoan={hasSSSCalamityLoan}
                                            setHasSSSCalamityLoan={setHasSSSCalamityLoan}
                                            hasPagibigLoan={hasPagibigLoan}
                                            setHasPagibigLoan={setHasPagibigLoan}
                                            hasPagibigCalamityLoan={hasPagibigCalamityLoan}
                                            setHasPagibigCalamityLoan={setHasPagibigCalamityLoan}
                                            hasCashAdvance={hasCashAdvance}
                                            setHasCashAdvance={setHasCashAdvance}
                                            hasDeductions={hasDeductions}
                                            setHasDeductions={setHasDeductions}
                                            hasBenefits={hasBenefits}
                                            setHasBenefits={setHasBenefits}
                                            hasReports={hasReports}
                                            setHasReports={setHasReports}
                                            hasSettings={hasSettings}
                                            setHasSettings={setHasSettings}
                                            hasCalendar={hasCalendar}
                                            setHasCalendar={setHasCalendar}
                                            hasUser={hasUser}
                                            setHasUser={setHasUser}
                                            userTimeOut={userTimeOut}
                                            setUserTimeOut={setUserTimeOut}

                                            // additional
                                            hasEmployeereliever={hasEmployeereliever} setHasEmployeereliever={setHasEmployeereliever}
                                            hasMassapproval={hasMassapproval} setHasMassapproval={setHasMassapproval}
                                            hasApproverheirarchyperlocation={hasApproverheirarchyperlocation} setHasApproverheirarchyperlocation={setHasApproverheirarchyperlocation}
                                            hasFinalPay={hasFinalPay} setHasFinalPay={setHasFinalPay}
                                            hasSubcon={hasSubcon} setHasSubcon={setHasSubcon}
                                            hasAgency={hasAgency} setHasAgency={setHasAgency}
                                            hasEmploymentStatus={hasEmploymentStatus} setHasEmploymentStatus={setHasEmploymentStatus}
                                            hasLoans={hasLoans} setHasLoans={setHasLoans}
                                            hasTimeKeeper={hasTimeKeeper} setHasTimeKeeper={setHasTimeKeeper}
                                            hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                                            hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                                            hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                                            hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                                            hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                                            hasResigned={hasResigned} setHasResigned={setHasResigned}
                                            hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                                            hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                                            hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                                            hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                                            hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                                            hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                                            hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                                            has201Report={has201Report} setHas201Report={setHas201Report}
                                            hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                                            hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                                            hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                                            hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                                            hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                                            hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                                            hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                                            hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                                            hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                                            hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                                            hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                                            hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                                            hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                                            hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                                            hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                                            hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                                            hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                                            hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                                            hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                                            hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                                            hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                                            hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                                            hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                                            hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                                            hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                                            hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                                            hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                                            hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                                            hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                                            hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                                            hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                                            hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                                            hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                                            hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                                            hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                                            hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                                            hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                                            hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                                            hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                                            hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                                            hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                                            hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                                            hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                                            hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                                            hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                                            hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                                            hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                                            hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                                            hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                                            hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                                            hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                                            hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                                            hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                                            hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                                            hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                                            hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                                            hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                                            hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                                            hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                                            hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                                            hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                                            hasNotification={hasNotification} setHasNotification={setHasNotification}
                                            hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}
                                            hasRequestApprovalTimeKeeper={hasRequestApprovalTimeKeeper} setHasRequestApprovalTimeKeeper={setHasRequestApprovalTimeKeeper}

                                            hasTamperedApproval={hasTamperedApproval} setHasTamperedApproval={setHasTamperedApproval}
                                            hasMobileDTRApproval={hasMobileDTRApproval} setHasMobileDTRApproval={setHasMobileDTRApproval}
                                            hasDTRWithOTViewing={hasDTRWithOTViewing} setHasDTRWithOTViewing={setHasDTRWithOTViewing}
                                            hasDTRCorrectionWorkers={hasDTRCorrectionWorkers} setHasDTRCorrectionWorkers={setHasDTRCorrectionWorkers}
                                            hasPlantilya={hasPlantilya} setHasPlantilya={setHasPlantilya}
                                            hasCostCenter={hasCostCenter} setHasCostCenter={setHasCostCenter}
                                            hasPayrollJournalAccount={hasPayrollJournalAccount} setHasPayrollJournalAccount={setHasPayrollJournalAccount}

                                            hasManHour={hasManHour} setHasManHour={setHasManHour}
                                            hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}

                                            setShowRequestMessage={setShowRequestMessage}
                                            setIsSuccess={setIsSuccess}
                                            setRequestMessage={setRequestMessage}
                                            handleUpdate={handleUpdate}
                                    />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"center", padding: "20px 0 0 0"}}>
                    {`${currentPage}/${totalPages}`}
                </div>
            </>
            ) :
            <></>}
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </>
    )
}
function SetInfoForUserTemplate({header, 
    _cell, 
    editHandleClick, 
    deleteHandleClick, 
    viewReports,
    isEditState, 
    setIsEditState,
    dataToEdit,
    description,
    setDescription,
    hasHome,
    setHasHome,
    hasAddEmployee,
    setHasAddEmployee,
    hasEmployeeList,
    setHasEmployeeList,
    hasEmployeeStatus,
    setHasEmployeeStatus,
    hasEmployeeSchedule,
    setHasEmployeeSchedule,
    hasTimeEntries,
    setHasTimeEntries,
    hasShiftSchedule,
    setHasShiftSchedule,
    hasProcessPayroll,
    setHasProcessPayroll,
    has13thMonth,
    setHas13thMonth,
    hasPayrollPeriod,
    setHasPayrollPeriod,
    hasClient,
    setHasClient,
    hasPayType,
    setHasPayType,
    hasHoliday,
    setHasHoliday,
    hasHolidayType,
    setHasHolidayType,
    hasLeaveType,
    setHasLeaveType,
    hasDepartment,
    setHasDepartment,
    hasSection,
    setHasSection,
    hasClassification,
    setHasClassification,
    hasCompany,
    setHasCompany,
    hasPosition,
    setHasPosition,
    hasJobTitle,
    setHasJobTitle,
    hasLocation,
    setHasLocation,
    hasDTRRulesConfiguration,
    setHasDTRRulesConfiguration,
    hasEmployeeMonthlySalary,
    setHasEmployeeMonthlySalary,
    hasEmployeeDailySalary,
    setHasEmployeeDailySalary,
    hasPositionDesignationSalary,
    hasQuotaBasedSalary,
    setHasPositionDesignationSalary,
    setHasQuotaBasedSalary,
    hasPositionDesignationSalaryLaUnion,
    setHasPositionDesignationSalaryLaUnion,
    hasEmployeeBankAccount,
    setHasEmployeeBankAccount,
    hasBIRTax,
    setHasBIRTax,
    hasPagibig,
    setHasPagibig,
    hasSSS,
    setHasSSS,
    hasPhilhealth,
    setHasPhilhealth,
    hasDTR,
    setHasDTR,
    hasDTRBiometrics,
    setHasDTRBiometrics,
    hasApproverHierarchy,
    setHasApproverHierarchy,
    hasRequestApproval,
    setHasRequestApproval,
    hasOvertime,
    setHasOvertime,
    hasDTRCorrection,
    setHasDTRCorrection,
    hasLeave,
    setHasLeave,
    hasChangeOfSchedule,
    setHasChangeOfSchedule,
    hasSSSLoan,
    setHasSSSLoan,
    hasSSSCalamityLoan,
    setHasSSSCalamityLoan,
    hasPagibigLoan,
    setHasPagibigLoan,
    hasPagibigCalamityLoan,
    setHasPagibigCalamityLoan,
    hasCashAdvance,
    setHasCashAdvance,
    hasDeductions,
    setHasDeductions,
    hasBenefits,
    setHasBenefits,
    hasReports,
    setHasReports,
    hasSettings,
    setHasSettings,
    hasCalendar,
    setHasCalendar,
    hasUser,
    setHasUser,
    userTimeOut,
    setUserTimeOut,

    // additional
    hasEmployeereliever, setHasEmployeereliever,
    hasMassapproval, setHasMassapproval,
    hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation,
    hasFinalPay, setHasFinalPay,
    hasSubcon, setHasSubcon,
    hasAgency, setHasAgency,
    hasEmploymentStatus, setHasEmploymentStatus,
    hasLoans, setHasLoans,
    hasTimeKeeper, setHasTimeKeeper,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,
    hasRequestApprovalTimeKeeper, setHasRequestApprovalTimeKeeper,

    hasTamperedApproval, setHasTamperedApproval,
    hasMobileDTRApproval, setHasMobileDTRApproval,
    hasDTRWithOTViewing, setHasDTRWithOTViewing,
    hasDTRCorrectionWorkers, setHasDTRCorrectionWorkers,
    hasPlantilya, setHasPlantilya,
    hasCostCenter, setHasCostCenter,
    hasPayrollJournalAccount, setHasPayrollJournalAccount,

    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,

    setShowRequestMessage,
    setIsSuccess,
    setRequestMessage,
    handleUpdate
}) {
    const data = _cell.render("Cell").props.row.original;
    const checkboxes = [
        { header: "Home", value: hasHome, onChange: (e) => setHasHome(e.target.checked) },
        { header: "Add Employee", value: hasAddEmployee, onChange: (e) => setHasAddEmployee(e.target.checked) },
        { header: "Employee List", value: hasEmployeeList, onChange: (e) => setHasEmployeeList(e.target.checked) },
        { header: "Employee Status", value: hasEmployeeStatus, onChange: (e) => setHasEmployeeStatus(e.target.checked) },
        { header: "Employee Schedule", value: hasEmployeeSchedule, onChange: (e) => setHasEmployeeSchedule(e.target.checked) },
        { header: "Time Entries", value: hasTimeEntries, onChange: (e) => setHasTimeEntries(e.target.checked) },
        { header: "Tampered Approval", value: hasTamperedApproval, onChange: (e) => setHasTamperedApproval(e.target.checked) },
        { header: "Shift Schedule", value: hasShiftSchedule, onChange: (e) => setHasShiftSchedule(e.target.checked) },
        { header: "Process Payroll", value: hasProcessPayroll, onChange: (e) => setHasProcessPayroll(e.target.checked) },
        { header: "13th Month", value: has13thMonth, onChange: (e) => setHas13thMonth(e.target.checked) },
        { header: "Payroll Period", value: hasPayrollPeriod, onChange: (e) => setHasPayrollPeriod(e.target.checked) },
        { header: "Client", value: hasClient, onChange: (e) => setHasClient(e.target.checked) },
        { header: "Pay Type", value: hasPayType, onChange: (e) => setHasPayType(e.target.checked) },
        { header: "Holiday", value: hasHoliday, onChange: (e) => setHasHoliday(e.target.checked) },
        { header: "Holiday Type", value: hasHolidayType, onChange: (e) => setHasHolidayType(e.target.checked) },
        { header: "Leave Type", value: hasLeaveType, onChange: (e) => setHasLeaveType(e.target.checked) },
        { header: "Department", value: hasDepartment, onChange: (e) => setHasDepartment(e.target.checked) },
        { header: "Section", value: hasSection, onChange: (e) => setHasSection(e.target.checked) },
        { header: "Classification", value: hasClassification, onChange: (e) => setHasClassification(e.target.checked) },
        { header: "Company", value: hasCompany, onChange: (e) => setHasCompany(e.target.checked) },
        { header: "Position", value: hasPosition, onChange: (e) => setHasPosition(e.target.checked) },
        { header: "Job Title", value: hasJobTitle, onChange: (e) => setHasJobTitle(e.target.checked) },
        { header: "Location", value: hasLocation, onChange: (e) => setHasLocation(e.target.checked) },
        { header: "DTR Rules Configuration", value: hasDTRRulesConfiguration, onChange: (e) => setHasDTRRulesConfiguration(e.target.checked) },
        { header: "Employee Monthly Salary", value: hasEmployeeMonthlySalary, onChange: (e) => setHasEmployeeMonthlySalary(e.target.checked) },
        { header: "Employee Daily Salary", value: hasEmployeeDailySalary, onChange: (e) => setHasEmployeeDailySalary(e.target.checked) },
        { header: "Position-Designation Salary", value: hasPositionDesignationSalary, onChange: (e) => setHasPositionDesignationSalary(e.target.checked) },
        { header: "Quota-Based Salary", value: hasQuotaBasedSalary, onChange: (e) => setHasQuotaBasedSalary(e.target.checked) },
        { header: "Position-Designation Salary (La Union)", value: hasPositionDesignationSalaryLaUnion, onChange: (e) => setHasPositionDesignationSalaryLaUnion(e.target.checked) },
        { header: "Employee Bank Account", value: hasEmployeeBankAccount, onChange: (e) => setHasEmployeeBankAccount(e.target.checked) },
        { header: "BIR / Tax", value: hasBIRTax, onChange: (e) => setHasBIRTax(e.target.checked) },
        { header: "Pagibig", value: hasPagibig, onChange: (e) => setHasPagibig(e.target.checked) },
        { header: "SSS", value: hasSSS, onChange: (e) => setHasSSS(e.target.checked) },
        { header: "Philhealth", value: hasPhilhealth, onChange: (e) => setHasPhilhealth(e.target.checked) },
        { header: "DTR (Admin's View)", value: hasDTR, onChange: (e) => setHasDTR(e.target.checked) },
        { header: "DTR (Employee's View)", value: hasDTRBiometrics, onChange: (e) => setHasDTRBiometrics(e.target.checked) },
        { header: "DTR With OT Viewing", value: hasDTRWithOTViewing, onChange: (e) => setHasDTRWithOTViewing(e.target.checked) },
        { header: "Mobile DTR Approval", value: hasMobileDTRApproval, onChange: (e) => setHasMobileDTRApproval(e.target.checked) },
        { header: "Approver Hierarchy", value: hasApproverHierarchy, onChange: (e) => setHasApproverHierarchy(e.target.checked) },
        { header: "Request Approval", value: hasRequestApproval, onChange: (e) => setHasRequestApproval(e.target.checked) },
        { header: "Request Approval Time Keeper", value: hasRequestApprovalTimeKeeper, onChange: (e) => setHasRequestApprovalTimeKeeper(e.target.checked) },
        { header: "Overtime", value: hasOvertime, onChange: (e) => setHasOvertime(e.target.checked) },
        { header: "DTR Correction Workers", value: hasDTRCorrectionWorkers, onChange: (e) => setHasDTRCorrectionWorkers(e.target.checked) },
        { header: "DTR Correction", value: hasDTRCorrection, onChange: (e) => setHasDTRCorrection(e.target.checked) },
        { header: "Leave", value: hasLeave, onChange: (e) => setHasLeave(e.target.checked) },
        { header: "Change of Schedule", value: hasChangeOfSchedule, onChange: (e) => setHasChangeOfSchedule(e.target.checked) },
        { header: "SSS Loan", value: hasSSSLoan, onChange: (e) => setHasSSSLoan(e.target.checked) },
        { header: "SSS Calamity Loan", value: hasSSSCalamityLoan, onChange: (e) => setHasSSSCalamityLoan(e.target.checked) },
        { header: "Pagibig Loan", value: hasPagibigLoan, onChange: (e) => setHasPagibigLoan(e.target.checked) },
        { header: "Pagibig Calamity Loan", value: hasPagibigCalamityLoan, onChange: (e) => setHasPagibigCalamityLoan(e.target.checked) },
        { header: "Cash Advance", value: hasCashAdvance, onChange: (e) => setHasCashAdvance(e.target.checked) },
        { header: "Deductions", value: hasDeductions, onChange: (e) => setHasDeductions(e.target.checked) },
        { header: "Benefits", value: hasBenefits, onChange: (e) => setHasBenefits(e.target.checked) },
        // { header: "Reports", value: hasReports, onChange: (e) => setHasReports(e.target.checked) },
        { header: "Settings", value: hasSettings, onChange: (e) => setHasSettings(e.target.checked) },
        { header: "Calendar", value: hasCalendar, onChange: (e) => setHasCalendar(e.target.checked) },
        { header: "User", value: hasUser, onChange: (e) => setHasUser(e.target.checked) },
        { header: "Employee Reliever", value: hasEmployeereliever, onChange: (e) => setHasEmployeereliever(e.target.checked) },
        { header: "Mass Approval", value: hasMassapproval, onChange: (e) => setHasMassapproval(e.target.checked) },
        { header: "Approver Hierarchy Per Location", value: hasApproverheirarchyperlocation, onChange: (e) => setHasApproverheirarchyperlocation(e.target.checked) },
        { header: "Final Pay", value: hasFinalPay, onChange: (e) => setHasFinalPay(e.target.checked) },
        { header: "Subcon", value: hasSubcon, onChange: (e) => setHasSubcon(e.target.checked) },
        { header: "Agency", value: hasAgency, onChange: (e) => setHasAgency(e.target.checked) },
        { header: "Employment Status", value: hasEmploymentStatus, onChange: (e) => setHasEmploymentStatus(e.target.checked) },
        { header: "Loans", value: hasLoans, onChange: (e) => setHasLoans(e.target.checked) },
        { header: "Time Keeper", value: hasTimeKeeper, onChange: (e) => setHasTimeKeeper(e.target.checked) },
        { header: "Plantilya", value: hasPlantilya, onChange: (e) => setHasPlantilya(e.target.checked) },
        { header: "Cost Center", value: hasCostCenter, onChange: (e) => setHasCostCenter(e.target.checked) },
        { header: "Payroll Journal Account", value: hasPayrollJournalAccount, onChange: (e) => setHasPayrollJournalAccount(e.target.checked) },
        { header: "Man Hour", value: hasManHour, onChange: (e) => setHasManHour(e.target.checked) },
        { header: "Yearly Report", value: hasYearlyReport, onChange: (e) => setHasYearlyReport(e.target.checked) },
        { header: "Per Day Tracker", value: hasPerDayTracker, onChange: (e) => setHasPerDayTracker(e.target.checked) },
        { header: "Overtime Summary Report", value: hasOvertimeSummaryReport, onChange: (e) => setHasOvertimeSummaryReport(e.target.checked) },
        { header: "Tracker Report", value: hasTrackerReport, onChange: (e) => setHasTrackerReport(e.target.checked) },
        { header: "Payslip", value: hasPayslip, onChange: (e) => setHasPayslip(e.target.checked) },
        { header: "Payroll Register", value: hasPayrollRegister, onChange: (e) => setHasPayrollRegister(e.target.checked) },
        { header: "Resigned", value: hasResigned, onChange: (e) => setHasResigned(e.target.checked) },
        { header: "Active Employees", value: hasActiveEmployees, onChange: (e) => setHasActiveEmployees(e.target.checked) },
        { header: "Year Of Service", value: hasYearofService, onChange: (e) => setHasYearofService(e.target.checked) },
        { header: "SSS Summary", value: hasSSSSummary, onChange: (e) => setHasSSSSummary(e.target.checked) },
        { header: "Pagibig Summary", value: hasPagibigSummary, onChange: (e) => setHasPagibigSummary(e.target.checked) },
        { header: "Philhealth Summary", value: hasPhilhealthSummary, onChange: (e) => setHasPhilhealthSummary(e.target.checked) },
        { header: "SSS Loan Report", value: hasSSSLoanReport, onChange: (e) => setHasSSSLoanReport(e.target.checked) },
        { header: "Pagibig Loan Report", value: hasPagibigLoanReport, onChange: (e) => setHasPagibigLoanReport(e.target.checked) },
        { header: "201 Report", value: has201Report, onChange: (e) => setHas201Report(e.target.checked) },
        { header: "Attendance Report", value: hasAttendanceReport, onChange: (e) => setHasAttendanceReport(e.target.checked) },
        { header: "Bank Transmittal BDO", value: hasBankTransmittalBDO, onChange: (e) => setHasBankTransmittalBDO(e.target.checked) },
        { header: "Bank Transmittal BPI", value: hasBankTransmittalBPI, onChange: (e) => setHasBankTransmittalBPI(e.target.checked) },
        { header: "Bank Transmittal ChinaBank Savings", value: hasBankTransmittalChinaBankSavings, onChange: (e) => setHasBankTransmittalChinaBankSavings(e.target.checked) },
        { header: "Bank Transmittal HSBC", value: hasBankTransmittalHSBC, onChange: (e) => setHasBankTransmittalHSBC(e.target.checked) },
        { header: "Bank Transmittal Security Bank", value: hasBankTransmittalSecurityBank, onChange: (e) => setHasBankTransmittalSecurityBank(e.target.checked) },
        { header: "Summary Of Tardiness", value: hasSummaryOfTardiness, onChange: (e) => setHasSummaryOfTardiness(e.target.checked) },
        { header: "Absences Memo", value: hasAbsencesMemo, onChange: (e) => setHasAbsencesMemo(e.target.checked) },
        { header: "Absences Report", value: hasAbsencesReport, onChange: (e) => setHasAbsencesReport(e.target.checked) },
        { header: "Action History Report", value: hasActionHistoryReport, onChange: (e) => setHasActionHistoryReport(e.target.checked) },
        { header: "Allowance Summary", value: hasAllowanceSummary, onChange: (e) => setHasAllowanceSummary(e.target.checked) },
        { header: "Audit Trail Report Employee Setup", value: hasAuditTrailReportEmployeeSetup, onChange: (e) => setHasAuditTrailReportEmployeeSetup(e.target.checked) },
        { header: "Bundy Clock Usage", value: hasBundyClockUsage, onChange: (e) => setHasBundyClockUsage(e.target.checked) },
        { header: "Basic Pay Adjustment Report", value: hasBasicPayAdjustmentReport, onChange: (e) => setHasBasicPayAdjustmentReport(e.target.checked) },
        { header: "Certificate Of Employment", value: hasCertificateOfEmployment, onChange: (e) => setHasCertificateOfEmployment(e.target.checked) },
        { header: "Certificate Of Pagibig", value: hasCertificateOfPagibig, onChange: (e) => setHasCertificateOfPagibig(e.target.checked) },
        { header: "Certificate Of Philhealth", value: hasCertificateOfPhilhealth, onChange: (e) => setHasCertificateOfPhilhealth(e.target.checked) },
        { header: "Certificate Of SSS", value: hasCertificateOfSSS, onChange: (e) => setHasCertificateOfSSS(e.target.checked) },
        { header: "Commissions Summary", value: hasCommissionsSummary, onChange: (e) => setHasCommissionsSummary(e.target.checked) },
        { header: "Cost Center Report", value: hasCostCenterReport, onChange: (e) => setHasCostCenterReport(e.target.checked) },
        { header: "Deductions Per Month", value: hasDeductionsPerMonth, onChange: (e) => setHasDeductionsPerMonth(e.target.checked) },
        { header: "DTR Report", value: hasDTRReport, onChange: (e) => setHasDTRReport(e.target.checked) },
        { header: "Earnings Per Month", value: hasEarningsPerMonth, onChange: (e) => setHasEarningsPerMonth(e.target.checked) },
        { header: "Employee Leave Group", value: hasEmployeeLeaveGroup, onChange: (e) => setHasEmployeeLeaveGroup(e.target.checked) },
        { header: "Employee Overtime Group", value: hasEmployeeOvertimeGroup, onChange: (e) => setHasEmployeeOvertimeGroup(e.target.checked) },
        { header: "Employee Expense Group", value: hasEmployeeExpenseGroup, onChange: (e) => setHasEmployeeExpenseGroup(e.target.checked) },
        { header: "Employee Leave History", value: hasEmployeeLeaveHistory, onChange: (e) => setHasEmployeeLeaveHistory(e.target.checked) },
        { header: "Employee Listing By Hiring Date", value: hasEmployeeListingByHiringDate, onChange: (e) => setHasEmployeeListingByHiringDate(e.target.checked) },
        { header: "Employee Register", value: hasEmployeeRegister, onChange: (e) => setHasEmployeeRegister(e.target.checked) },
        { header: "Expense Report", value: hasExpenseReport, onChange: (e) => setHasExpenseReport(e.target.checked) },
        { header: "Government Employee Inventory", value: hasGovernmentEmployeeInventory, onChange: (e) => setHasGovernmentEmployeeInventory(e.target.checked) },
        { header: "Headcount Report", value: hasHeadcountReport, onChange: (e) => setHasHeadcountReport(e.target.checked) },
        { header: "Holiday Premium Summary", value: hasHolidayPremiumSummary, onChange: (e) => setHasHolidayPremiumSummary(e.target.checked) },
        { header: "Leave Ledger Report", value: hasLeaveLedgerReport, onChange: (e) => setHasLeaveLedgerReport(e.target.checked) },
        { header: "Leave Summary Report", value: hasLeaveSummaryReport, onChange: (e) => setHasLeaveSummaryReport(e.target.checked) },
        { header: "Loan History", value: hasLoanHistory, onChange: (e) => setHasLoanHistory(e.target.checked) },
        { header: "Loan Payments Summary", value: hasLoanPaymentsSummary, onChange: (e) => setHasLoanPaymentsSummary(e.target.checked) },
        { header: "Loans Monthly Amortization Summary", value: hasLoansMonthlyAmortizationSummary, onChange: (e) => setHasLoansMonthlyAmortizationSummary(e.target.checked) },
        { header: "Loans Penalty History", value: hasLoansPenaltyHistory, onChange: (e) => setHasLoansPenaltyHistory(e.target.checked) },
        { header: "Night Differential Summary", value: hasNightDifferentialSummary, onChange: (e) => setHasNightDifferentialSummary(e.target.checked) },
        { header: "Non-Taxable Allowances Report", value: hasNonTaxableAllowancesReport, onChange: (e) => setHasNonTaxableAllowancesReport(e.target.checked) },
        { header: "Other Earnings Report", value: hasOtherEarningsReport, onChange: (e) => setHasOtherEarningsReport(e.target.checked) },
        { header: "Other Deductions Summary", value: hasOtherDeductionsSummary, onChange: (e) => setHasOtherDeductionsSummary(e.target.checked) },
        { header: "Outstanding Loans", value: hasOutstandingLoans, onChange: (e) => setHasOutstandingLoans(e.target.checked) },
        { header: "Payroll Cash Register", value: hasPayrollCashRegister, onChange: (e) => setHasPayrollCashRegister(e.target.checked) },
        { header: "Payroll Check Register", value: hasPayrollCheckRegister, onChange: (e) => setHasPayrollCheckRegister(e.target.checked) },
        { header: "Payroll Debit Memo", value: hasPayrollDebitMemo, onChange: (e) => setHasPayrollDebitMemo(e.target.checked) },
        { header: "Payroll Journal By Cost Center", value: hasPayrollJournalByCostCenter, onChange: (e) => setHasPayrollJournalByCostCenter(e.target.checked) },
        { header: "Payroll Journal By Department", value: hasPayrollJournalByDepartment, onChange: (e) => setHasPayrollJournalByDepartment(e.target.checked) },
        { header: "Payroll Journal By Summary", value: hasPayrollJournalBySummary, onChange: (e) => setHasPayrollJournalBySummary(e.target.checked) },
        { header: "Payroll Per Payment Method", value: hasPayrollPerPaymentMethod, onChange: (e) => setHasPayrollPerPaymentMethod(e.target.checked) },
        { header: "Select Logs", value: hasSelectLogs, onChange: (e) => setHasSelectLogs(e.target.checked) },
        { header: "Summary Report By Month And Department", value: hasSummaryReportByMonthAndDepartment, onChange: (e) => setHasSummaryReportByMonthAndDepartment(e.target.checked) },
        { header: "Tardiness Memo", value: hasTardinessMemo, onChange: (e) => setHasTardinessMemo(e.target.checked) },
        { header: "Time Keeping History Detailed Report", value: hasTimeKeepingHistoryDetailedReport, onChange: (e) => setHasTimeKeepingHistoryDetailedReport(e.target.checked) },
        { header: "Time Keeping Hours Worked Report", value: hasTimeKeepingHoursWorkedReport, onChange: (e) => setHasTimeKeepingHoursWorkedReport(e.target.checked) },
        { header: "Time Keeping Hours Worked Summary", value: hasTimeKeepingHoursWorkedSummary, onChange: (e) => setHasTimeKeepingHoursWorkedSummary(e.target.checked) },
        { header: "Timesheet Status Report", value: hasTimesheetStatusReport, onChange: (e) => setHasTimesheetStatusReport(e.target.checked) },
        { header: "YTD Deduction Summary", value: hasYTDDeductionSummary, onChange: (e) => setHasYTDDeductionSummary(e.target.checked) },
        { header: "YTD Earnings Summary", value: hasYTDEarningsSummary, onChange: (e) => setHasYTDEarningsSummary(e.target.checked) },
        { header: "YTD Payroll Register", value: hasYTDPayrollRegister, onChange: (e) => setHasYTDPayrollRegister(e.target.checked) },
        { header: "Notifications", value: hasNotification, onChange: (e) => setHasNotification(e.target.checked) },
        { header: "Mobile Biometrics", value: hasMobileBiometrics, onChange: (e) => setHasMobileBiometrics(e.target.checked) },
    ];

    const submit = (e) =>{
        const allFalse = checkboxes.every(checkbox => checkbox.value === false);

        if(description === ""){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please input a template name");
            return;
        }

        if(allFalse){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select an access at least 1");
            return;
        }

        handleUpdate(e);
    }
    const close = () =>{
        setDescription("");
        setHasHome(false);
        setHasAddEmployee(false);
        setHasEmployeeList(false);
        setHasEmployeeStatus(false);
        setHasEmployeeSchedule(false);
        setHasTimeEntries(false);
        setHasShiftSchedule(false);
        setHasProcessPayroll(false);
        setHas13thMonth(false);
        setHasPayrollPeriod(false);
        setHasClient(false);
        setHasPayType(false);
        setHasHoliday(false);
        setHasHolidayType(false);
        setHasLeaveType(false);
        setHasDepartment(false);
        setHasSection(false);
        setHasClassification(false);
        setHasCompany(false);
        setHasPosition(false);
        setHasJobTitle(false);
        setHasLocation(false);
        setHasEmployeeMonthlySalary(false);
        setHasEmployeeDailySalary(false);
        setHasPositionDesignationSalary(false);
        setHasQuotaBasedSalary(false);
        setHasPositionDesignationSalaryLaUnion(false);
        setHasEmployeeBankAccount(false);
        setHasBIRTax(false);
        setHasPagibig(false);
        setHasSSS(false);
        setHasPhilhealth(false);
        setHasDTR(false);
        setHasDTRBiometrics(false);
        setHasApproverHierarchy(false);
        setHasRequestApproval(false);
        setHasOvertime(false);
        setHasDTRCorrection(false);
        setHasLeave(false);
        setHasChangeOfSchedule(false);
        setHasSSSLoan(false);
        setHasSSSCalamityLoan(false);
        setHasPagibigLoan(false);
        setHasPagibigCalamityLoan(false);
        setHasCashAdvance(false);
        setHasDeductions(false);
        setHasBenefits(false);
        setHasReports(false);
        setHasSettings(false);
        setHasCalendar(false);
        setHasUser(false);
        setUserTimeOut("");

        // Additional
        setHasEmployeereliever(false);
        setHasMassapproval(false);
        setHasApproverheirarchyperlocation(false);
        setHasFinalPay(false);
        setHasSubcon(false);
        setHasAgency(false);
        setHasEmploymentStatus(false);
        setHasLoans(false);
        setHasTimeKeeper(false);
        setHasPerDayTracker(false);
        setHasOvertimeSummaryReport(false);
        setHasTrackerReport(false);
        setHasPayslip(false);
        setHasPayrollRegister(false);
        setHasResigned(false);
        setHasActiveEmployees(false);
        setHasYearofService(false);
        setHasSSSSummary(false);
        setHasPagibigSummary(false);
        setHasPhilhealthSummary(false);
        setHasSSSLoanReport(false);
        setHasPagibigLoanReport(false);
        setHas201Report(false);
        setHasAttendanceReport(false);
        setHasBankTransmittalBDO(false);
        setHasBankTransmittalBPI(false);
        setHasBankTransmittalChinaBankSavings(false);
        setHasBankTransmittalHSBC(false);
        setHasBankTransmittalSecurityBank(false);
        setHasSummaryOfTardiness(false);
        setHasAbsencesMemo(false);
        setHasAbsencesReport(false);
        setHasActionHistoryReport(false);
        setHasAllowanceSummary(false);
        setHasAuditTrailReportEmployeeSetup(false);
        setHasBundyClockUsage(false);
        setHasBasicPayAdjustmentReport(false);
        setHasCertificateOfEmployment(false);
        setHasCertificateOfPagibig(false);
        setHasCertificateOfPhilhealth(false);
        setHasCertificateOfSSS(false);
        setHasCommissionsSummary(false);
        setHasCostCenterReport(false);
        setHasDeductionsPerMonth(false);
        setHasDTRReport(false);
        setHasEarningsPerMonth(false);
        setHasEmployeeLeaveGroup(false);
        setHasEmployeeOvertimeGroup(false);
        setHasEmployeeExpenseGroup(false);
        setHasEmployeeLeaveHistory(false);
        setHasEmployeeListingByHiringDate(false);
        setHasEmployeeRegister(false);
        setHasExpenseReport(false);
        setHasGovernmentEmployeeInventory(false);
        setHasHeadcountReport(false);
        setHasHolidayPremiumSummary(false);
        setHasLeaveLedgerReport(false);
        setHasLeaveSummaryReport(false);
        setHasLoanHistory(false);
        setHasLoanPaymentsSummary(false);
        setHasLoansMonthlyAmortizationSummary(false);
        setHasLoansPenaltyHistory(false);
        setHasNightDifferentialSummary(false);
        setHasNonTaxableAllowancesReport(false);
        setHasOtherEarningsReport(false);
        setHasOtherDeductionsSummary(false);
        setHasOutstandingLoans(false);
        setHasPayrollCashRegister(false);
        setHasPayrollCheckRegister(false);
        setHasPayrollDebitMemo(false);
        setHasPayrollJournalByCostCenter(false);
        setHasPayrollJournalByDepartment(false);
        setHasPayrollJournalBySummary(false);
        setHasPayrollPerPaymentMethod(false);
        setHasSelectLogs(false);
        setHasSummaryReportByMonthAndDepartment(false);
        setHasTardinessMemo(false);
        setHasTimeKeepingHistoryDetailedReport(false);
        setHasTimeKeepingHoursWorkedReport(false);
        setHasTimeKeepingHoursWorkedSummary(false);
        setHasTimesheetStatusReport(false);
        setHasYTDDeductionSummary(false);
        setHasYTDEarningsSummary(false);
        setHasYTDPayrollRegister(false);
        setHasNotification(false);
        setHasMobileBiometrics(false);

        setHasTamperedApproval(false)
        setHasDTRWithOTViewing(false)
        setHasMobileDTRApproval(false)
        setHasRequestApprovalTimeKeeper(false)
        setHasDTRCorrectionWorkers(false)
        setHasPlantilya(false)
        setHasCostCenter(false)
        setHasPayrollJournalAccount(false)

        setHasManHour(false)
        setHasYearlyReport(false)

        setIsEditState(false)
    }

    if(isEditState && dataToEdit.id === data.id){
        const checkbox = checkboxes.find(checkbox => checkbox.header === header);

        if(header === "Id"){
            return (
                <td>
                    {dataToEdit.id}
                </td>
            )
        }

        if(header === "Template Name"){
            return (
                <td>
                    <input
                        placeholder="Template Name"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        style={{color: "gray",
                            height: "30px",
                            borderRadius: "3px",
                            border: "1px solid #80808080",
                            outline: "none"
                        }}
                    />
                </td>
            )
        }

        if(header === "User Time Out (minutes)"){
            return (
                <td>
                    <input
                        placeholder="User time out (minutes)"
                        value={userTimeOut}
                        type='number'
                        onChange={(e) => setUserTimeOut(e.target.value)}
                        style={{color: "gray",
                            height: "30px",
                            borderRadius: "3px",
                            border: "1px solid #80808080",
                            outline: "none"
                        }}
                    />
                </td>
            )
        }

        if (header === "") {
            return(
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="Save">
                            <div style={{padding:"0 5px"}} onClick={(e)=>submit(e)}><SaveIcon/></div>
                        </Tooltip>
                        { deleteHandleClick ? 
                        <Tooltip text="Cancel">
                            <div style={{padding:"0 5px"}} onClick={()=>close()}><DoDisturbIcon/></div>
                        </Tooltip>
                        :
                        <></>
                        }
                    </div>
                </td>
            )
        }

        if (checkbox) {
            return (
                <td>
                    <input 
                        type="checkbox" 
                        className="checkbox" 
                        checked={checkbox.value} 
                        onChange={checkbox.onChange} 
                    />
                </td>
            );
        }
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header !== "Template Name" && header !== "" && header !== "Id" && header !== "User Time Out (minutes)" && header !== "Reports"){
        const value = _cell.render("Cell").props.value

        return (
            <td>
                <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={value}
                        disabled={true}
                />
            </td>
        )
    }

    if(header === "Reports"){
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewReports(data)}><FormatAlignJustifyIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }
    

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
export function CreateTableForReports({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    viewReports,
    isAddState,
    setIsAddState,
    isEditState,
    setIsEditState,
    dataToEdit,
    description,
    setDescription,
    hasHome,
    setHasHome,
    hasAddEmployee,
    setHasAddEmployee,
    hasEmployeeList,
    setHasEmployeeList,
    hasEmployeeStatus,
    setHasEmployeeStatus,
    hasEmployeeSchedule,
    setHasEmployeeSchedule,
    hasTimeEntries,
    setHasTimeEntries,
    hasShiftSchedule,
    setHasShiftSchedule,
    hasProcessPayroll,
    setHasProcessPayroll,
    has13thMonth,
    setHas13thMonth,
    hasPayrollPeriod,
    setHasPayrollPeriod,
    hasClient,
    setHasClient,
    hasPayType,
    setHasPayType,
    hasHoliday,
    setHasHoliday,
    hasHolidayType,
    setHasHolidayType,
    hasLeaveType,
    setHasLeaveType,
    hasDepartment,
    setHasDepartment,
    hasSection,
    setHasSection,
    hasClassification,
    setHasClassification,
    hasCompany,
    setHasCompany,
    hasPosition,
    setHasPosition,
    hasJobTitle,
    setHasJobTitle,
    hasLocation,
    setHasLocation,
    hasEmployeeMonthlySalary,
    setHasEmployeeMonthlySalary,
    hasEmployeeDailySalary,
    setHasEmployeeDailySalary,
    hasPositionDesignationSalary,
    hasQuotaBasedSalary,
    setHasPositionDesignationSalary,
    setHasQuotaBasedSalary,
    hasEmployeeBankAccount,
    setHasEmployeeBankAccount,
    hasBIRTax,
    setHasBIRTax,
    hasPagibig,
    setHasPagibig,
    hasSSS,
    setHasSSS,
    hasPhilhealth,
    setHasPhilhealth,
    hasDTR,
    setHasDTR,
    hasDTRBiometrics,
    setHasDTRBiometrics,
    hasApproverHierarchy,
    setHasApproverHierarchy,
    hasRequestApproval,
    setHasRequestApproval,
    hasOvertime,
    setHasOvertime,
    hasDTRCorrection,
    setHasDTRCorrection,
    hasLeave,
    setHasLeave,
    hasChangeOfSchedule,
    setHasChangeOfSchedule,
    hasSSSLoan,
    setHasSSSLoan,
    hasSSSCalamityLoan,
    setHasSSSCalamityLoan,
    hasPagibigLoan,
    setHasPagibigLoan,
    hasPagibigCalamityLoan,
    setHasPagibigCalamityLoan,
    hasCashAdvance,
    setHasCashAdvance,
    hasDeductions,
    setHasDeductions,
    hasBenefits,
    setHasBenefits,
    hasReports,
    setHasReports,
    hasSettings,
    setHasSettings,
    hasCalendar,
    setHasCalendar,
    hasUser,
    setHasUser,
    userTimeOut,
    setUserTimeOut,

    // additional
    hasEmployeereliever, setHasEmployeereliever,
    hasMassapproval, setHasMassapproval,
    hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation,
    hasFinalPay, setHasFinalPay,
    hasSubcon, setHasSubcon,
    hasAgency, setHasAgency,
    hasEmploymentStatus, setHasEmploymentStatus,
    hasLoans, setHasLoans,
    hasTimeKeeper, setHasTimeKeeper,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,

    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,
    hasBIR2316, setHasBIR2316,
    hasBIR1601C, setHasBIR1601C,
    hasAlphaList, setHasAlphaList,
    hasLoanReport, setHasLoanReport,
    hasBankTransmittalReport, setHasBankTransmittalReport,

    handleSubmit,
    handleUpdate,

    currentPage, setCurrentPage
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const checkboxes = [
        { value: hasManHour, onChange: (e) => setHasManHour(e.target.checked) },
        { value: hasYearlyReport, onChange: (e) => setHasYearlyReport(e.target.checked) },
        { value: hasBIR2316, onChange: (e) => setHasBIR2316(e.target.checked) },
        { value: hasBIR1601C, onChange: (e) => setHasBIR1601C(e.target.checked) },
        { value: hasAlphaList, onChange: (e) => setHasAlphaList(e.target.checked) },
        { value: hasLoanReport, onChange: (e) => setHasLoanReport(e.target.checked) },
        { value: hasBankTransmittalReport, onChange: (e) => setHasBankTransmittalReport(e.target.checked) },
        { value: hasPerDayTracker, onChange: (e) => setHasPerDayTracker(e.target.checked) },
        { value: hasOvertimeSummaryReport, onChange: (e) => setHasOvertimeSummaryReport(e.target.checked) },
        { value: hasTrackerReport, onChange: (e) => setHasTrackerReport(e.target.checked) },
        { value: hasPayslip, onChange: (e) => setHasPayslip(e.target.checked) },
        { value: hasPayrollRegister, onChange: (e) => setHasPayrollRegister(e.target.checked) },
        { value: hasResigned, onChange: (e) => setHasResigned(e.target.checked) },
        { value: hasActiveEmployees, onChange: (e) => setHasActiveEmployees(e.target.checked) },
        { value: hasYearofService, onChange: (e) => setHasYearofService(e.target.checked) },
        { value: hasSSSSummary, onChange: (e) => setHasSSSSummary(e.target.checked) },
        { value: hasPagibigSummary, onChange: (e) => setHasPagibigSummary(e.target.checked) },
        { value: hasPhilhealthSummary, onChange: (e) => setHasPhilhealthSummary(e.target.checked) },
        { value: hasSSSLoanReport, onChange: (e) => setHasSSSLoanReport(e.target.checked) },
        { value: hasPagibigLoanReport, onChange: (e) => setHasPagibigLoanReport(e.target.checked) },
        { value: has201Report, onChange: (e) => setHas201Report(e.target.checked) },
        { value: hasAttendanceReport, onChange: (e) => setHasAttendanceReport(e.target.checked) },
        { value: hasBankTransmittalBDO, onChange: (e) => setHasBankTransmittalBDO(e.target.checked) },
        { value: hasBankTransmittalBPI, onChange: (e) => setHasBankTransmittalBPI(e.target.checked) },
        { value: hasBankTransmittalChinaBankSavings, onChange: (e) => setHasBankTransmittalChinaBankSavings(e.target.checked) },
        { value: hasBankTransmittalHSBC, onChange: (e) => setHasBankTransmittalHSBC(e.target.checked) },
        { value: hasBankTransmittalSecurityBank, onChange: (e) => setHasBankTransmittalSecurityBank(e.target.checked) },
        { value: hasSummaryOfTardiness, onChange: (e) => setHasSummaryOfTardiness(e.target.checked) },
        { value: hasAbsencesMemo, onChange: (e) => setHasAbsencesMemo(e.target.checked) },
        { value: hasAbsencesReport, onChange: (e) => setHasAbsencesReport(e.target.checked) },
        { value: hasActionHistoryReport, onChange: (e) => setHasActionHistoryReport(e.target.checked) },
        { value: hasAllowanceSummary, onChange: (e) => setHasAllowanceSummary(e.target.checked) },
        { value: hasAuditTrailReportEmployeeSetup, onChange: (e) => setHasAuditTrailReportEmployeeSetup(e.target.checked) },
        { value: hasBundyClockUsage, onChange: (e) => setHasBundyClockUsage(e.target.checked) },
        { value: hasBasicPayAdjustmentReport, onChange: (e) => setHasBasicPayAdjustmentReport(e.target.checked) },
        { value: hasCertificateOfEmployment, onChange: (e) => setHasCertificateOfEmployment(e.target.checked) },
        { value: hasCertificateOfPagibig, onChange: (e) => setHasCertificateOfPagibig(e.target.checked) },
        { value: hasCertificateOfPhilhealth, onChange: (e) => setHasCertificateOfPhilhealth(e.target.checked) },
        { value: hasCertificateOfSSS, onChange: (e) => setHasCertificateOfSSS(e.target.checked) },
        { value: hasCommissionsSummary, onChange: (e) => setHasCommissionsSummary(e.target.checked) },
        { value: hasCostCenterReport, onChange: (e) => setHasCostCenterReport(e.target.checked) },
        { value: hasDeductionsPerMonth, onChange: (e) => setHasDeductionsPerMonth(e.target.checked) },
        { value: hasDTRReport, onChange: (e) => setHasDTRReport(e.target.checked) },
        { value: hasEarningsPerMonth, onChange: (e) => setHasEarningsPerMonth(e.target.checked) },
        { value: hasEmployeeLeaveGroup, onChange: (e) => setHasEmployeeLeaveGroup(e.target.checked) },
        { value: hasEmployeeOvertimeGroup, onChange: (e) => setHasEmployeeOvertimeGroup(e.target.checked) },
        { value: hasEmployeeExpenseGroup, onChange: (e) => setHasEmployeeExpenseGroup(e.target.checked) },
        { value: hasEmployeeLeaveHistory, onChange: (e) => setHasEmployeeLeaveHistory(e.target.checked) },
        { value: hasEmployeeListingByHiringDate, onChange: (e) => setHasEmployeeListingByHiringDate(e.target.checked) },
        { value: hasEmployeeRegister, onChange: (e) => setHasEmployeeRegister(e.target.checked) },
        { value: hasExpenseReport, onChange: (e) => setHasExpenseReport(e.target.checked) },
        { value: hasGovernmentEmployeeInventory, onChange: (e) => setHasGovernmentEmployeeInventory(e.target.checked) },
        { value: hasHeadcountReport, onChange: (e) => setHasHeadcountReport(e.target.checked) },
        { value: hasHolidayPremiumSummary, onChange: (e) => setHasHolidayPremiumSummary(e.target.checked) },
        { value: hasLeaveLedgerReport, onChange: (e) => setHasLeaveLedgerReport(e.target.checked) },
        { value: hasLeaveSummaryReport, onChange: (e) => setHasLeaveSummaryReport(e.target.checked) },
        { value: hasLoanHistory, onChange: (e) => setHasLoanHistory(e.target.checked) },
        { value: hasLoanPaymentsSummary, onChange: (e) => setHasLoanPaymentsSummary(e.target.checked) },
        { value: hasLoansMonthlyAmortizationSummary, onChange: (e) => setHasLoansMonthlyAmortizationSummary(e.target.checked) },
        { value: hasLoansPenaltyHistory, onChange: (e) => setHasLoansPenaltyHistory(e.target.checked) },
        { value: hasNightDifferentialSummary, onChange: (e) => setHasNightDifferentialSummary(e.target.checked) },
        { value: hasNonTaxableAllowancesReport, onChange: (e) => setHasNonTaxableAllowancesReport(e.target.checked) },
        { value: hasOtherEarningsReport, onChange: (e) => setHasOtherEarningsReport(e.target.checked) },
        { value: hasOtherDeductionsSummary, onChange: (e) => setHasOtherDeductionsSummary(e.target.checked) },
        { value: hasOutstandingLoans, onChange: (e) => setHasOutstandingLoans(e.target.checked) },
        { value: hasPayrollCashRegister, onChange: (e) => setHasPayrollCashRegister(e.target.checked) },
        { value: hasPayrollCheckRegister, onChange: (e) => setHasPayrollCheckRegister(e.target.checked) },
        { value: hasPayrollDebitMemo, onChange: (e) => setHasPayrollDebitMemo(e.target.checked) },
        { value: hasPayrollJournalByCostCenter, onChange: (e) => setHasPayrollJournalByCostCenter(e.target.checked) },
        { value: hasPayrollJournalByDepartment, onChange: (e) => setHasPayrollJournalByDepartment(e.target.checked) },
        { value: hasPayrollJournalBySummary, onChange: (e) => setHasPayrollJournalBySummary(e.target.checked) },
        { value: hasPayrollPerPaymentMethod, onChange: (e) => setHasPayrollPerPaymentMethod(e.target.checked) },
        { value: hasSelectLogs, onChange: (e) => setHasSelectLogs(e.target.checked) },
        { value: hasSummaryReportByMonthAndDepartment, onChange: (e) => setHasSummaryReportByMonthAndDepartment(e.target.checked) },
        { value: hasTardinessMemo, onChange: (e) => setHasTardinessMemo(e.target.checked) },
        { value: hasTimeKeepingHistoryDetailedReport, onChange: (e) => setHasTimeKeepingHistoryDetailedReport(e.target.checked) },
        { value: hasTimeKeepingHoursWorkedReport, onChange: (e) => setHasTimeKeepingHoursWorkedReport(e.target.checked) },
        { value: hasTimeKeepingHoursWorkedSummary, onChange: (e) => setHasTimeKeepingHoursWorkedSummary(e.target.checked) },
        { value: hasTimesheetStatusReport, onChange: (e) => setHasTimesheetStatusReport(e.target.checked) },
        { value: hasYTDDeductionSummary, onChange: (e) => setHasYTDDeductionSummary(e.target.checked) },
        { value: hasYTDEarningsSummary, onChange: (e) => setHasYTDEarningsSummary(e.target.checked) },
        { value: hasYTDPayrollRegister, onChange: (e) => setHasYTDPayrollRegister(e.target.checked) },
    ];

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {isAddState && dataList[0].id === undefined?
                        <tr>
                            {checkboxes.map((checkbox, index) => (
                                <td key={index}>
                                    <input 
                                        type="checkbox" 
                                        className="checkbox" 
                                        checked={checkbox.value} 
                                        onChange={checkbox.onChange} 
                                    />
                                </td>
                            ))}
                        </tr>
                        :
                        <></>
                    }
                    

                    {
                        dataList[0].id &&
                        currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForReports header={cell.render("Cell").props.column.Header} 
                                                _cell={cell}
                                                editHandleClick={editHandleClick}
                                                deleteHandleClick={deleteHandleClick}
                                                viewReports={viewReports}
                                                isEditState={isEditState}
                                                setIsEditState={setIsEditState}
                                                dataToEdit={dataToEdit}
                                                description={description} 
                                                setDescription={setDescription}
                                                hasHome={hasHome}
                                                setHasHome={setHasHome}
                                                hasAddEmployee={hasAddEmployee}
                                                setHasAddEmployee={setHasAddEmployee}
                                                hasEmployeeList={hasEmployeeList}
                                                setHasEmployeeList={setHasEmployeeList}
                                                hasEmployeeStatus={hasEmployeeStatus}
                                                setHasEmployeeStatus={setHasEmployeeStatus}
                                                hasEmployeeSchedule={hasEmployeeSchedule}
                                                setHasEmployeeSchedule={setHasEmployeeSchedule}
                                                hasTimeEntries={hasTimeEntries}
                                                setHasTimeEntries={setHasTimeEntries}
                                                hasShiftSchedule={hasShiftSchedule}
                                                setHasShiftSchedule={setHasShiftSchedule}
                                                hasProcessPayroll={hasProcessPayroll}
                                                setHasProcessPayroll={setHasProcessPayroll}
                                                has13thMonth={has13thMonth}
                                                setHas13thMonth={setHas13thMonth}
                                                hasPayrollPeriod={hasPayrollPeriod}
                                                setHasPayrollPeriod={setHasPayrollPeriod}
                                                hasClient={hasClient}
                                                setHasClient={setHasClient}
                                                hasPayType={hasPayType}
                                                setHasPayType={setHasPayType}
                                                hasHoliday={hasHoliday}
                                                setHasHoliday={setHasHoliday}
                                                hasHolidayType={hasHolidayType}
                                                setHasHolidayType={setHasHolidayType}
                                                hasLeaveType={hasLeaveType}
                                                setHasLeaveType={setHasLeaveType}
                                                hasDepartment={hasDepartment}
                                                setHasDepartment={setHasDepartment}
                                                hasSection={hasSection}
                                                setHasSection={setHasSection}
                                                hasClassification={hasClassification}
                                                setHasClassification={setHasClassification}
                                                hasCompany={hasCompany}
                                                setHasCompany={setHasCompany}
                                                hasPosition={hasPosition}
                                                setHasPosition={setHasPosition}
                                                hasJobTitle={hasJobTitle}
                                                setHasJobTitle={setHasJobTitle}
                                                hasLocation={hasLocation}
                                                setHasLocation={setHasLocation}
                                                hasEmployeeMonthlySalary={hasEmployeeMonthlySalary}
                                                setHasEmployeeMonthlySalary={setHasEmployeeMonthlySalary}
                                                hasEmployeeDailySalary={hasEmployeeDailySalary}
                                                setHasEmployeeDailySalary={setHasEmployeeDailySalary}
                                                hasPositionDesignationSalary={hasPositionDesignationSalary}
                                                hasQuotaBasedSalary={hasQuotaBasedSalary}
                                                setHasPositionDesignationSalary={setHasPositionDesignationSalary}
                                                setHasQuotaBasedSalary={setHasQuotaBasedSalary}
                                                hasEmployeeBankAccount={hasEmployeeBankAccount}
                                                setHasEmployeeBankAccount={setHasEmployeeBankAccount}
                                                hasBIRTax={hasBIRTax}
                                                setHasBIRTax={setHasBIRTax}
                                                hasPagibig={hasPagibig}
                                                setHasPagibig={setHasPagibig}
                                                hasSSS={hasSSS}
                                                setHasSSS={setHasSSS}
                                                hasPhilhealth={hasPhilhealth}
                                                setHasPhilhealth={setHasPhilhealth}
                                                hasDTR={hasDTR}
                                                setHasDTR={setHasDTR}
                                                hasDTRBiometrics={hasDTRBiometrics}
                                                setHasDTRBiometrics={setHasDTRBiometrics}
                                                hasApproverHierarchy={hasApproverHierarchy}
                                                setHasApproverHierarchy={setHasApproverHierarchy}
                                                hasRequestApproval={hasRequestApproval}
                                                setHasRequestApproval={setHasRequestApproval}
                                                hasOvertime={hasOvertime}
                                                setHasOvertime={setHasOvertime}
                                                hasDTRCorrection={hasDTRCorrection}
                                                setHasDTRCorrection={setHasDTRCorrection}
                                                hasLeave={hasLeave}
                                                setHasLeave={setHasLeave}
                                                hasChangeOfSchedule={hasChangeOfSchedule}
                                                setHasChangeOfSchedule={setHasChangeOfSchedule}
                                                hasSSSLoan={hasSSSLoan}
                                                setHasSSSLoan={setHasSSSLoan}
                                                hasSSSCalamityLoan={hasSSSCalamityLoan}
                                                setHasSSSCalamityLoan={setHasSSSCalamityLoan}
                                                hasPagibigLoan={hasPagibigLoan}
                                                setHasPagibigLoan={setHasPagibigLoan}
                                                hasPagibigCalamityLoan={hasPagibigCalamityLoan}
                                                setHasPagibigCalamityLoan={setHasPagibigCalamityLoan}
                                                hasCashAdvance={hasCashAdvance}
                                                setHasCashAdvance={setHasCashAdvance}
                                                hasDeductions={hasDeductions}
                                                setHasDeductions={setHasDeductions}
                                                hasBenefits={hasBenefits}
                                                setHasBenefits={setHasBenefits}
                                                hasReports={hasReports}
                                                setHasReports={setHasReports}
                                                hasSettings={hasSettings}
                                                setHasSettings={setHasSettings}
                                                hasCalendar={hasCalendar}
                                                setHasCalendar={setHasCalendar}
                                                hasUser={hasUser}
                                                setHasUser={setHasUser}
                                                userTimeOut={userTimeOut}
                                                setUserTimeOut={setUserTimeOut}

                                                // additional
                                                hasEmployeereliever={hasEmployeereliever} setHasEmployeereliever={setHasEmployeereliever}
                                                hasMassapproval={hasMassapproval} setHasMassapproval={setHasMassapproval}
                                                hasApproverheirarchyperlocation={hasApproverheirarchyperlocation} setHasApproverheirarchyperlocation={setHasApproverheirarchyperlocation}
                                                hasFinalPay={hasFinalPay} setHasFinalPay={setHasFinalPay}
                                                hasSubcon={hasSubcon} setHasSubcon={setHasSubcon}
                                                hasAgency={hasAgency} setHasAgency={setHasAgency}
                                                hasEmploymentStatus={hasEmploymentStatus} setHasEmploymentStatus={setHasEmploymentStatus}
                                                hasLoans={hasLoans} setHasLoans={setHasLoans}
                                                hasTimeKeeper={hasTimeKeeper} setHasTimeKeeper={setHasTimeKeeper}
                                                hasPerDayTracker={hasPerDayTracker} setHasPerDayTracker={setHasPerDayTracker}
                                                hasOvertimeSummaryReport={hasOvertimeSummaryReport} setHasOvertimeSummaryReport={setHasOvertimeSummaryReport}
                                                hasTrackerReport={hasTrackerReport} setHasTrackerReport={setHasTrackerReport}
                                                hasPayslip={hasPayslip} setHasPayslip={setHasPayslip}
                                                hasPayrollRegister={hasPayrollRegister} setHasPayrollRegister={setHasPayrollRegister}
                                                hasResigned={hasResigned} setHasResigned={setHasResigned}
                                                hasActiveEmployees={hasActiveEmployees} setHasActiveEmployees={setHasActiveEmployees}
                                                hasYearofService={hasYearofService} setHasYearofService={setHasYearofService}
                                                hasSSSSummary={hasSSSSummary} setHasSSSSummary={setHasSSSSummary}
                                                hasPagibigSummary={hasPagibigSummary} setHasPagibigSummary={setHasPagibigSummary}
                                                hasPhilhealthSummary={hasPhilhealthSummary} setHasPhilhealthSummary={setHasPhilhealthSummary}
                                                hasSSSLoanReport={hasSSSLoanReport} setHasSSSLoanReport={setHasSSSLoanReport}
                                                hasPagibigLoanReport={hasPagibigLoanReport} setHasPagibigLoanReport={setHasPagibigLoanReport}
                                                has201Report={has201Report} setHas201Report={setHas201Report}
                                                hasAttendanceReport={hasAttendanceReport} setHasAttendanceReport={setHasAttendanceReport}
                                                hasBankTransmittalBDO={hasBankTransmittalBDO} setHasBankTransmittalBDO={setHasBankTransmittalBDO}
                                                hasBankTransmittalBPI={hasBankTransmittalBPI} setHasBankTransmittalBPI={setHasBankTransmittalBPI}
                                                hasBankTransmittalChinaBankSavings={hasBankTransmittalChinaBankSavings} setHasBankTransmittalChinaBankSavings={setHasBankTransmittalChinaBankSavings}
                                                hasBankTransmittalHSBC={hasBankTransmittalHSBC} setHasBankTransmittalHSBC={setHasBankTransmittalHSBC}
                                                hasBankTransmittalSecurityBank={hasBankTransmittalSecurityBank} setHasBankTransmittalSecurityBank={setHasBankTransmittalSecurityBank}
                                                hasSummaryOfTardiness={hasSummaryOfTardiness} setHasSummaryOfTardiness={setHasSummaryOfTardiness}
                                                hasAbsencesMemo={hasAbsencesMemo} setHasAbsencesMemo={setHasAbsencesMemo}
                                                hasAbsencesReport={hasAbsencesReport} setHasAbsencesReport={setHasAbsencesReport}
                                                hasActionHistoryReport={hasActionHistoryReport} setHasActionHistoryReport={setHasActionHistoryReport}
                                                hasAllowanceSummary={hasAllowanceSummary} setHasAllowanceSummary={setHasAllowanceSummary}
                                                hasAuditTrailReportEmployeeSetup={hasAuditTrailReportEmployeeSetup} setHasAuditTrailReportEmployeeSetup={setHasAuditTrailReportEmployeeSetup}
                                                hasBundyClockUsage={hasBundyClockUsage} setHasBundyClockUsage={setHasBundyClockUsage}
                                                hasBasicPayAdjustmentReport={hasBasicPayAdjustmentReport} setHasBasicPayAdjustmentReport={setHasBasicPayAdjustmentReport}
                                                hasCertificateOfEmployment={hasCertificateOfEmployment} setHasCertificateOfEmployment={setHasCertificateOfEmployment}
                                                hasCertificateOfPagibig={hasCertificateOfPagibig} setHasCertificateOfPagibig={setHasCertificateOfPagibig}
                                                hasCertificateOfPhilhealth={hasCertificateOfPhilhealth} setHasCertificateOfPhilhealth={setHasCertificateOfPhilhealth}
                                                hasCertificateOfSSS={hasCertificateOfSSS} setHasCertificateOfSSS={setHasCertificateOfSSS}
                                                hasCommissionsSummary={hasCommissionsSummary} setHasCommissionsSummary={setHasCommissionsSummary}
                                                hasCostCenterReport={hasCostCenterReport} setHasCostCenterReport={setHasCostCenterReport}
                                                hasDeductionsPerMonth={hasDeductionsPerMonth} setHasDeductionsPerMonth={setHasDeductionsPerMonth}
                                                hasDTRReport={hasDTRReport} setHasDTRReport={setHasDTRReport}
                                                hasEarningsPerMonth={hasEarningsPerMonth} setHasEarningsPerMonth={setHasEarningsPerMonth}
                                                hasEmployeeLeaveGroup={hasEmployeeLeaveGroup} setHasEmployeeLeaveGroup={setHasEmployeeLeaveGroup}
                                                hasEmployeeOvertimeGroup={hasEmployeeOvertimeGroup} setHasEmployeeOvertimeGroup={setHasEmployeeOvertimeGroup}
                                                hasEmployeeExpenseGroup={hasEmployeeExpenseGroup} setHasEmployeeExpenseGroup={setHasEmployeeExpenseGroup}
                                                hasEmployeeLeaveHistory={hasEmployeeLeaveHistory} setHasEmployeeLeaveHistory={setHasEmployeeLeaveHistory}
                                                hasEmployeeListingByHiringDate={hasEmployeeListingByHiringDate} setHasEmployeeListingByHiringDate={setHasEmployeeListingByHiringDate}
                                                hasEmployeeRegister={hasEmployeeRegister} setHasEmployeeRegister={setHasEmployeeRegister}
                                                hasExpenseReport={hasExpenseReport} setHasExpenseReport={setHasExpenseReport}
                                                hasGovernmentEmployeeInventory={hasGovernmentEmployeeInventory} setHasGovernmentEmployeeInventory={setHasGovernmentEmployeeInventory}
                                                hasHeadcountReport={hasHeadcountReport} setHasHeadcountReport={setHasHeadcountReport}
                                                hasHolidayPremiumSummary={hasHolidayPremiumSummary} setHasHolidayPremiumSummary={setHasHolidayPremiumSummary}
                                                hasLeaveLedgerReport={hasLeaveLedgerReport} setHasLeaveLedgerReport={setHasLeaveLedgerReport}
                                                hasLeaveSummaryReport={hasLeaveSummaryReport} setHasLeaveSummaryReport={setHasLeaveSummaryReport}
                                                hasLoanHistory={hasLoanHistory} setHasLoanHistory={setHasLoanHistory}
                                                hasLoanPaymentsSummary={hasLoanPaymentsSummary} setHasLoanPaymentsSummary={setHasLoanPaymentsSummary}
                                                hasLoansMonthlyAmortizationSummary={hasLoansMonthlyAmortizationSummary} setHasLoansMonthlyAmortizationSummary={setHasLoansMonthlyAmortizationSummary}
                                                hasLoansPenaltyHistory={hasLoansPenaltyHistory} setHasLoansPenaltyHistory={setHasLoansPenaltyHistory}
                                                hasNightDifferentialSummary={hasNightDifferentialSummary} setHasNightDifferentialSummary={setHasNightDifferentialSummary}
                                                hasNonTaxableAllowancesReport={hasNonTaxableAllowancesReport} setHasNonTaxableAllowancesReport={setHasNonTaxableAllowancesReport}
                                                hasOtherEarningsReport={hasOtherEarningsReport} setHasOtherEarningsReport={setHasOtherEarningsReport}
                                                hasOtherDeductionsSummary={hasOtherDeductionsSummary} setHasOtherDeductionsSummary={setHasOtherDeductionsSummary}
                                                hasOutstandingLoans={hasOutstandingLoans} setHasOutstandingLoans={setHasOutstandingLoans}
                                                hasPayrollCashRegister={hasPayrollCashRegister} setHasPayrollCashRegister={setHasPayrollCashRegister}
                                                hasPayrollCheckRegister={hasPayrollCheckRegister} setHasPayrollCheckRegister={setHasPayrollCheckRegister}
                                                hasPayrollDebitMemo={hasPayrollDebitMemo} setHasPayrollDebitMemo={setHasPayrollDebitMemo}
                                                hasPayrollJournalByCostCenter={hasPayrollJournalByCostCenter} setHasPayrollJournalByCostCenter={setHasPayrollJournalByCostCenter}
                                                hasPayrollJournalByDepartment={hasPayrollJournalByDepartment} setHasPayrollJournalByDepartment={setHasPayrollJournalByDepartment}
                                                hasPayrollJournalBySummary={hasPayrollJournalBySummary} setHasPayrollJournalBySummary={setHasPayrollJournalBySummary}
                                                hasPayrollPerPaymentMethod={hasPayrollPerPaymentMethod} setHasPayrollPerPaymentMethod={setHasPayrollPerPaymentMethod}
                                                hasSelectLogs={hasSelectLogs} setHasSelectLogs={setHasSelectLogs}
                                                hasSummaryReportByMonthAndDepartment={hasSummaryReportByMonthAndDepartment} setHasSummaryReportByMonthAndDepartment={setHasSummaryReportByMonthAndDepartment}
                                                hasTardinessMemo={hasTardinessMemo} setHasTardinessMemo={setHasTardinessMemo}
                                                hasTimeKeepingHistoryDetailedReport={hasTimeKeepingHistoryDetailedReport} setHasTimeKeepingHistoryDetailedReport={setHasTimeKeepingHistoryDetailedReport}
                                                hasTimeKeepingHoursWorkedReport={hasTimeKeepingHoursWorkedReport} setHasTimeKeepingHoursWorkedReport={setHasTimeKeepingHoursWorkedReport}
                                                hasTimeKeepingHoursWorkedSummary={hasTimeKeepingHoursWorkedSummary} setHasTimeKeepingHoursWorkedSummary={setHasTimeKeepingHoursWorkedSummary}
                                                hasTimesheetStatusReport={hasTimesheetStatusReport} setHasTimesheetStatusReport={setHasTimesheetStatusReport}
                                                hasYTDDeductionSummary={hasYTDDeductionSummary} setHasYTDDeductionSummary={setHasYTDDeductionSummary}
                                                hasYTDEarningsSummary={hasYTDEarningsSummary} setHasYTDEarningsSummary={setHasYTDEarningsSummary}
                                                hasYTDPayrollRegister={hasYTDPayrollRegister} setHasYTDPayrollRegister={setHasYTDPayrollRegister}
                                                hasNotification={hasNotification} setHasNotification={setHasNotification}
                                                hasMobileBiometrics={hasMobileBiometrics} setHasMobileBiometrics={setHasMobileBiometrics}

                                                hasManHour={hasManHour} setHasManHour={setHasManHour}
                                                hasYearlyReport={hasYearlyReport} setHasYearlyReport={setHasYearlyReport}
                                                hasBIR2316={hasBIR2316} setHasBIR2316={setHasBIR2316}
                                                hasBIR1601C={hasBIR1601C} setHasBIR1601C={setHasBIR1601C}
                                                hasAlphaList={hasAlphaList} setHasAlphaList={setHasAlphaList}
                                                hasLoanReport={hasLoanReport} setHasLoanReport={setHasLoanReport}
                                                hasBankTransmittalReport={hasBankTransmittalReport} setHasBankTransmittalReport={setHasBankTransmittalReport}

                                                setShowRequestMessage={setShowRequestMessage}
                                                setIsSuccess={setIsSuccess}
                                                setRequestMessage={setRequestMessage}
                                                handleUpdate={handleUpdate}
                                        />
                                    ))}
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </div>
    )
}
function SetInfoForReports({header, 
    _cell, 
    editHandleClick, 
    deleteHandleClick, 
    viewReports,
    isEditState, 
    setIsEditState,
    dataToEdit,
    description,
    setDescription,
    hasHome,
    setHasHome,
    hasAddEmployee,
    setHasAddEmployee,
    hasEmployeeList,
    setHasEmployeeList,
    hasEmployeeStatus,
    setHasEmployeeStatus,
    hasEmployeeSchedule,
    setHasEmployeeSchedule,
    hasTimeEntries,
    setHasTimeEntries,
    hasShiftSchedule,
    setHasShiftSchedule,
    hasProcessPayroll,
    setHasProcessPayroll,
    has13thMonth,
    setHas13thMonth,
    hasPayrollPeriod,
    setHasPayrollPeriod,
    hasClient,
    setHasClient,
    hasPayType,
    setHasPayType,
    hasHoliday,
    setHasHoliday,
    hasHolidayType,
    setHasHolidayType,
    hasLeaveType,
    setHasLeaveType,
    hasDepartment,
    setHasDepartment,
    hasSection,
    setHasSection,
    hasClassification,
    setHasClassification,
    hasCompany,
    setHasCompany,
    hasPosition,
    setHasPosition,
    hasJobTitle,
    setHasJobTitle,
    hasLocation,
    setHasLocation,
    hasDTRRulesConfiguration,
    setHasDTRRulesConfiguration,
    hasEmployeeMonthlySalary,
    setHasEmployeeMonthlySalary,
    hasEmployeeDailySalary,
    setHasEmployeeDailySalary,
    hasPositionDesignationSalary,
    hasQuotaBasedSalary,
    setHasPositionDesignationSalary,
    setHasQuotaBasedSalary,
    hasEmployeeBankAccount,
    setHasEmployeeBankAccount,
    hasBIRTax,
    setHasBIRTax,
    hasPagibig,
    setHasPagibig,
    hasSSS,
    setHasSSS,
    hasPhilhealth,
    setHasPhilhealth,
    hasDTR,
    setHasDTR,
    hasDTRBiometrics,
    setHasDTRBiometrics,
    hasApproverHierarchy,
    setHasApproverHierarchy,
    hasRequestApproval,
    setHasRequestApproval,
    hasOvertime,
    setHasOvertime,
    hasDTRCorrection,
    setHasDTRCorrection,
    hasLeave,
    setHasLeave,
    hasChangeOfSchedule,
    setHasChangeOfSchedule,
    hasSSSLoan,
    setHasSSSLoan,
    hasSSSCalamityLoan,
    setHasSSSCalamityLoan,
    hasPagibigLoan,
    setHasPagibigLoan,
    hasPagibigCalamityLoan,
    setHasPagibigCalamityLoan,
    hasCashAdvance,
    setHasCashAdvance,
    hasDeductions,
    setHasDeductions,
    hasBenefits,
    setHasBenefits,
    hasReports,
    setHasReports,
    hasSettings,
    setHasSettings,
    hasCalendar,
    setHasCalendar,
    hasUser,
    setHasUser,
    userTimeOut,
    setUserTimeOut,

    // additional
    hasEmployeereliever, setHasEmployeereliever,
    hasMassapproval, setHasMassapproval,
    hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation,
    hasFinalPay, setHasFinalPay,
    hasSubcon, setHasSubcon,
    hasAgency, setHasAgency,
    hasEmploymentStatus, setHasEmploymentStatus,
    hasLoans, setHasLoans,
    hasTimeKeeper, setHasTimeKeeper,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,
    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,
    hasBIR2316, setHasBIR2316,
    hasBIR1601C, setHasBIR1601C,
    hasAlphaList, setHasAlphaList,
    hasLoanReport, setHasLoanReport,
    hasBankTransmittalReport, setHasBankTransmittalReport,

    setShowRequestMessage,
    setIsSuccess,
    setRequestMessage,
    handleUpdate
}) {
    const data = _cell.render("Cell").props.row.original;
    const checkboxes = [
        { header: "Home", value: hasHome, onChange: (e) => setHasHome(e.target.checked) },
        { header: "Add Employee", value: hasAddEmployee, onChange: (e) => setHasAddEmployee(e.target.checked) },
        { header: "Employee List", value: hasEmployeeList, onChange: (e) => setHasEmployeeList(e.target.checked) },
        { header: "Employee Status", value: hasEmployeeStatus, onChange: (e) => setHasEmployeeStatus(e.target.checked) },
        { header: "Employee Schedule", value: hasEmployeeSchedule, onChange: (e) => setHasEmployeeSchedule(e.target.checked) },
        { header: "Time Entries", value: hasTimeEntries, onChange: (e) => setHasTimeEntries(e.target.checked) },
        { header: "Shift Schedule", value: hasShiftSchedule, onChange: (e) => setHasShiftSchedule(e.target.checked) },
        { header: "Process Payroll", value: hasProcessPayroll, onChange: (e) => setHasProcessPayroll(e.target.checked) },
        { header: "13th Month", value: has13thMonth, onChange: (e) => setHas13thMonth(e.target.checked) },
        { header: "Payroll Period", value: hasPayrollPeriod, onChange: (e) => setHasPayrollPeriod(e.target.checked) },
        { header: "Client", value: hasClient, onChange: (e) => setHasClient(e.target.checked) },
        { header: "Pay Type", value: hasPayType, onChange: (e) => setHasPayType(e.target.checked) },
        { header: "Holiday", value: hasHoliday, onChange: (e) => setHasHoliday(e.target.checked) },
        { header: "Holiday Type", value: hasHolidayType, onChange: (e) => setHasHolidayType(e.target.checked) },
        { header: "Leave Type", value: hasLeaveType, onChange: (e) => setHasLeaveType(e.target.checked) },
        { header: "Department", value: hasDepartment, onChange: (e) => setHasDepartment(e.target.checked) },
        { header: "Section", value: hasSection, onChange: (e) => setHasSection(e.target.checked) },
        { header: "Classification", value: hasClassification, onChange: (e) => setHasClassification(e.target.checked) },
        { header: "Company", value: hasCompany, onChange: (e) => setHasCompany(e.target.checked) },
        { header: "Position", value: hasPosition, onChange: (e) => setHasPosition(e.target.checked) },
        { header: "Job Title", value: hasJobTitle, onChange: (e) => setHasJobTitle(e.target.checked) },
        { header: "Location", value: hasLocation, onChange: (e) => setHasLocation(e.target.checked) },
        { header: "DTR Rules Configuration", value: hasDTRRulesConfiguration, onChange: (e) => setHasDTRRulesConfiguration(e.target.checked) },
        { header: "Employee Monthly Salary", value: hasEmployeeMonthlySalary, onChange: (e) => setHasEmployeeMonthlySalary(e.target.checked) },
        { header: "Employee Daily Salary", value: hasEmployeeDailySalary, onChange: (e) => setHasEmployeeDailySalary(e.target.checked) },
        { header: "Position-Designation Salary", value: hasPositionDesignationSalary, onChange: (e) => setHasPositionDesignationSalary(e.target.checked) },
        { header: "Quota-Based Salary", value: hasQuotaBasedSalary, onChange: (e) => setHasQuotaBasedSalary(e.target.checked) },
        { header: "Employee Bank Account", value: hasEmployeeBankAccount, onChange: (e) => setHasEmployeeBankAccount(e.target.checked) },
        { header: "BIR / Tax", value: hasBIRTax, onChange: (e) => setHasBIRTax(e.target.checked) },
        { header: "Pagibig", value: hasPagibig, onChange: (e) => setHasPagibig(e.target.checked) },
        { header: "SSS", value: hasSSS, onChange: (e) => setHasSSS(e.target.checked) },
        { header: "Philhealth", value: hasPhilhealth, onChange: (e) => setHasPhilhealth(e.target.checked) },
        { header: "DTR", value: hasDTR, onChange: (e) => setHasDTR(e.target.checked) },
        { header: "DTR Biometrics", value: hasDTRBiometrics, onChange: (e) => setHasDTRBiometrics(e.target.checked) },
        { header: "Approver Hierarchy", value: hasApproverHierarchy, onChange: (e) => setHasApproverHierarchy(e.target.checked) },
        { header: "Request Approval", value: hasRequestApproval, onChange: (e) => setHasRequestApproval(e.target.checked) },
        { header: "Overtime", value: hasOvertime, onChange: (e) => setHasOvertime(e.target.checked) },
        { header: "DTR Correction", value: hasDTRCorrection, onChange: (e) => setHasDTRCorrection(e.target.checked) },
        { header: "Leave", value: hasLeave, onChange: (e) => setHasLeave(e.target.checked) },
        { header: "Change of Schedule", value: hasChangeOfSchedule, onChange: (e) => setHasChangeOfSchedule(e.target.checked) },
        { header: "SSS Loan", value: hasSSSLoan, onChange: (e) => setHasSSSLoan(e.target.checked) },
        { header: "SSS Calamity Loan", value: hasSSSCalamityLoan, onChange: (e) => setHasSSSCalamityLoan(e.target.checked) },
        { header: "Pagibig Loan", value: hasPagibigLoan, onChange: (e) => setHasPagibigLoan(e.target.checked) },
        { header: "Pagibig Calamity Loan", value: hasPagibigCalamityLoan, onChange: (e) => setHasPagibigCalamityLoan(e.target.checked) },
        { header: "Cash Advance", value: hasCashAdvance, onChange: (e) => setHasCashAdvance(e.target.checked) },
        { header: "Deductions", value: hasDeductions, onChange: (e) => setHasDeductions(e.target.checked) },
        { header: "Benefits", value: hasBenefits, onChange: (e) => setHasBenefits(e.target.checked) },
        // { header: "Reports", value: hasReports, onChange: (e) => setHasReports(e.target.checked) },
        { header: "Settings", value: hasSettings, onChange: (e) => setHasSettings(e.target.checked) },
        { header: "Calendar", value: hasCalendar, onChange: (e) => setHasCalendar(e.target.checked) },
        { header: "User", value: hasUser, onChange: (e) => setHasUser(e.target.checked) },
        { header: "Employee Reliever", value: hasEmployeereliever, onChange: (e) => setHasEmployeereliever(e.target.checked) },
        { header: "Mass Approval", value: hasMassapproval, onChange: (e) => setHasMassapproval(e.target.checked) },
        { header: "Approver Hierarchy Per Location", value: hasApproverheirarchyperlocation, onChange: (e) => setHasApproverheirarchyperlocation(e.target.checked) },
        { header: "Final Pay", value: hasFinalPay, onChange: (e) => setHasFinalPay(e.target.checked) },
        { header: "Subcon", value: hasSubcon, onChange: (e) => setHasSubcon(e.target.checked) },
        { header: "Agency", value: hasAgency, onChange: (e) => setHasAgency(e.target.checked) },
        { header: "Employment Status", value: hasEmploymentStatus, onChange: (e) => setHasEmploymentStatus(e.target.checked) },
        { header: "Loans", value: hasLoans, onChange: (e) => setHasLoans(e.target.checked) },
        { header: "Time Keeper", value: hasTimeKeeper, onChange: (e) => setHasTimeKeeper(e.target.checked) },
        { header: "Man Hour", value: hasManHour, onChange: (e) => setHasManHour(e.target.checked) },
        { header: "Yearly Report", value: hasYearlyReport, onChange: (e) => setHasYearlyReport(e.target.checked) },
        { header: "BIR Form No. 2316", value: hasBIR2316, onChange: (e) => setHasBIR2316(e.target.checked) },
        { header: "BIR Form No. 1601C", value: hasBIR1601C, onChange: (e) => setHasBIR1601C(e.target.checked) },
        { header: "Alphalist", value: hasAlphaList, onChange: (e) => setHasAlphaList(e.target.checked) },
        { header: "Loan Report", value: hasLoanReport, onChange: (e) => setHasLoanReport(e.target.checked) },
        { header: "Bank Transmittal Report", value: hasBankTransmittalReport, onChange: (e) => setHasBankTransmittalReport(e.target.checked) },
        { header: "Per Day Tracker", value: hasPerDayTracker, onChange: (e) => setHasPerDayTracker(e.target.checked) },
        { header: "Overtime Summary Report", value: hasOvertimeSummaryReport, onChange: (e) => setHasOvertimeSummaryReport(e.target.checked) },
        { header: "Tracker Report", value: hasTrackerReport, onChange: (e) => setHasTrackerReport(e.target.checked) },
        { header: "Payslip", value: hasPayslip, onChange: (e) => setHasPayslip(e.target.checked) },
        { header: "Payroll Register", value: hasPayrollRegister, onChange: (e) => setHasPayrollRegister(e.target.checked) },
        { header: "Resigned", value: hasResigned, onChange: (e) => setHasResigned(e.target.checked) },
        { header: "Active Employees", value: hasActiveEmployees, onChange: (e) => setHasActiveEmployees(e.target.checked) },
        { header: "Year Of Service", value: hasYearofService, onChange: (e) => setHasYearofService(e.target.checked) },
        { header: "SSS Summary", value: hasSSSSummary, onChange: (e) => setHasSSSSummary(e.target.checked) },
        { header: "Pagibig Summary", value: hasPagibigSummary, onChange: (e) => setHasPagibigSummary(e.target.checked) },
        { header: "Philhealth Summary", value: hasPhilhealthSummary, onChange: (e) => setHasPhilhealthSummary(e.target.checked) },
        { header: "SSS Loan Report", value: hasSSSLoanReport, onChange: (e) => setHasSSSLoanReport(e.target.checked) },
        { header: "Pagibig Loan Report", value: hasPagibigLoanReport, onChange: (e) => setHasPagibigLoanReport(e.target.checked) },
        { header: "201 Report", value: has201Report, onChange: (e) => setHas201Report(e.target.checked) },
        { header: "Attendance Report", value: hasAttendanceReport, onChange: (e) => setHasAttendanceReport(e.target.checked) },
        { header: "Bank Transmittal BDO", value: hasBankTransmittalBDO, onChange: (e) => setHasBankTransmittalBDO(e.target.checked) },
        { header: "Bank Transmittal BPI", value: hasBankTransmittalBPI, onChange: (e) => setHasBankTransmittalBPI(e.target.checked) },
        { header: "Bank Transmittal ChinaBank Savings", value: hasBankTransmittalChinaBankSavings, onChange: (e) => setHasBankTransmittalChinaBankSavings(e.target.checked) },
        { header: "Bank Transmittal HSBC", value: hasBankTransmittalHSBC, onChange: (e) => setHasBankTransmittalHSBC(e.target.checked) },
        { header: "Bank Transmittal Security Bank", value: hasBankTransmittalSecurityBank, onChange: (e) => setHasBankTransmittalSecurityBank(e.target.checked) },
        { header: "Summary Of Tardiness", value: hasSummaryOfTardiness, onChange: (e) => setHasSummaryOfTardiness(e.target.checked) },
        { header: "Absences Memo", value: hasAbsencesMemo, onChange: (e) => setHasAbsencesMemo(e.target.checked) },
        { header: "Absences Report", value: hasAbsencesReport, onChange: (e) => setHasAbsencesReport(e.target.checked) },
        { header: "Action History Report", value: hasActionHistoryReport, onChange: (e) => setHasActionHistoryReport(e.target.checked) },
        { header: "Allowance Summary", value: hasAllowanceSummary, onChange: (e) => setHasAllowanceSummary(e.target.checked) },
        { header: "Audit Trail Report Employee Setup", value: hasAuditTrailReportEmployeeSetup, onChange: (e) => setHasAuditTrailReportEmployeeSetup(e.target.checked) },
        { header: "Bundy Clock Usage", value: hasBundyClockUsage, onChange: (e) => setHasBundyClockUsage(e.target.checked) },
        { header: "Basic Pay Adjustment Report", value: hasBasicPayAdjustmentReport, onChange: (e) => setHasBasicPayAdjustmentReport(e.target.checked) },
        { header: "Certificate Of Employment", value: hasCertificateOfEmployment, onChange: (e) => setHasCertificateOfEmployment(e.target.checked) },
        { header: "Certificate Of Pagibig", value: hasCertificateOfPagibig, onChange: (e) => setHasCertificateOfPagibig(e.target.checked) },
        { header: "Certificate Of Philhealth", value: hasCertificateOfPhilhealth, onChange: (e) => setHasCertificateOfPhilhealth(e.target.checked) },
        { header: "Certificate Of SSS", value: hasCertificateOfSSS, onChange: (e) => setHasCertificateOfSSS(e.target.checked) },
        { header: "Commissions Summary", value: hasCommissionsSummary, onChange: (e) => setHasCommissionsSummary(e.target.checked) },
        { header: "Cost Center Report", value: hasCostCenterReport, onChange: (e) => setHasCostCenterReport(e.target.checked) },
        { header: "Deductions Per Month", value: hasDeductionsPerMonth, onChange: (e) => setHasDeductionsPerMonth(e.target.checked) },
        { header: "DTR Report", value: hasDTRReport, onChange: (e) => setHasDTRReport(e.target.checked) },
        { header: "Earnings Per Month", value: hasEarningsPerMonth, onChange: (e) => setHasEarningsPerMonth(e.target.checked) },
        { header: "Employee Leave Group", value: hasEmployeeLeaveGroup, onChange: (e) => setHasEmployeeLeaveGroup(e.target.checked) },
        { header: "Employee Overtime Group", value: hasEmployeeOvertimeGroup, onChange: (e) => setHasEmployeeOvertimeGroup(e.target.checked) },
        { header: "Employee Expense Group", value: hasEmployeeExpenseGroup, onChange: (e) => setHasEmployeeExpenseGroup(e.target.checked) },
        { header: "Employee Leave History", value: hasEmployeeLeaveHistory, onChange: (e) => setHasEmployeeLeaveHistory(e.target.checked) },
        { header: "Employee Listing By Hiring Date", value: hasEmployeeListingByHiringDate, onChange: (e) => setHasEmployeeListingByHiringDate(e.target.checked) },
        { header: "Employee Register", value: hasEmployeeRegister, onChange: (e) => setHasEmployeeRegister(e.target.checked) },
        { header: "Expense Report", value: hasExpenseReport, onChange: (e) => setHasExpenseReport(e.target.checked) },
        { header: "Government Employee Inventory", value: hasGovernmentEmployeeInventory, onChange: (e) => setHasGovernmentEmployeeInventory(e.target.checked) },
        { header: "Headcount Report", value: hasHeadcountReport, onChange: (e) => setHasHeadcountReport(e.target.checked) },
        { header: "Holiday Premium Summary", value: hasHolidayPremiumSummary, onChange: (e) => setHasHolidayPremiumSummary(e.target.checked) },
        { header: "Leave Ledger Report", value: hasLeaveLedgerReport, onChange: (e) => setHasLeaveLedgerReport(e.target.checked) },
        { header: "Leave Summary Report", value: hasLeaveSummaryReport, onChange: (e) => setHasLeaveSummaryReport(e.target.checked) },
        { header: "Loan History", value: hasLoanHistory, onChange: (e) => setHasLoanHistory(e.target.checked) },
        { header: "Loan Payments Summary", value: hasLoanPaymentsSummary, onChange: (e) => setHasLoanPaymentsSummary(e.target.checked) },
        { header: "Loans Monthly Amortization Summary", value: hasLoansMonthlyAmortizationSummary, onChange: (e) => setHasLoansMonthlyAmortizationSummary(e.target.checked) },
        { header: "Loans Penalty History", value: hasLoansPenaltyHistory, onChange: (e) => setHasLoansPenaltyHistory(e.target.checked) },
        { header: "Night Differential Summary", value: hasNightDifferentialSummary, onChange: (e) => setHasNightDifferentialSummary(e.target.checked) },
        { header: "Non-Taxable Allowances Report", value: hasNonTaxableAllowancesReport, onChange: (e) => setHasNonTaxableAllowancesReport(e.target.checked) },
        { header: "Other Earnings Report", value: hasOtherEarningsReport, onChange: (e) => setHasOtherEarningsReport(e.target.checked) },
        { header: "Other Deductions Summary", value: hasOtherDeductionsSummary, onChange: (e) => setHasOtherDeductionsSummary(e.target.checked) },
        { header: "Outstanding Loans", value: hasOutstandingLoans, onChange: (e) => setHasOutstandingLoans(e.target.checked) },
        { header: "Payroll Cash Register", value: hasPayrollCashRegister, onChange: (e) => setHasPayrollCashRegister(e.target.checked) },
        { header: "Payroll Check Register", value: hasPayrollCheckRegister, onChange: (e) => setHasPayrollCheckRegister(e.target.checked) },
        { header: "Payroll Debit Memo", value: hasPayrollDebitMemo, onChange: (e) => setHasPayrollDebitMemo(e.target.checked) },
        { header: "Payroll Journal By Cost Center", value: hasPayrollJournalByCostCenter, onChange: (e) => setHasPayrollJournalByCostCenter(e.target.checked) },
        { header: "Payroll Journal By Department", value: hasPayrollJournalByDepartment, onChange: (e) => setHasPayrollJournalByDepartment(e.target.checked) },
        { header: "Payroll Journal By Summary", value: hasPayrollJournalBySummary, onChange: (e) => setHasPayrollJournalBySummary(e.target.checked) },
        { header: "Payroll Per Payment Method", value: hasPayrollPerPaymentMethod, onChange: (e) => setHasPayrollPerPaymentMethod(e.target.checked) },
        { header: "Select Logs", value: hasSelectLogs, onChange: (e) => setHasSelectLogs(e.target.checked) },
        { header: "Summary Report By Month And Department", value: hasSummaryReportByMonthAndDepartment, onChange: (e) => setHasSummaryReportByMonthAndDepartment(e.target.checked) },
        { header: "Tardiness Memo", value: hasTardinessMemo, onChange: (e) => setHasTardinessMemo(e.target.checked) },
        { header: "Time Keeping History Detailed Report", value: hasTimeKeepingHistoryDetailedReport, onChange: (e) => setHasTimeKeepingHistoryDetailedReport(e.target.checked) },
        { header: "Time Keeping Hours Worked Report", value: hasTimeKeepingHoursWorkedReport, onChange: (e) => setHasTimeKeepingHoursWorkedReport(e.target.checked) },
        { header: "Time Keeping Hours Worked Summary", value: hasTimeKeepingHoursWorkedSummary, onChange: (e) => setHasTimeKeepingHoursWorkedSummary(e.target.checked) },
        { header: "Timesheet Status Report", value: hasTimesheetStatusReport, onChange: (e) => setHasTimesheetStatusReport(e.target.checked) },
        { header: "YTD Deduction Summary", value: hasYTDDeductionSummary, onChange: (e) => setHasYTDDeductionSummary(e.target.checked) },
        { header: "YTD Earnings Summary", value: hasYTDEarningsSummary, onChange: (e) => setHasYTDEarningsSummary(e.target.checked) },
        { header: "YTD Payroll Register", value: hasYTDPayrollRegister, onChange: (e) => setHasYTDPayrollRegister(e.target.checked) },
    ];

    const submit = (e) =>{
        const allFalse = checkboxes.every(checkbox => checkbox.value === false);

        if(description === ""){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please input a template name");
            return;
        }

        if(allFalse){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select an access at least 1");
            return;
        }

        handleUpdate(e);
    }
    const close = () =>{
        setDescription("");
        setHasHome(false);
        setHasAddEmployee(false);
        setHasEmployeeList(false);
        setHasEmployeeStatus(false);
        setHasEmployeeSchedule(false);
        setHasTimeEntries(false);
        setHasShiftSchedule(false);
        setHasProcessPayroll(false);
        setHas13thMonth(false);
        setHasPayrollPeriod(false);
        setHasClient(false);
        setHasPayType(false);
        setHasHoliday(false);
        setHasHolidayType(false);
        setHasLeaveType(false);
        setHasDepartment(false);
        setHasSection(false);
        setHasClassification(false);
        setHasCompany(false);
        setHasPosition(false);
        setHasJobTitle(false);
        setHasLocation(false);
        setHasEmployeeMonthlySalary(false);
        setHasEmployeeDailySalary(false);
        setHasPositionDesignationSalary(false);
        setHasQuotaBasedSalary(false);
        setHasEmployeeBankAccount(false);
        setHasBIRTax(false);
        setHasPagibig(false);
        setHasSSS(false);
        setHasPhilhealth(false);
        setHasDTR(false);
        setHasDTRBiometrics(false);
        setHasApproverHierarchy(false);
        setHasRequestApproval(false);
        setHasOvertime(false);
        setHasDTRCorrection(false);
        setHasLeave(false);
        setHasChangeOfSchedule(false);
        setHasSSSLoan(false);
        setHasSSSCalamityLoan(false);
        setHasPagibigLoan(false);
        setHasPagibigCalamityLoan(false);
        setHasCashAdvance(false);
        setHasDeductions(false);
        setHasBenefits(false);
        setHasReports(false);
        setHasSettings(false);
        setHasCalendar(false);
        setHasUser(false);
        setUserTimeOut("");

        // Additional
        setHasEmployeereliever(false);
        setHasMassapproval(false);
        setHasApproverheirarchyperlocation(false);
        setHasFinalPay(false);
        setHasSubcon(false);
        setHasAgency(false);
        setHasEmploymentStatus(false);
        setHasLoans(false);
        setHasTimeKeeper(false);
        setHasPerDayTracker(false);
        setHasOvertimeSummaryReport(false);
        setHasTrackerReport(false);
        setHasPayslip(false);
        setHasPayrollRegister(false);
        setHasResigned(false);
        setHasActiveEmployees(false);
        setHasYearofService(false);
        setHasSSSSummary(false);
        setHasPagibigSummary(false);
        setHasPhilhealthSummary(false);
        setHasSSSLoanReport(false);
        setHasPagibigLoanReport(false);
        setHas201Report(false);
        setHasAttendanceReport(false);
        setHasBankTransmittalBDO(false);
        setHasBankTransmittalBPI(false);
        setHasBankTransmittalChinaBankSavings(false);
        setHasBankTransmittalHSBC(false);
        setHasBankTransmittalSecurityBank(false);
        setHasSummaryOfTardiness(false);
        setHasAbsencesMemo(false);
        setHasAbsencesReport(false);
        setHasActionHistoryReport(false);
        setHasAllowanceSummary(false);
        setHasAuditTrailReportEmployeeSetup(false);
        setHasBundyClockUsage(false);
        setHasBasicPayAdjustmentReport(false);
        setHasCertificateOfEmployment(false);
        setHasCertificateOfPagibig(false);
        setHasCertificateOfPhilhealth(false);
        setHasCertificateOfSSS(false);
        setHasCommissionsSummary(false);
        setHasCostCenterReport(false);
        setHasDeductionsPerMonth(false);
        setHasDTRReport(false);
        setHasEarningsPerMonth(false);
        setHasEmployeeLeaveGroup(false);
        setHasEmployeeOvertimeGroup(false);
        setHasEmployeeExpenseGroup(false);
        setHasEmployeeLeaveHistory(false);
        setHasEmployeeListingByHiringDate(false);
        setHasEmployeeRegister(false);
        setHasExpenseReport(false);
        setHasGovernmentEmployeeInventory(false);
        setHasHeadcountReport(false);
        setHasHolidayPremiumSummary(false);
        setHasLeaveLedgerReport(false);
        setHasLeaveSummaryReport(false);
        setHasLoanHistory(false);
        setHasLoanPaymentsSummary(false);
        setHasLoansMonthlyAmortizationSummary(false);
        setHasLoansPenaltyHistory(false);
        setHasNightDifferentialSummary(false);
        setHasNonTaxableAllowancesReport(false);
        setHasOtherEarningsReport(false);
        setHasOtherDeductionsSummary(false);
        setHasOutstandingLoans(false);
        setHasPayrollCashRegister(false);
        setHasPayrollCheckRegister(false);
        setHasPayrollDebitMemo(false);
        setHasPayrollJournalByCostCenter(false);
        setHasPayrollJournalByDepartment(false);
        setHasPayrollJournalBySummary(false);
        setHasPayrollPerPaymentMethod(false);
        setHasSelectLogs(false);
        setHasSummaryReportByMonthAndDepartment(false);
        setHasTardinessMemo(false);
        setHasTimeKeepingHistoryDetailedReport(false);
        setHasTimeKeepingHoursWorkedReport(false);
        setHasTimeKeepingHoursWorkedSummary(false);
        setHasTimesheetStatusReport(false);
        setHasYTDDeductionSummary(false);
        setHasYTDEarningsSummary(false);
        setHasYTDPayrollRegister(false);
        setHasNotification(false);
        setHasMobileBiometrics(false);

        setHasManHour(false);
        setHasYearlyReport(false);
        setHasBIR2316(false);
        setHasBIR1601C(false);
        setHasAlphaList(false);
        setHasLoanReport(false);
        setHasBankTransmittalReport(false);

        setIsEditState(false)
    }

    if(isEditState && dataToEdit.id === data.id){
        const checkbox = checkboxes.find(checkbox => checkbox.header === header);

        if(header === "Id"){
            return (
                <td>
                    {dataToEdit.id}
                </td>
            )
        }

        if(header === "Template Name"){
            return (
                <td>
                    <input
                        placeholder="Template Name"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        style={{color: "gray",
                            height: "30px",
                            borderRadius: "3px",
                            border: "1px solid #80808080",
                            outline: "none"
                        }}
                    />
                </td>
            )
        }

        if(header === "User Time Out (minutes)"){
            return (
                <td>
                    <input
                        placeholder="User time out (minutes)"
                        value={userTimeOut}
                        type='number'
                        onChange={(e) => setUserTimeOut(e.target.value)}
                        style={{color: "gray",
                            height: "30px",
                            borderRadius: "3px",
                            border: "1px solid #80808080",
                            outline: "none"
                        }}
                    />
                </td>
            )
        }

        if (header === "") {
            return(
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        <Tooltip text="Save">
                            <div style={{padding:"0 5px"}} onClick={(e)=>submit(e)}><SaveIcon/></div>
                        </Tooltip>
                        { deleteHandleClick ? 
                        <Tooltip text="Cancel">
                            <div style={{padding:"0 5px"}} onClick={()=>close()}><DoDisturbIcon/></div>
                        </Tooltip>
                        :
                        <></>
                        }
                    </div>
                </td>
            )
        }

        if (checkbox) {
            return (
                <td>
                    <input 
                        type="checkbox" 
                        className="checkbox" 
                        checked={checkbox.value} 
                        onChange={checkbox.onChange} 
                    />
                </td>
            );
        }
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header !== "Template Name" && header !== "" && header !== "Id" && header !== "User Time Out (minutes)" && header !== "Reports"){
        const value = _cell.render("Cell").props.value

        return (
            <td>
                <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={value}
                        disabled={true}
                />
            </td>
        )
    }

    if(header === "Reports"){
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewReports(data)}><FormatAlignJustifyIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }
    

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function Filter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "AccessTemplateId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="AccessTemplateId">Template Id</option>
            </select>
        </div>
    );
};

// NEW
function AddTemplateFormNew({
    isOpen, 
    onClose,

    description, setDescription,
    hasHome, setHasHome,
    hasAddEmployee, setHasAddEmployee,
    hasEmployeeList, setHasEmployeeList,
    hasEmployeeStatus, setHasEmployeeStatus,
    hasEmployeeSchedule, setHasEmployeeSchedule,
    hasTimeEntries, setHasTimeEntries,
    hasShiftSchedule, setHasShiftSchedule,
    hasProcessPayroll, setHasProcessPayroll,
    has13thMonth, setHas13thMonth,
    hasPayrollPeriod, setHasPayrollPeriod,
    hasClient, setHasClient,
    hasPayType, setHasPayType,
    hasHoliday, setHasHoliday,
    hasHolidayType, setHasHolidayType,
    hasLeaveType, setHasLeaveType,
    hasDepartment, setHasDepartment,
    hasSection, setHasSection,
    hasClassification, setHasClassification,
    hasCompany, setHasCompany,
    hasPosition, setHasPosition,
    hasJobTitle, setHasJobTitle,
    hasLocation, setHasLocation,
    hasDTRRulesConfiguration, setHasDTRRulesConfiguration,
    hasEmployeeMonthlySalary, setHasEmployeeMonthlySalary,
    hasEmployeeDailySalary, setHasEmployeeDailySalary,
    hasPositionDesignationSalary, setHasPositionDesignationSalary,
    hasQuotaBasedSalary, setHasQuotaBasedSalary,
    hasEmployeeBankAccount, setHasEmployeeBankAccount,
    hasBIRTax, setHasBIRTax,
    hasPagibig, setHasPagibig,
    hasSSS, setHasSSS,
    hasPhilhealth, setHasPhilhealth,
    hasDTR, setHasDTR,
    hasDTRBiometrics, setHasDTRBiometrics,
    hasApproverHierarchy, setHasApproverHierarchy,
    hasRequestApproval, setHasRequestApproval,
    hasOvertime, setHasOvertime,
    hasDTRCorrection, setHasDTRCorrection,
    hasLeave, setHasLeave,
    hasChangeOfSchedule, setHasChangeOfSchedule,
    hasSSSLoan, setHasSSSLoan,
    hasSSSCalamityLoan, setHasSSSCalamityLoan,
    hasPagibigLoan, setHasPagibigLoan,
    hasPagibigCalamityLoan, setHasPagibigCalamityLoan,
    hasCashAdvance, setHasCashAdvance,
    hasDeductions, setHasDeductions,
    hasBenefits, setHasBenefits,
    hasReports, setHasReports,
    hasSettings, setHasSettings,
    hasCalendar, setHasCalendar,
    hasUser, setHasUser,
    userTimeOut, setUserTimeOut,

    // additional
    hasEmployeereliever, setHasEmployeereliever,
    hasMassapproval, setHasMassapproval,
    hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation,
    hasFinalPay, setHasFinalPay,
    hasSubcon, setHasSubcon,
    hasAgency, setHasAgency,
    hasEmploymentStatus, setHasEmploymentStatus,
    hasLoans, setHasLoans,
    hasTimeKeeper, setHasTimeKeeper,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,
    hasRequestApprovalTimeKeeper, setHasRequestApprovalTimeKeeper,
    hasTamperedApproval, setHasTamperedApproval,
    hasMobileDTRApproval, setHasMobileDTRApproval,
    hasDTRWithOTViewing, setHasDTRWithOTViewing,
    hasDTRCorrectionWorkers, setHasDTRCorrectionWorkers,
    hasPlantilya, setHasPlantilya,
    hasCostCenter, setHasCostCenter,
    hasPayrollJournalAccount, setHasPayrollJournalAccount,

    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,
    hasBIR2316, setHasBIR2316,
    hasBIR1601C, setHasBIR1601C,
    hasAlphaList, setHasAlphaList,
    hasLoanReport, setHasLoanReport,
    hasBankTransmittalReport, setHasBankTransmittalReport,
    hasOffsetCredits, setHasOffsetCredits,
    hasOffsetRequest, setHasOffsetRequest,
    hasEmployeeGroup1, setHasEmployeeGroup1,
    hasEmployeeGroup2, setHasEmployeeGroup2,
    hasOnBoarding, setHasOnBoarding,
    hasOnBoardingPersonnel, setHasOnBoardingPersonnel,
    hasOutBoarding, setHasOutBoarding,
    hasOnBoardingRequirements, setHasOnBoardingRequirements,
    hasOutBoardingRequirements, setHasOutBoardingRequirements,

    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description 
        ){
            setErrorState(true);
            return;
        }

        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Template</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>

                        <div className="popUp-item info-item column">
                            <div className="info-item-label">User Timeout (auto log-out duration)</div>
                            <div className="info-item-input">
                                <input
                                placeholder="0"
                                type='number'
                                value={userTimeOut}
                                onChange={(e) => setUserTimeOut(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>

                        <div style={{border: "1px solid #80808080", padding: "5px", borderRadius: "5px", width: "90%"}}>
                            <div className="info-item-label" style={{color: "#668fca"}}>Home</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHome} onChange={(e)=>setHasHome(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Home</div>
                            </div>
                            





                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Personnel</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAddEmployee} onChange={(e)=>setHasAddEmployee(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Add Employee</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeList} onChange={(e)=>setHasEmployeeList(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee List</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmploymentStatus} onChange={(e) => setHasEmploymentStatus(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employment Status</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeSchedule} onChange={(e)=>setHasEmployeeSchedule(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Schedule</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeereliever} onChange={(e) => setHasEmployeereliever(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Reliever</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOnBoarding} onChange={(e) => setHasOnBoarding(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>On Boarding</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOutBoarding} onChange={(e) => setHasOutBoarding(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Out Boarding</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOnBoardingPersonnel} onChange={(e) => setHasOnBoardingPersonnel(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>On Boarding Personnel</div>
                            </div>











                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Time Keeping</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeEntries} onChange={(e)=>setHasTimeEntries(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Entries</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTamperedApproval} onChange={(e)=>setHasTamperedApproval(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Tampered Approval</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasShiftSchedule} onChange={(e)=>setHasShiftSchedule(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Shift Schedule</div>
                            </div>










                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Payroll</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasProcessPayroll} onChange={(e)=>setHasProcessPayroll(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Process Payroll</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={has13thMonth} onChange={(e)=>setHas13thMonth(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>13th Month</div>
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasFinalPay} onChange={(e) => setHasFinalPay(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Final Pay</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSubcon} onChange={(e) => setHasSubcon(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Subcon</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAgency} onChange={(e) => setHasAgency(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Agency</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollPeriod} onChange={(e)=>setHasPayrollPeriod(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Period</div>
                            </div>










                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Maintenance</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasClient} onChange={(e)=>setHasClient(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Client</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayType} onChange={(e)=>setHasPayType(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pay Type</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHoliday} onChange={(e)=>setHasHoliday(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Holiday</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHolidayType} onChange={(e)=>setHasHolidayType(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Holiday Type</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeaveType} onChange={(e)=>setHasLeaveType(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave Types</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDepartment} onChange={(e)=>setHasDepartment(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Department</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSection} onChange={(e)=>setHasSection(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Section</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasClassification} onChange={(e)=>setHasClassification(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Classification</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCompany} onChange={(e)=>setHasCompany(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Company</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPosition} onChange={(e)=>setHasPosition(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Position</div>
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeStatus} onChange={(e)=>setHasEmployeeStatus(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Status</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasJobTitle} onChange={(e)=>setHasJobTitle(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Job Title</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeGroup1} onChange={(e)=>setHasEmployeeGroup1(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Group 1</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeGroup2} onChange={(e)=>setHasEmployeeGroup2(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Group 2</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLocation} onChange={(e)=>setHasLocation(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Location</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRRulesConfiguration} onChange={(e)=>setHasDTRRulesConfiguration(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Rules Configuration</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeeper} onChange={(e) => setHasTimeKeeper(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeper</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPlantilya} onChange={(e)=>setHasPlantilya(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Plantilya</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCostCenter} onChange={(e)=>setHasCostCenter(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Cost Center</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalAccount} onChange={(e)=>setHasPayrollJournalAccount(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal Account</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOnBoardingRequirements} onChange={(e)=>setHasOnBoardingRequirements(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>On Boarding Requirements</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOutBoardingRequirements} onChange={(e)=>setHasOutBoardingRequirements(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Out Boarding Requirements</div> 
                            </div>













                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Salary Module</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeMonthlySalary} onChange={(e)=>setHasEmployeeMonthlySalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Monthly Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeDailySalary} onChange={(e)=>setHasEmployeeDailySalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Daily Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPositionDesignationSalary} onChange={(e)=>setHasPositionDesignationSalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Position Designation Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasQuotaBasedSalary} onChange={(e)=>setHasQuotaBasedSalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Quota-Based Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeBankAccount} onChange={(e)=>setHasEmployeeBankAccount(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Bank Account</div>
                            </div>


















                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Government Premiums</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBIRTax} onChange={(e)=>setHasBIRTax(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>BIR Tax</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibig} onChange={(e)=>setHasPagibig(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pagibig</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSS} onChange={(e)=>setHasSSS(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPhilhealth} onChange={(e)=>setHasPhilhealth(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Philhealth</div>
                            </div>











                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Transaction</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTR} onChange={(e)=>setHasDTR(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR (Admin's View)</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRBiometrics} onChange={(e)=>setHasDTRBiometrics(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR (Employee's View)</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRWithOTViewing} onChange={(e)=>setHasDTRWithOTViewing(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR With OT Viewing</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasMobileDTRApproval} onChange={(e)=>setHasMobileDTRApproval(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Mobile DTR Approval</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasApproverHierarchy} onChange={(e)=>setHasApproverHierarchy(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Approver Hierarchy</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasApproverheirarchyperlocation} onChange={(e) => setHasApproverheirarchyperlocation(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Approver Hierarchy Per Location</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasRequestApproval} onChange={(e)=>setHasRequestApproval(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Request Approval</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasRequestApprovalTimeKeeper} onChange={(e)=>setHasRequestApprovalTimeKeeper(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Request Approval TimeKeeper</div> 
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasMassapproval} onChange={(e) => setHasMassapproval(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Mass Approval</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRCorrectionWorkers} onChange={(e)=>setHasDTRCorrectionWorkers(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Correction Workers</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOvertime} onChange={(e)=>setHasOvertime(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Overtime</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRCorrection} onChange={(e)=>setHasDTRCorrection(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Correction</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeave} onChange={(e)=>setHasLeave(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasChangeOfSchedule} onChange={(e)=>setHasChangeOfSchedule(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Change of Schedule</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOffsetCredits} onChange={(e)=>setHasOffsetCredits(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Offset Credits</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOffsetRequest} onChange={(e)=>setHasOffsetRequest(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Offset Request</div>
                            </div>




















                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Loans & Benefits</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSLoan} onChange={(e)=>setHasSSSLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSCalamityLoan} onChange={(e)=>setHasSSSCalamityLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Calamity Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigLoan} onChange={(e)=>setHasPagibigLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pagibig Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigCalamityLoan} onChange={(e)=>setHasPagibigCalamityLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pagibig Calamity Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCashAdvance} onChange={(e)=>setHasCashAdvance(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Cash Advance</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoans} onChange={(e) => setHasLoans(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loans</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDeductions} onChange={(e)=>setHasDeductions(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Deductions</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBenefits} onChange={(e)=>setHasBenefits(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Benefits</div>
                            </div>

                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Settings</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSettings} onChange={(e)=>setHasSettings(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Settings</div>
                            </div>









                                                

                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Reports</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBIR2316} onChange={(e) => setHasBIR2316(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>BIR 2316</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBIR1601C} onChange={(e) => setHasBIR1601C(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>BIR 1601C</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAlphaList} onChange={(e) => setHasAlphaList(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Alpha List</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPerDayTracker} onChange={(e) => setHasPerDayTracker(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Per Day Tracker</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOvertimeSummaryReport} onChange={(e) => setHasOvertimeSummaryReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Overtime Summary Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTrackerReport} onChange={(e) => setHasTrackerReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Tracker Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayslip} onChange={(e) => setHasPayslip(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payslip</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollRegister} onChange={(e) => setHasPayrollRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasResigned} onChange={(e) => setHasResigned(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Resigned</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasActiveEmployees} onChange={(e) => setHasActiveEmployees(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Active Employees</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYearofService} onChange={(e) => setHasYearofService(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Year of Service</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSSummary} onChange={(e) => setHasSSSSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigSummary} onChange={(e) => setHasPagibigSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pag-IBIG Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPhilhealthSummary} onChange={(e) => setHasPhilhealthSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>PhilHealth Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSLoanReport} onChange={(e) => setHasSSSLoanReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Loan Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigLoanReport} onChange={(e) => setHasPagibigLoanReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pag-IBIG Loan Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={has201Report} onChange={(e) => setHas201Report(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>201 Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAttendanceReport} onChange={(e) => setHasAttendanceReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Attendance Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalBDO} onChange={(e) => setHasBankTransmittalBDO(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal BDO</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalBPI} onChange={(e) => setHasBankTransmittalBPI(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal BPI</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalChinaBankSavings} onChange={(e) => setHasBankTransmittalChinaBankSavings(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal China Bank Savings</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalHSBC} onChange={(e) => setHasBankTransmittalHSBC(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal HSBC</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalSecurityBank} onChange={(e) => setHasBankTransmittalSecurityBank(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal Security Bank</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSummaryOfTardiness} onChange={(e) => setHasSummaryOfTardiness(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Summary of Tardiness</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAbsencesMemo} onChange={(e) => setHasAbsencesMemo(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Absences Memo</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAbsencesReport} onChange={(e) => setHasAbsencesReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Absences Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasActionHistoryReport} onChange={(e) => setHasActionHistoryReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Action History Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAllowanceSummary} onChange={(e) => setHasAllowanceSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Allowance Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAuditTrailReportEmployeeSetup} onChange={(e) => setHasAuditTrailReportEmployeeSetup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Audit Trail Report (Employee Setup)</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBundyClockUsage} onChange={(e) => setHasBundyClockUsage(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bundy Clock Usage</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBasicPayAdjustmentReport} onChange={(e) => setHasBasicPayAdjustmentReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Basic Pay Adjustment Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfEmployment} onChange={(e) => setHasCertificateOfEmployment(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of Employment</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfPagibig} onChange={(e) => setHasCertificateOfPagibig(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of Pag-IBIG</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfPhilhealth} onChange={(e) => setHasCertificateOfPhilhealth(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of PhilHealth</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfSSS} onChange={(e) => setHasCertificateOfSSS(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of SSS</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCommissionsSummary} onChange={(e) => setHasCommissionsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Commissions Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCostCenterReport} onChange={(e) => setHasCostCenterReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Cost Center Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDeductionsPerMonth} onChange={(e) => setHasDeductionsPerMonth(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Deductions Per Month</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRReport} onChange={(e) => setHasDTRReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEarningsPerMonth} onChange={(e) => setHasEarningsPerMonth(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Earnings Per Month</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeLeaveGroup} onChange={(e) => setHasEmployeeLeaveGroup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Leave Group</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeOvertimeGroup} onChange={(e) => setHasEmployeeOvertimeGroup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Overtime Group</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeExpenseGroup} onChange={(e) => setHasEmployeeExpenseGroup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Expense Group</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeLeaveHistory} onChange={(e) => setHasEmployeeLeaveHistory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Leave History</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeListingByHiringDate} onChange={(e) => setHasEmployeeListingByHiringDate(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Listing By Hiring Date</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeRegister} onChange={(e) => setHasEmployeeRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasExpenseReport} onChange={(e) => setHasExpenseReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Expense Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasGovernmentEmployeeInventory} onChange={(e) => setHasGovernmentEmployeeInventory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Government Employee Inventory</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHeadcountReport} onChange={(e) => setHasHeadcountReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Headcount Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHolidayPremiumSummary} onChange={(e) => setHasHolidayPremiumSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Holiday Premium Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeaveLedgerReport} onChange={(e) => setHasLeaveLedgerReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave Ledger Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeaveSummaryReport} onChange={(e) => setHasLeaveSummaryReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave Summary Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoanHistory} onChange={(e) => setHasLoanHistory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loan History</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoanPaymentsSummary} onChange={(e) => setHasLoanPaymentsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loan Payments Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoansMonthlyAmortizationSummary} onChange={(e) => setHasLoansMonthlyAmortizationSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loans Monthly Amortization Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoansPenaltyHistory} onChange={(e) => setHasLoansPenaltyHistory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loans Penalty History</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasNightDifferentialSummary} onChange={(e) => setHasNightDifferentialSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Night Differential Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasNonTaxableAllowancesReport} onChange={(e) => setHasNonTaxableAllowancesReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Non-Taxable Allowances Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOtherEarningsReport} onChange={(e) => setHasOtherEarningsReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Other Earnings Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOtherDeductionsSummary} onChange={(e) => setHasOtherDeductionsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Other Deductions Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOutstandingLoans} onChange={(e) => setHasOutstandingLoans(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Outstanding Loans</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollCashRegister} onChange={(e) => setHasPayrollCashRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Cash Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollCheckRegister} onChange={(e) => setHasPayrollCheckRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Check Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollDebitMemo} onChange={(e) => setHasPayrollDebitMemo(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Debit Memo</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalByCostCenter} onChange={(e) => setHasPayrollJournalByCostCenter(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal By Cost Center</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalByDepartment} onChange={(e) => setHasPayrollJournalByDepartment(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal By Department</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalBySummary} onChange={(e) => setHasPayrollJournalBySummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal By Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollPerPaymentMethod} onChange={(e) => setHasPayrollPerPaymentMethod(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Per Payment Method</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSelectLogs} onChange={(e) => setHasSelectLogs(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Select Logs</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSummaryReportByMonthAndDepartment} onChange={(e) => setHasSummaryReportByMonthAndDepartment(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Summary Report By Month And Department</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTardinessMemo} onChange={(e) => setHasTardinessMemo(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Tardiness Memo</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeepingHistoryDetailedReport} onChange={(e) => setHasTimeKeepingHistoryDetailedReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeping History Detailed Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeepingHoursWorkedReport} onChange={(e) => setHasTimeKeepingHoursWorkedReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeping Hours Worked Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeepingHoursWorkedSummary} onChange={(e) => setHasTimeKeepingHoursWorkedSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeping Hours Worked Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimesheetStatusReport} onChange={(e) => setHasTimesheetStatusReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Timesheet Status Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYTDDeductionSummary} onChange={(e) => setHasYTDDeductionSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>YTD Deduction Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYTDEarningsSummary} onChange={(e) => setHasYTDEarningsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>YTD Earnings Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYTDPayrollRegister} onChange={(e) => setHasYTDPayrollRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>YTD Payroll Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasManHour} onChange={(e) => setHasManHour(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Man Hour</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYearlyReport} onChange={(e) => setHasYearlyReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Yearly Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoanReport} onChange={(e) => setHasLoanReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loan Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalReport} onChange={(e) => setHasBankTransmittalReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal Report</div>
                            </div>







                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Calendar</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCalendar} onChange={(e)=>setHasCalendar(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Calendar</div>
                            </div>










                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>User</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasUser} onChange={(e)=>setHasUser(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>User</div>
                            </div>








                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Others</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasNotification} onChange={(e)=>setHasNotification(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Notification</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasMobileBiometrics} onChange={(e)=>setHasMobileBiometrics(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Mobile Biometrics</div>
                            </div>

                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditTemplateFormNew({
    isOpen, 
    onClose,

    description, setDescription,
    hasHome, setHasHome,
    hasAddEmployee, setHasAddEmployee,
    hasEmployeeList, setHasEmployeeList,
    hasEmployeeStatus, setHasEmployeeStatus,
    hasEmployeeSchedule, setHasEmployeeSchedule,
    hasTimeEntries, setHasTimeEntries,
    hasShiftSchedule, setHasShiftSchedule,
    hasProcessPayroll, setHasProcessPayroll,
    has13thMonth, setHas13thMonth,
    hasPayrollPeriod, setHasPayrollPeriod,
    hasClient, setHasClient,
    hasPayType, setHasPayType,
    hasHoliday, setHasHoliday,
    hasHolidayType, setHasHolidayType,
    hasLeaveType, setHasLeaveType,
    hasDepartment, setHasDepartment,
    hasSection, setHasSection,
    hasClassification, setHasClassification,
    hasCompany, setHasCompany,
    hasPosition, setHasPosition,
    hasJobTitle, setHasJobTitle,
    hasLocation, setHasLocation,
    hasDTRRulesConfiguration, setHasDTRRulesConfiguration,
    hasEmployeeMonthlySalary, setHasEmployeeMonthlySalary,
    hasEmployeeDailySalary, setHasEmployeeDailySalary,
    hasPositionDesignationSalary, setHasPositionDesignationSalary,
    hasQuotaBasedSalary, setHasQuotaBasedSalary,
    hasEmployeeBankAccount, setHasEmployeeBankAccount,
    hasBIRTax, setHasBIRTax,
    hasPagibig, setHasPagibig,
    hasSSS, setHasSSS,
    hasPhilhealth, setHasPhilhealth,
    hasDTR, setHasDTR,
    hasDTRBiometrics, setHasDTRBiometrics,
    hasApproverHierarchy, setHasApproverHierarchy,
    hasRequestApproval, setHasRequestApproval,
    hasOvertime, setHasOvertime,
    hasDTRCorrection, setHasDTRCorrection,
    hasLeave, setHasLeave,
    hasChangeOfSchedule, setHasChangeOfSchedule,
    hasSSSLoan, setHasSSSLoan,
    hasSSSCalamityLoan, setHasSSSCalamityLoan,
    hasPagibigLoan, setHasPagibigLoan,
    hasPagibigCalamityLoan, setHasPagibigCalamityLoan,
    hasCashAdvance, setHasCashAdvance,
    hasDeductions, setHasDeductions,
    hasBenefits, setHasBenefits,
    hasReports, setHasReports,
    hasSettings, setHasSettings,
    hasCalendar, setHasCalendar,
    hasUser, setHasUser,
    userTimeOut, setUserTimeOut,

    // additional
    hasEmployeereliever, setHasEmployeereliever,
    hasMassapproval, setHasMassapproval,
    hasApproverheirarchyperlocation, setHasApproverheirarchyperlocation,
    hasFinalPay, setHasFinalPay,
    hasSubcon, setHasSubcon,
    hasAgency, setHasAgency,
    hasEmploymentStatus, setHasEmploymentStatus,
    hasLoans, setHasLoans,
    hasTimeKeeper, setHasTimeKeeper,
    hasPerDayTracker, setHasPerDayTracker,
    hasOvertimeSummaryReport, setHasOvertimeSummaryReport,
    hasTrackerReport, setHasTrackerReport,
    hasPayslip, setHasPayslip,
    hasPayrollRegister, setHasPayrollRegister,
    hasResigned, setHasResigned,
    hasActiveEmployees, setHasActiveEmployees,
    hasYearofService, setHasYearofService,
    hasSSSSummary, setHasSSSSummary,
    hasPagibigSummary, setHasPagibigSummary,
    hasPhilhealthSummary, setHasPhilhealthSummary,
    hasSSSLoanReport, setHasSSSLoanReport,
    hasPagibigLoanReport, setHasPagibigLoanReport,
    has201Report, setHas201Report,
    hasAttendanceReport, setHasAttendanceReport,
    hasBankTransmittalBDO, setHasBankTransmittalBDO,
    hasBankTransmittalBPI, setHasBankTransmittalBPI,
    hasBankTransmittalChinaBankSavings, setHasBankTransmittalChinaBankSavings,
    hasBankTransmittalHSBC, setHasBankTransmittalHSBC,
    hasBankTransmittalSecurityBank, setHasBankTransmittalSecurityBank,
    hasSummaryOfTardiness, setHasSummaryOfTardiness,
    hasAbsencesMemo, setHasAbsencesMemo,
    hasAbsencesReport, setHasAbsencesReport,
    hasActionHistoryReport, setHasActionHistoryReport,
    hasAllowanceSummary, setHasAllowanceSummary,
    hasAuditTrailReportEmployeeSetup, setHasAuditTrailReportEmployeeSetup,
    hasBundyClockUsage, setHasBundyClockUsage,
    hasBasicPayAdjustmentReport, setHasBasicPayAdjustmentReport,
    hasCertificateOfEmployment, setHasCertificateOfEmployment,
    hasCertificateOfPagibig, setHasCertificateOfPagibig,
    hasCertificateOfPhilhealth, setHasCertificateOfPhilhealth,
    hasCertificateOfSSS, setHasCertificateOfSSS,
    hasCommissionsSummary, setHasCommissionsSummary,
    hasCostCenterReport, setHasCostCenterReport,
    hasDeductionsPerMonth, setHasDeductionsPerMonth,
    hasDTRReport, setHasDTRReport,
    hasEarningsPerMonth, setHasEarningsPerMonth,
    hasEmployeeLeaveGroup, setHasEmployeeLeaveGroup,
    hasEmployeeOvertimeGroup, setHasEmployeeOvertimeGroup,
    hasEmployeeExpenseGroup, setHasEmployeeExpenseGroup,
    hasEmployeeLeaveHistory, setHasEmployeeLeaveHistory,
    hasEmployeeListingByHiringDate, setHasEmployeeListingByHiringDate,
    hasEmployeeRegister, setHasEmployeeRegister,
    hasExpenseReport, setHasExpenseReport,
    hasGovernmentEmployeeInventory, setHasGovernmentEmployeeInventory,
    hasHeadcountReport, setHasHeadcountReport,
    hasHolidayPremiumSummary, setHasHolidayPremiumSummary,
    hasLeaveLedgerReport, setHasLeaveLedgerReport,
    hasLeaveSummaryReport, setHasLeaveSummaryReport,
    hasLoanHistory, setHasLoanHistory,
    hasLoanPaymentsSummary, setHasLoanPaymentsSummary,
    hasLoansMonthlyAmortizationSummary, setHasLoansMonthlyAmortizationSummary,
    hasLoansPenaltyHistory, setHasLoansPenaltyHistory,
    hasNightDifferentialSummary, setHasNightDifferentialSummary,
    hasNonTaxableAllowancesReport, setHasNonTaxableAllowancesReport,
    hasOtherEarningsReport, setHasOtherEarningsReport,
    hasOtherDeductionsSummary, setHasOtherDeductionsSummary,
    hasOutstandingLoans, setHasOutstandingLoans,
    hasPayrollCashRegister, setHasPayrollCashRegister,
    hasPayrollCheckRegister, setHasPayrollCheckRegister,
    hasPayrollDebitMemo, setHasPayrollDebitMemo,
    hasPayrollJournalByCostCenter, setHasPayrollJournalByCostCenter,
    hasPayrollJournalByDepartment, setHasPayrollJournalByDepartment,
    hasPayrollJournalBySummary, setHasPayrollJournalBySummary,
    hasPayrollPerPaymentMethod, setHasPayrollPerPaymentMethod,
    hasSelectLogs, setHasSelectLogs,
    hasSummaryReportByMonthAndDepartment, setHasSummaryReportByMonthAndDepartment,
    hasTardinessMemo, setHasTardinessMemo,
    hasTimeKeepingHistoryDetailedReport, setHasTimeKeepingHistoryDetailedReport,
    hasTimeKeepingHoursWorkedReport, setHasTimeKeepingHoursWorkedReport,
    hasTimeKeepingHoursWorkedSummary, setHasTimeKeepingHoursWorkedSummary,
    hasTimesheetStatusReport, setHasTimesheetStatusReport,
    hasYTDDeductionSummary, setHasYTDDeductionSummary,
    hasYTDEarningsSummary, setHasYTDEarningsSummary,
    hasYTDPayrollRegister, setHasYTDPayrollRegister,
    hasNotification, setHasNotification,
    hasMobileBiometrics, setHasMobileBiometrics,
    hasRequestApprovalTimeKeeper, setHasRequestApprovalTimeKeeper,
    hasTamperedApproval, setHasTamperedApproval,
    hasMobileDTRApproval, setHasMobileDTRApproval,
    hasDTRWithOTViewing, setHasDTRWithOTViewing,
    hasDTRCorrectionWorkers, setHasDTRCorrectionWorkers,
    hasPlantilya, setHasPlantilya,
    hasCostCenter, setHasCostCenter,
    hasPayrollJournalAccount, setHasPayrollJournalAccount,

    hasManHour, setHasManHour,
    hasYearlyReport, setHasYearlyReport,
    hasBIR2316, setHasBIR2316,
    hasBIR1601C, setHasBIR1601C,
    hasAlphaList, setHasAlphaList,
    hasLoanReport, setHasLoanReport,
    hasBankTransmittalReport, setHasBankTransmittalReport,
    hasOffsetCredits, setHasOffsetCredits,
    hasOffsetRequest, setHasOffsetRequest,
    hasEmployeeGroup1, setHasEmployeeGroup1,
    hasEmployeeGroup2, setHasEmployeeGroup2,
    hasOnBoarding, setHasOnBoarding,
    hasOnBoardingPersonnel, setHasOnBoardingPersonnel,
    hasOutBoarding, setHasOutBoarding,
    hasOnBoardingRequirements, setHasOnBoardingRequirements,
    hasOutBoardingRequirements, setHasOutBoardingRequirements,

    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!description 
        ){
            setErrorState(true);
            return;
        }

        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Edit Template</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>

                        <div className="popUp-item info-item column">
                            <div className="info-item-label">User Timeout (auto log-out duration)</div>
                            <div className="info-item-input">
                                <input
                                placeholder="0"
                                type='number'
                                value={userTimeOut}
                                onChange={(e) => setUserTimeOut(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>

                        <div style={{border: "1px solid #80808080", padding: "5px", borderRadius: "5px", width: "90%"}}>
                            <div className="info-item-label" style={{color: "#668fca"}}>Home</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHome} onChange={(e)=>setHasHome(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Home</div>
                            </div>
                            





                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Personnel</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAddEmployee} onChange={(e)=>setHasAddEmployee(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Add Employee</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeList} onChange={(e)=>setHasEmployeeList(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee List</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmploymentStatus} onChange={(e) => setHasEmploymentStatus(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employment Status</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeSchedule} onChange={(e)=>setHasEmployeeSchedule(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Schedule</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeereliever} onChange={(e) => setHasEmployeereliever(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Reliever</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOnBoarding} onChange={(e) => setHasOnBoarding(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>On Boarding</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOutBoarding} onChange={(e) => setHasOutBoarding(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Out Boarding</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOnBoardingPersonnel} onChange={(e) => setHasOnBoardingPersonnel(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>On Boarding Personnel</div>
                            </div>











                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Time Keeping</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeEntries} onChange={(e)=>setHasTimeEntries(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Entries</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTamperedApproval} onChange={(e)=>setHasTamperedApproval(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Tampered Approval</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasShiftSchedule} onChange={(e)=>setHasShiftSchedule(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Shift Schedule</div>
                            </div>










                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Payroll</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasProcessPayroll} onChange={(e)=>setHasProcessPayroll(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Process Payroll</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={has13thMonth} onChange={(e)=>setHas13thMonth(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>13th Month</div>
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasFinalPay} onChange={(e) => setHasFinalPay(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Final Pay</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSubcon} onChange={(e) => setHasSubcon(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Subcon</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAgency} onChange={(e) => setHasAgency(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Agency</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollPeriod} onChange={(e)=>setHasPayrollPeriod(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Period</div>
                            </div>










                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Maintenance</div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasClient} onChange={(e)=>setHasClient(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Client</div>
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayType} onChange={(e)=>setHasPayType(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pay Type</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHoliday} onChange={(e)=>setHasHoliday(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Holiday</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHolidayType} onChange={(e)=>setHasHolidayType(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Holiday Type</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeaveType} onChange={(e)=>setHasLeaveType(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave Types</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDepartment} onChange={(e)=>setHasDepartment(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Department</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSection} onChange={(e)=>setHasSection(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Section</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasClassification} onChange={(e)=>setHasClassification(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Classification</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCompany} onChange={(e)=>setHasCompany(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Company</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPosition} onChange={(e)=>setHasPosition(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Position</div>
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeStatus} onChange={(e)=>setHasEmployeeStatus(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Status</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasJobTitle} onChange={(e)=>setHasJobTitle(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Job Title</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeGroup1} onChange={(e)=>setHasEmployeeGroup1(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Group 1</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeGroup2} onChange={(e)=>setHasEmployeeGroup2(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Group 2</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLocation} onChange={(e)=>setHasLocation(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Location</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRRulesConfiguration} onChange={(e)=>setHasDTRRulesConfiguration(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Rules Configuration</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeeper} onChange={(e) => setHasTimeKeeper(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeper</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPlantilya} onChange={(e)=>setHasPlantilya(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Plantilya</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCostCenter} onChange={(e)=>setHasCostCenter(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Cost Center</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalAccount} onChange={(e)=>setHasPayrollJournalAccount(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal Account</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOnBoardingRequirements} onChange={(e)=>setHasOnBoardingRequirements(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>On Boarding Requirements</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOutBoardingRequirements} onChange={(e)=>setHasOutBoardingRequirements(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Out Boarding Requirements</div> 
                            </div>













                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Salary Module</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeMonthlySalary} onChange={(e)=>setHasEmployeeMonthlySalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Monthly Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeDailySalary} onChange={(e)=>setHasEmployeeDailySalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Daily Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPositionDesignationSalary} onChange={(e)=>setHasPositionDesignationSalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Position Designation Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasQuotaBasedSalary} onChange={(e)=>setHasQuotaBasedSalary(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Quota-Based Salary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeBankAccount} onChange={(e)=>setHasEmployeeBankAccount(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Bank Account</div>
                            </div>


















                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Government Premiums</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBIRTax} onChange={(e)=>setHasBIRTax(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>BIR Tax</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibig} onChange={(e)=>setHasPagibig(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pagibig</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSS} onChange={(e)=>setHasSSS(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPhilhealth} onChange={(e)=>setHasPhilhealth(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Philhealth</div>
                            </div>











                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Transaction</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTR} onChange={(e)=>setHasDTR(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR (Admin's View)</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRBiometrics} onChange={(e)=>setHasDTRBiometrics(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR (Employee's View)</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRWithOTViewing} onChange={(e)=>setHasDTRWithOTViewing(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR With OT Viewing</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasMobileDTRApproval} onChange={(e)=>setHasMobileDTRApproval(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Mobile DTR Approval</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasApproverHierarchy} onChange={(e)=>setHasApproverHierarchy(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Approver Hierarchy</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasApproverheirarchyperlocation} onChange={(e) => setHasApproverheirarchyperlocation(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Approver Hierarchy Per Location</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasRequestApproval} onChange={(e)=>setHasRequestApproval(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Request Approval</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasRequestApprovalTimeKeeper} onChange={(e)=>setHasRequestApprovalTimeKeeper(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Request Approval TimeKeeper</div> 
                            </div>
                            
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasMassapproval} onChange={(e) => setHasMassapproval(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Mass Approval</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRCorrectionWorkers} onChange={(e)=>setHasDTRCorrectionWorkers(e.target.checked)}/> 
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Correction Workers</div> 
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOvertime} onChange={(e)=>setHasOvertime(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Overtime</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRCorrection} onChange={(e)=>setHasDTRCorrection(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Correction</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeave} onChange={(e)=>setHasLeave(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasChangeOfSchedule} onChange={(e)=>setHasChangeOfSchedule(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Change of Schedule</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOffsetCredits} onChange={(e)=>setHasOffsetCredits(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Offset Credits</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOffsetRequest} onChange={(e)=>setHasOffsetRequest(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Offset Request</div>
                            </div>




















                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Loans & Benefits</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSLoan} onChange={(e)=>setHasSSSLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSCalamityLoan} onChange={(e)=>setHasSSSCalamityLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Calamity Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigLoan} onChange={(e)=>setHasPagibigLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pagibig Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigCalamityLoan} onChange={(e)=>setHasPagibigCalamityLoan(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pagibig Calamity Loan</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCashAdvance} onChange={(e)=>setHasCashAdvance(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Cash Advance</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoans} onChange={(e) => setHasLoans(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loans</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDeductions} onChange={(e)=>setHasDeductions(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Deductions</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBenefits} onChange={(e)=>setHasBenefits(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Benefits</div>
                            </div>

                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Settings</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSettings} onChange={(e)=>setHasSettings(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Settings</div>
                            </div>









                                                

                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Reports</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBIR2316} onChange={(e) => setHasBIR2316(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>BIR 2316</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBIR1601C} onChange={(e) => setHasBIR1601C(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>BIR 1601C</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAlphaList} onChange={(e) => setHasAlphaList(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Alpha List</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPerDayTracker} onChange={(e) => setHasPerDayTracker(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Per Day Tracker</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOvertimeSummaryReport} onChange={(e) => setHasOvertimeSummaryReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Overtime Summary Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTrackerReport} onChange={(e) => setHasTrackerReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Tracker Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayslip} onChange={(e) => setHasPayslip(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payslip</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollRegister} onChange={(e) => setHasPayrollRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasResigned} onChange={(e) => setHasResigned(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Resigned</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasActiveEmployees} onChange={(e) => setHasActiveEmployees(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Active Employees</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYearofService} onChange={(e) => setHasYearofService(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Year of Service</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSSummary} onChange={(e) => setHasSSSSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigSummary} onChange={(e) => setHasPagibigSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pag-IBIG Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPhilhealthSummary} onChange={(e) => setHasPhilhealthSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>PhilHealth Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSSSLoanReport} onChange={(e) => setHasSSSLoanReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>SSS Loan Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPagibigLoanReport} onChange={(e) => setHasPagibigLoanReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Pag-IBIG Loan Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={has201Report} onChange={(e) => setHas201Report(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>201 Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAttendanceReport} onChange={(e) => setHasAttendanceReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Attendance Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalBDO} onChange={(e) => setHasBankTransmittalBDO(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal BDO</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalBPI} onChange={(e) => setHasBankTransmittalBPI(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal BPI</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalChinaBankSavings} onChange={(e) => setHasBankTransmittalChinaBankSavings(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal China Bank Savings</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalHSBC} onChange={(e) => setHasBankTransmittalHSBC(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal HSBC</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalSecurityBank} onChange={(e) => setHasBankTransmittalSecurityBank(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal Security Bank</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSummaryOfTardiness} onChange={(e) => setHasSummaryOfTardiness(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Summary of Tardiness</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAbsencesMemo} onChange={(e) => setHasAbsencesMemo(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Absences Memo</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAbsencesReport} onChange={(e) => setHasAbsencesReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Absences Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasActionHistoryReport} onChange={(e) => setHasActionHistoryReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Action History Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAllowanceSummary} onChange={(e) => setHasAllowanceSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Allowance Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasAuditTrailReportEmployeeSetup} onChange={(e) => setHasAuditTrailReportEmployeeSetup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Audit Trail Report (Employee Setup)</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBundyClockUsage} onChange={(e) => setHasBundyClockUsage(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bundy Clock Usage</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBasicPayAdjustmentReport} onChange={(e) => setHasBasicPayAdjustmentReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Basic Pay Adjustment Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfEmployment} onChange={(e) => setHasCertificateOfEmployment(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of Employment</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfPagibig} onChange={(e) => setHasCertificateOfPagibig(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of Pag-IBIG</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfPhilhealth} onChange={(e) => setHasCertificateOfPhilhealth(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of PhilHealth</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCertificateOfSSS} onChange={(e) => setHasCertificateOfSSS(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Certificate of SSS</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCommissionsSummary} onChange={(e) => setHasCommissionsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Commissions Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCostCenterReport} onChange={(e) => setHasCostCenterReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Cost Center Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDeductionsPerMonth} onChange={(e) => setHasDeductionsPerMonth(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Deductions Per Month</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasDTRReport} onChange={(e) => setHasDTRReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>DTR Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEarningsPerMonth} onChange={(e) => setHasEarningsPerMonth(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Earnings Per Month</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeLeaveGroup} onChange={(e) => setHasEmployeeLeaveGroup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Leave Group</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeOvertimeGroup} onChange={(e) => setHasEmployeeOvertimeGroup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Overtime Group</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeExpenseGroup} onChange={(e) => setHasEmployeeExpenseGroup(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Expense Group</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeLeaveHistory} onChange={(e) => setHasEmployeeLeaveHistory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Leave History</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeListingByHiringDate} onChange={(e) => setHasEmployeeListingByHiringDate(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Listing By Hiring Date</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasEmployeeRegister} onChange={(e) => setHasEmployeeRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Employee Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasExpenseReport} onChange={(e) => setHasExpenseReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Expense Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasGovernmentEmployeeInventory} onChange={(e) => setHasGovernmentEmployeeInventory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Government Employee Inventory</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHeadcountReport} onChange={(e) => setHasHeadcountReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Headcount Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasHolidayPremiumSummary} onChange={(e) => setHasHolidayPremiumSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Holiday Premium Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeaveLedgerReport} onChange={(e) => setHasLeaveLedgerReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave Ledger Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLeaveSummaryReport} onChange={(e) => setHasLeaveSummaryReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Leave Summary Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoanHistory} onChange={(e) => setHasLoanHistory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loan History</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoanPaymentsSummary} onChange={(e) => setHasLoanPaymentsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loan Payments Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoansMonthlyAmortizationSummary} onChange={(e) => setHasLoansMonthlyAmortizationSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loans Monthly Amortization Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoansPenaltyHistory} onChange={(e) => setHasLoansPenaltyHistory(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loans Penalty History</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasNightDifferentialSummary} onChange={(e) => setHasNightDifferentialSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Night Differential Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasNonTaxableAllowancesReport} onChange={(e) => setHasNonTaxableAllowancesReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Non-Taxable Allowances Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOtherEarningsReport} onChange={(e) => setHasOtherEarningsReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Other Earnings Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOtherDeductionsSummary} onChange={(e) => setHasOtherDeductionsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Other Deductions Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasOutstandingLoans} onChange={(e) => setHasOutstandingLoans(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Outstanding Loans</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollCashRegister} onChange={(e) => setHasPayrollCashRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Cash Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollCheckRegister} onChange={(e) => setHasPayrollCheckRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Check Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollDebitMemo} onChange={(e) => setHasPayrollDebitMemo(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Debit Memo</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalByCostCenter} onChange={(e) => setHasPayrollJournalByCostCenter(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal By Cost Center</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalByDepartment} onChange={(e) => setHasPayrollJournalByDepartment(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal By Department</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollJournalBySummary} onChange={(e) => setHasPayrollJournalBySummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Journal By Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasPayrollPerPaymentMethod} onChange={(e) => setHasPayrollPerPaymentMethod(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Payroll Per Payment Method</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSelectLogs} onChange={(e) => setHasSelectLogs(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Select Logs</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasSummaryReportByMonthAndDepartment} onChange={(e) => setHasSummaryReportByMonthAndDepartment(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Summary Report By Month And Department</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTardinessMemo} onChange={(e) => setHasTardinessMemo(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Tardiness Memo</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeepingHistoryDetailedReport} onChange={(e) => setHasTimeKeepingHistoryDetailedReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeping History Detailed Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeepingHoursWorkedReport} onChange={(e) => setHasTimeKeepingHoursWorkedReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeping Hours Worked Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimeKeepingHoursWorkedSummary} onChange={(e) => setHasTimeKeepingHoursWorkedSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Time Keeping Hours Worked Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasTimesheetStatusReport} onChange={(e) => setHasTimesheetStatusReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Timesheet Status Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYTDDeductionSummary} onChange={(e) => setHasYTDDeductionSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>YTD Deduction Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYTDEarningsSummary} onChange={(e) => setHasYTDEarningsSummary(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>YTD Earnings Summary</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYTDPayrollRegister} onChange={(e) => setHasYTDPayrollRegister(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>YTD Payroll Register</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasManHour} onChange={(e) => setHasManHour(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Man Hour</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasYearlyReport} onChange={(e) => setHasYearlyReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Yearly Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasLoanReport} onChange={(e) => setHasLoanReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Loan Report</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasBankTransmittalReport} onChange={(e) => setHasBankTransmittalReport(e.target.checked)} />
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Bank Transmittal Report</div>
                            </div>







                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Calendar</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasCalendar} onChange={(e)=>setHasCalendar(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Calendar</div>
                            </div>










                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>User</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasUser} onChange={(e)=>setHasUser(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>User</div>
                            </div>








                            <div className="info-item-label" style={{marginTop:"25px", color: "#668fca"}}>Others</div>
                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasNotification} onChange={(e)=>setHasNotification(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Notification</div>
                            </div>

                            <div className="popUp-item info-item row" style={{alignItems:"center", padding: "0"}}>
                                <div className="info-item-input">
                                    <input type="checkbox" className="checkbox" checked={hasMobileBiometrics} onChange={(e)=>setHasMobileBiometrics(e.target.checked)}/>
                                </div>
                                <div className="info-item-label" style={{paddingLeft:"10px"}}>Mobile Biometrics</div>
                            </div>

                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export default Users
